
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref2fb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref2fb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $0ae9019609d046a1$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $63cbeabc75241824$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $63cbeabc75241824$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $63cbeabc75241824$export$2e2bcd8739ae039) || f === (0, $3acd474ceacf8a38$export$2e2bcd8739ae039) ? f : $0ae9019609d046a1$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0ae9019609d046a1$var$zero() {
    return 0;
}

function $674b813fb857ae76$var$length(array) {
    return array.length | 0;
}
function $674b813fb857ae76$var$empty(length) {
    return !(length > 0);
}
function $674b813fb857ae76$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $674b813fb857ae76$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $674b813fb857ae76$export$2e2bcd8739ae039(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $674b813fb857ae76$var$reducer(values.pop());
    values = values.map($674b813fb857ae76$var$arrayify);
    const lengths = values.map($674b813fb857ae76$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($674b813fb857ae76$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

function $4eefdd235be3059b$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}


function $317408b795339b26$export$2e2bcd8739ae039(values, valueof) {
    const v = (0, $4eefdd235be3059b$export$2e2bcd8739ae039)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

function $24461355656d8852$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $d9caf9fd1659d791$export$2e2bcd8739ae039(x) {
    return x;
}


function $6f0c14a1378d16c1$export$2e2bcd8739ae039(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), keys);
}
function $6f0c14a1378d16c1$export$d4abd167df80d226(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, Array.from, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), keys);
}
function $6f0c14a1378d16c1$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $6f0c14a1378d16c1$export$4ed6fc79ae2c51b5(values, ...keys) {
    return $6f0c14a1378d16c1$var$flatten($6f0c14a1378d16c1$export$d4abd167df80d226(values, ...keys), keys);
}
function $6f0c14a1378d16c1$export$788c7294dbcd8e36(values, reduce, ...keys) {
    return $6f0c14a1378d16c1$var$flatten($6f0c14a1378d16c1$export$24814875ed03194b(values, reduce, ...keys), keys);
}
function $6f0c14a1378d16c1$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), reduce, keys);
}
function $6f0c14a1378d16c1$export$24814875ed03194b(values, reduce, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, Array.from, reduce, keys);
}
function $6f0c14a1378d16c1$export$b610b8812bbcded9(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, (0, $d9caf9fd1659d791$export$2e2bcd8739ae039), $6f0c14a1378d16c1$var$unique, keys);
}
function $6f0c14a1378d16c1$export$8b04ba635e5803cd(values, ...keys) {
    return $6f0c14a1378d16c1$var$nest(values, Array.from, $6f0c14a1378d16c1$var$unique, keys);
}
function $6f0c14a1378d16c1$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $6f0c14a1378d16c1$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

function $3ce2d353ce06f740$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

function $be26fde1f1f97ef0$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}



function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $70ebee7adc32f27f$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}



function $752ccd95a674b233$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $3dc3306e587e145d$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $3dc3306e587e145d$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$3dc3306e587e145d$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $752ccd95a674b233$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($3dc3306e587e145d$export$5708b2c031939e56(f));
}
function $3dc3306e587e145d$export$5708b2c031939e56(compare = (0, $63cbeabc75241824$export$2e2bcd8739ae039)) {
    if (compare === (0, $63cbeabc75241824$export$2e2bcd8739ae039)) return $3dc3306e587e145d$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $3dc3306e587e145d$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $6637506e64922c38$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $3dc3306e587e145d$export$686e14b8469efec4) : (0, $3dc3306e587e145d$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $6637506e64922c38$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $6637506e64922c38$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $6637506e64922c38$var$swap(array, left, right);
        while(i < j){
            $6637506e64922c38$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $6637506e64922c38$var$swap(array, left, j);
        else ++j, $6637506e64922c38$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $6637506e64922c38$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}


function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $591ad978f2ce6133$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}




function $f89111cbb3c9d70b$export$2e2bcd8739ae039(values, compare = (0, $63cbeabc75241824$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $63cbeabc75241824$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $63cbeabc75241824$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}


function $231c9024a6754413$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $591ad978f2ce6133$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)((0, $6637506e64922c38$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $231c9024a6754413$export$f924a6cad778dddb(values, p, valueof = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $231c9024a6754413$export$f1fcc854ecc6ce55(values, p, valueof = (0, $591ad978f2ce6133$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $591ad978f2ce6133$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $70ebee7adc32f27f$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $3ce2d353ce06f740$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $6637506e64922c38$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $3dc3306e587e145d$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $f89111cbb3c9d70b$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}


function $5713cbb46e42efc2$export$2e2bcd8739ae039(values, valueof) {
    return (0, $231c9024a6754413$export$2e2bcd8739ae039)(values, 0.5, valueof);
}
function $5713cbb46e42efc2$export$57546ab4fd3c7a5e(values, valueof) {
    return (0, $231c9024a6754413$export$f1fcc854ecc6ce55)(values, 0.5, valueof);
}


function $50f73767cb5db446$export$2e2bcd8739ae039(values, valueof) {
    const counts = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

function $a9640ed34ca3d852$export$2e2bcd8739ae039(values, pairof = $a9640ed34ca3d852$export$a04cb3fe8b81dd) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $a9640ed34ca3d852$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

function $0b47a96a2caef260$export$2e2bcd8739ae039(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

function $daf42a1f07322cf6$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

const $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7c028b8201e48c5a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7c028b8201e48c5a$var$tickSpec(stop, start, count) : $7c028b8201e48c5a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7c028b8201e48c5a$var$tickSpec(start, stop, count)[2];
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7c028b8201e48c5a$export$bc64d00cc98e7e95(stop, start, count) : $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $575c8f74500ed33b$export$2e2bcd8739ae039(x) {
    return x;
}


var $834b38f205523964$var$top = 1, $834b38f205523964$var$right = 2, $834b38f205523964$var$bottom = 3, $834b38f205523964$var$left = 4, $834b38f205523964$var$epsilon = 1e-6;
function $834b38f205523964$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $834b38f205523964$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $834b38f205523964$var$number(scale) {
    return (d)=>+scale(d);
}
function $834b38f205523964$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $834b38f205523964$var$entering() {
    return !this.__axis;
}
function $834b38f205523964$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$left ? -1 : 1, x = orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? "x" : "y", transform = orient === $834b38f205523964$var$top || orient === $834b38f205523964$var$bottom ? $834b38f205523964$var$translateX : $834b38f205523964$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $575c8f74500ed33b$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $834b38f205523964$var$center : $834b38f205523964$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $834b38f205523964$var$top ? "0em" : orient === $834b38f205523964$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $834b38f205523964$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $834b38f205523964$var$left || orient === $834b38f205523964$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($834b38f205523964$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $834b38f205523964$var$right ? "start" : orient === $834b38f205523964$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $834b38f205523964$export$59b8cfab074bdeb1(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$top, scale);
}
function $834b38f205523964$export$b0d2e24dc4f898f0(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$right, scale);
}
function $834b38f205523964$export$e5cb22533a15e72e(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$bottom, scale);
}
function $834b38f205523964$export$2749afb169a520d2(scale) {
    return $834b38f205523964$var$axis($834b38f205523964$var$left, scale);
}


var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;



function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}


function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $cade2308c136039a$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a3d7edd03ec30cc1$var$arrayAll(select) {
    return function() {
        return (0, $cade2308c136039a$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a3d7edd03ec30cc1$var$arrayAll(select);
    else select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, parents);
}


function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $5fb24786d2a5f87a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $31ffd623f27a3a65$var$find = Array.prototype.find;
function $31ffd623f27a3a65$var$childFind(match) {
    return function() {
        return $31ffd623f27a3a65$var$find.call(this.children, match);
    };
}
function $31ffd623f27a3a65$var$childFirst() {
    return this.firstElementChild;
}
function $31ffd623f27a3a65$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $31ffd623f27a3a65$var$childFirst : $31ffd623f27a3a65$var$childFind(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}



var $956143cec557381d$var$filter = Array.prototype.filter;
function $956143cec557381d$var$children() {
    return Array.from(this.children);
}
function $956143cec557381d$var$childrenFilter(match) {
    return function() {
        return $956143cec557381d$var$filter.call(this.children, match);
    };
}
function $956143cec557381d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $956143cec557381d$var$children : $956143cec557381d$var$childrenFilter(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}




function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._enter || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $cf943aeeeea8dffb$var$datum(node) {
    return node.__data__;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $cf943aeeeea8dffb$var$datum);
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d8d677a8510c2e55$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $cf943aeeeea8dffb$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $cf943aeeeea8dffb$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._exit || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}


function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63bab9b342eb32db$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(merges, this._parents);
}


function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}


function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}


function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}


function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}


function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}




function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}


function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $6e0da2549057218e$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}


function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}


function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $dd1fb49221ad966f$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $dd1fb49221ad966f$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}


function* $98373fa9c0ecbfb2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
function $28a9f77d63e1ff25$var$selection_selection() {
    return this;
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $31121acbef1e6956$export$2e2bcd8739ae039),
    selectAll: (0, $a3d7edd03ec30cc1$export$2e2bcd8739ae039),
    selectChild: (0, $31ffd623f27a3a65$export$2e2bcd8739ae039),
    selectChildren: (0, $956143cec557381d$export$2e2bcd8739ae039),
    filter: (0, $ebbd333b038c2847$export$2e2bcd8739ae039),
    data: (0, $cf943aeeeea8dffb$export$2e2bcd8739ae039),
    enter: (0, $3e99928b06782938$export$2e2bcd8739ae039),
    exit: (0, $69a673ff94b874e4$export$2e2bcd8739ae039),
    join: (0, $80f6488751784891$export$2e2bcd8739ae039),
    merge: (0, $63bab9b342eb32db$export$2e2bcd8739ae039),
    selection: $28a9f77d63e1ff25$var$selection_selection,
    order: (0, $7a935994b7a1f6cf$export$2e2bcd8739ae039),
    sort: (0, $faed8eab1469f61d$export$2e2bcd8739ae039),
    call: (0, $fa7212ea177e0f60$export$2e2bcd8739ae039),
    nodes: (0, $c2d66609f799a53b$export$2e2bcd8739ae039),
    node: (0, $cb2fe8996a284614$export$2e2bcd8739ae039),
    size: (0, $8d2a1d37edc5fc51$export$2e2bcd8739ae039),
    empty: (0, $3ed6ae19ad0a17a6$export$2e2bcd8739ae039),
    each: (0, $4a407aa055eb21e9$export$2e2bcd8739ae039),
    attr: (0, $8ba31651ad7591ba$export$2e2bcd8739ae039),
    style: (0, $6abb942964e997ae$export$2e2bcd8739ae039),
    property: (0, $2b37810bbc11c28b$export$2e2bcd8739ae039),
    classed: (0, $6515c3ccac9efd7a$export$2e2bcd8739ae039),
    text: (0, $23bcbc7d81179ba9$export$2e2bcd8739ae039),
    html: (0, $d5514f1406649954$export$2e2bcd8739ae039),
    raise: (0, $c6aae8ef09c3d03d$export$2e2bcd8739ae039),
    lower: (0, $4669a19c71181bd1$export$2e2bcd8739ae039),
    append: (0, $00a766249763e814$export$2e2bcd8739ae039),
    insert: (0, $45485f4f27d149f8$export$2e2bcd8739ae039),
    remove: (0, $d587d6535138580c$export$2e2bcd8739ae039),
    clone: (0, $3323c835dc2d74de$export$2e2bcd8739ae039),
    datum: (0, $d048e3258aa4fe8e$export$2e2bcd8739ae039),
    on: (0, $dd1fb49221ad966f$export$2e2bcd8739ae039),
    dispatch: (0, $27c639e461d8a390$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $98373fa9c0ecbfb2$export$2e2bcd8739ae039)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;


function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $914edae09cbfb4c0$export$524615cd03e458cc = {
    passive: false
};
const $914edae09cbfb4c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $914edae09cbfb4c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));



function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : b instanceof Date ? (0, $063cbb46f86ba478$export$2e2bcd8739ae039) : (0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $23bbf03008765dcc$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf536f4647e343d9$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))(a, b);
}


function $c447ae86a8320d39$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $1be794af963d8372$export$2e2bcd8739ae039(event, node) {
    event = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $e782289d8bd71451$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $150ba4634a330696$var$emptyOn = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $150ba4634a330696$export$a5d151aee16efd42) && schedule.state < (0, $150ba4634a330696$export$a2e792214ded83b2);
        schedule.state = (0, $150ba4634a330696$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this, name);
    });
}




var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $2938f7d64470581a$export$f0954fd7d5368655) : (0, $2938f7d64470581a$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bYoiY = parcelRequire("bYoiY");

function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039))(a, b);
}


function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $e4d1a233c7242264$export$da8cba906d64c082) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}



function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}



function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $9d186bb80d60f6c9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $9d186bb80d60f6c9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($9d186bb80d60f6c9$var$easeVarying(this._id, value));
}




function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $150ba4634a330696$export$2cd8252107eb640b) : (0, $150ba4634a330696$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}


function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}





function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $13be595fcf5febb7$var$Selection = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}







function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $e4d1a233c7242264$export$56bec7123bb3589a) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}



function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}


function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}




function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id0);
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $9c22ba9ec568d18f$export$2e2bcd8739ae039),
    selectAll: (0, $79e977f9a26c99f1$export$2e2bcd8739ae039),
    selectChild: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChild,
    selectChildren: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChildren,
    filter: (0, $c1e3543439d9f5fd$export$2e2bcd8739ae039),
    merge: (0, $e7e726720f484153$export$2e2bcd8739ae039),
    selection: (0, $13be595fcf5febb7$export$2e2bcd8739ae039),
    transition: (0, $e8ee9e113d6ecbba$export$2e2bcd8739ae039),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $fd664209e896113c$export$2e2bcd8739ae039),
    attr: (0, $2a651cfc4e49b53d$export$2e2bcd8739ae039),
    attrTween: (0, $cad13035adb29669$export$2e2bcd8739ae039),
    style: (0, $d0bf366fdef4c332$export$2e2bcd8739ae039),
    styleTween: (0, $83672080502c9717$export$2e2bcd8739ae039),
    text: (0, $e62b6dd5e7df40e7$export$2e2bcd8739ae039),
    textTween: (0, $64d823b28aa7019a$export$2e2bcd8739ae039),
    remove: (0, $b59e1b517983ad92$export$2e2bcd8739ae039),
    tween: (0, $922feb1dfe9c8dcf$export$2e2bcd8739ae039),
    delay: (0, $09cd57996bd81614$export$2e2bcd8739ae039),
    duration: (0, $9c9f124117d5bf14$export$2e2bcd8739ae039),
    ease: (0, $8ea7852b6976e6d1$export$2e2bcd8739ae039),
    easeVarying: (0, $9d186bb80d60f6c9$export$2e2bcd8739ae039),
    end: (0, $5220ae42feb560ba$export$2e2bcd8739ae039),
    [Symbol.iterator]: $a4d5b9ef4f9cfabb$var$selection_prototype[Symbol.iterator]
};



function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $5b131c7b61a09e82$export$89238d3bc79d3ada)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $e782289d8bd71451$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.interrupt = (0, $c1dd383074e2630e$export$2e2bcd8739ae039);
(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.transition = (0, $b5b43281074f9351$export$2e2bcd8739ae039);







var $4fc3d848825eb4c8$export$2e2bcd8739ae039 = (x)=>()=>x;


function $de0b5bec424cf247$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $48e2d3ac3b9a75ee$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
const { abs: $5c8970f4694d4107$var$abs, max: $5c8970f4694d4107$var$max, min: $5c8970f4694d4107$var$min } = Math;
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8385105b4986daed$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $de0b5bec424cf247$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && event.altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : $5c8970f4694d4107$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $5c8970f4694d4107$var$X ? N : $5c8970f4694d4107$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : $5c8970f4694d4107$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $5c8970f4694d4107$var$X ? S : $5c8970f4694d4107$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $1be794af963d8372$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($5c8970f4694d4107$var$abs(point.cur[0] - point[0]) > $5c8970f4694d4107$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[0][0])), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[0][1])), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $5c8970f4694d4107$var$max(W - e0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $5c8970f4694d4107$var$max(N - s0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, w0 - dx * signX)), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, n0 - dy * signY)), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $48e2d3ac3b9a75ee$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $905558291b0c219c$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}





parcelRequire("bYoiY");








function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $458fe095863893c0$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $458fe095863893c0$export$2e2bcd8739ae039),
    "s": (0, $fe491ef31c379765$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}


var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $f4c0f29ad920aaa1$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $95e9c493347f9308$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $dd689cef4c920567$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $fe491ef31c379765$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $e8b109bb95cf9845$export$2e2bcd8739ae039)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}


var $670604c4306869d0$export$6c421550c66a327d = 1e-6;
var $670604c4306869d0$export$92c06fba281fe81b = 1e-12;
var $670604c4306869d0$export$18c7bea995a110f = Math.PI;
var $670604c4306869d0$export$e51408a300e8929a = $670604c4306869d0$export$18c7bea995a110f / 2;
var $670604c4306869d0$export$c39a5cba78ea0fc2 = $670604c4306869d0$export$18c7bea995a110f / 4;
var $670604c4306869d0$export$a4b4b4d4d776fe92 = $670604c4306869d0$export$18c7bea995a110f * 2;
var $670604c4306869d0$export$41fc368e1a942b97 = 180 / $670604c4306869d0$export$18c7bea995a110f;
var $670604c4306869d0$export$8449e153fbd325fc = $670604c4306869d0$export$18c7bea995a110f / 180;
var $670604c4306869d0$export$2335f513bbd82c6d = Math.abs;
var $670604c4306869d0$export$628dc4eed22b0fbd = Math.atan;
var $670604c4306869d0$export$b8b770ee6a0d9760 = Math.atan2;
var $670604c4306869d0$export$50d414a77b60d802 = Math.cos;
var $670604c4306869d0$export$803ce6b71a0a94b2 = Math.ceil;
var $670604c4306869d0$export$b310ec824aaee37f = Math.exp;
var $670604c4306869d0$export$a3fe094919f356fd = Math.floor;
var $670604c4306869d0$export$f95c7888b62f8e9a = Math.hypot;
var $670604c4306869d0$export$bef1f36f5486a6a3 = Math.log;
var $670604c4306869d0$export$9c297f60e22e3389 = Math.pow;
var $670604c4306869d0$export$5de3937cb4b592ed = Math.sin;
var $670604c4306869d0$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $670604c4306869d0$export$eba8049fb5020b81 = Math.sqrt;
var $670604c4306869d0$export$fcdd3b0b3246a325 = Math.tan;
function $670604c4306869d0$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $670604c4306869d0$export$18c7bea995a110f : Math.acos(x);
}
function $670604c4306869d0$export$41726bdb1fc63f(x) {
    return x > 1 ? $670604c4306869d0$export$e51408a300e8929a : x < -1 ? -$670604c4306869d0$export$e51408a300e8929a : Math.asin(x);
}
function $670604c4306869d0$export$e808712c2966e662(x) {
    return (x = $670604c4306869d0$export$5de3937cb4b592ed(x / 2)) * x;
}



function $f233d25ba5a1175b$export$2e2bcd8739ae039() {}


function $2f42e5268a6797f5$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $f3f0691eeedc9e29$export$2e2bcd8739ae039(a, b) {
    return (0, $670604c4306869d0$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $670604c4306869d0$export$6c421550c66a327d) && (0, $670604c4306869d0$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $670604c4306869d0$export$6c421550c66a327d);
}



function $b2af5411bf749438$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $b2af5411bf749438$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $670604c4306869d0$export$6c421550c66a327d);
        }
        subject.push(x = new $b2af5411bf749438$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $b2af5411bf749438$var$Intersection(p0, null, x, false));
        subject.push(x = new $b2af5411bf749438$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $b2af5411bf749438$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $b2af5411bf749438$var$link(subject);
    $b2af5411bf749438$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $b2af5411bf749438$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}



// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $44a48d1cb1f34224$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $44a48d1cb1f34224$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $44a48d1cb1f34224$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $44a48d1cb1f34224$export$5a6391da70c130da(values, valueof) {
    const adder = new $44a48d1cb1f34224$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}



function $36ccb64133f7e1ee$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $670604c4306869d0$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $670604c4306869d0$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $36ccb64133f7e1ee$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $670604c4306869d0$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda),
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi)
    ];
}
function $36ccb64133f7e1ee$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $36ccb64133f7e1ee$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $36ccb64133f7e1ee$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $36ccb64133f7e1ee$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $36ccb64133f7e1ee$export$6789498aec2cb34b(d) {
    var l = (0, $670604c4306869d0$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}



function $3befe798acd13223$var$longitude(point) {
    return (0, $670604c4306869d0$export$2335f513bbd82c6d)(point[0]) <= (0, $670604c4306869d0$export$18c7bea995a110f) ? point[0] : (0, $670604c4306869d0$export$c5552dfdbc7cec71)(point[0]) * (((0, $670604c4306869d0$export$2335f513bbd82c6d)(point[0]) + (0, $670604c4306869d0$export$18c7bea995a110f)) % (0, $670604c4306869d0$export$a4b4b4d4d776fe92) - (0, $670604c4306869d0$export$18c7bea995a110f));
}
function $3befe798acd13223$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $3befe798acd13223$var$longitude(point), phi = point[1], sinPhi = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi), normal = [
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda),
        -(0, $670604c4306869d0$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $670604c4306869d0$export$e51408a300e8929a) + (0, $670604c4306869d0$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $3befe798acd13223$var$longitude(point0), phi0 = point0[1] / 2 + (0, $670604c4306869d0$export$c39a5cba78ea0fc2), sinPhi0 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $3befe798acd13223$var$longitude(point1), phi1 = point1[1] / 2 + (0, $670604c4306869d0$export$c39a5cba78ea0fc2), sinPhi1 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $670604c4306869d0$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $670604c4306869d0$export$b8b770ee6a0d9760)(k * sign * (0, $670604c4306869d0$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $670604c4306869d0$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $670604c4306869d0$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)((0, $36ccb64133f7e1ee$export$6e6697ef026a96)(point0), (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(point1));
                (0, $36ccb64133f7e1ee$export$6789498aec2cb34b)(arc);
                var intersection = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)(normal, arc);
                (0, $36ccb64133f7e1ee$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $670604c4306869d0$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $670604c4306869d0$export$6c421550c66a327d) || angle < (0, $670604c4306869d0$export$6c421550c66a327d) && sum < -(0, $670604c4306869d0$export$92c06fba281fe81b)) ^ winding & 1;
}


function* $54ced0ad7294c1a8$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $54ced0ad7294c1a8$export$2e2bcd8739ae039(arrays) {
    return Array.from($54ced0ad7294c1a8$var$flatten(arrays));
}


function $fbd6c74debefbf49$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $2f42e5268a6797f5$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $54ced0ad7294c1a8$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $3befe798acd13223$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $b2af5411bf749438$export$2e2bcd8739ae039)(segments, $fbd6c74debefbf49$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($fbd6c74debefbf49$var$validSegment));
        }
        return clip;
    };
}
function $fbd6c74debefbf49$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $fbd6c74debefbf49$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d) : (0, $670604c4306869d0$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d) : (0, $670604c4306869d0$export$e51408a300e8929a) - b[1]);
}



var $6887d3a2b3b1b107$export$2e2bcd8739ae039 = (0, $fbd6c74debefbf49$export$2e2bcd8739ae039)(function() {
    return true;
}, $6887d3a2b3b1b107$var$clipAntimeridianLine, $6887d3a2b3b1b107$var$clipAntimeridianInterpolate, [
    -(0, $670604c4306869d0$export$18c7bea995a110f),
    -(0, $670604c4306869d0$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $6887d3a2b3b1b107$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $670604c4306869d0$export$18c7bea995a110f) : -(0, $670604c4306869d0$export$18c7bea995a110f), delta = (0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(delta - (0, $670604c4306869d0$export$18c7bea995a110f)) < (0, $670604c4306869d0$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $670604c4306869d0$export$e51408a300e8929a) : -(0, $670604c4306869d0$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $670604c4306869d0$export$18c7bea995a110f)) {
                if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $670604c4306869d0$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $670604c4306869d0$export$6c421550c66a327d); // handle degeneracies
                if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $670604c4306869d0$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $670604c4306869d0$export$6c421550c66a327d);
                phi0 = $6887d3a2b3b1b107$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $6887d3a2b3b1b107$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $670604c4306869d0$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $670604c4306869d0$export$6c421550c66a327d) ? (0, $670604c4306869d0$export$628dc4eed22b0fbd)(((0, $670604c4306869d0$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi1)) * (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda1) - (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi0)) * (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $6887d3a2b3b1b107$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $670604c4306869d0$export$e51408a300e8929a);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $670604c4306869d0$export$18c7bea995a110f), phi);
        stream.point((0, $670604c4306869d0$export$18c7bea995a110f), 0);
        stream.point((0, $670604c4306869d0$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), -phi);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), 0);
        stream.point(-(0, $670604c4306869d0$export$18c7bea995a110f), phi);
    } else if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $670604c4306869d0$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $670604c4306869d0$export$18c7bea995a110f) : -(0, $670604c4306869d0$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}




function $b8847947ca497f4e$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $2f457a25c4f4f64a$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $f7d73791d6cf97d0$var$rotationIdentity(lambda, phi) {
    if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda) > (0, $670604c4306869d0$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $670604c4306869d0$export$a4b4b4d4d776fe92)) * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
    return [
        lambda,
        phi
    ];
}
$f7d73791d6cf97d0$var$rotationIdentity.invert = $f7d73791d6cf97d0$var$rotationIdentity;
function $f7d73791d6cf97d0$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $670604c4306869d0$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $2f457a25c4f4f64a$export$2e2bcd8739ae039)($f7d73791d6cf97d0$var$rotationLambda(deltaLambda), $f7d73791d6cf97d0$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $f7d73791d6cf97d0$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $f7d73791d6cf97d0$var$rotationPhiGamma(deltaPhi, deltaGamma) : $f7d73791d6cf97d0$var$rotationIdentity;
}
function $f7d73791d6cf97d0$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda) > (0, $670604c4306869d0$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $670604c4306869d0$export$a4b4b4d4d776fe92)) * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
        return [
            lambda,
            phi
        ];
    };
}
function $f7d73791d6cf97d0$var$rotationLambda(deltaLambda) {
    var rotation = $f7d73791d6cf97d0$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $f7d73791d6cf97d0$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $f7d73791d6cf97d0$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $670604c4306869d0$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $670604c4306869d0$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $670604c4306869d0$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(phi), x = (0, $670604c4306869d0$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $670604c4306869d0$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $670604c4306869d0$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $670604c4306869d0$export$50d414a77b60d802)(phi), x = (0, $670604c4306869d0$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $670604c4306869d0$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $670604c4306869d0$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $670604c4306869d0$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $f7d73791d6cf97d0$export$2e2bcd8739ae039(rotate) {
    rotate = $f7d73791d6cf97d0$export$a2ba89726971a90f(rotate[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), rotate[1] * (0, $670604c4306869d0$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $670604c4306869d0$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), coordinates[1] * (0, $670604c4306869d0$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates[1] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), coordinates[1] * (0, $670604c4306869d0$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates[1] *= (0, $670604c4306869d0$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $d53290674478fba6$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $670604c4306869d0$export$50d414a77b60d802)(radius), sinRadius = (0, $670604c4306869d0$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $d53290674478fba6$var$circleRadius(cosRadius, t0);
        t1 = $d53290674478fba6$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $36ccb64133f7e1ee$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $670604c4306869d0$export$50d414a77b60d802)(t),
            -sinRadius * (0, $670604c4306869d0$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $d53290674478fba6$var$circleRadius(cosRadius, point) {
    point = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $36ccb64133f7e1ee$export$6789498aec2cb34b)(point);
    var radius = (0, $670604c4306869d0$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $670604c4306869d0$export$a4b4b4d4d776fe92) - (0, $670604c4306869d0$export$6c421550c66a327d)) % (0, $670604c4306869d0$export$a4b4b4d4d776fe92);
}
function $d53290674478fba6$export$2e2bcd8739ae039() {
    var center = (0, $b8847947ca497f4e$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(90), precision = (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $670604c4306869d0$export$41fc368e1a942b97), x[1] *= (0, $670604c4306869d0$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $670604c4306869d0$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $670604c4306869d0$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $f7d73791d6cf97d0$export$a2ba89726971a90f)(-c[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), -c[1] * (0, $670604c4306869d0$export$8449e153fbd325fc), 0).invert;
        $d53290674478fba6$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $b8847947ca497f4e$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $b8847947ca497f4e$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}





function $24a437a45f982759$export$2e2bcd8739ae039(radius) {
    var cr = (0, $670604c4306869d0$export$50d414a77b60d802)(radius), delta = 6 * (0, $670604c4306869d0$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $670604c4306869d0$export$2335f513bbd82c6d)(cr) > (0, $670604c4306869d0$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $d53290674478fba6$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $670604c4306869d0$export$50d414a77b60d802)(lambda) * (0, $670604c4306869d0$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $670604c4306869d0$export$18c7bea995a110f) : -(0, $670604c4306869d0$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(point0, point2) || (0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $f3f0691eeedc9e29$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(a), pb = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $36ccb64133f7e1ee$export$4763f5351b14293f)(n1, n2), A = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(n1, c1), B = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(n2, c2);
        (0, $36ccb64133f7e1ee$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(A, u), uu = (0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $36ccb64133f7e1ee$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $670604c4306869d0$export$eba8049fb5020b81)(t2), q = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $36ccb64133f7e1ee$export$e62eba72fc898eae)(q, A);
        q = (0, $36ccb64133f7e1ee$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $670604c4306869d0$export$2335f513bbd82c6d)(delta - (0, $670604c4306869d0$export$18c7bea995a110f)) < (0, $670604c4306869d0$export$6c421550c66a327d), meridian = polar || delta < (0, $670604c4306869d0$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $670604c4306869d0$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $670604c4306869d0$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $670604c4306869d0$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $36ccb64133f7e1ee$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $36ccb64133f7e1ee$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $36ccb64133f7e1ee$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $670604c4306869d0$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $fbd6c74debefbf49$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $670604c4306869d0$export$18c7bea995a110f),
        radius - (0, $670604c4306869d0$export$18c7bea995a110f)
    ]);
}




function $b55afac96a294cb9$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $7d62d240b7fd88a7$var$clipMax = 1e9, $7d62d240b7fd88a7$var$clipMin = -$7d62d240b7fd88a7$var$clipMax;
function $7d62d240b7fd88a7$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $670604c4306869d0$export$2335f513bbd82c6d)(p[0] - x0) < (0, $670604c4306869d0$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $670604c4306869d0$export$2335f513bbd82c6d)(p[0] - x1) < (0, $670604c4306869d0$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $670604c4306869d0$export$2335f513bbd82c6d)(p[1] - y0) < (0, $670604c4306869d0$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $2f42e5268a6797f5$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $54ced0ad7294c1a8$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $b2af5411bf749438$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, x_)),
                    y_ = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, y_))
                ], b = [
                    x = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, x)),
                    y = Math.max($7d62d240b7fd88a7$var$clipMin, Math.min($7d62d240b7fd88a7$var$clipMax, y))
                ];
                if ((0, $b55afac96a294cb9$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}



var $523470b6dc0fb943$export$2e2bcd8739ae039 = (x)=>x;




function $0412b2d170387dff$export$2e2bcd8739ae039(methods) {
    return {
        stream: $0412b2d170387dff$export$6b468dcfb64c653c(methods)
    };
}
function $0412b2d170387dff$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $0412b2d170387dff$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $0412b2d170387dff$var$TransformStream() {}
$0412b2d170387dff$var$TransformStream.prototype = {
    constructor: $0412b2d170387dff$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};


function $f64eb890237a613b$var$streamGeometry(geometry, stream) {
    if (geometry && $f64eb890237a613b$var$streamGeometryType.hasOwnProperty(geometry.type)) $f64eb890237a613b$var$streamGeometryType[geometry.type](geometry, stream);
}
var $f64eb890237a613b$var$streamObjectType = {
    Feature: function(object, stream) {
        $f64eb890237a613b$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$f64eb890237a613b$var$streamGeometry(features[i].geometry, stream);
    }
};
var $f64eb890237a613b$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $f64eb890237a613b$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f64eb890237a613b$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $f64eb890237a613b$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f64eb890237a613b$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$f64eb890237a613b$var$streamGeometry(geometries[i], stream);
    }
};
function $f64eb890237a613b$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $f64eb890237a613b$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$f64eb890237a613b$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $f64eb890237a613b$export$2e2bcd8739ae039(object, stream) {
    if (object && $f64eb890237a613b$var$streamObjectType.hasOwnProperty(object.type)) $f64eb890237a613b$var$streamObjectType[object.type](object, stream);
    else $f64eb890237a613b$var$streamGeometry(object, stream);
}



var $efdab2656f7d9ccc$var$x0 = Infinity, $efdab2656f7d9ccc$var$y0 = $efdab2656f7d9ccc$var$x0, $efdab2656f7d9ccc$var$x1 = -$efdab2656f7d9ccc$var$x0, $efdab2656f7d9ccc$var$y1 = $efdab2656f7d9ccc$var$x1;
var $efdab2656f7d9ccc$var$boundsStream = {
    point: $efdab2656f7d9ccc$var$boundsPoint,
    lineStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $efdab2656f7d9ccc$var$x0,
                $efdab2656f7d9ccc$var$y0
            ],
            [
                $efdab2656f7d9ccc$var$x1,
                $efdab2656f7d9ccc$var$y1
            ]
        ];
        $efdab2656f7d9ccc$var$x1 = $efdab2656f7d9ccc$var$y1 = -($efdab2656f7d9ccc$var$y0 = $efdab2656f7d9ccc$var$x0 = Infinity);
        return bounds;
    }
};
function $efdab2656f7d9ccc$var$boundsPoint(x, y) {
    if (x < $efdab2656f7d9ccc$var$x0) $efdab2656f7d9ccc$var$x0 = x;
    if (x > $efdab2656f7d9ccc$var$x1) $efdab2656f7d9ccc$var$x1 = x;
    if (y < $efdab2656f7d9ccc$var$y0) $efdab2656f7d9ccc$var$y0 = y;
    if (y > $efdab2656f7d9ccc$var$y1) $efdab2656f7d9ccc$var$y1 = y;
}
var $efdab2656f7d9ccc$export$2e2bcd8739ae039 = $efdab2656f7d9ccc$var$boundsStream;


function $f635eb16c9b15b07$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projection.stream((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039)));
    fitBounds((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $f635eb16c9b15b07$export$e450184041869e7f(projection, extent, object) {
    return $f635eb16c9b15b07$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $f635eb16c9b15b07$export$33a367fa1728c3ba(projection, size, object) {
    return $f635eb16c9b15b07$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $f635eb16c9b15b07$export$7d8f2192ef31c5a7(projection, width, object) {
    return $f635eb16c9b15b07$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $f635eb16c9b15b07$export$7069bab0d2ced675(projection, height, object) {
    return $f635eb16c9b15b07$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $64af1b85c5f97f77$var$maxDepth = 16, $64af1b85c5f97f77$var$cosMinDistance = (0, $670604c4306869d0$export$50d414a77b60d802)(30 * (0, $670604c4306869d0$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $64af1b85c5f97f77$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $64af1b85c5f97f77$var$resample(project, delta2) : $64af1b85c5f97f77$var$resampleNone(project);
}
function $64af1b85c5f97f77$var$resampleNone(project) {
    return (0, $0412b2d170387dff$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $64af1b85c5f97f77$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $670604c4306869d0$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $670604c4306869d0$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $670604c4306869d0$export$2335f513bbd82c6d)((0, $670604c4306869d0$export$2335f513bbd82c6d)(c) - 1) < (0, $670604c4306869d0$export$6c421550c66a327d) || (0, $670604c4306869d0$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $670604c4306869d0$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $670604c4306869d0$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $670604c4306869d0$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $64af1b85c5f97f77$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $36ccb64133f7e1ee$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $64af1b85c5f97f77$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $64af1b85c5f97f77$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $5ee116a807460c55$var$transformRadians = (0, $0412b2d170387dff$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $670604c4306869d0$export$8449e153fbd325fc), y * (0, $670604c4306869d0$export$8449e153fbd325fc));
    }
});
function $5ee116a807460c55$var$transformRotate(rotate) {
    return (0, $0412b2d170387dff$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $5ee116a807460c55$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $5ee116a807460c55$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $5ee116a807460c55$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $670604c4306869d0$export$50d414a77b60d802)(alpha), sinAlpha = (0, $670604c4306869d0$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $5ee116a807460c55$export$2e2bcd8739ae039(project) {
    return $5ee116a807460c55$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $5ee116a807460c55$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $6887d3a2b3b1b107$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $523470b6dc0fb943$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), point[1] * (0, $670604c4306869d0$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $670604c4306869d0$export$41fc368e1a942b97),
            point[1] * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $5ee116a807460c55$var$transformRadians($5ee116a807460c55$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $24a437a45f982759$export$2e2bcd8739ae039)(theta = _ * (0, $670604c4306869d0$export$8449e153fbd325fc)) : (theta = null, $6887d3a2b3b1b107$export$2e2bcd8739ae039), reset()) : theta * (0, $670604c4306869d0$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $523470b6dc0fb943$export$2e2bcd8739ae039) : (0, $7d62d240b7fd88a7$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $670604c4306869d0$export$41fc368e1a942b97),
            phi * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $670604c4306869d0$export$41fc368e1a942b97),
            deltaPhi * (0, $670604c4306869d0$export$41fc368e1a942b97),
            deltaGamma * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $670604c4306869d0$export$8449e153fbd325fc), recenter()) : alpha * (0, $670604c4306869d0$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $64af1b85c5f97f77$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $670604c4306869d0$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $f635eb16c9b15b07$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $f635eb16c9b15b07$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $f635eb16c9b15b07$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $f635eb16c9b15b07$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $5ee116a807460c55$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $5ee116a807460c55$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $f7d73791d6cf97d0$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $2f457a25c4f4f64a$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $2f457a25c4f4f64a$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $64af1b85c5f97f77$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $91fc065f2c677322$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $670604c4306869d0$export$18c7bea995a110f) / 3, m = (0, $5ee116a807460c55$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $670604c4306869d0$export$8449e153fbd325fc), phi1 = _[1] * (0, $670604c4306869d0$export$8449e153fbd325fc)) : [
            phi0 * (0, $670604c4306869d0$export$41fc368e1a942b97),
            phi1 * (0, $670604c4306869d0$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $5474082c8e90dfac$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $670604c4306869d0$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $670604c4306869d0$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $be3cbe5874066802$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $670604c4306869d0$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $670604c4306869d0$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(n) < (0, $670604c4306869d0$export$6c421550c66a327d)) return (0, $5474082c8e90dfac$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $670604c4306869d0$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $670604c4306869d0$export$eba8049fb5020b81)(c - 2 * n * (0, $670604c4306869d0$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $670604c4306869d0$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x, (0, $670604c4306869d0$export$2335f513bbd82c6d)(r0y)) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(r0y);
        if (r0y * n < 0) l -= (0, $670604c4306869d0$export$18c7bea995a110f) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(x) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(r0y);
        return [
            l / n,
            (0, $670604c4306869d0$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $be3cbe5874066802$export$2e2bcd8739ae039() {
    return (0, $91fc065f2c677322$export$228272587c4d24d8)($be3cbe5874066802$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $189dcd4c41cb3d8a$export$2e2bcd8739ae039() {
    return (0, $be3cbe5874066802$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $dae3a16b5ba78504$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $dae3a16b5ba78504$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $189dcd4c41cb3d8a$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $be3cbe5874066802$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $be3cbe5874066802$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $dae3a16b5ba78504$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.120 * k + (0, $670604c4306869d0$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.234 * k - (0, $670604c4306869d0$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.166 * k + (0, $670604c4306869d0$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $670604c4306869d0$export$6c421550c66a327d),
                y + 0.234 * k - (0, $670604c4306869d0$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $f635eb16c9b15b07$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $f635eb16c9b15b07$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $f635eb16c9b15b07$export$7d8f2192ef31c5a7)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $f635eb16c9b15b07$export$7069bab0d2ced675)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}



function $8549f9238ecb0bb6$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $670604c4306869d0$export$50d414a77b60d802)(x), cy = (0, $670604c4306869d0$export$50d414a77b60d802)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x),
            k * (0, $670604c4306869d0$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $8549f9238ecb0bb6$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $670604c4306869d0$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $670604c4306869d0$export$5de3937cb4b592ed)(c), cc = (0, $670604c4306869d0$export$50d414a77b60d802)(c);
        return [
            (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $670604c4306869d0$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



var $cde1dad42250dd7d$export$5e11f94fc4a8d2c6 = (0, $8549f9238ecb0bb6$export$f1211ac1bdb0796)(function(cxcy) {
    return (0, $670604c4306869d0$export$eba8049fb5020b81)(2 / (1 + cxcy));
});
$cde1dad42250dd7d$export$5e11f94fc4a8d2c6.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $670604c4306869d0$export$41726bdb1fc63f)(z / 2);
});
function $cde1dad42250dd7d$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($cde1dad42250dd7d$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}




var $7a9894a70b3e10e2$export$b94a4d6aa3dd25c = (0, $8549f9238ecb0bb6$export$f1211ac1bdb0796)(function(c) {
    return (c = (0, $670604c4306869d0$export$fd6306be3fde5b04)(c)) && c / (0, $670604c4306869d0$export$5de3937cb4b592ed)(c);
});
$7a9894a70b3e10e2$export$b94a4d6aa3dd25c.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)(function(z) {
    return z;
});
function $7a9894a70b3e10e2$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($7a9894a70b3e10e2$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}






function $ff090f04ba81e8e2$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $670604c4306869d0$export$bef1f36f5486a6a3)((0, $670604c4306869d0$export$fcdd3b0b3246a325)(((0, $670604c4306869d0$export$e51408a300e8929a) + phi) / 2))
    ];
}
$ff090f04ba81e8e2$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)((0, $670604c4306869d0$export$b310ec824aaee37f)(y)) - (0, $670604c4306869d0$export$e51408a300e8929a)
    ];
};
function $ff090f04ba81e8e2$export$2e2bcd8739ae039() {
    return $ff090f04ba81e8e2$export$44b9b66a01f2127b($ff090f04ba81e8e2$export$94ff8a57e9b91cc3).scale(961 / (0, $670604c4306869d0$export$a4b4b4d4d776fe92));
}
function $ff090f04ba81e8e2$export$44b9b66a01f2127b(project) {
    var m = (0, $5ee116a807460c55$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $670604c4306869d0$export$18c7bea995a110f) * scale(), t = m((0, $f7d73791d6cf97d0$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $ff090f04ba81e8e2$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}


function $c71ea640260518ba$var$tany(y) {
    return (0, $670604c4306869d0$export$fcdd3b0b3246a325)(((0, $670604c4306869d0$export$e51408a300e8929a) + y) / 2);
}
function $c71ea640260518ba$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $670604c4306869d0$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $670604c4306869d0$export$5de3937cb4b592ed)(y0) : (0, $670604c4306869d0$export$bef1f36f5486a6a3)(cy0 / (0, $670604c4306869d0$export$50d414a77b60d802)(y1)) / (0, $670604c4306869d0$export$bef1f36f5486a6a3)($c71ea640260518ba$var$tany(y1) / $c71ea640260518ba$var$tany(y0)), f = cy0 * (0, $670604c4306869d0$export$9c297f60e22e3389)($c71ea640260518ba$var$tany(y0), n) / n;
    if (!n) return 0, $ff090f04ba81e8e2$export$94ff8a57e9b91cc3;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $670604c4306869d0$export$e51408a300e8929a) + (0, $670604c4306869d0$export$6c421550c66a327d)) y = -(0, $670604c4306869d0$export$e51408a300e8929a) + (0, $670604c4306869d0$export$6c421550c66a327d);
        } else if (y > (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d)) y = (0, $670604c4306869d0$export$e51408a300e8929a) - (0, $670604c4306869d0$export$6c421550c66a327d);
        var r = f / (0, $670604c4306869d0$export$9c297f60e22e3389)($c71ea640260518ba$var$tany(y), n);
        return [
            r * (0, $670604c4306869d0$export$5de3937cb4b592ed)(n * x),
            f - r * (0, $670604c4306869d0$export$50d414a77b60d802)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $670604c4306869d0$export$c5552dfdbc7cec71)(n) * (0, $670604c4306869d0$export$eba8049fb5020b81)(x * x + fy * fy), l = (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x, (0, $670604c4306869d0$export$2335f513bbd82c6d)(fy)) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(fy);
        if (fy * n < 0) l -= (0, $670604c4306869d0$export$18c7bea995a110f) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(x) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(fy);
        return [
            l / n,
            2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)((0, $670604c4306869d0$export$9c297f60e22e3389)(f / r, 1 / n)) - (0, $670604c4306869d0$export$e51408a300e8929a)
        ];
    };
    return project;
}
function $c71ea640260518ba$export$2e2bcd8739ae039() {
    return (0, $91fc065f2c677322$export$228272587c4d24d8)($c71ea640260518ba$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}




function $b150c6d84b26cddf$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$b150c6d84b26cddf$export$f5fee52180f2f058.invert = $b150c6d84b26cddf$export$f5fee52180f2f058;
function $b150c6d84b26cddf$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($b150c6d84b26cddf$export$f5fee52180f2f058).scale(152.63);
}


function $d8f5b846585bb1cd$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $670604c4306869d0$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $670604c4306869d0$export$5de3937cb4b592ed)(y0) : (cy0 - (0, $670604c4306869d0$export$50d414a77b60d802)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(n) < (0, $670604c4306869d0$export$6c421550c66a327d)) return 0, $b150c6d84b26cddf$export$f5fee52180f2f058;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(nx),
            g - gy * (0, $670604c4306869d0$export$50d414a77b60d802)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $670604c4306869d0$export$b8b770ee6a0d9760)(x, (0, $670604c4306869d0$export$2335f513bbd82c6d)(gy)) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(gy);
        if (gy * n < 0) l -= (0, $670604c4306869d0$export$18c7bea995a110f) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(x) * (0, $670604c4306869d0$export$c5552dfdbc7cec71)(gy);
        return [
            l / n,
            g - (0, $670604c4306869d0$export$c5552dfdbc7cec71)(n) * (0, $670604c4306869d0$export$eba8049fb5020b81)(x * x + gy * gy)
        ];
    };
    return project;
}
function $d8f5b846585bb1cd$export$2e2bcd8739ae039() {
    return (0, $91fc065f2c677322$export$228272587c4d24d8)($d8f5b846585bb1cd$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}



var $fc041bd5ad9011bc$var$A1 = 1.340264, $fc041bd5ad9011bc$var$A2 = -0.081106, $fc041bd5ad9011bc$var$A3 = 0.000893, $fc041bd5ad9011bc$var$A4 = 0.003796, $fc041bd5ad9011bc$var$M = (0, $670604c4306869d0$export$eba8049fb5020b81)(3) / 2, $fc041bd5ad9011bc$var$iterations = 12;
function $fc041bd5ad9011bc$export$a320734067e7a731(lambda, phi) {
    var l = (0, $670604c4306869d0$export$41726bdb1fc63f)($fc041bd5ad9011bc$var$M * (0, $670604c4306869d0$export$5de3937cb4b592ed)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $670604c4306869d0$export$50d414a77b60d802)(l) / ($fc041bd5ad9011bc$var$M * ($fc041bd5ad9011bc$var$A1 + 3 * $fc041bd5ad9011bc$var$A2 * l2 + l6 * (7 * $fc041bd5ad9011bc$var$A3 + 9 * $fc041bd5ad9011bc$var$A4 * l2))),
        l * ($fc041bd5ad9011bc$var$A1 + $fc041bd5ad9011bc$var$A2 * l2 + l6 * ($fc041bd5ad9011bc$var$A3 + $fc041bd5ad9011bc$var$A4 * l2))
    ];
}
$fc041bd5ad9011bc$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $fc041bd5ad9011bc$var$iterations; ++i){
        fy = l * ($fc041bd5ad9011bc$var$A1 + $fc041bd5ad9011bc$var$A2 * l2 + l6 * ($fc041bd5ad9011bc$var$A3 + $fc041bd5ad9011bc$var$A4 * l2)) - y;
        fpy = $fc041bd5ad9011bc$var$A1 + 3 * $fc041bd5ad9011bc$var$A2 * l2 + l6 * (7 * $fc041bd5ad9011bc$var$A3 + 9 * $fc041bd5ad9011bc$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $670604c4306869d0$export$2335f513bbd82c6d)(delta) < (0, $670604c4306869d0$export$92c06fba281fe81b)) break;
    }
    return [
        $fc041bd5ad9011bc$var$M * x * ($fc041bd5ad9011bc$var$A1 + 3 * $fc041bd5ad9011bc$var$A2 * l2 + l6 * (7 * $fc041bd5ad9011bc$var$A3 + 9 * $fc041bd5ad9011bc$var$A4 * l2)) / (0, $670604c4306869d0$export$50d414a77b60d802)(l),
        (0, $670604c4306869d0$export$41726bdb1fc63f)((0, $670604c4306869d0$export$5de3937cb4b592ed)(l) / $fc041bd5ad9011bc$var$M)
    ];
};
function $fc041bd5ad9011bc$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($fc041bd5ad9011bc$export$a320734067e7a731).scale(177.158);
}




function $ec357a35bfb88504$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $670604c4306869d0$export$50d414a77b60d802)(y), k = (0, $670604c4306869d0$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x) / k,
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(y) / k
    ];
}
$ec357a35bfb88504$export$dc8c6ddfc8b22c85.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)((0, $670604c4306869d0$export$628dc4eed22b0fbd));
function $ec357a35bfb88504$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($ec357a35bfb88504$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}




function $5bed72effbe81a9c$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $670604c4306869d0$export$50d414a77b60d802)(y) * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x),
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(y)
    ];
}
$5bed72effbe81a9c$export$1cd9c2eb846182a.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)((0, $670604c4306869d0$export$41726bdb1fc63f));
function $5bed72effbe81a9c$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($5bed72effbe81a9c$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $670604c4306869d0$export$6c421550c66a327d));
}






var $aac5fcedac7c8011$var$areaSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $aac5fcedac7c8011$var$areaRingSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $aac5fcedac7c8011$var$x00, $aac5fcedac7c8011$var$y00, $aac5fcedac7c8011$var$x0, $aac5fcedac7c8011$var$y0;
var $aac5fcedac7c8011$var$areaStream = {
    point: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonStart: function() {
        $aac5fcedac7c8011$var$areaStream.lineStart = $aac5fcedac7c8011$var$areaRingStart;
        $aac5fcedac7c8011$var$areaStream.lineEnd = $aac5fcedac7c8011$var$areaRingEnd;
    },
    polygonEnd: function() {
        $aac5fcedac7c8011$var$areaStream.lineStart = $aac5fcedac7c8011$var$areaStream.lineEnd = $aac5fcedac7c8011$var$areaStream.point = (0, $f233d25ba5a1175b$export$2e2bcd8739ae039);
        $aac5fcedac7c8011$var$areaSum.add((0, $670604c4306869d0$export$2335f513bbd82c6d)($aac5fcedac7c8011$var$areaRingSum));
        $aac5fcedac7c8011$var$areaRingSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $aac5fcedac7c8011$var$areaSum / 2;
        $aac5fcedac7c8011$var$areaSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
        return area;
    }
};
function $aac5fcedac7c8011$var$areaRingStart() {
    $aac5fcedac7c8011$var$areaStream.point = $aac5fcedac7c8011$var$areaPointFirst;
}
function $aac5fcedac7c8011$var$areaPointFirst(x, y) {
    $aac5fcedac7c8011$var$areaStream.point = $aac5fcedac7c8011$var$areaPoint;
    $aac5fcedac7c8011$var$x00 = $aac5fcedac7c8011$var$x0 = x, $aac5fcedac7c8011$var$y00 = $aac5fcedac7c8011$var$y0 = y;
}
function $aac5fcedac7c8011$var$areaPoint(x, y) {
    $aac5fcedac7c8011$var$areaRingSum.add($aac5fcedac7c8011$var$y0 * x - $aac5fcedac7c8011$var$x0 * y);
    $aac5fcedac7c8011$var$x0 = x, $aac5fcedac7c8011$var$y0 = y;
}
function $aac5fcedac7c8011$var$areaRingEnd() {
    $aac5fcedac7c8011$var$areaPoint($aac5fcedac7c8011$var$x00, $aac5fcedac7c8011$var$y00);
}
var $aac5fcedac7c8011$export$2e2bcd8739ae039 = $aac5fcedac7c8011$var$areaStream;




// TODO Enforce positive area for exterior, negative area for interior?
var $8d0804faef1e75f0$var$X0 = 0, $8d0804faef1e75f0$var$Y0 = 0, $8d0804faef1e75f0$var$Z0 = 0, $8d0804faef1e75f0$var$X1 = 0, $8d0804faef1e75f0$var$Y1 = 0, $8d0804faef1e75f0$var$Z1 = 0, $8d0804faef1e75f0$var$X2 = 0, $8d0804faef1e75f0$var$Y2 = 0, $8d0804faef1e75f0$var$Z2 = 0, $8d0804faef1e75f0$var$x00, $8d0804faef1e75f0$var$y00, $8d0804faef1e75f0$var$x0, $8d0804faef1e75f0$var$y0;
var $8d0804faef1e75f0$var$centroidStream = {
    point: $8d0804faef1e75f0$var$centroidPoint,
    lineStart: $8d0804faef1e75f0$var$centroidLineStart,
    lineEnd: $8d0804faef1e75f0$var$centroidLineEnd,
    polygonStart: function() {
        $8d0804faef1e75f0$var$centroidStream.lineStart = $8d0804faef1e75f0$var$centroidRingStart;
        $8d0804faef1e75f0$var$centroidStream.lineEnd = $8d0804faef1e75f0$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPoint;
        $8d0804faef1e75f0$var$centroidStream.lineStart = $8d0804faef1e75f0$var$centroidLineStart;
        $8d0804faef1e75f0$var$centroidStream.lineEnd = $8d0804faef1e75f0$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $8d0804faef1e75f0$var$Z2 ? [
            $8d0804faef1e75f0$var$X2 / $8d0804faef1e75f0$var$Z2,
            $8d0804faef1e75f0$var$Y2 / $8d0804faef1e75f0$var$Z2
        ] : $8d0804faef1e75f0$var$Z1 ? [
            $8d0804faef1e75f0$var$X1 / $8d0804faef1e75f0$var$Z1,
            $8d0804faef1e75f0$var$Y1 / $8d0804faef1e75f0$var$Z1
        ] : $8d0804faef1e75f0$var$Z0 ? [
            $8d0804faef1e75f0$var$X0 / $8d0804faef1e75f0$var$Z0,
            $8d0804faef1e75f0$var$Y0 / $8d0804faef1e75f0$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $8d0804faef1e75f0$var$X0 = $8d0804faef1e75f0$var$Y0 = $8d0804faef1e75f0$var$Z0 = $8d0804faef1e75f0$var$X1 = $8d0804faef1e75f0$var$Y1 = $8d0804faef1e75f0$var$Z1 = $8d0804faef1e75f0$var$X2 = $8d0804faef1e75f0$var$Y2 = $8d0804faef1e75f0$var$Z2 = 0;
        return centroid;
    }
};
function $8d0804faef1e75f0$var$centroidPoint(x, y) {
    $8d0804faef1e75f0$var$X0 += x;
    $8d0804faef1e75f0$var$Y0 += y;
    ++$8d0804faef1e75f0$var$Z0;
}
function $8d0804faef1e75f0$var$centroidLineStart() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointFirstLine;
}
function $8d0804faef1e75f0$var$centroidPointFirstLine(x, y) {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointLine;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidPointLine(x, y) {
    var dx = x - $8d0804faef1e75f0$var$x0, dy = y - $8d0804faef1e75f0$var$y0, z = (0, $670604c4306869d0$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $8d0804faef1e75f0$var$X1 += z * ($8d0804faef1e75f0$var$x0 + x) / 2;
    $8d0804faef1e75f0$var$Y1 += z * ($8d0804faef1e75f0$var$y0 + y) / 2;
    $8d0804faef1e75f0$var$Z1 += z;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidLineEnd() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPoint;
}
function $8d0804faef1e75f0$var$centroidRingStart() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointFirstRing;
}
function $8d0804faef1e75f0$var$centroidRingEnd() {
    $8d0804faef1e75f0$var$centroidPointRing($8d0804faef1e75f0$var$x00, $8d0804faef1e75f0$var$y00);
}
function $8d0804faef1e75f0$var$centroidPointFirstRing(x, y) {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointRing;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x00 = $8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y00 = $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidPointRing(x, y) {
    var dx = x - $8d0804faef1e75f0$var$x0, dy = y - $8d0804faef1e75f0$var$y0, z = (0, $670604c4306869d0$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $8d0804faef1e75f0$var$X1 += z * ($8d0804faef1e75f0$var$x0 + x) / 2;
    $8d0804faef1e75f0$var$Y1 += z * ($8d0804faef1e75f0$var$y0 + y) / 2;
    $8d0804faef1e75f0$var$Z1 += z;
    z = $8d0804faef1e75f0$var$y0 * x - $8d0804faef1e75f0$var$x0 * y;
    $8d0804faef1e75f0$var$X2 += z * ($8d0804faef1e75f0$var$x0 + x);
    $8d0804faef1e75f0$var$Y2 += z * ($8d0804faef1e75f0$var$y0 + y);
    $8d0804faef1e75f0$var$Z2 += z * 3;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
var $8d0804faef1e75f0$export$2e2bcd8739ae039 = $8d0804faef1e75f0$var$centroidStream;




function $bc272bd0e70c3e89$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$bc272bd0e70c3e89$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $670604c4306869d0$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039)
};





var $9d42a1f4ad2437ef$var$lengthSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $9d42a1f4ad2437ef$var$lengthRing, $9d42a1f4ad2437ef$var$x00, $9d42a1f4ad2437ef$var$y00, $9d42a1f4ad2437ef$var$x0, $9d42a1f4ad2437ef$var$y0;
var $9d42a1f4ad2437ef$var$lengthStream = {
    point: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineStart: function() {
        $9d42a1f4ad2437ef$var$lengthStream.point = $9d42a1f4ad2437ef$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($9d42a1f4ad2437ef$var$lengthRing) $9d42a1f4ad2437ef$var$lengthPoint($9d42a1f4ad2437ef$var$x00, $9d42a1f4ad2437ef$var$y00);
        $9d42a1f4ad2437ef$var$lengthStream.point = (0, $f233d25ba5a1175b$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $9d42a1f4ad2437ef$var$lengthRing = true;
    },
    polygonEnd: function() {
        $9d42a1f4ad2437ef$var$lengthRing = null;
    },
    result: function() {
        var length = +$9d42a1f4ad2437ef$var$lengthSum;
        $9d42a1f4ad2437ef$var$lengthSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
        return length;
    }
};
function $9d42a1f4ad2437ef$var$lengthPointFirst(x, y) {
    $9d42a1f4ad2437ef$var$lengthStream.point = $9d42a1f4ad2437ef$var$lengthPoint;
    $9d42a1f4ad2437ef$var$x00 = $9d42a1f4ad2437ef$var$x0 = x, $9d42a1f4ad2437ef$var$y00 = $9d42a1f4ad2437ef$var$y0 = y;
}
function $9d42a1f4ad2437ef$var$lengthPoint(x, y) {
    $9d42a1f4ad2437ef$var$x0 -= x, $9d42a1f4ad2437ef$var$y0 -= y;
    $9d42a1f4ad2437ef$var$lengthSum.add((0, $670604c4306869d0$export$eba8049fb5020b81)($9d42a1f4ad2437ef$var$x0 * $9d42a1f4ad2437ef$var$x0 + $9d42a1f4ad2437ef$var$y0 * $9d42a1f4ad2437ef$var$y0));
    $9d42a1f4ad2437ef$var$x0 = x, $9d42a1f4ad2437ef$var$y0 = y;
}
var $9d42a1f4ad2437ef$export$2e2bcd8739ae039 = $9d42a1f4ad2437ef$var$lengthStream;


// Simple caching for constant-radius points.
let $eeca8dbd32c6e6b7$var$cacheDigits, $eeca8dbd32c6e6b7$var$cacheAppend, $eeca8dbd32c6e6b7$var$cacheRadius, $eeca8dbd32c6e6b7$var$cacheCircle;
class $eeca8dbd32c6e6b7$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $eeca8dbd32c6e6b7$var$append : $eeca8dbd32c6e6b7$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $eeca8dbd32c6e6b7$var$cacheRadius || this._append !== $eeca8dbd32c6e6b7$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $eeca8dbd32c6e6b7$var$cacheRadius = r;
                    $eeca8dbd32c6e6b7$var$cacheAppend = this._append;
                    $eeca8dbd32c6e6b7$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $eeca8dbd32c6e6b7$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $eeca8dbd32c6e6b7$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $eeca8dbd32c6e6b7$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $eeca8dbd32c6e6b7$var$append;
    if (d !== $eeca8dbd32c6e6b7$var$cacheDigits) {
        const k = 10 ** d;
        $eeca8dbd32c6e6b7$var$cacheDigits = d;
        $eeca8dbd32c6e6b7$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $eeca8dbd32c6e6b7$var$cacheAppend;
}


function $58c46562f4a8d739$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $aac5fcedac7c8011$export$2e2bcd8739ae039)));
        return (0, $aac5fcedac7c8011$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $9d42a1f4ad2437ef$export$2e2bcd8739ae039)));
        return (0, $9d42a1f4ad2437ef$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039)));
        return (0, $efdab2656f7d9ccc$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $8d0804faef1e75f0$export$2e2bcd8739ae039)));
        return (0, $8d0804faef1e75f0$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $523470b6dc0fb943$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $eeca8dbd32c6e6b7$export$2e2bcd8739ae039)(digits)) : new (0, $bc272bd0e70c3e89$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $eeca8dbd32c6e6b7$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}




function $30512e786dc906d9$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $670604c4306869d0$export$50d414a77b60d802)(y), k = 1 + (0, $670604c4306869d0$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $670604c4306869d0$export$5de3937cb4b592ed)(x) / k,
        (0, $670604c4306869d0$export$5de3937cb4b592ed)(y) / k
    ];
}
$30512e786dc906d9$export$f9ccbb0dcb3dcd2b.invert = (0, $8549f9238ecb0bb6$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)(z);
});
function $30512e786dc906d9$export$2e2bcd8739ae039() {
    return (0, $5ee116a807460c55$export$2e2bcd8739ae039)($30512e786dc906d9$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}



function $75766842dfa94e14$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $670604c4306869d0$export$bef1f36f5486a6a3)((0, $670604c4306869d0$export$fcdd3b0b3246a325)(((0, $670604c4306869d0$export$e51408a300e8929a) + phi) / 2)),
        -lambda
    ];
}
$75766842dfa94e14$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $670604c4306869d0$export$628dc4eed22b0fbd)((0, $670604c4306869d0$export$b310ec824aaee37f)(x)) - (0, $670604c4306869d0$export$e51408a300e8929a)
    ];
};
function $75766842dfa94e14$export$2e2bcd8739ae039() {
    var m = (0, $ff090f04ba81e8e2$export$44b9b66a01f2127b)($75766842dfa94e14$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}




var $bfWFq = parcelRequire("bfWFq");

var $bYoiY = parcelRequire("bYoiY");
const $70576c5c5ae147f6$export$8449e153fbd325fc = Math.PI / 180;
const $70576c5c5ae147f6$export$41fc368e1a942b97 = 180 / Math.PI;


// https://observablehq.com/@mbostock/lab-and-rgb
const $80e69e9a1ed94a67$var$K = 18, $80e69e9a1ed94a67$var$Xn = 0.96422, $80e69e9a1ed94a67$var$Yn = 1, $80e69e9a1ed94a67$var$Zn = 0.82521, $80e69e9a1ed94a67$var$t0 = 4 / 29, $80e69e9a1ed94a67$var$t1 = 6 / 29, $80e69e9a1ed94a67$var$t2 = 3 * $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1, $80e69e9a1ed94a67$var$t3 = $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1 * $80e69e9a1ed94a67$var$t1;
function $80e69e9a1ed94a67$var$labConvert(o) {
    if (o instanceof $80e69e9a1ed94a67$export$f2722c70a60257f7) return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $80e69e9a1ed94a67$export$d9397e094a5fbb9a) return $80e69e9a1ed94a67$var$hcl2lab(o);
    if (!(o instanceof (0, $bYoiY.Rgb))) o = (0, $bYoiY.rgbConvert)(o);
    var r = $80e69e9a1ed94a67$var$rgb2lrgb(o.r), g = $80e69e9a1ed94a67$var$rgb2lrgb(o.g), b = $80e69e9a1ed94a67$var$rgb2lrgb(o.b), y = $80e69e9a1ed94a67$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $80e69e9a1ed94a67$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $80e69e9a1ed94a67$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $80e69e9a1ed94a67$var$Xn);
        z = $80e69e9a1ed94a67$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $80e69e9a1ed94a67$var$Zn);
    }
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $80e69e9a1ed94a67$export$3e2c219d3ab79d01(l, opacity) {
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$labConvert(l) : new $80e69e9a1ed94a67$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)($80e69e9a1ed94a67$export$f2722c70a60257f7, $80e69e9a1ed94a67$export$2e2bcd8739ae039, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        return new $80e69e9a1ed94a67$export$f2722c70a60257f7(this.l + $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $80e69e9a1ed94a67$export$f2722c70a60257f7(this.l - $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $80e69e9a1ed94a67$var$Xn * $80e69e9a1ed94a67$var$lab2xyz(x);
        y = $80e69e9a1ed94a67$var$Yn * $80e69e9a1ed94a67$var$lab2xyz(y);
        z = $80e69e9a1ed94a67$var$Zn * $80e69e9a1ed94a67$var$lab2xyz(z);
        return new (0, $bYoiY.Rgb)($80e69e9a1ed94a67$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $80e69e9a1ed94a67$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $80e69e9a1ed94a67$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $80e69e9a1ed94a67$var$xyz2lab(t) {
    return t > $80e69e9a1ed94a67$var$t3 ? Math.pow(t, 1 / 3) : t / $80e69e9a1ed94a67$var$t2 + $80e69e9a1ed94a67$var$t0;
}
function $80e69e9a1ed94a67$var$lab2xyz(t) {
    return t > $80e69e9a1ed94a67$var$t1 ? t * t * t : $80e69e9a1ed94a67$var$t2 * (t - $80e69e9a1ed94a67$var$t0);
}
function $80e69e9a1ed94a67$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $80e69e9a1ed94a67$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $80e69e9a1ed94a67$var$hclConvert(o) {
    if (o instanceof $80e69e9a1ed94a67$export$d9397e094a5fbb9a) return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $80e69e9a1ed94a67$export$f2722c70a60257f7)) o = $80e69e9a1ed94a67$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $70576c5c5ae147f6$export$41fc368e1a942b97);
    return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $80e69e9a1ed94a67$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$hclConvert(l) : new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $80e69e9a1ed94a67$var$hclConvert(h) : new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $80e69e9a1ed94a67$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $80e69e9a1ed94a67$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $70576c5c5ae147f6$export$8449e153fbd325fc);
    return new $80e69e9a1ed94a67$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $bfWFq.default)($80e69e9a1ed94a67$export$d9397e094a5fbb9a, $80e69e9a1ed94a67$export$d0e870ba50062ff1, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(this.h, this.c, this.l + $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $80e69e9a1ed94a67$export$d9397e094a5fbb9a(this.h, this.c, this.l - $80e69e9a1ed94a67$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $80e69e9a1ed94a67$var$hcl2lab(this).rgb();
    }
}));



function $86158b7019ca6112$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $80e69e9a1ed94a67$export$d0e870ba50062ff1)(start)).h, (end = (0, $80e69e9a1ed94a67$export$d0e870ba50062ff1)(end)).h), c = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $86158b7019ca6112$export$2e2bcd8739ae039 = $86158b7019ca6112$var$hcl((0, $529dc8928f6a4077$export$97d7b0c7ddb78dcf));
var $86158b7019ca6112$export$5aaa50f7615f9b70 = $86158b7019ca6112$var$hcl((0, $529dc8928f6a4077$export$2e2bcd8739ae039));


var $bYoiY = parcelRequire("bYoiY");

function $852106acfdc40efe$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $bYoiY.hsl)(start)).h, (end = (0, $bYoiY.hsl)(end)).h), s = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $852106acfdc40efe$export$2e2bcd8739ae039 = $852106acfdc40efe$var$hsl((0, $529dc8928f6a4077$export$97d7b0c7ddb78dcf));
var $852106acfdc40efe$export$a2c535e270a59256 = $852106acfdc40efe$var$hsl((0, $529dc8928f6a4077$export$2e2bcd8739ae039));



function $5eb07f15d29dfb2b$export$2e2bcd8739ae039(start, end) {
    var l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)((start = (0, $80e69e9a1ed94a67$export$2e2bcd8739ae039)(start)).l, (end = (0, $80e69e9a1ed94a67$export$2e2bcd8739ae039)(end)).l), a = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.a, end.a), b = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $25f2a121ae5a240e$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $8385105b4986daed$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

function $4f501ce7bede8755$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}


const $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c9f66a4d1c06b373$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c9f66a4d1c06b373$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c9f66a4d1c06b373$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c9f66a4d1c06b373$var$append : $c9f66a4d1c06b373$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._append`A${r},${r},0,${+(da >= $c9f66a4d1c06b373$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c9f66a4d1c06b373$export$bb654e07daaf8c3a() {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c9f66a4d1c06b373$export$bb654e07daaf8c3a.prototype = $c9f66a4d1c06b373$export$4b2950bdac9b6ee9.prototype;
function $c9f66a4d1c06b373$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9(+digits);
}




// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $e8a0bfad26e955e5$var$mul = 0x19660D;
const $e8a0bfad26e955e5$var$inc = 0x3C6EF35F;
const $e8a0bfad26e955e5$var$eps = 1 / 0x100000000;
function $e8a0bfad26e955e5$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $e8a0bfad26e955e5$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $e8a0bfad26e955e5$var$mul * state + $e8a0bfad26e955e5$var$inc | 0, $e8a0bfad26e955e5$var$eps * (state >>> 0));
}



function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}




const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}





const $a6e17c0ec55d7735$var$ascendingBisect = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $63cbeabc75241824$export$2e2bcd8739ae039));
const $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
const $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
const $a6e17c0ec55d7735$export$c1cb828b1117c77b = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $591ad978f2ce6133$export$2e2bcd8739ae039)).center;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;



function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}


var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $acd329741cbdf381$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $8385105b4986daed$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $afe237385175446a$export$f0954fd7d5368655) clamp = $afe237385175446a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $c0f8a9efb1caa699$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $afe237385175446a$export$f0954fd7d5368655, rescale()) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039() {
    return $afe237385175446a$export$6b468dcfb64c653c()($afe237385175446a$export$f0954fd7d5368655, $afe237385175446a$export$f0954fd7d5368655);
}








function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1589426e0436f502$export$2e2bcd8739ae039)(max) - (0, $1589426e0436f502$export$2e2bcd8739ae039)(step)) + 1;
}


function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $162912dc121d0934$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $54a757fa53542946$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $d27f2d3c2137f747$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $f4e256a3cb9c44da$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
}


function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $b0a07d06c8b316c1$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}




function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $5bf2f979a0299157$var$transformLog(x) {
    return Math.log(x);
}
function $5bf2f979a0299157$var$transformExp(x) {
    return Math.exp(x);
}
function $5bf2f979a0299157$var$transformLogn(x) {
    return -Math.log(-x);
}
function $5bf2f979a0299157$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $5bf2f979a0299157$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $5bf2f979a0299157$var$powp(base) {
    return base === 10 ? $5bf2f979a0299157$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $5bf2f979a0299157$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $5bf2f979a0299157$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $5bf2f979a0299157$export$860836db074028f0(transform) {
    const scale = transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $5bf2f979a0299157$var$logp(base), pows = $5bf2f979a0299157$var$powp(base);
        if (domain()[0] < 0) {
            logs = $5bf2f979a0299157$var$reflect(logs), pows = $5bf2f979a0299157$var$reflect(pows);
            transform($5bf2f979a0299157$var$transformLogn, $5bf2f979a0299157$var$transformExpn);
        } else transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $5bf2f979a0299157$export$2e2bcd8739ae039() {
    const scale = $5bf2f979a0299157$export$860836db074028f0((0, $afe237385175446a$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $afe237385175446a$export$784d13d8ee351f07)(scale, $5bf2f979a0299157$export$2e2bcd8739ae039()).base(scale.base());
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}










function $cb758ed0dff37844$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $cb758ed0dff37844$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $cb758ed0dff37844$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($cb758ed0dff37844$var$transformSymlog(c), $cb758ed0dff37844$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($cb758ed0dff37844$var$transformSymlog(c = +_), $cb758ed0dff37844$var$transformSymexp(c)) : c;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $cb758ed0dff37844$export$2e2bcd8739ae039() {
    var scale = $cb758ed0dff37844$export$4602684e614eba38((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $cb758ed0dff37844$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $d97c146f4f811488$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d97c146f4f811488$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d97c146f4f811488$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d97c146f4f811488$export$34695211ec403a46(transform) {
    var scale = transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($d97c146f4f811488$var$transformSqrt, $d97c146f4f811488$var$transformSquare) : transform($d97c146f4f811488$var$transformPow(exponent), $d97c146f4f811488$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $d97c146f4f811488$export$2e2bcd8739ae039() {
    var scale = $d97c146f4f811488$export$34695211ec403a46((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $d97c146f4f811488$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $d97c146f4f811488$export$eba8049fb5020b81() {
    return $d97c146f4f811488$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $f9c43af42f8b19e4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $afe237385175446a$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $8385105b4986daed$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $c0f8a9efb1caa699$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $f9c43af42f8b19e4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $f9c43af42f8b19e4$export$2e2bcd8739ae039() {
    var scale = (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)($f9c43af42f8b19e4$var$transformer()((0, $afe237385175446a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$2e2bcd8739ae039());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$6843e08bf2ff981f() {
    var scale = (0, $5bf2f979a0299157$export$860836db074028f0)($f9c43af42f8b19e4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$9d4af4de62c81941() {
    var scale = (0, $cb758ed0dff37844$export$4602684e614eba38)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$de9f78581b4f2405() {
    var scale = (0, $d97c146f4f811488$export$34695211ec403a46)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$413d935127ed466e() {
    return $f9c43af42f8b19e4$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}




function $19e76371916c670d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $afe237385175446a$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $8385105b4986daed$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $c0f8a9efb1caa699$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $19e76371916c670d$export$2e2bcd8739ae039() {
    var scale = (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)($19e76371916c670d$var$transformer()((0, $afe237385175446a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$2e2bcd8739ae039());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$5f0266a9159c47fb() {
    var scale = (0, $5bf2f979a0299157$export$860836db074028f0)($19e76371916c670d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$50b3da713cf557c6() {
    var scale = (0, $cb758ed0dff37844$export$4602684e614eba38)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$d6cedcc63bf26e7e() {
    var scale = (0, $d97c146f4f811488$export$34695211ec403a46)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $f9c43af42f8b19e4$export$784d13d8ee351f07)(scale, $19e76371916c670d$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $5b694e64f5326630$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $19e76371916c670d$export$33ddefb5c4ab9e9c() {
    return $19e76371916c670d$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}



function $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}



function $96238d247b54f1ee$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $231c9024a6754413$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $63cbeabc75241824$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $96238d247b54f1ee$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}



function $8058838348a44fed$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8058838348a44fed$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
}

const $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $f26fc9b6912de968$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1000;
const $a28c7a35eadfe1f6$export$683905d551c33fa9 = $a28c7a35eadfe1f6$export$79ef0e34099623dc * 60;
const $a28c7a35eadfe1f6$export$4157bf0c8e241659 = $a28c7a35eadfe1f6$export$683905d551c33fa9 * 60;
const $a28c7a35eadfe1f6$export$353686095f4fbf45 = $a28c7a35eadfe1f6$export$4157bf0c8e241659 * 24;
const $a28c7a35eadfe1f6$export$c241eb88520d5016 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 7;
const $a28c7a35eadfe1f6$export$ab95684df7020b26 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 30;
const $a28c7a35eadfe1f6$export$61f8ee2d834c6959 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 365;


const $51fe2e20810fcb40$export$8888529b966033e5 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $51fe2e20810fcb40$export$6657a54f3034cf45 = $51fe2e20810fcb40$export$8888529b966033e5.range;
const $51fe2e20810fcb40$export$c8cbc42cefd47140 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $51fe2e20810fcb40$export$d277e198508549a1 = $51fe2e20810fcb40$export$c8cbc42cefd47140.range;
const $51fe2e20810fcb40$export$fb065be2d7ea4a71 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45));
});
const $51fe2e20810fcb40$export$a491caaf5e9481aa = $51fe2e20810fcb40$export$fb065be2d7ea4a71.range;



const $9472e71f07850dab$export$46c68a5833bc315b = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc) - date.getMinutes() * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $9472e71f07850dab$export$fb843f9087cd5235 = $9472e71f07850dab$export$46c68a5833bc315b.range;
const $9472e71f07850dab$export$31f6f2b3c63ac75e = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $9472e71f07850dab$export$6e7a76cd5f50b719 = $9472e71f07850dab$export$31f6f2b3c63ac75e.range;



const $292297f992a3b17e$export$a7e4c34a52f0576 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $292297f992a3b17e$export$186d65358374c0a2 = $292297f992a3b17e$export$a7e4c34a52f0576.range;
const $292297f992a3b17e$export$efe6712d6003761b = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $292297f992a3b17e$export$cedd563624e8ee50 = $292297f992a3b17e$export$efe6712d6003761b.range;


const $031c190f93ea3efa$export$7e1084fb688591c1 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $031c190f93ea3efa$export$3e24aa839cd0f1c4 = $031c190f93ea3efa$export$7e1084fb688591c1.range;
const $031c190f93ea3efa$export$cd49b3d2bcfe50d5 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $031c190f93ea3efa$export$49159f585997498 = $031c190f93ea3efa$export$cd49b3d2bcfe50d5.range;



const $490d5c36270b8fcb$export$3d3c77ce7df7d30d = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$export$3d3c77ce7df7d30d.range;




const $79ec6c01997bf022$export$edc5e5cb87280477 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$export$edc5e5cb87280477;
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$export$edc5e5cb87280477.range;








function $7f6029921eecd017$var$timeWeekday(i) {
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
const $7f6029921eecd017$export$22ee6205b762968c = $7f6029921eecd017$var$timeWeekday(0);
const $7f6029921eecd017$export$e79bbe0177cf1b01 = $7f6029921eecd017$var$timeWeekday(1);
const $7f6029921eecd017$export$57c0658c29f77708 = $7f6029921eecd017$var$timeWeekday(2);
const $7f6029921eecd017$export$3fbeef226c256e43 = $7f6029921eecd017$var$timeWeekday(3);
const $7f6029921eecd017$export$608689422d5cf9f4 = $7f6029921eecd017$var$timeWeekday(4);
const $7f6029921eecd017$export$548e5227aa183dca = $7f6029921eecd017$var$timeWeekday(5);
const $7f6029921eecd017$export$c56a3ad248908e19 = $7f6029921eecd017$var$timeWeekday(6);
const $7f6029921eecd017$export$eac514c8a8674eba = $7f6029921eecd017$export$22ee6205b762968c.range;
const $7f6029921eecd017$export$f7219b1481948356 = $7f6029921eecd017$export$e79bbe0177cf1b01.range;
const $7f6029921eecd017$export$77e22b12c5bed05b = $7f6029921eecd017$export$57c0658c29f77708.range;
const $7f6029921eecd017$export$b85d407a471809e8 = $7f6029921eecd017$export$3fbeef226c256e43.range;
const $7f6029921eecd017$export$c1bc1c49254c8855 = $7f6029921eecd017$export$608689422d5cf9f4.range;
const $7f6029921eecd017$export$3691a1557fff46f1 = $7f6029921eecd017$export$548e5227aa183dca.range;
const $7f6029921eecd017$export$b755452d02cba8d2 = $7f6029921eecd017$export$c56a3ad248908e19.range;
function $7f6029921eecd017$var$utcWeekday(i) {
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
const $7f6029921eecd017$export$4898b06303a92011 = $7f6029921eecd017$var$utcWeekday(0);
const $7f6029921eecd017$export$9cfc53b9cfafd080 = $7f6029921eecd017$var$utcWeekday(1);
const $7f6029921eecd017$export$2a6d545f77eceb15 = $7f6029921eecd017$var$utcWeekday(2);
const $7f6029921eecd017$export$a5c25d8ed64433c4 = $7f6029921eecd017$var$utcWeekday(3);
const $7f6029921eecd017$export$1db08111baec2f53 = $7f6029921eecd017$var$utcWeekday(4);
const $7f6029921eecd017$export$29265e34dd5921f7 = $7f6029921eecd017$var$utcWeekday(5);
const $7f6029921eecd017$export$85b74dad05049604 = $7f6029921eecd017$var$utcWeekday(6);
const $7f6029921eecd017$export$6f3e1c2b0f7d7880 = $7f6029921eecd017$export$4898b06303a92011.range;
const $7f6029921eecd017$export$1d2d8b858bb366f9 = $7f6029921eecd017$export$9cfc53b9cfafd080.range;
const $7f6029921eecd017$export$1d5f6785fc7f30f8 = $7f6029921eecd017$export$2a6d545f77eceb15.range;
const $7f6029921eecd017$export$7a75faf0e37ef4af = $7f6029921eecd017$export$a5c25d8ed64433c4.range;
const $7f6029921eecd017$export$417eb959611b2f2f = $7f6029921eecd017$export$1db08111baec2f53.range;
const $7f6029921eecd017$export$59d308db7af08c64 = $7f6029921eecd017$export$29265e34dd5921f7.range;
const $7f6029921eecd017$export$a124108a0a7f34c8 = $7f6029921eecd017$export$85b74dad05049604.range;




const $dd6e0f506bfbbd03$export$cd17cfe45df0c046 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$69a4e90dd2cc3bd1 = $dd6e0f506bfbbd03$export$cd17cfe45df0c046.range;
const $dd6e0f506bfbbd03$export$d5c3802e389714c4 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$3e24d311e17f5802 = $dd6e0f506bfbbd03$export$d5c3802e389714c4.range;


function $047ba3ec3f41562e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            1,
            (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $a28c7a35eadfe1f6$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $a28c7a35eadfe1f6$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $a28c7a35eadfe1f6$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $a28c7a35eadfe1f6$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $a28c7a35eadfe1f6$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start / (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959), stop / (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $79ec6c01997bf022$export$edc5e5cb87280477).every(Math.max((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$047ba3ec3f41562e$export$826ba5ae907e9767, $047ba3ec3f41562e$export$6262d8d056ea44c4] = $047ba3ec3f41562e$var$ticker((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4), (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5), (0, $7f6029921eecd017$export$4898b06303a92011), (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71), (0, $9472e71f07850dab$export$31f6f2b3c63ac75e), (0, $292297f992a3b17e$export$efe6712d6003761b));
const [$047ba3ec3f41562e$export$60c76498552d28a6, $047ba3ec3f41562e$export$69511150134dd174] = $047ba3ec3f41562e$var$ticker((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046), (0, $031c190f93ea3efa$export$7e1084fb688591c1), (0, $7f6029921eecd017$export$22ee6205b762968c), (0, $51fe2e20810fcb40$export$8888529b966033e5), (0, $9472e71f07850dab$export$46c68a5833bc315b), (0, $292297f992a3b17e$export$a7e4c34a52f0576));



function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$9cfc53b9cfafd080).ceil(week) : (0, $7f6029921eecd017$export$9cfc53b9cfafd080)(week);
                    week = (0, $51fe2e20810fcb40$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$e79bbe0177cf1b01).ceil(week) : (0, $7f6029921eecd017$export$e79bbe0177cf1b01)(week);
                    week = (0, $51fe2e20810fcb40$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$8888529b966033e5).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$22ee6205b762968c).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$608689422d5cf9f4)(d) : (0, $7f6029921eecd017$export$608689422d5cf9f4).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$608689422d5cf9f4).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d), d) + ((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$e79bbe0177cf1b01).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$608689422d5cf9f4)(d) : (0, $7f6029921eecd017$export$608689422d5cf9f4).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$c8cbc42cefd47140).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$4898b06303a92011).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$1db08111baec2f53)(d) : (0, $7f6029921eecd017$export$1db08111baec2f53).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$1db08111baec2f53).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d), d) + ((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$9cfc53b9cfafd080).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$1db08111baec2f53)(d) : (0, $7f6029921eecd017$export$1db08111baec2f53).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $463505b9d968caf4$export$2e2bcd8739ae039)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}





function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $047ba3ec3f41562e$export$60c76498552d28a6), (0, $047ba3ec3f41562e$export$69511150134dd174), (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046), (0, $031c190f93ea3efa$export$7e1084fb688591c1), (0, $7f6029921eecd017$export$22ee6205b762968c), (0, $51fe2e20810fcb40$export$8888529b966033e5), (0, $9472e71f07850dab$export$46c68a5833bc315b), (0, $292297f992a3b17e$export$a7e4c34a52f0576), (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d), (0, $0a9ce0165786feda$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $f4e8dbe80a3143de$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply((0, $304372357472b2a4$export$56bbcdb8aca31149)((0, $047ba3ec3f41562e$export$826ba5ae907e9767), (0, $047ba3ec3f41562e$export$6262d8d056ea44c4), (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4), (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5), (0, $7f6029921eecd017$export$4898b06303a92011), (0, $51fe2e20810fcb40$export$c8cbc42cefd47140), (0, $9472e71f07850dab$export$31f6f2b3c63ac75e), (0, $292297f992a3b17e$export$efe6712d6003761b), (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d), (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}


function $fe769d98421e6dac$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}



var $c38bc04632290fce$export$2e2bcd8739ae039 = (scheme)=>(0, $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $145b892380fd2d31$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $145b892380fd2d31$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($145b892380fd2d31$export$3005042704f95a69);



var $923009811f34a285$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $923009811f34a285$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($923009811f34a285$export$3005042704f95a69);



var $1346c9d2a50a7688$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $1346c9d2a50a7688$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($1346c9d2a50a7688$export$3005042704f95a69);



var $c6eb5bbbe1fe33f2$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $c6eb5bbbe1fe33f2$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($c6eb5bbbe1fe33f2$export$3005042704f95a69);

function $9952aaaded0c8a28$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}


var $bfWFq = parcelRequire("bfWFq");

var $bYoiY = parcelRequire("bYoiY");

var $046e8f1d7426ff04$var$A = -0.14861, $046e8f1d7426ff04$var$B = 1.78277, $046e8f1d7426ff04$var$C = -0.29227, $046e8f1d7426ff04$var$D = -0.90649, $046e8f1d7426ff04$var$E = 1.97294, $046e8f1d7426ff04$var$ED = $046e8f1d7426ff04$var$E * $046e8f1d7426ff04$var$D, $046e8f1d7426ff04$var$EB = $046e8f1d7426ff04$var$E * $046e8f1d7426ff04$var$B, $046e8f1d7426ff04$var$BC_DA = $046e8f1d7426ff04$var$B * $046e8f1d7426ff04$var$C - $046e8f1d7426ff04$var$D * $046e8f1d7426ff04$var$A;
function $046e8f1d7426ff04$var$cubehelixConvert(o) {
    if (o instanceof $046e8f1d7426ff04$export$57ed4bde61a1e2f2) return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $bYoiY.Rgb))) o = (0, $bYoiY.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($046e8f1d7426ff04$var$BC_DA * b + $046e8f1d7426ff04$var$ED * r - $046e8f1d7426ff04$var$EB * g) / ($046e8f1d7426ff04$var$BC_DA + $046e8f1d7426ff04$var$ED - $046e8f1d7426ff04$var$EB), bl = b - l, k = ($046e8f1d7426ff04$var$E * (g - l) - $046e8f1d7426ff04$var$C * bl) / $046e8f1d7426ff04$var$D, s = Math.sqrt(k * k + bl * bl) / ($046e8f1d7426ff04$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $70576c5c5ae147f6$export$41fc368e1a942b97) - 120 : NaN;
    return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $046e8f1d7426ff04$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $046e8f1d7426ff04$var$cubehelixConvert(h) : new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $046e8f1d7426ff04$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)($046e8f1d7426ff04$export$57ed4bde61a1e2f2, $046e8f1d7426ff04$export$2e2bcd8739ae039, (0, $bfWFq.extend)((0, $bYoiY.Color), {
    brighter (k) {
        k = k == null ? (0, $bYoiY.brighter) : Math.pow((0, $bYoiY.brighter), k);
        return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $bYoiY.darker) : Math.pow((0, $bYoiY.darker), k);
        return new $046e8f1d7426ff04$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $70576c5c5ae147f6$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $bYoiY.Rgb)(255 * (l + a * ($046e8f1d7426ff04$var$A * cosh + $046e8f1d7426ff04$var$B * sinh)), 255 * (l + a * ($046e8f1d7426ff04$var$C * cosh + $046e8f1d7426ff04$var$D * sinh)), 255 * (l + a * ($046e8f1d7426ff04$var$E * cosh)), this.opacity);
    }
}));




function $ffc3b01ae2663238$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(start)).h, (end = (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(end)).h), s = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $ffc3b01ae2663238$export$2e2bcd8739ae039 = $ffc3b01ae2663238$var$cubehelix((0, $529dc8928f6a4077$export$97d7b0c7ddb78dcf));
var $ffc3b01ae2663238$export$934fa09ad474a1b4 = $ffc3b01ae2663238$var$cubehelix((0, $529dc8928f6a4077$export$2e2bcd8739ae039));


var $99c57285242dd2ea$export$fc70efcec537be98 = (0, $ffc3b01ae2663238$export$934fa09ad474a1b4)((0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $99c57285242dd2ea$export$c5cedbc1ab3be2c3 = (0, $ffc3b01ae2663238$export$934fa09ad474a1b4)((0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $99c57285242dd2ea$var$c = (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)();
function $99c57285242dd2ea$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $99c57285242dd2ea$var$c.h = 360 * t - 100;
    $99c57285242dd2ea$var$c.s = 1.5 - 1.5 * ts;
    $99c57285242dd2ea$var$c.l = 0.8 - 0.9 * ts;
    return $99c57285242dd2ea$var$c + "";
}



var $29d6cb6ff87ef07d$export$2e2bcd8739ae039 = (0, $ffc3b01ae2663238$export$934fa09ad474a1b4)((0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $046e8f1d7426ff04$export$2e2bcd8739ae039)(-240, 0.5, 1.0));



var $54d7f7dcce705495$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $54d7f7dcce705495$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($54d7f7dcce705495$export$3005042704f95a69);



var $8f3c9c616b880108$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $8f3c9c616b880108$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($8f3c9c616b880108$export$3005042704f95a69);



var $7bfe5c88f8446526$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $7bfe5c88f8446526$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($7bfe5c88f8446526$export$3005042704f95a69);


function $c1e92c032cb158e3$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $c1e92c032cb158e3$export$2e2bcd8739ae039 = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $c1e92c032cb158e3$export$c41e69203f572e8d = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $c1e92c032cb158e3$export$ad0c8285c8ea6dbd = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $c1e92c032cb158e3$export$6664860a633d9daf = $c1e92c032cb158e3$var$ramp((0, $fe769d98421e6dac$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



var $595eb3851ff257d2$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $595eb3851ff257d2$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($595eb3851ff257d2$export$3005042704f95a69);



var $eeccadfeb064b2e3$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $eeccadfeb064b2e3$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($eeccadfeb064b2e3$export$3005042704f95a69);



var $cd2b06ef8006df98$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $cd2b06ef8006df98$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($cd2b06ef8006df98$export$3005042704f95a69);



var $bebec87caf5c9753$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $bebec87caf5c9753$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($bebec87caf5c9753$export$3005042704f95a69);



var $378e987a98dccf42$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $378e987a98dccf42$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($378e987a98dccf42$export$3005042704f95a69);



var $256ade4440a037db$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $256ade4440a037db$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($256ade4440a037db$export$3005042704f95a69);



var $fa43973b0e53adde$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $fa43973b0e53adde$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($fa43973b0e53adde$export$3005042704f95a69);



var $5387771dbbae7a61$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $5387771dbbae7a61$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($5387771dbbae7a61$export$3005042704f95a69);



var $1d375f28523a6def$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $1d375f28523a6def$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($1d375f28523a6def$export$3005042704f95a69);



var $459633cf9cf535bb$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $459633cf9cf535bb$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($459633cf9cf535bb$export$3005042704f95a69);



var $d593cda9522f5e9b$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $d593cda9522f5e9b$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($d593cda9522f5e9b$export$3005042704f95a69);



var $c0b866951e59a25a$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $c0b866951e59a25a$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($c0b866951e59a25a$export$3005042704f95a69);



var $cc75fec219df38fc$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $cc75fec219df38fc$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($cc75fec219df38fc$export$3005042704f95a69);



var $34bd5cca956fffae$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $34bd5cca956fffae$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($34bd5cca956fffae$export$3005042704f95a69);



var $1061f70ec19e6f6b$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $1061f70ec19e6f6b$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($1061f70ec19e6f6b$export$3005042704f95a69);


var $bYoiY = parcelRequire("bYoiY");
var $8a82e5e51ab56b0d$var$c = (0, $bYoiY.rgb)(), $8a82e5e51ab56b0d$var$pi_1_3 = Math.PI / 3, $8a82e5e51ab56b0d$var$pi_2_3 = Math.PI * 2 / 3;
function $8a82e5e51ab56b0d$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $8a82e5e51ab56b0d$var$c.r = 255 * (x = Math.sin(t)) * x;
    $8a82e5e51ab56b0d$var$c.g = 255 * (x = Math.sin(t + $8a82e5e51ab56b0d$var$pi_1_3)) * x;
    $8a82e5e51ab56b0d$var$c.b = 255 * (x = Math.sin(t + $8a82e5e51ab56b0d$var$pi_2_3)) * x;
    return $8a82e5e51ab56b0d$var$c + "";
}



var $9f2dc97368c5eb16$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $9f2dc97368c5eb16$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($9f2dc97368c5eb16$export$3005042704f95a69);

function $b6e6a61cd0d5bfcf$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}



var $9f35832fa0e76f1c$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $9f35832fa0e76f1c$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($9f35832fa0e76f1c$export$3005042704f95a69);



var $59f93d7737a98115$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $59f93d7737a98115$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($59f93d7737a98115$export$3005042704f95a69);



var $8ba4ac8d08f3d776$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $8ba4ac8d08f3d776$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($8ba4ac8d08f3d776$export$3005042704f95a69);



var $f3f63506e2889591$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $fe769d98421e6dac$export$2e2bcd8739ae039));
var $f3f63506e2889591$export$2e2bcd8739ae039 = (0, $c38bc04632290fce$export$2e2bcd8739ae039)($f3f63506e2889591$export$3005042704f95a69);


var $5c89bc3d03077aec$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");


var $b0a93f4c47fccf6f$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");


var $8720e88c6715774d$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");


var $892d66d4b4370fa9$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $8b74c2f853351d4b$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");


var $21804f83495238ab$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");


var $067ed124de63e363$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");


var $0b28fee23808bb16$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");


var $2c32d07a5d4299df$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");


var $4fe0d67c4ca00f70$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");



const $f0560c970166d25b$export$2335f513bbd82c6d = Math.abs;
const $f0560c970166d25b$export$b8b770ee6a0d9760 = Math.atan2;
const $f0560c970166d25b$export$50d414a77b60d802 = Math.cos;
const $f0560c970166d25b$export$8960430cfd85939f = Math.max;
const $f0560c970166d25b$export$96ec731ed4dcb222 = Math.min;
const $f0560c970166d25b$export$5de3937cb4b592ed = Math.sin;
const $f0560c970166d25b$export$eba8049fb5020b81 = Math.sqrt;
const $f0560c970166d25b$export$6c421550c66a327d = 1e-12;
const $f0560c970166d25b$export$18c7bea995a110f = Math.PI;
const $f0560c970166d25b$export$e51408a300e8929a = $f0560c970166d25b$export$18c7bea995a110f / 2;
const $f0560c970166d25b$export$a4b4b4d4d776fe92 = 2 * $f0560c970166d25b$export$18c7bea995a110f;
function $f0560c970166d25b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f0560c970166d25b$export$18c7bea995a110f : Math.acos(x);
}
function $f0560c970166d25b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $f0560c970166d25b$export$e51408a300e8929a : x <= -1 ? -$f0560c970166d25b$export$e51408a300e8929a : Math.asin(x);
}


const $134055608cfdbbf1$var$sqrt3 = (0, $f0560c970166d25b$export$eba8049fb5020b81)(3);
var $134055608cfdbbf1$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size + (0, $f0560c970166d25b$export$96ec731ed4dcb222)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $134055608cfdbbf1$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};


var $77cd44e2ac6dc1c2$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size / (0, $f0560c970166d25b$export$18c7bea995a110f));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $f0560c970166d25b$export$a4b4b4d4d776fe92));
    }
};


var $6389eccbe795c95c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};


const $42af998bb354705d$var$tan30 = (0, $f0560c970166d25b$export$eba8049fb5020b81)(1 / 3);
const $42af998bb354705d$var$tan30_2 = $42af998bb354705d$var$tan30 * 2;
var $42af998bb354705d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size / $42af998bb354705d$var$tan30_2);
        const x = y * $42af998bb354705d$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};


var $f2564dd3ed0020e5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};


var $6eee48c5df32b70c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size - (0, $f0560c970166d25b$export$96ec731ed4dcb222)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}



function $5c3aa3aea2c844cf$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $c9f66a4d1c06b373$export$4b2950bdac9b6ee9)(digits);
}









var $1dda04e919c4f021$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $efaaae86227c5844$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



const $4ff326387f52757d$var$ka = 0.89081309152928522810;
const $4ff326387f52757d$var$kr = (0, $f0560c970166d25b$export$5de3937cb4b592ed)((0, $f0560c970166d25b$export$18c7bea995a110f) / 10) / (0, $f0560c970166d25b$export$5de3937cb4b592ed)(7 * (0, $f0560c970166d25b$export$18c7bea995a110f) / 10);
const $4ff326387f52757d$var$kx = (0, $f0560c970166d25b$export$5de3937cb4b592ed)((0, $f0560c970166d25b$export$a4b4b4d4d776fe92) / 10) * $4ff326387f52757d$var$kr;
const $4ff326387f52757d$var$ky = -(0, $f0560c970166d25b$export$50d414a77b60d802)((0, $f0560c970166d25b$export$a4b4b4d4d776fe92) / 10) * $4ff326387f52757d$var$kr;
var $4ff326387f52757d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size * $4ff326387f52757d$var$ka);
        const x = $4ff326387f52757d$var$kx * r;
        const y = $4ff326387f52757d$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $f0560c970166d25b$export$a4b4b4d4d776fe92) * i / 5;
            const c = (0, $f0560c970166d25b$export$50d414a77b60d802)(a);
            const s = (0, $f0560c970166d25b$export$5de3937cb4b592ed)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



const $d45526fd1ffbd617$var$sqrt3 = (0, $f0560c970166d25b$export$eba8049fb5020b81)(3);
var $d45526fd1ffbd617$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $f0560c970166d25b$export$eba8049fb5020b81)(size / ($d45526fd1ffbd617$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$d45526fd1ffbd617$var$sqrt3 * y, -y);
        context.lineTo($d45526fd1ffbd617$var$sqrt3 * y, -y);
        context.closePath();
    }
};



const $70a1b9646572faf7$var$sqrt3 = (0, $f0560c970166d25b$export$eba8049fb5020b81)(3);
var $70a1b9646572faf7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size) * 0.6824;
        const t = s / 2;
        const u = s * $70a1b9646572faf7$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



const $6b5c98530d683be5$var$c = -0.5;
const $6b5c98530d683be5$var$s = (0, $f0560c970166d25b$export$eba8049fb5020b81)(3) / 2;
const $6b5c98530d683be5$var$k = 1 / (0, $f0560c970166d25b$export$eba8049fb5020b81)(12);
const $6b5c98530d683be5$var$a = ($6b5c98530d683be5$var$k / 2 + 1) * 3;
var $6b5c98530d683be5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size / $6b5c98530d683be5$var$a);
        const x0 = r / 2, y0 = r * $6b5c98530d683be5$var$k;
        const x1 = x0, y1 = r * $6b5c98530d683be5$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($6b5c98530d683be5$var$c * x0 - $6b5c98530d683be5$var$s * y0, $6b5c98530d683be5$var$s * x0 + $6b5c98530d683be5$var$c * y0);
        context.lineTo($6b5c98530d683be5$var$c * x1 - $6b5c98530d683be5$var$s * y1, $6b5c98530d683be5$var$s * x1 + $6b5c98530d683be5$var$c * y1);
        context.lineTo($6b5c98530d683be5$var$c * x2 - $6b5c98530d683be5$var$s * y2, $6b5c98530d683be5$var$s * x2 + $6b5c98530d683be5$var$c * y2);
        context.lineTo($6b5c98530d683be5$var$c * x0 + $6b5c98530d683be5$var$s * y0, $6b5c98530d683be5$var$c * y0 - $6b5c98530d683be5$var$s * x0);
        context.lineTo($6b5c98530d683be5$var$c * x1 + $6b5c98530d683be5$var$s * y1, $6b5c98530d683be5$var$c * y1 - $6b5c98530d683be5$var$s * x1);
        context.lineTo($6b5c98530d683be5$var$c * x2 + $6b5c98530d683be5$var$s * y2, $6b5c98530d683be5$var$c * y2 - $6b5c98530d683be5$var$s * x2);
        context.closePath();
    }
};



var $91f4a6205a1a3d92$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $f0560c970166d25b$export$eba8049fb5020b81)(size - (0, $f0560c970166d25b$export$96ec731ed4dcb222)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $497fe223f0c7b3e8$export$19158c96a6700c15 = [
    (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039),
    (0, $6389eccbe795c95c$export$2e2bcd8739ae039),
    (0, $42af998bb354705d$export$2e2bcd8739ae039),
    (0, $1dda04e919c4f021$export$2e2bcd8739ae039),
    (0, $4ff326387f52757d$export$2e2bcd8739ae039),
    (0, $d45526fd1ffbd617$export$2e2bcd8739ae039),
    (0, $6b5c98530d683be5$export$2e2bcd8739ae039)
];
const $497fe223f0c7b3e8$export$915e06de6acf8fe = [
    (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039),
    (0, $6eee48c5df32b70c$export$2e2bcd8739ae039),
    (0, $91f4a6205a1a3d92$export$2e2bcd8739ae039),
    (0, $70a1b9646572faf7$export$2e2bcd8739ae039),
    (0, $134055608cfdbbf1$export$2e2bcd8739ae039),
    (0, $efaaae86227c5844$export$2e2bcd8739ae039),
    (0, $f2564dd3ed0020e5$export$2e2bcd8739ae039)
];
function $497fe223f0c7b3e8$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(type || (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}









var $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e4199827a75856fd$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $e4199827a75856fd$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh(rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e4199827a75856fd$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $4aeb7326706b2467$export$2e2bcd8739ae039 = (x)=>()=>x;


function $7a8a51016481311d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}


function $b2e4663bd9fbfcc1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $91e02783b8b1c24a$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $a3c1094a2e8782d7$export$f0954fd7d5368655);
}
function $91e02783b8b1c24a$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $e4199827a75856fd$export$2e2bcd8739ae039), listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $a3c1094a2e8782d7$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $7a8a51016481311d$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $905558291b0c219c$export$833237748009e1e1)(event.view, g.moved);
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}











function $0f3e37548c3914c7$export$43f40ad3fa1d5c97(x) {
    return x != null && !Number.isNaN(x);
}
function $0f3e37548c3914c7$export$686e14b8469efec4(a, b) {
    return +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(b) - +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(a) || (0, $63cbeabc75241824$export$2e2bcd8739ae039)(a, b);
}
function $0f3e37548c3914c7$export$e82554a8bd790ef9(a, b) {
    return +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(b) - +$0f3e37548c3914c7$export$43f40ad3fa1d5c97(a) || (0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(a, b);
}
function $0f3e37548c3914c7$export$6ce6c9218151d511(x) {
    return x != null && `${x}` !== "";
}
function $0f3e37548c3914c7$export$145b33b964ff85c1(x) {
    return isFinite(x) ? x : NaN;
}
function $0f3e37548c3914c7$export$aa5128ab863cd04(x) {
    return x > 0 && isFinite(x) ? x : NaN;
}
function $0f3e37548c3914c7$export$5f47f64d03acd206(x) {
    return x < 0 && isFinite(x) ? x : NaN;
}


function $cb17f3275e1ef5a0$export$2e2bcd8739ae039(date, fallback) {
    if (!(date instanceof Date)) date = new Date(+date);
    if (isNaN(date)) return typeof fallback === "function" ? fallback(date) : fallback;
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const milliseconds = date.getUTCMilliseconds();
    return `${$cb17f3275e1ef5a0$var$formatYear(date.getUTCFullYear(), 4)}-${$cb17f3275e1ef5a0$var$pad(date.getUTCMonth() + 1, 2)}-${$cb17f3275e1ef5a0$var$pad(date.getUTCDate(), 2)}${hours || minutes || seconds || milliseconds ? `T${$cb17f3275e1ef5a0$var$pad(hours, 2)}:${$cb17f3275e1ef5a0$var$pad(minutes, 2)}${seconds || milliseconds ? `:${$cb17f3275e1ef5a0$var$pad(seconds, 2)}${milliseconds ? `.${$cb17f3275e1ef5a0$var$pad(milliseconds, 3)}` : ``}` : ``}Z` : ``}`;
}
function $cb17f3275e1ef5a0$var$formatYear(year) {
    return year < 0 ? `-${$cb17f3275e1ef5a0$var$pad(-year, 6)}` : year > 9999 ? `+${$cb17f3275e1ef5a0$var$pad(year, 6)}` : $cb17f3275e1ef5a0$var$pad(year, 4);
}
function $cb17f3275e1ef5a0$var$pad(value, width) {
    return `${value}`.padStart(width, "0");
}



const $a25d0745dd917edb$var$re = /^(?:[-+]\d{2})?\d{4}(?:-\d{2}(?:-\d{2})?)?(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{3})?)?(?:Z|[-+]\d{2}:?\d{2})?)?$/;
function $a25d0745dd917edb$export$2e2bcd8739ae039(string, fallback) {
    if (!$a25d0745dd917edb$var$re.test(string += "")) return typeof fallback === "function" ? fallback(string) : fallback;
    return new Date(string);
}





const $49e9bdee870d78f0$var$durationSecond = 1000;
const $49e9bdee870d78f0$var$durationMinute = $49e9bdee870d78f0$var$durationSecond * 60;
const $49e9bdee870d78f0$var$durationHour = $49e9bdee870d78f0$var$durationMinute * 60;
const $49e9bdee870d78f0$var$durationDay = $49e9bdee870d78f0$var$durationHour * 24;
const $49e9bdee870d78f0$var$durationWeek = $49e9bdee870d78f0$var$durationDay * 7;
const $49e9bdee870d78f0$var$durationMonth = $49e9bdee870d78f0$var$durationDay * 30;
const $49e9bdee870d78f0$var$durationYear = $49e9bdee870d78f0$var$durationDay * 365;
// See https://github.com/d3/d3-time/blob/9e8dc940f38f78d7588aad68a54a25b1f0c2d97b/src/ticks.js#L14-L33
const $49e9bdee870d78f0$var$tickIntervals = [
    [
        "millisecond",
        1
    ],
    [
        "2 milliseconds",
        2
    ],
    [
        "5 milliseconds",
        5
    ],
    [
        "10 milliseconds",
        10
    ],
    [
        "20 milliseconds",
        20
    ],
    [
        "50 milliseconds",
        50
    ],
    [
        "100 milliseconds",
        100
    ],
    [
        "200 milliseconds",
        200
    ],
    [
        "500 milliseconds",
        500
    ],
    [
        "second",
        $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "5 seconds",
        5 * $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "15 seconds",
        15 * $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "30 seconds",
        30 * $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "minute",
        $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "5 minutes",
        5 * $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "15 minutes",
        15 * $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "30 minutes",
        30 * $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "hour",
        $49e9bdee870d78f0$var$durationHour
    ],
    [
        "3 hours",
        3 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "6 hours",
        6 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "12 hours",
        12 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "day",
        $49e9bdee870d78f0$var$durationDay
    ],
    [
        "2 days",
        2 * $49e9bdee870d78f0$var$durationDay
    ],
    [
        "week",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "2 weeks",
        2 * $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "month",
        $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "3 months",
        3 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "6 months",
        6 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "year",
        $49e9bdee870d78f0$var$durationYear
    ],
    [
        "2 years",
        2 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "5 years",
        5 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "10 years",
        10 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "20 years",
        20 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "50 years",
        50 * $49e9bdee870d78f0$var$durationYear
    ],
    [
        "100 years",
        100 * $49e9bdee870d78f0$var$durationYear
    ] // TODO generalize to longer time scales
];
const $49e9bdee870d78f0$var$durations = new Map([
    [
        "second",
        $49e9bdee870d78f0$var$durationSecond
    ],
    [
        "minute",
        $49e9bdee870d78f0$var$durationMinute
    ],
    [
        "hour",
        $49e9bdee870d78f0$var$durationHour
    ],
    [
        "day",
        $49e9bdee870d78f0$var$durationDay
    ],
    [
        "monday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "tuesday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "wednesday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "thursday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "friday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "saturday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "sunday",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "week",
        $49e9bdee870d78f0$var$durationWeek
    ],
    [
        "month",
        $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "year",
        $49e9bdee870d78f0$var$durationYear
    ]
]);
const $49e9bdee870d78f0$var$timeIntervals = new Map([
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d)
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$a7e4c34a52f0576)
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$46c68a5833bc315b)
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$8888529b966033e5)
    ],
    [
        "monday",
        (0, $7f6029921eecd017$export$e79bbe0177cf1b01)
    ],
    [
        "tuesday",
        (0, $7f6029921eecd017$export$57c0658c29f77708)
    ],
    [
        "wednesday",
        (0, $7f6029921eecd017$export$3fbeef226c256e43)
    ],
    [
        "thursday",
        (0, $7f6029921eecd017$export$608689422d5cf9f4)
    ],
    [
        "friday",
        (0, $7f6029921eecd017$export$548e5227aa183dca)
    ],
    [
        "saturday",
        (0, $7f6029921eecd017$export$c56a3ad248908e19)
    ],
    [
        "sunday",
        (0, $7f6029921eecd017$export$22ee6205b762968c)
    ],
    [
        "week",
        (0, $7f6029921eecd017$export$22ee6205b762968c)
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$7e1084fb688591c1)
    ],
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)
    ]
]);
const $49e9bdee870d78f0$var$utcIntervals = new Map([
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d)
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$efe6712d6003761b)
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$31f6f2b3c63ac75e)
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71)
    ],
    [
        "monday",
        (0, $7f6029921eecd017$export$9cfc53b9cfafd080)
    ],
    [
        "tuesday",
        (0, $7f6029921eecd017$export$2a6d545f77eceb15)
    ],
    [
        "wednesday",
        (0, $7f6029921eecd017$export$a5c25d8ed64433c4)
    ],
    [
        "thursday",
        (0, $7f6029921eecd017$export$1db08111baec2f53)
    ],
    [
        "friday",
        (0, $7f6029921eecd017$export$29265e34dd5921f7)
    ],
    [
        "saturday",
        (0, $7f6029921eecd017$export$85b74dad05049604)
    ],
    [
        "sunday",
        (0, $7f6029921eecd017$export$4898b06303a92011)
    ],
    [
        "week",
        (0, $7f6029921eecd017$export$4898b06303a92011)
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5)
    ],
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)
    ]
]);
const $49e9bdee870d78f0$export$6b9291a5690ab4c6 = Symbol("intervalDuration");
const $49e9bdee870d78f0$export$84d7908c031f9a60 = Symbol("intervalType");
// We greedily mutate D3’s standard intervals on load so that the hidden fields
// are available even if specified as e.g. d3.utcMonth instead of "month".
for (const [name, interval] of $49e9bdee870d78f0$var$timeIntervals){
    interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6] = $49e9bdee870d78f0$var$durations.get(name);
    interval[$49e9bdee870d78f0$export$84d7908c031f9a60] = "time";
}
for (const [name, interval] of $49e9bdee870d78f0$var$utcIntervals){
    interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6] = $49e9bdee870d78f0$var$durations.get(name);
    interval[$49e9bdee870d78f0$export$84d7908c031f9a60] = "utc";
}
const $49e9bdee870d78f0$var$utcFormatIntervals = [
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4),
        "utc"
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5),
        "utc"
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71),
        "utc",
        6 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$31f6f2b3c63ac75e),
        "utc",
        3 * $49e9bdee870d78f0$var$durationDay
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$efe6712d6003761b),
        "utc",
        6 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
        "utc",
        30 * $49e9bdee870d78f0$var$durationMinute
    ]
];
const $49e9bdee870d78f0$var$timeFormatIntervals = [
    [
        "year",
        (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046),
        "time"
    ],
    [
        "month",
        (0, $031c190f93ea3efa$export$7e1084fb688591c1),
        "time"
    ],
    [
        "day",
        (0, $51fe2e20810fcb40$export$8888529b966033e5),
        "time",
        6 * $49e9bdee870d78f0$var$durationMonth
    ],
    [
        "hour",
        (0, $9472e71f07850dab$export$46c68a5833bc315b),
        "time",
        3 * $49e9bdee870d78f0$var$durationDay
    ],
    [
        "minute",
        (0, $292297f992a3b17e$export$a7e4c34a52f0576),
        "time",
        6 * $49e9bdee870d78f0$var$durationHour
    ],
    [
        "second",
        (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
        "time",
        30 * $49e9bdee870d78f0$var$durationMinute
    ]
];
// An interleaved array of UTC and local time intervals, in descending order
// from largest to smallest, used to determine the most specific standard time
// format for a given array of dates. This is a subset of the tick intervals
// listed above; we only need the breakpoints where the format changes.
const $49e9bdee870d78f0$var$formatIntervals = [
    $49e9bdee870d78f0$var$utcFormatIntervals[0],
    $49e9bdee870d78f0$var$timeFormatIntervals[0],
    $49e9bdee870d78f0$var$utcFormatIntervals[1],
    $49e9bdee870d78f0$var$timeFormatIntervals[1],
    $49e9bdee870d78f0$var$utcFormatIntervals[2],
    $49e9bdee870d78f0$var$timeFormatIntervals[2],
    // Below day, local time typically has an hourly offset from UTC and hence the
    // two are aligned and indistinguishable; therefore, we only consider UTC, and
    // we don’t consider these if the domain only has a single value.
    ...$49e9bdee870d78f0$var$utcFormatIntervals.slice(3)
];
function $49e9bdee870d78f0$export$713f3432fde4ec88(input) {
    let name = `${input}`.toLowerCase();
    if (name.endsWith("s")) name = name.slice(0, -1); // drop plural
    let period = 1;
    const match = /^(?:(\d+)\s+)/.exec(name);
    if (match) {
        name = name.slice(match[0].length);
        period = +match[1];
    }
    switch(name){
        case "quarter":
            name = "month";
            period *= 3;
            break;
        case "half":
            name = "month";
            period *= 6;
            break;
    }
    let interval = $49e9bdee870d78f0$var$utcIntervals.get(name);
    if (!interval) throw new Error(`unknown interval: ${input}`);
    if (period > 1 && !interval.every) throw new Error(`non-periodic interval: ${name}`);
    return [
        name,
        period
    ];
}
function $49e9bdee870d78f0$export$5b8228f091405edd(input) {
    return $49e9bdee870d78f0$var$asInterval($49e9bdee870d78f0$export$713f3432fde4ec88(input), "time");
}
function $49e9bdee870d78f0$export$4c170b80b09a0a2c(input) {
    return $49e9bdee870d78f0$var$asInterval($49e9bdee870d78f0$export$713f3432fde4ec88(input), "utc");
}
function $49e9bdee870d78f0$var$asInterval([name, period], type) {
    let interval = (type === "time" ? $49e9bdee870d78f0$var$timeIntervals : $49e9bdee870d78f0$var$utcIntervals).get(name);
    if (period > 1) {
        interval = interval.every(period);
        interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6] = $49e9bdee870d78f0$var$durations.get(name) * period;
        interval[$49e9bdee870d78f0$export$84d7908c031f9a60] = type;
    }
    return interval;
}
function $49e9bdee870d78f0$export$29a4ccaf5efe074d(interval, n) {
    if (!(n > 1)) return; // no need to generalize
    const duration = interval[$49e9bdee870d78f0$export$6b9291a5690ab4c6];
    if (!$49e9bdee870d78f0$var$tickIntervals.some(([, d])=>d === duration)) return; // nonstandard or unknown interval
    if (duration % $49e9bdee870d78f0$var$durationDay === 0 && $49e9bdee870d78f0$var$durationDay < duration && duration < $49e9bdee870d78f0$var$durationMonth) return; // not generalizable
    const [i] = $49e9bdee870d78f0$var$tickIntervals[(0, $0ae9019609d046a1$export$2e2bcd8739ae039)(([, step])=>Math.log(step)).center($49e9bdee870d78f0$var$tickIntervals, Math.log(duration * n))];
    return (interval[$49e9bdee870d78f0$export$84d7908c031f9a60] === "time" ? $49e9bdee870d78f0$export$5b8228f091405edd : $49e9bdee870d78f0$export$4c170b80b09a0a2c)(i);
}
function $49e9bdee870d78f0$var$formatTimeInterval(name, type, anchor) {
    const format = type === "time" ? (0, $0a9ce0165786feda$export$94f4d87fad5dcf9a) : (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb);
    // For tips and legends, use a format that doesn’t require context.
    if (anchor == null) return format(name === "year" ? "%Y" : name === "month" ? "%Y-%m" : name === "day" ? "%Y-%m-%d" : name === "hour" || name === "minute" ? "%Y-%m-%dT%H:%M" : name === "second" ? "%Y-%m-%dT%H:%M:%S" : "%Y-%m-%dT%H:%M:%S.%L");
    // Otherwise, assume that this is for axis ticks.
    const template = $49e9bdee870d78f0$var$getTimeTemplate(anchor);
    switch(name){
        case "millisecond":
            return $49e9bdee870d78f0$var$formatConditional(format(".%L"), format(":%M:%S"), template);
        case "second":
            return $49e9bdee870d78f0$var$formatConditional(format(":%S"), format("%-I:%M"), template);
        case "minute":
            return $49e9bdee870d78f0$var$formatConditional(format("%-I:%M"), format("%p"), template);
        case "hour":
            return $49e9bdee870d78f0$var$formatConditional(format("%-I %p"), format("%b %-d"), template);
        case "day":
            return $49e9bdee870d78f0$var$formatConditional(format("%-d"), format("%b"), template);
        case "month":
            return $49e9bdee870d78f0$var$formatConditional(format("%b"), format("%Y"), template);
        case "year":
            return format("%Y");
    }
    throw new Error("unable to format time ticks");
}
function $49e9bdee870d78f0$var$getTimeTemplate(anchor) {
    return anchor === "left" || anchor === "right" ? (f1, f2)=>`\n${f1}\n${f2}` // extra newline to keep f1 centered
     : anchor === "top" ? (f1, f2)=>`${f2}\n${f1}` : (f1, f2)=>`${f1}\n${f2}`;
}
function $49e9bdee870d78f0$var$getFormatIntervals(type) {
    return type === "time" ? $49e9bdee870d78f0$var$timeFormatIntervals : type === "utc" ? $49e9bdee870d78f0$var$utcFormatIntervals : $49e9bdee870d78f0$var$formatIntervals;
}
function $49e9bdee870d78f0$export$8d2dceb4d1e6fd24(type, dates, anchor) {
    const step = (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)((0, $a9640ed34ca3d852$export$2e2bcd8739ae039)(dates, (a, b)=>Math.abs(b - a))); // maybe undefined!
    if (step < 1000) return $49e9bdee870d78f0$var$formatTimeInterval("millisecond", "utc", anchor);
    for (const [name, interval, intervalType, maxStep] of $49e9bdee870d78f0$var$getFormatIntervals(type)){
        if (step > maxStep) break; // e.g., 52 weeks
        if (name === "hour" && !step) break; // e.g., domain with a single date
        if (dates.every((d)=>interval.floor(d) >= d)) return $49e9bdee870d78f0$var$formatTimeInterval(name, intervalType, anchor);
    }
}
function $49e9bdee870d78f0$var$formatConditional(format1, format2, template) {
    return (x, i, X)=>{
        const f1 = format1(x, i); // always shown
        const f2 = format2(x, i); // only shown if different
        const j = i - (0, $cd9e805a4bbd13f9$export$c25b1294fe9f63f1)(X); // detect reversed domains
        return i !== j && X[j] !== undefined && f2 === format2(X[j], j) ? f1 : template(f1, f2);
    };
}


const $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 = Object.getPrototypeOf(Uint8Array);
const $cd9e805a4bbd13f9$var$objectToString = Object.prototype.toString;
const $cd9e805a4bbd13f9$export$c800939f8d8c9f76 = Symbol("reindex");
function $cd9e805a4bbd13f9$export$1414f04542a0b4f4(data, value, type) {
    const valueType = typeof value;
    return valueType === "string" ? $cd9e805a4bbd13f9$var$maybeTypedMap(data, $cd9e805a4bbd13f9$export$e0f35d825088c098(value), type) : valueType === "function" ? $cd9e805a4bbd13f9$var$maybeTypedMap(data, value, type) : valueType === "number" || value instanceof Date || valueType === "boolean" ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(data, $cd9e805a4bbd13f9$export$c983f826f44ff86(value), type) : typeof value?.transform === "function" ? $cd9e805a4bbd13f9$var$maybeTypedArrayify(value.transform(data), type) : $cd9e805a4bbd13f9$var$maybeTake($cd9e805a4bbd13f9$var$maybeTypedArrayify(value, type), data?.[$cd9e805a4bbd13f9$export$c800939f8d8c9f76]);
}
function $cd9e805a4bbd13f9$var$maybeTake(values, index) {
    return index ? $cd9e805a4bbd13f9$export$b7df5d561049483a(values, index) : values;
}
function $cd9e805a4bbd13f9$var$maybeTypedMap(data, f, type) {
    return $cd9e805a4bbd13f9$export$871de8747c9eaa88(data, type?.prototype instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 ? $cd9e805a4bbd13f9$var$floater(f) : f, type);
}
function $cd9e805a4bbd13f9$var$maybeTypedArrayify(data, type) {
    return type === undefined ? $cd9e805a4bbd13f9$export$3131421a7d01b4fb(data) // preserve undefined type
     : data instanceof type ? data : type.prototype instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 && !(data instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9) ? type.from(data, $cd9e805a4bbd13f9$var$coerceNumber) : type.from(data);
}
function $cd9e805a4bbd13f9$var$floater(f) {
    return (d, i)=>$cd9e805a4bbd13f9$var$coerceNumber(f(d, i));
}
const $cd9e805a4bbd13f9$export$439306a4dcaafbb9 = [
    null
]; // for data-less decoration marks, e.g. frame
const $cd9e805a4bbd13f9$export$e0f35d825088c098 = (name)=>(d)=>d[name];
const $cd9e805a4bbd13f9$export$305f7d4e9d4624f2 = {
    transform: $cd9e805a4bbd13f9$export$d02631cccf789723
};
const $cd9e805a4bbd13f9$export$f0954fd7d5368655 = {
    transform: (d)=>d
};
const $cd9e805a4bbd13f9$export$7f9972325ebfd559 = ()=>0;
const $cd9e805a4bbd13f9$export$80bf7733f1207381 = ()=>1;
const $cd9e805a4bbd13f9$export$7a668e70ea2210d9 = ()=>true;
const $cd9e805a4bbd13f9$export$22b082955e083ec3 = (x)=>x == null ? x : `${x}`;
const $cd9e805a4bbd13f9$export$98e628dec113755e = (x)=>x == null ? x : +x;
const $cd9e805a4bbd13f9$export$4a21f16c33752377 = (x)=>x == null ? x : !!x;
const $cd9e805a4bbd13f9$export$43128fadae87b74a = (x)=>x ? x[0] : undefined;
const $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d = (x)=>x ? x[1] : undefined;
const $cd9e805a4bbd13f9$export$1fa4a8860392dfdb = (x)=>x ? x[2] : undefined;
const $cd9e805a4bbd13f9$export$c983f826f44ff86 = (x)=>()=>x;
function $cd9e805a4bbd13f9$export$c4df44c805494ac9(reduce) {
    const p = +`${reduce}`.slice(1) / 100;
    return (I, f)=>(0, $231c9024a6754413$export$2e2bcd8739ae039)(I, p, f);
}
function $cd9e805a4bbd13f9$export$803a244824c02a83(values) {
    return values instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 ? values : $cd9e805a4bbd13f9$export$871de8747c9eaa88(values, $cd9e805a4bbd13f9$var$coerceNumber, Float64Array);
}
// Unlike Mark’s number, here we want to convert null and undefined to NaN since
// the result will be stored in a Float64Array and we don’t want null to be
// coerced to zero. We use Number instead of unary + to allow BigInt coercion.
function $cd9e805a4bbd13f9$var$coerceNumber(x) {
    return x == null ? NaN : Number(x);
}
function $cd9e805a4bbd13f9$export$9a67b3ad4b3297f7(values) {
    return $cd9e805a4bbd13f9$export$871de8747c9eaa88(values, $cd9e805a4bbd13f9$export$187f75afdaf90d5b);
}
function $cd9e805a4bbd13f9$export$187f75afdaf90d5b(x) {
    return x instanceof Date && !isNaN(x) ? x : typeof x === "string" ? (0, $a25d0745dd917edb$export$2e2bcd8739ae039)(x) : x == null || isNaN(x = +x) ? undefined : new Date(x);
}
function $cd9e805a4bbd13f9$export$6dcb63290aa6d572(value, defaultValue) {
    if (value === undefined) value = defaultValue;
    return value === null ? [
        undefined,
        "none"
    ] : $cd9e805a4bbd13f9$export$e82f763eaa28f6fe(value) ? [
        undefined,
        value
    ] : [
        value,
        undefined
    ];
}
function $cd9e805a4bbd13f9$export$75c96357b71c0240(value, defaultValue) {
    if (value === undefined) value = defaultValue;
    return value === null || typeof value === "number" ? [
        undefined,
        value
    ] : [
        value,
        undefined
    ];
}
function $cd9e805a4bbd13f9$export$a305618d7bff6223(input, name, allowed) {
    if (input != null) return $cd9e805a4bbd13f9$export$2e81050496d0e63e(input, name, allowed);
}
function $cd9e805a4bbd13f9$export$2e81050496d0e63e(input, name, allowed) {
    const i = `${input}`.toLowerCase();
    if (!allowed.includes(i)) throw new Error(`invalid ${name}: ${input}`);
    return i;
}
function $cd9e805a4bbd13f9$export$3131421a7d01b4fb(data) {
    return data == null || data instanceof Array || data instanceof $cd9e805a4bbd13f9$export$914b3a8889b8a8a9 ? data : Array.from(data);
}
function $cd9e805a4bbd13f9$export$871de8747c9eaa88(values, f, type = Array) {
    return values == null ? values : values instanceof type ? values.map(f) : type.from(values, f);
}
function $cd9e805a4bbd13f9$export$58adb3bec8346d0f(values, type = Array) {
    return values instanceof type ? values.slice() : type.from(values);
}
function $cd9e805a4bbd13f9$export$98a86545e71eb684({ x: x, x1: x1, x2: x2 }) {
    return x !== undefined || x1 !== undefined || x2 !== undefined;
}
function $cd9e805a4bbd13f9$export$6fec46f4cb6f332e({ y: y, y1: y1, y2: y2 }) {
    return y !== undefined || y1 !== undefined || y2 !== undefined;
}
function $cd9e805a4bbd13f9$export$3ebe4f8dba92c238(options) {
    return $cd9e805a4bbd13f9$export$98a86545e71eb684(options) || $cd9e805a4bbd13f9$export$6fec46f4cb6f332e(options) || options.interval !== undefined;
}
function $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a(option) {
    return option?.toString === $cd9e805a4bbd13f9$var$objectToString;
}
function $cd9e805a4bbd13f9$export$1fb8003448468be0(option) {
    return $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a(option) && (option.type !== undefined || option.domain !== undefined);
}
function $cd9e805a4bbd13f9$export$dae3322343de7d27(option) {
    return $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a(option) && typeof option.transform !== "function";
}
function $cd9e805a4bbd13f9$export$d6cc17845c0d71a0(sort) {
    return $cd9e805a4bbd13f9$export$dae3322343de7d27(sort) && sort.value === undefined && sort.channel === undefined;
}
function $cd9e805a4bbd13f9$export$988dfb0cf3d08a43(x, x1, x2, x3 = $cd9e805a4bbd13f9$export$f0954fd7d5368655) {
    if (x1 === undefined && x2 === undefined) // {x} or {}
    x1 = 0, x2 = x === undefined ? x3 : x;
    else if (x1 === undefined) // {x, x2} or {x2}
    x1 = x === undefined ? 0 : x;
    else if (x2 === undefined) // {x, x1} or {x1}
    x2 = x === undefined ? 0 : x;
    return [
        x1,
        x2
    ];
}
function $cd9e805a4bbd13f9$export$8598999985068071(x, y) {
    return x === undefined && y === undefined ? [
        $cd9e805a4bbd13f9$export$43128fadae87b74a,
        $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d
    ] : [
        x,
        y
    ];
}
function $cd9e805a4bbd13f9$export$9040d0441634ebe5({ z: z, fill: fill, stroke: stroke } = {}) {
    if (z === undefined) [z] = $cd9e805a4bbd13f9$export$6dcb63290aa6d572(fill);
    if (z === undefined) [z] = $cd9e805a4bbd13f9$export$6dcb63290aa6d572(stroke);
    return z;
}
function $cd9e805a4bbd13f9$export$d02631cccf789723(data) {
    const n = data.length;
    const r = new Uint32Array(n);
    for(let i = 0; i < n; ++i)r[i] = i;
    return r;
}
function $cd9e805a4bbd13f9$export$9c59b80dda569a6e(data, test) {
    return $cd9e805a4bbd13f9$export$d02631cccf789723(data).filter((i)=>test(data[i], i, data));
}
function $cd9e805a4bbd13f9$export$b7df5d561049483a(values, index) {
    return $cd9e805a4bbd13f9$export$871de8747c9eaa88(index, (i)=>values[i], values.constructor);
}
function $cd9e805a4bbd13f9$export$db49c4d122d2e604(f) {
    return f.length === 1 ? (index, values)=>f($cd9e805a4bbd13f9$export$b7df5d561049483a(values, index)) : f;
}
function $cd9e805a4bbd13f9$export$7ec32827e4221318(I, i, j) {
    return I.subarray ? I.subarray(i, j) : I.slice(i, j);
}
function $cd9e805a4bbd13f9$export$7e1278799275f68e(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function $cd9e805a4bbd13f9$export$84405e33d6be068e(key, options) {
    if (options[key] !== undefined) return options[key];
    switch(key){
        case "x1":
        case "x2":
            key = "x";
            break;
        case "y1":
        case "y2":
            key = "y";
            break;
    }
    return options[key];
}
function $cd9e805a4bbd13f9$export$4e0c71f277ca26b3(source) {
    // Defines a column whose values are lazily populated by calling the returned
    // setter. If the given source is labeled, the label is propagated to the
    // returned column definition.
    let value;
    return [
        {
            transform: ()=>value,
            label: $cd9e805a4bbd13f9$export$bd9d73a16a2ec705(source)
        },
        (v)=>value = v
    ];
}
function $cd9e805a4bbd13f9$export$46d040b9076e32ab(source) {
    return source == null ? [
        source
    ] : $cd9e805a4bbd13f9$export$4e0c71f277ca26b3(source);
}
function $cd9e805a4bbd13f9$export$bd9d73a16a2ec705(value, defaultValue) {
    return typeof value === "string" ? value : value && value.label !== undefined ? value.label : defaultValue;
}
function $cd9e805a4bbd13f9$export$a61423b330c3444c(x1, x2) {
    return {
        transform (data) {
            const X1 = x1.transform(data);
            const X2 = x2.transform(data);
            return $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7(X1) || $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7(X2) ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(X1, (_, i)=>new Date((+X1[i] + +X2[i]) / 2)) : $cd9e805a4bbd13f9$export$871de8747c9eaa88(X1, (_, i)=>(+X1[i] + +X2[i]) / 2, Float64Array);
        },
        label: x1.label
    };
}
function $cd9e805a4bbd13f9$export$90792ed47ffcc9f3(V, scale) {
    const t = $cd9e805a4bbd13f9$export$2170e2fe1255e79b(scale?.interval, scale?.type);
    return t ? $cd9e805a4bbd13f9$export$871de8747c9eaa88(V, t) : V;
}
function $cd9e805a4bbd13f9$export$2170e2fe1255e79b(interval, type) {
    const i = $cd9e805a4bbd13f9$export$91a968a7e5747089(interval, type);
    return i && ((v)=>(0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97)(v) ? i.floor(v) : v);
}
function $cd9e805a4bbd13f9$export$91a968a7e5747089(interval, type) {
    if (interval == null) return;
    if (typeof interval === "number") {
        if (0 < interval && interval < 1 && Number.isInteger(1 / interval)) interval = -1 / interval;
        const n = Math.abs(interval);
        return interval < 0 ? {
            floor: (d)=>Math.floor(d * n) / n,
            offset: (d)=>(d * n + 1) / n,
            range: (lo, hi)=>(0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(Math.ceil(lo * n), hi * n).map((x)=>x / n)
        } : {
            floor: (d)=>Math.floor(d / n) * n,
            offset: (d)=>d + n,
            range: (lo, hi)=>(0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(Math.ceil(lo / n), hi / n).map((x)=>x * n)
        };
    }
    if (typeof interval === "string") return (type === "time" ? (0, $49e9bdee870d78f0$export$5b8228f091405edd) : (0, $49e9bdee870d78f0$export$4c170b80b09a0a2c))(interval);
    if (typeof interval.floor !== "function") throw new Error("invalid interval; missing floor method");
    if (typeof interval.offset !== "function") throw new Error("invalid interval; missing offset method");
    return interval;
}
function $cd9e805a4bbd13f9$export$e13732492629ec8c(interval, type) {
    interval = $cd9e805a4bbd13f9$export$91a968a7e5747089(interval, type);
    if (interval && typeof interval.range !== "function") throw new Error("invalid interval: missing range method");
    return interval;
}
function $cd9e805a4bbd13f9$export$367d1ceccf20717f(interval, type) {
    interval = $cd9e805a4bbd13f9$export$e13732492629ec8c(interval, type);
    if (interval && typeof interval.ceil !== "function") throw new Error("invalid interval: missing ceil method");
    return interval;
}
function $cd9e805a4bbd13f9$export$99c391ff8c95e1af(t) {
    return $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e(t) && typeof t?.floor === "function" && t.floor() instanceof Date;
}
function $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e(t) {
    return typeof t?.range === "function";
}
function $cd9e805a4bbd13f9$export$f4579685de3ca7bf(value) {
    return value === undefined || $cd9e805a4bbd13f9$export$dae3322343de7d27(value) ? value : {
        value: value
    };
}
function $cd9e805a4bbd13f9$export$a152540187b5d206(source) {
    return source == null ? null : {
        transform: (data)=>$cd9e805a4bbd13f9$export$1414f04542a0b4f4(data, source, Float64Array),
        label: $cd9e805a4bbd13f9$export$bd9d73a16a2ec705(source)
    };
}
function $cd9e805a4bbd13f9$export$b172b2c11ac297b9(data) {
    if (!$cd9e805a4bbd13f9$export$9652023d9040757(data)) return false;
    for (const d of data){
        if (d == null) continue;
        return typeof d === "object" && "0" in d && "1" in d;
    }
}
function $cd9e805a4bbd13f9$export$9652023d9040757(value) {
    return value && typeof value[Symbol.iterator] === "function";
}
function $cd9e805a4bbd13f9$export$43674e37205f3011(values) {
    for (const value of values){
        if (value == null) continue;
        return typeof value !== "object" || value instanceof Date;
    }
}
function $cd9e805a4bbd13f9$export$ded408f9a9c9003b(values) {
    for (const value of values){
        if (value == null) continue;
        const type = typeof value;
        return type === "string" || type === "boolean";
    }
}
function $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7(values) {
    for (const value of values){
        if (value == null) continue;
        return value instanceof Date;
    }
}
function $cd9e805a4bbd13f9$export$4ca903a67c0d1c91(values) {
    for (const value of values){
        if (value == null) continue;
        return typeof value === "string" && isNaN(value) && (0, $a25d0745dd917edb$export$2e2bcd8739ae039)(value);
    }
}
function $cd9e805a4bbd13f9$export$797f4d96e209972c(values) {
    for (const value of values){
        if (value == null) continue;
        if (typeof value !== "string") return false;
        if (!value.trim()) continue;
        return !isNaN(value);
    }
}
function $cd9e805a4bbd13f9$export$e90fb89750dba83f(values) {
    for (const value of values){
        if (value == null) continue;
        return typeof value === "number";
    }
}
function $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1(values, is) {
    let every;
    for (const value of values){
        if (value == null) continue;
        if (!is(value)) return false;
        every = true;
    }
    return every;
}
const $cd9e805a4bbd13f9$var$namedColors = new Set("none,currentcolor,transparent,aliceblue,antiquewhite,aqua,aquamarine,azure,beige,bisque,black,blanchedalmond,blue,blueviolet,brown,burlywood,cadetblue,chartreuse,chocolate,coral,cornflowerblue,cornsilk,crimson,cyan,darkblue,darkcyan,darkgoldenrod,darkgray,darkgreen,darkgrey,darkkhaki,darkmagenta,darkolivegreen,darkorange,darkorchid,darkred,darksalmon,darkseagreen,darkslateblue,darkslategray,darkslategrey,darkturquoise,darkviolet,deeppink,deepskyblue,dimgray,dimgrey,dodgerblue,firebrick,floralwhite,forestgreen,fuchsia,gainsboro,ghostwhite,gold,goldenrod,gray,green,greenyellow,grey,honeydew,hotpink,indianred,indigo,ivory,khaki,lavender,lavenderblush,lawngreen,lemonchiffon,lightblue,lightcoral,lightcyan,lightgoldenrodyellow,lightgray,lightgreen,lightgrey,lightpink,lightsalmon,lightseagreen,lightskyblue,lightslategray,lightslategrey,lightsteelblue,lightyellow,lime,limegreen,linen,magenta,maroon,mediumaquamarine,mediumblue,mediumorchid,mediumpurple,mediumseagreen,mediumslateblue,mediumspringgreen,mediumturquoise,mediumvioletred,midnightblue,mintcream,mistyrose,moccasin,navajowhite,navy,oldlace,olive,olivedrab,orange,orangered,orchid,palegoldenrod,palegreen,paleturquoise,palevioletred,papayawhip,peachpuff,peru,pink,plum,powderblue,purple,rebeccapurple,red,rosybrown,royalblue,saddlebrown,salmon,sandybrown,seagreen,seashell,sienna,silver,skyblue,slateblue,slategray,slategrey,snow,springgreen,steelblue,tan,teal,thistle,tomato,turquoise,violet,wheat,white,whitesmoke,yellow".split(",")); // prettier-ignore
function $cd9e805a4bbd13f9$export$e82f763eaa28f6fe(value) {
    if (typeof value !== "string") return false;
    value = value.toLowerCase().trim();
    return /^#[0-9a-f]{3,8}$/.test(value) || // hex rgb, rgba, rrggbb, rrggbbaa
    /^(?:url|var|rgb|rgba|hsl|hsla|hwb|lab|lch|oklab|oklch|color|color-mix)\(.*\)$/.test(value) || // <funciri>, CSS variable, color, etc.
    $cd9e805a4bbd13f9$var$namedColors.has(value) // currentColor, red, etc.
    ;
}
function $cd9e805a4bbd13f9$export$4108b961417e5a2a(value) {
    return typeof value === "number" && (0 <= value && value <= 1 || isNaN(value));
}
function $cd9e805a4bbd13f9$export$143ac3c9068abf57(value) {
    return value == null || $cd9e805a4bbd13f9$export$e56af863d5645d5f(value);
}
function $cd9e805a4bbd13f9$export$e56af863d5645d5f(value) {
    return /^\s*none\s*$/i.test(value);
}
function $cd9e805a4bbd13f9$export$e2647994a9b8277a(value) {
    return /^\s*round\s*$/i.test(value);
}
function $cd9e805a4bbd13f9$export$6738a673c9b9c522(value, name) {
    return $cd9e805a4bbd13f9$export$a305618d7bff6223(value, name, [
        "middle",
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]);
}
function $cd9e805a4bbd13f9$export$e2bf218018856d53(value = "middle") {
    return $cd9e805a4bbd13f9$export$6738a673c9b9c522(value, "frameAnchor");
}
function $cd9e805a4bbd13f9$export$c25b1294fe9f63f1(values) {
    if (values == null) return;
    const first = values[0];
    const last = values[values.length - 1];
    return (0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(first, last);
}
function $cd9e805a4bbd13f9$export$4dc9a6b0ae3dfd2a(options = {}, ...rest) {
    let o = options;
    for (const defaults of rest){
        for(const key in defaults)if (o[key] === undefined) {
            const value = defaults[key];
            if (o === options) o = {
                ...o,
                [key]: value
            };
            else o[key] = value;
        }
    }
    return o;
}
function $cd9e805a4bbd13f9$export$e1744e1bc4c7f337(things) {
    console.warn("named iterables are deprecated; please use an object instead");
    const names = new Set();
    return Object.fromEntries(Array.from(things, (thing)=>{
        const { name: name } = thing;
        if (name == null) throw new Error("missing name");
        const key = `${name}`;
        if (key === "__proto__") throw new Error(`illegal name: ${key}`);
        if (names.has(key)) throw new Error(`duplicate name: ${key}`);
        names.add(key);
        return [
            name,
            thing
        ];
    }));
}
function $cd9e805a4bbd13f9$export$b221e5d053773f17(things) {
    return $cd9e805a4bbd13f9$export$9652023d9040757(things) ? $cd9e805a4bbd13f9$export$e1744e1bc4c7f337(things) : things;
}


function $d18c56c98d932ebe$export$7a9bd61063bd9325(compute) {
    let cacheValue, cacheKeys;
    return (...keys)=>{
        if (cacheKeys?.length !== keys.length || cacheKeys.some((k, i)=>k !== keys[i])) {
            cacheKeys = keys;
            cacheValue = compute(...keys);
        }
        return cacheValue;
    };
}


const $4b16c4377cd1e2de$var$numberFormat = (0, $d18c56c98d932ebe$export$7a9bd61063bd9325)((locale)=>{
    return new Intl.NumberFormat(locale);
});
const $4b16c4377cd1e2de$var$monthFormat = (0, $d18c56c98d932ebe$export$7a9bd61063bd9325)((locale, month)=>{
    return new Intl.DateTimeFormat(locale, {
        timeZone: "UTC",
        ...month && {
            month: month
        }
    });
});
const $4b16c4377cd1e2de$var$weekdayFormat = (0, $d18c56c98d932ebe$export$7a9bd61063bd9325)((locale, weekday)=>{
    return new Intl.DateTimeFormat(locale, {
        timeZone: "UTC",
        ...weekday && {
            weekday: weekday
        }
    });
});
function $4b16c4377cd1e2de$export$f5dd818bff069720(locale = "en-US") {
    const format = $4b16c4377cd1e2de$var$numberFormat(locale);
    return (i)=>i != null && !isNaN(i) ? format.format(i) : undefined;
}
function $4b16c4377cd1e2de$export$d0536c8e7f45796e(locale = "en-US", format = "short") {
    const fmt = $4b16c4377cd1e2de$var$monthFormat(locale, format);
    return (i)=>i != null && !isNaN(i = +new Date(Date.UTC(2000, +i))) ? fmt.format(i) : undefined;
}
function $4b16c4377cd1e2de$export$407180b957f39d7e(locale = "en-US", format = "short") {
    const fmt = $4b16c4377cd1e2de$var$weekdayFormat(locale, format);
    return (i)=>i != null && !isNaN(i = +new Date(Date.UTC(2001, 0, +i))) ? fmt.format(i) : undefined;
}
function $4b16c4377cd1e2de$export$1431bc52824a265(date) {
    return (0, $cb17f3275e1ef5a0$export$2e2bcd8739ae039)(date, "Invalid Date");
}
function $4b16c4377cd1e2de$export$f8e35388847b8492(locale = "en-US") {
    const number = $4b16c4377cd1e2de$export$f5dd818bff069720(locale);
    return (v)=>(v instanceof Date ? $4b16c4377cd1e2de$export$1431bc52824a265 : typeof v === "number" ? number : (0, $cd9e805a4bbd13f9$export$22b082955e083ec3))(v);
}
const $4b16c4377cd1e2de$export$bb457229db2006fb = $4b16c4377cd1e2de$export$f8e35388847b8492();



let $30c329e934b7a0f1$var$warnings = 0;
let $30c329e934b7a0f1$var$lastMessage;
function $30c329e934b7a0f1$export$1876d6a9858b29e7() {
    const w = $30c329e934b7a0f1$var$warnings;
    $30c329e934b7a0f1$var$warnings = 0;
    $30c329e934b7a0f1$var$lastMessage = undefined;
    return w;
}
function $30c329e934b7a0f1$export$c106dd0671a0fc2d(message) {
    if (message === $30c329e934b7a0f1$var$lastMessage) return;
    $30c329e934b7a0f1$var$lastMessage = message;
    console.warn(message);
    ++$30c329e934b7a0f1$var$warnings;
}


const $547e5698440387a8$export$cc800923e997bb8 = (typeof window !== "undefined" ? window.devicePixelRatio > 1 : typeof it === "undefined") ? 0 : 0.5; // prettier-ignore
let $547e5698440387a8$var$nextClipId = 0;
function $547e5698440387a8$export$3944aa75e0f0f740() {
    return `plot-clip-${++$547e5698440387a8$var$nextClipId}`;
}
function $547e5698440387a8$export$9dd6ff9ea0189349(mark, { title: title, href: href, ariaLabel: variaLabel, ariaDescription: ariaDescription, ariaHidden: ariaHidden, target: target, fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, strokeLinejoin: strokeLinejoin, strokeLinecap: strokeLinecap, strokeMiterlimit: strokeMiterlimit, strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset, opacity: opacity, mixBlendMode: mixBlendMode, imageFilter: imageFilter, paintOrder: paintOrder, pointerEvents: pointerEvents, shapeRendering: shapeRendering, channels: channels }, { ariaLabel: cariaLabel, fill: defaultFill = "currentColor", fillOpacity: defaultFillOpacity, stroke: defaultStroke = "none", strokeOpacity: defaultStrokeOpacity, strokeWidth: defaultStrokeWidth, strokeLinecap: defaultStrokeLinecap, strokeLinejoin: defaultStrokeLinejoin, strokeMiterlimit: defaultStrokeMiterlimit, paintOrder: defaultPaintOrder }) {
    // Some marks don’t support fill (e.g., tick and rule).
    if (defaultFill === null) {
        fill = null;
        fillOpacity = null;
    }
    // Some marks don’t support stroke (e.g., image).
    if (defaultStroke === null) {
        stroke = null;
        strokeOpacity = null;
    }
    // Some marks default to fill with no stroke, while others default to stroke
    // with no fill. For example, bar and area default to fill, while dot and line
    // default to stroke. For marks that fill by default, the default fill only
    // applies if the stroke is (constant) none; if you set a stroke, then the
    // default fill becomes none. Similarly for marks that stroke by stroke, the
    // default stroke only applies if the fill is (constant) none.
    if ((0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(defaultFill)) {
        if (!(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(defaultStroke) && (!(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) || channels?.fill)) defaultStroke = "none";
    } else if ((0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(defaultStroke) && (!(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(stroke) || channels?.stroke)) defaultFill = "none";
    const [vfill, cfill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill, defaultFill);
    const [vfillOpacity, cfillOpacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(fillOpacity, defaultFillOpacity);
    const [vstroke, cstroke] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke, defaultStroke);
    const [vstrokeOpacity, cstrokeOpacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeOpacity, defaultStrokeOpacity);
    const [vopacity, copacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(opacity);
    // For styles that have no effect if there is no stroke, only apply the
    // defaults if the stroke is not the constant none. (If stroke is a channel,
    // then cstroke will be undefined, but there’s still a stroke; hence we don’t
    // use isNoneish here.)
    if (!(0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(cstroke)) {
        if (strokeWidth === undefined) strokeWidth = defaultStrokeWidth;
        if (strokeLinecap === undefined) strokeLinecap = defaultStrokeLinecap;
        if (strokeLinejoin === undefined) strokeLinejoin = defaultStrokeLinejoin;
        // The default stroke miterlimit need not be applied if the current stroke
        // is the constant round; this only has effect on miter joins.
        if (strokeMiterlimit === undefined && !(0, $cd9e805a4bbd13f9$export$e2647994a9b8277a)(strokeLinejoin)) strokeMiterlimit = defaultStrokeMiterlimit;
        // The paint order only takes effect if there is both a fill and a stroke
        // (at least if we ignore markers, which no built-in marks currently use).
        if (!(0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(cfill) && paintOrder === undefined) paintOrder = defaultPaintOrder;
    }
    const [vstrokeWidth, cstrokeWidth] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeWidth);
    // Some marks don’t support fill (e.g., tick and rule).
    if (defaultFill !== null) {
        mark.fill = $547e5698440387a8$export$e1c487990851f09f(cfill, "currentColor");
        mark.fillOpacity = $547e5698440387a8$export$1db7b3628ce7c301(cfillOpacity, 1);
    }
    // Some marks don’t support stroke (e.g., image).
    if (defaultStroke !== null) {
        mark.stroke = $547e5698440387a8$export$e1c487990851f09f(cstroke, "none");
        mark.strokeWidth = $547e5698440387a8$export$1db7b3628ce7c301(cstrokeWidth, 1);
        mark.strokeOpacity = $547e5698440387a8$export$1db7b3628ce7c301(cstrokeOpacity, 1);
        mark.strokeLinejoin = $547e5698440387a8$export$e1c487990851f09f(strokeLinejoin, "miter");
        mark.strokeLinecap = $547e5698440387a8$export$e1c487990851f09f(strokeLinecap, "butt");
        mark.strokeMiterlimit = $547e5698440387a8$export$1db7b3628ce7c301(strokeMiterlimit, 4);
        mark.strokeDasharray = $547e5698440387a8$export$e1c487990851f09f(strokeDasharray, "none");
        mark.strokeDashoffset = $547e5698440387a8$export$e1c487990851f09f(strokeDashoffset, "0");
    }
    mark.target = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(target);
    mark.ariaLabel = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(cariaLabel);
    mark.ariaDescription = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(ariaDescription);
    mark.ariaHidden = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(ariaHidden);
    mark.opacity = $547e5698440387a8$export$1db7b3628ce7c301(copacity, 1);
    mark.mixBlendMode = $547e5698440387a8$export$e1c487990851f09f(mixBlendMode, "normal");
    mark.imageFilter = $547e5698440387a8$export$e1c487990851f09f(imageFilter, "none");
    mark.paintOrder = $547e5698440387a8$export$e1c487990851f09f(paintOrder, "normal");
    mark.pointerEvents = $547e5698440387a8$export$e1c487990851f09f(pointerEvents, "auto");
    mark.shapeRendering = $547e5698440387a8$export$e1c487990851f09f(shapeRendering, "auto");
    return {
        title: {
            value: title,
            optional: true,
            filter: null
        },
        href: {
            value: href,
            optional: true,
            filter: null
        },
        ariaLabel: {
            value: variaLabel,
            optional: true,
            filter: null
        },
        fill: {
            value: vfill,
            scale: "auto",
            optional: true
        },
        fillOpacity: {
            value: vfillOpacity,
            scale: "auto",
            optional: true
        },
        stroke: {
            value: vstroke,
            scale: "auto",
            optional: true
        },
        strokeOpacity: {
            value: vstrokeOpacity,
            scale: "auto",
            optional: true
        },
        strokeWidth: {
            value: vstrokeWidth,
            optional: true
        },
        opacity: {
            value: vopacity,
            scale: "auto",
            optional: true
        }
    };
}
function $547e5698440387a8$export$15b4cd30900b219a(selection, L) {
    if (L) selection.filter((i)=>(0, $0f3e37548c3914c7$export$6ce6c9218151d511)(L[i])).append("title").call($547e5698440387a8$export$539290aca48c3ba8, L);
}
function $547e5698440387a8$export$1a6f5a923ffc407(selection, L) {
    if (L) selection.filter(([i])=>(0, $0f3e37548c3914c7$export$6ce6c9218151d511)(L[i])).append("title").call($547e5698440387a8$export$c9237586da8aa924, L);
}
function $547e5698440387a8$export$539290aca48c3ba8(selection, T) {
    if (T) selection.text((i)=>(0, $4b16c4377cd1e2de$export$bb457229db2006fb)(T[i]));
}
function $547e5698440387a8$export$c9237586da8aa924(selection, T) {
    if (T) selection.text(([i])=>(0, $4b16c4377cd1e2de$export$bb457229db2006fb)(T[i]));
}
function $547e5698440387a8$export$43a1bc6cf61126e3(selection, { target: target, tip: tip }, { ariaLabel: AL, title: T, fill: F, fillOpacity: FO, stroke: S, strokeOpacity: SO, strokeWidth: SW, opacity: O, href: H }) {
    if (AL) $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-label", (i)=>AL[i]);
    if (F) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill", (i)=>F[i]);
    if (FO) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill-opacity", (i)=>FO[i]);
    if (S) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke", (i)=>S[i]);
    if (SO) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-opacity", (i)=>SO[i]);
    if (SW) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-width", (i)=>SW[i]);
    if (O) $547e5698440387a8$export$47765c6b16054eb2(selection, "opacity", (i)=>O[i]);
    if (H) $547e5698440387a8$var$applyHref(selection, (i)=>H[i], target);
    if (!tip) $547e5698440387a8$export$15b4cd30900b219a(selection, T);
}
function $547e5698440387a8$export$ddd674e1b6498f54(selection, { target: target, tip: tip }, { ariaLabel: AL, title: T, fill: F, fillOpacity: FO, stroke: S, strokeOpacity: SO, strokeWidth: SW, opacity: O, href: H }) {
    if (AL) $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-label", ([i])=>AL[i]);
    if (F) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill", ([i])=>F[i]);
    if (FO) $547e5698440387a8$export$47765c6b16054eb2(selection, "fill-opacity", ([i])=>FO[i]);
    if (S) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke", ([i])=>S[i]);
    if (SO) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-opacity", ([i])=>SO[i]);
    if (SW) $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-width", ([i])=>SW[i]);
    if (O) $547e5698440387a8$export$47765c6b16054eb2(selection, "opacity", ([i])=>O[i]);
    if (H) $547e5698440387a8$var$applyHref(selection, ([i])=>H[i], target);
    if (!tip) $547e5698440387a8$export$1a6f5a923ffc407(selection, T);
}
function $547e5698440387a8$var$groupAesthetics({ ariaLabel: AL, title: T, fill: F, fillOpacity: FO, stroke: S, strokeOpacity: SO, strokeWidth: SW, opacity: O, href: H }, { tip: tip }) {
    return [
        AL,
        tip ? undefined : T,
        F,
        FO,
        S,
        SO,
        SW,
        O,
        H
    ].filter((c)=>c !== undefined);
}
function $547e5698440387a8$export$ae9fea6755af6637(I, Z, z) {
    const G = (0, $6f0c14a1378d16c1$export$2e2bcd8739ae039)(I, (i)=>Z[i]);
    if (z === undefined && G.size > 1 + I.length >> 1) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the implicit z channel has high cardinality. This may occur when the fill or stroke channel is associated with quantitative data rather than ordinal or categorical data. You can suppress this warning by setting the z option explicitly; if this data represents a single series, set z to null.`);
    return G.values();
}
function* $547e5698440387a8$export$33c8ab41edf38638(I, position, mark, channels) {
    const { z: z } = mark;
    const { z: Z } = channels; // group channel
    const A = $547e5698440387a8$var$groupAesthetics(channels, mark); // aesthetic channels
    const C = [
        ...position,
        ...A
    ]; // all channels
    // Group the current index by Z (if any).
    for (const G of Z ? $547e5698440387a8$export$ae9fea6755af6637(I, Z, z) : [
        I
    ]){
        let Ag; // the A-values (aesthetics) of the current group, if any
        let Gg; // the current group index (a subset of G, and I), if any
        out: for (const i of G){
            // If any channel has an undefined value for this index, skip it.
            for (const c of C)if (!(0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97)(c[i])) {
                if (Gg) Gg.push(-1);
                continue out;
            }
            // Otherwise, if this is a new group, record the aesthetics for this
            // group. Yield the current group and start a new one.
            if (Ag === undefined) {
                if (Gg) yield Gg;
                Ag = A.map((c)=>(0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(c[i])), Gg = [
                    i
                ];
                continue;
            }
            // Otherwise, add the current index to the current group. Then, if any of
            // the aesthetics don’t match the current group, yield the current group
            // and start a new group of the current index.
            Gg.push(i);
            for(let j = 0; j < A.length; ++j){
                const k = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(A[j][i]);
                if (k !== Ag[j]) {
                    yield Gg;
                    Ag = A.map((c)=>(0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(c[i])), Gg = [
                        i
                    ];
                    continue out;
                }
            }
        }
        // Yield the current group, if any.
        if (Gg) yield Gg;
    }
}
function $547e5698440387a8$export$1920f6ea06533ca7(clip) {
    if (clip === true) clip = "frame";
    else if (clip === false) clip = null;
    else if (clip != null) clip = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(clip, "clip", [
        "frame",
        "sphere"
    ]);
    return clip;
}
// Note: may mutate selection.node!
function $547e5698440387a8$var$applyClip(selection, mark, dimensions, context) {
    let clipUrl;
    const { clip: clip = context.clip } = mark;
    switch(clip){
        case "frame":
            {
                const { width: width, height: height, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, marginBottom: marginBottom } = dimensions;
                const id = $547e5698440387a8$export$3944aa75e0f0f740();
                clipUrl = `url(#${id})`;
                selection = (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((g)=>g.append("svg:clipPath").attr("id", id).append("rect").attr("x", marginLeft).attr("y", marginTop).attr("width", width - marginRight - marginLeft).attr("height", height - marginTop - marginBottom)).each(function() {
                    this.appendChild(selection.node());
                    selection.node = ()=>this; // Note: mutation!
                });
                break;
            }
        case "sphere":
            {
                const { projection: projection } = context;
                if (!projection) throw new Error(`the "sphere" clip option requires a projection`);
                const id = $547e5698440387a8$export$3944aa75e0f0f740();
                clipUrl = `url(#${id})`;
                selection.append("clipPath").attr("id", id).append("path").attr("d", (0, $58c46562f4a8d739$export$2e2bcd8739ae039)(projection)({
                    type: "Sphere"
                }));
                break;
            }
    }
    // Here we’re careful to apply the ARIA attributes to the outer G element when
    // clipping is applied, and to apply the ARIA attributes before any other
    // attributes (for readability).
    $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-label", mark.ariaLabel);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-description", mark.ariaDescription);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "aria-hidden", mark.ariaHidden);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "clip-path", clipUrl);
}
function $547e5698440387a8$export$b9ed040f258dd66e(selection, mark, dimensions, context) {
    $547e5698440387a8$var$applyClip(selection, mark, dimensions, context);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "fill", mark.fill);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "fill-opacity", mark.fillOpacity);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke", mark.stroke);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-width", mark.strokeWidth);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-opacity", mark.strokeOpacity);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-linejoin", mark.strokeLinejoin);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-linecap", mark.strokeLinecap);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-miterlimit", mark.strokeMiterlimit);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-dasharray", mark.strokeDasharray);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "stroke-dashoffset", mark.strokeDashoffset);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "shape-rendering", mark.shapeRendering);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "filter", mark.imageFilter);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "paint-order", mark.paintOrder);
    const { pointerEvents: pointerEvents = context.pointerSticky === false ? "none" : undefined } = mark;
    $547e5698440387a8$export$47765c6b16054eb2(selection, "pointer-events", pointerEvents);
}
function $547e5698440387a8$export$2949c2472f804203(selection, mark) {
    $547e5698440387a8$export$d63a6b7859608045(selection, "mix-blend-mode", mark.mixBlendMode);
    $547e5698440387a8$export$47765c6b16054eb2(selection, "opacity", mark.opacity);
}
function $547e5698440387a8$var$applyHref(selection, href, target) {
    selection.each(function(i) {
        const h = href(i);
        if (h != null) {
            const a = this.ownerDocument.createElementNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).svg, "a");
            a.setAttribute("fill", "inherit");
            a.setAttributeNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).xlink, "href", h);
            if (target != null) a.setAttribute("target", target);
            this.parentNode.insertBefore(a, this).appendChild(this);
        }
    });
}
function $547e5698440387a8$export$47765c6b16054eb2(selection, name, value) {
    if (value != null) selection.attr(name, value);
}
function $547e5698440387a8$export$d63a6b7859608045(selection, name, value) {
    if (value != null) selection.style(name, value);
}
function $547e5698440387a8$export$9f9dcb98c894b623(selection, mark, { x: x, y: y }, tx = $547e5698440387a8$export$cc800923e997bb8, ty = $547e5698440387a8$export$cc800923e997bb8) {
    tx += mark.dx;
    ty += mark.dy;
    if (x?.bandwidth) tx += x.bandwidth() / 2;
    if (y?.bandwidth) ty += y.bandwidth() / 2;
    if (tx || ty) selection.attr("transform", `translate(${tx},${ty})`);
}
function $547e5698440387a8$export$e1c487990851f09f(value, impliedValue) {
    if ((value = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(value)) !== impliedValue) return value;
}
function $547e5698440387a8$export$1db7b3628ce7c301(value, impliedValue) {
    if ((value = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(value)) !== impliedValue) return value;
}
// https://www.w3.org/TR/CSS21/grammar.html
const $547e5698440387a8$var$validClassName = /^-?([_a-z]|[\240-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])([_a-z0-9-]|[\240-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])*$/i;
function $547e5698440387a8$export$22300e6eaecca37(name) {
    // The default should be changed whenever the default styles are changed, so
    // as to avoid conflict when multiple versions of Plot are on the page.
    if (name === undefined) return "plot-d6a7b5";
    name = `${name}`;
    if (!$547e5698440387a8$var$validClassName.test(name)) throw new Error(`invalid class name: ${name}`);
    return name;
}
function $547e5698440387a8$export$4e6c5cc1af44143e(selection, style) {
    if (typeof style === "string") selection.property("style", style);
    else if (style != null) for (const element of selection)Object.assign(element.style, style);
}
function $547e5698440387a8$export$867c1a80005e0d82({ frameAnchor: frameAnchor }, { width: width, height: height, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft }) {
    return [
        /left$/.test(frameAnchor) ? marginLeft : /right$/.test(frameAnchor) ? width - marginRight : (marginLeft + width - marginRight) / 2,
        /^top/.test(frameAnchor) ? marginTop : /^bottom/.test(frameAnchor) ? height - marginBottom : (marginTop + height - marginBottom) / 2
    ];
}


function $871355576fc3efd9$export$fd42f52fd3ae1109(options = {}) {
    const { document: document = typeof window !== "undefined" ? window.document : undefined, clip: clip } = options;
    return {
        document: document,
        clip: (0, $547e5698440387a8$export$1920f6ea06533ca7)(clip)
    };
}
function $871355576fc3efd9$export$185802fd694ee1f5(name, { document: document }) {
    return (0, $cf81072cf307ee25$export$2e2bcd8739ae039)((0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name).call(document.documentElement));
}






// Positional scales have associated axes, and for ordinal data, a point or band
// scale is used instead of an ordinal scale.
const $743dde21c57c19a0$export$5880b8b5730aff45 = Symbol("position");
const $743dde21c57c19a0$export$35e9368ef982300f = Symbol("color");
const $743dde21c57c19a0$export$872dd985a098dd45 = Symbol("radius");
const $743dde21c57c19a0$export$f24224f1c91d8156 = Symbol("length");
const $743dde21c57c19a0$export$c17a3be1057836e = Symbol("opacity");
const $743dde21c57c19a0$export$8f701197936bc2a6 = Symbol("symbol");
const $743dde21c57c19a0$export$b74061472fe7c07 = Symbol("projection");
const $743dde21c57c19a0$export$4bb7493d241fd8a5 = new Map([
    [
        "x",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "y",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "fx",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "fy",
        $743dde21c57c19a0$export$5880b8b5730aff45
    ],
    [
        "r",
        $743dde21c57c19a0$export$872dd985a098dd45
    ],
    [
        "color",
        $743dde21c57c19a0$export$35e9368ef982300f
    ],
    [
        "opacity",
        $743dde21c57c19a0$export$c17a3be1057836e
    ],
    [
        "symbol",
        $743dde21c57c19a0$export$8f701197936bc2a6
    ],
    [
        "length",
        $743dde21c57c19a0$export$f24224f1c91d8156
    ],
    [
        "projection",
        $743dde21c57c19a0$export$b74061472fe7c07
    ]
]);
function $743dde21c57c19a0$export$1680e4b48df7f4f2(kind) {
    return kind === $743dde21c57c19a0$export$5880b8b5730aff45 || kind === $743dde21c57c19a0$export$b74061472fe7c07;
}
function $743dde21c57c19a0$export$2d070ad8c31ab6b9(kind) {
    return kind === $743dde21c57c19a0$export$5880b8b5730aff45 || kind === $743dde21c57c19a0$export$872dd985a098dd45 || kind === $743dde21c57c19a0$export$f24224f1c91d8156 || kind === $743dde21c57c19a0$export$c17a3be1057836e;
}



const $7ef09cabd5617a1b$export$91aa808ec3c0b8ec = Math.sqrt(3);
const $7ef09cabd5617a1b$export$9ac4eebcf02b462f = 2 / $7ef09cabd5617a1b$export$91aa808ec3c0b8ec;
const $7ef09cabd5617a1b$var$symbolHexagon = {
    draw (context, size) {
        const rx = Math.sqrt(size / Math.PI), ry = rx * $7ef09cabd5617a1b$export$9ac4eebcf02b462f, hy = ry / 2;
        context.moveTo(0, ry);
        context.lineTo(rx, hy);
        context.lineTo(rx, -hy);
        context.lineTo(0, -ry);
        context.lineTo(-rx, -hy);
        context.lineTo(-rx, hy);
        context.closePath();
    }
};
const $7ef09cabd5617a1b$var$symbols = new Map([
    [
        "asterisk",
        (0, $134055608cfdbbf1$export$2e2bcd8739ae039)
    ],
    [
        "circle",
        (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039)
    ],
    [
        "cross",
        (0, $6389eccbe795c95c$export$2e2bcd8739ae039)
    ],
    [
        "diamond",
        (0, $42af998bb354705d$export$2e2bcd8739ae039)
    ],
    [
        "diamond2",
        (0, $f2564dd3ed0020e5$export$2e2bcd8739ae039)
    ],
    [
        "hexagon",
        $7ef09cabd5617a1b$var$symbolHexagon
    ],
    [
        "plus",
        (0, $6eee48c5df32b70c$export$2e2bcd8739ae039)
    ],
    [
        "square",
        (0, $1dda04e919c4f021$export$2e2bcd8739ae039)
    ],
    [
        "square2",
        (0, $efaaae86227c5844$export$2e2bcd8739ae039)
    ],
    [
        "star",
        (0, $4ff326387f52757d$export$2e2bcd8739ae039)
    ],
    [
        "times",
        (0, $91f4a6205a1a3d92$export$2e2bcd8739ae039)
    ],
    [
        "triangle",
        (0, $d45526fd1ffbd617$export$2e2bcd8739ae039)
    ],
    [
        "triangle2",
        (0, $70a1b9646572faf7$export$2e2bcd8739ae039)
    ],
    [
        "wye",
        (0, $6b5c98530d683be5$export$2e2bcd8739ae039)
    ]
]);
function $7ef09cabd5617a1b$var$isSymbolObject(value) {
    return value && typeof value.draw === "function";
}
function $7ef09cabd5617a1b$export$a244864fd9645c7f(value) {
    if ($7ef09cabd5617a1b$var$isSymbolObject(value)) return true;
    if (typeof value !== "string") return false;
    return $7ef09cabd5617a1b$var$symbols.has(value.toLowerCase());
}
function $7ef09cabd5617a1b$export$355b55bc2192971a(symbol) {
    if (symbol == null || $7ef09cabd5617a1b$var$isSymbolObject(symbol)) return symbol;
    const value = $7ef09cabd5617a1b$var$symbols.get(`${symbol}`.toLowerCase());
    if (value) return value;
    throw new Error(`invalid symbol: ${symbol}`);
}
function $7ef09cabd5617a1b$export$5b4fe6145c7212af(symbol) {
    if (symbol == null || $7ef09cabd5617a1b$var$isSymbolObject(symbol)) return [
        undefined,
        symbol
    ];
    if (typeof symbol === "string") {
        const value = $7ef09cabd5617a1b$var$symbols.get(`${symbol}`.toLowerCase());
        if (value) return [
            undefined,
            value
        ];
    }
    return [
        symbol,
        undefined
    ];
}








function $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6({ filter: f1, sort: s1, reverse: r1, transform: t1, initializer: i1, ...options } = {}, transform) {
    // If both t1 and t2 are defined, returns a composite transform that first
    // applies t1 and then applies t2.
    if (t1 === undefined) {
        // explicit transform overrides filter, sort, and reverse
        if (f1 != null) t1 = $9dfbc15f77c5eeba$var$filterTransform(f1);
        if (s1 != null && !(0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) t1 = $9dfbc15f77c5eeba$var$composeTransform(t1, $9dfbc15f77c5eeba$var$sortTransform(s1));
        if (r1) t1 = $9dfbc15f77c5eeba$var$composeTransform(t1, $9dfbc15f77c5eeba$var$reverseTransform);
    }
    if (transform != null && i1 != null) throw new Error("transforms cannot be applied after initializers");
    return {
        ...options,
        ...(s1 === null || (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) && {
            sort: s1
        },
        transform: $9dfbc15f77c5eeba$var$composeTransform(t1, transform)
    };
}
function $9dfbc15f77c5eeba$export$aff46cc71669aeb2({ filter: f1, sort: s1, reverse: r1, initializer: i1, ...options } = {}, initializer) {
    // If both i1 and i2 are defined, returns a composite initializer that first
    // applies i1 and then applies i2.
    if (i1 === undefined) {
        // explicit initializer overrides filter, sort, and reverse
        if (f1 != null) i1 = $9dfbc15f77c5eeba$var$filterTransform(f1);
        if (s1 != null && !(0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) i1 = $9dfbc15f77c5eeba$var$composeInitializer(i1, $9dfbc15f77c5eeba$var$sortTransform(s1));
        if (r1) i1 = $9dfbc15f77c5eeba$var$composeInitializer(i1, $9dfbc15f77c5eeba$var$reverseTransform);
    }
    return {
        ...options,
        ...(s1 === null || (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(s1)) && {
            sort: s1
        },
        initializer: $9dfbc15f77c5eeba$var$composeInitializer(i1, initializer)
    };
}
function $9dfbc15f77c5eeba$var$composeTransform(t1, t2) {
    if (t1 == null) return t2 === null ? undefined : t2;
    if (t2 == null) return t1 === null ? undefined : t1;
    return function(data, facets, plotOptions) {
        ({ data: data, facets: facets } = t1.call(this, data, facets, plotOptions));
        return t2.call(this, (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(data), facets, plotOptions);
    };
}
function $9dfbc15f77c5eeba$var$composeInitializer(i1, i2) {
    if (i1 == null) return i2 === null ? undefined : i2;
    if (i2 == null) return i1 === null ? undefined : i1;
    return function(data, facets, channels, ...args) {
        let c1, d1, f1, c2, d2, f2;
        ({ data: d1 = data, facets: f1 = facets, channels: c1 } = i1.call(this, data, facets, channels, ...args));
        ({ data: d2 = d1, facets: f2 = f1, channels: c2 } = i2.call(this, d1, f1, {
            ...channels,
            ...c1
        }, ...args));
        return {
            data: d2,
            facets: f2,
            channels: {
                ...c1,
                ...c2
            }
        };
    };
}
function $9dfbc15f77c5eeba$var$apply(options, t) {
    return (options.initializer != null ? $9dfbc15f77c5eeba$export$aff46cc71669aeb2 : $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options, t);
}
function $9dfbc15f77c5eeba$export$3dea766d36a8935f(test, options) {
    return $9dfbc15f77c5eeba$var$apply(options, $9dfbc15f77c5eeba$var$filterTransform(test));
}
function $9dfbc15f77c5eeba$var$filterTransform(value) {
    return (data, facets)=>{
        const V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value);
        return {
            data: data,
            facets: facets.map((I)=>I.filter((i)=>V[i]))
        };
    };
}
function $9dfbc15f77c5eeba$export$66c1ae025e96b4bc({ sort: sort, ...options } = {}) {
    return {
        ...$9dfbc15f77c5eeba$var$apply(options, $9dfbc15f77c5eeba$var$reverseTransform),
        sort: (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null
    };
}
function $9dfbc15f77c5eeba$var$reverseTransform(data, facets) {
    return {
        data: data,
        facets: facets.map((I)=>I.slice().reverse())
    };
}
function $9dfbc15f77c5eeba$export$448332262467e042({ seed: seed, sort: sort, ...options } = {}) {
    return {
        ...$9dfbc15f77c5eeba$var$apply(options, $9dfbc15f77c5eeba$var$sortValue(seed == null ? Math.random : (0, $e8a0bfad26e955e5$export$2e2bcd8739ae039)(seed))),
        sort: (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null
    };
}
function $9dfbc15f77c5eeba$export$97db5808d8f88186(order, { sort: sort, ...options } = {}) {
    return {
        ...((0, $cd9e805a4bbd13f9$export$dae3322343de7d27)(order) && order.channel !== undefined ? $9dfbc15f77c5eeba$export$aff46cc71669aeb2 : $9dfbc15f77c5eeba$var$apply)(options, $9dfbc15f77c5eeba$var$sortTransform(order)),
        sort: (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null
    };
}
function $9dfbc15f77c5eeba$var$sortTransform(value) {
    return (typeof value === "function" && value.length !== 1 ? $9dfbc15f77c5eeba$var$sortData : $9dfbc15f77c5eeba$var$sortValue)(value);
}
function $9dfbc15f77c5eeba$var$sortData(compare) {
    return (data, facets)=>{
        const compareData = (i, j)=>compare(data[i], data[j]);
        return {
            data: data,
            facets: facets.map((I)=>I.slice().sort(compareData))
        };
    };
}
function $9dfbc15f77c5eeba$var$sortValue(value) {
    let channel, order;
    ({ channel: channel, value: value, order: order } = {
        ...(0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(value)
    });
    const negate = channel?.startsWith("-");
    if (negate) channel = channel.slice(1);
    if (order === undefined) order = negate ? (0, $0f3e37548c3914c7$export$e82554a8bd790ef9) : (0, $0f3e37548c3914c7$export$686e14b8469efec4);
    if (typeof order !== "function") switch(`${order}`.toLowerCase()){
        case "ascending":
            order = (0, $0f3e37548c3914c7$export$686e14b8469efec4);
            break;
        case "descending":
            order = (0, $0f3e37548c3914c7$export$e82554a8bd790ef9);
            break;
        default:
            throw new Error(`invalid order: ${order}`);
    }
    return (data, facets, channels)=>{
        let V;
        if (channel === undefined) V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value);
        else {
            if (channels === undefined) throw new Error("channel sort requires an initializer");
            V = channels[channel];
            if (!V) return {}; // ignore missing channel
            V = V.value;
        }
        const compareValue = (i, j)=>order(V[i], V[j]);
        return {
            data: data,
            facets: facets.map((I)=>I.slice().sort(compareValue))
        };
    };
}


function $23ff17797d38563c$export$ae9fea6755af6637(outputs, options) {
    return $23ff17797d38563c$var$groupn(null, null, outputs, options);
}
function $23ff17797d38563c$export$72a2c66beca1513f(outputs = {
    y: "count"
}, options = {}) {
    const { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655) } = options;
    if (x == null) throw new Error("missing channel: x");
    return $23ff17797d38563c$var$groupn(x, null, outputs, options);
}
function $23ff17797d38563c$export$8f6637e44de78be2(outputs = {
    x: "count"
}, options = {}) {
    const { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655) } = options;
    if (y == null) throw new Error("missing channel: y");
    return $23ff17797d38563c$var$groupn(null, y, outputs, options);
}
function $23ff17797d38563c$export$e5e25fbcc1f7affe(outputs = {
    fill: "count"
}, options = {}) {
    let { x: x, y: y } = options;
    [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    if (x == null) throw new Error("missing channel: x");
    if (y == null) throw new Error("missing channel: y");
    return $23ff17797d38563c$var$groupn(x, y, outputs, options);
}
function $23ff17797d38563c$var$groupn(x, y, { data: reduceData = $23ff17797d38563c$export$e9e62aaf7ac0743d, filter: filter, sort: sort, reverse: reverse, ...outputs // output channel definitions
 } = {}, inputs = {} // input channels and options
) {
    // Compute the outputs.
    outputs = $23ff17797d38563c$export$ac28e1cbca805a54(outputs, inputs);
    reduceData = $23ff17797d38563c$var$maybeGroupReduce(reduceData, (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655));
    sort = sort == null ? undefined : $23ff17797d38563c$var$maybeGroupOutput("sort", sort, inputs);
    filter = filter == null ? undefined : $23ff17797d38563c$var$maybeGroupEvaluator("filter", filter, inputs);
    // Produce x and y output channels as appropriate.
    const [GX, setGX] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(x);
    const [GY, setGY] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(y);
    // Greedily materialize the z, fill, and stroke channels (if channels and not
    // constants) so that we can reference them for subdividing groups without
    // computing them more than once.
    const { z: z, fill: fill, stroke: stroke, x1: x1, x2: x2, y1: y1, y2: y2, ...options } = inputs;
    const [GZ, setGZ] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(z);
    const [vfill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    const [vstroke] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke);
    const [GF, setGF] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(vfill);
    const [GS, setGS] = (0, $cd9e805a4bbd13f9$export$46d040b9076e32ab)(vstroke);
    return {
        ..."z" in inputs && {
            z: GZ || z
        },
        ..."fill" in inputs && {
            fill: GF || fill
        },
        ..."stroke" in inputs && {
            stroke: GS || stroke
        },
        ...(0, $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options, (data, facets, plotOptions)=>{
            const X = (0, $cd9e805a4bbd13f9$export$90792ed47ffcc9f3)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, x), plotOptions?.x);
            const Y = (0, $cd9e805a4bbd13f9$export$90792ed47ffcc9f3)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, y), plotOptions?.y);
            const Z = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, z);
            const F = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, vfill);
            const S = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, vstroke);
            const G = $23ff17797d38563c$export$2b68910c7fd8dbce(outputs, {
                z: Z,
                fill: F,
                stroke: S
            });
            const groupFacets = [];
            const groupData = [];
            const GX = X && setGX([]);
            const GY = Y && setGY([]);
            const GZ = Z && setGZ([]);
            const GF = F && setGF([]);
            const GS = S && setGS([]);
            let i = 0;
            for (const o of outputs)o.initialize(data);
            if (sort) sort.initialize(data);
            if (filter) filter.initialize(data);
            for (const facet of facets){
                const groupFacet = [];
                for (const o of outputs)o.scope("facet", facet);
                if (sort) sort.scope("facet", facet);
                if (filter) filter.scope("facet", facet);
                for (const [f, I] of $23ff17797d38563c$export$66e58775f8a76bc5(facet, G)){
                    for (const [y, gg] of $23ff17797d38563c$export$66e58775f8a76bc5(I, Y))for (const [x, g] of $23ff17797d38563c$export$66e58775f8a76bc5(gg, X)){
                        const extent = {
                            data: data
                        };
                        if (X) extent.x = x;
                        if (Y) extent.y = y;
                        if (filter && !filter.reduce(g, extent)) continue;
                        groupFacet.push(i++);
                        groupData.push(reduceData.reduceIndex(g, data, extent));
                        if (X) GX.push(x);
                        if (Y) GY.push(y);
                        if (Z) GZ.push(G === Z ? f : Z[g[0]]);
                        if (F) GF.push(G === F ? f : F[g[0]]);
                        if (S) GS.push(G === S ? f : S[g[0]]);
                        for (const o of outputs)o.reduce(g, extent);
                        if (sort) sort.reduce(g, extent);
                    }
                }
                groupFacets.push(groupFacet);
            }
            $23ff17797d38563c$export$e6df691e0874bc87(groupFacets, sort, reverse);
            return {
                data: groupData,
                facets: groupFacets
            };
        }),
        ...!$23ff17797d38563c$export$c8c5ed0593b91b40(outputs, "x") && (GX ? {
            x: GX
        } : {
            x1: x1,
            x2: x2
        }),
        ...!$23ff17797d38563c$export$c8c5ed0593b91b40(outputs, "y") && (GY ? {
            y: GY
        } : {
            y1: y1,
            y2: y2
        }),
        ...Object.fromEntries(outputs.map(({ name: name, output: output })=>[
                name,
                output
            ]))
    };
}
function $23ff17797d38563c$export$c8c5ed0593b91b40(outputs, ...names) {
    for (const { name: name } of outputs){
        if (names.includes(name)) return true;
    }
    return false;
}
function $23ff17797d38563c$export$8c5fe1f2932839cd(outputs, inputs, asOutput = $23ff17797d38563c$export$d428705214c4bb4c) {
    const entries = Object.entries(outputs);
    // Propagate standard mark channels by default.
    if (inputs.title != null && outputs.title === undefined) entries.push([
        "title",
        $23ff17797d38563c$var$reduceTitle
    ]);
    if (inputs.href != null && outputs.href === undefined) entries.push([
        "href",
        $23ff17797d38563c$export$e76bb8aee9fc4afa
    ]);
    return entries.filter(([, reduce])=>reduce !== undefined).map(([name, reduce])=>reduce === null ? $23ff17797d38563c$var$nullOutput(name) : asOutput(name, reduce, inputs));
}
function $23ff17797d38563c$export$d428705214c4bb4c(name, reduce, inputs, asEvaluator = $23ff17797d38563c$export$af9bcd7c8847e1bc) {
    let scale; // optional per-channel scale override
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(reduce) && "reduce" in reduce) scale = reduce.scale, reduce = reduce.reduce; // N.B. array.reduce
    const evaluator = asEvaluator(name, reduce, inputs);
    const [output, setOutput] = (0, $cd9e805a4bbd13f9$export$4e0c71f277ca26b3)(evaluator.label);
    let O;
    return {
        name: name,
        output: scale === undefined ? output : {
            value: output,
            scale: scale
        },
        initialize (data) {
            evaluator.initialize(data);
            O = setOutput([]);
        },
        scope (scope, I) {
            evaluator.scope(scope, I);
        },
        reduce (I, extent) {
            O.push(evaluator.reduce(I, extent));
        }
    };
}
function $23ff17797d38563c$var$nullOutput(name) {
    return {
        name: name,
        initialize () {},
        scope () {},
        reduce () {}
    };
}
function $23ff17797d38563c$export$af9bcd7c8847e1bc(name, reduce, inputs, asReduce = $23ff17797d38563c$export$8741001136aed6bd) {
    const input = (0, $cd9e805a4bbd13f9$export$84405e33d6be068e)(name, inputs);
    const reducer = asReduce(reduce, input);
    let V, context;
    return {
        label: (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(reducer === $23ff17797d38563c$export$32697fc8b2c2e2f7 ? null : input, reducer.label),
        initialize (data) {
            V = input === undefined ? data : (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, input);
            if (reducer.scope === "data") context = reducer.reduceIndex((0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data), V);
        },
        scope (scope, I) {
            if (reducer.scope === scope) context = reducer.reduceIndex(I, V);
        },
        reduce (I, extent) {
            return reducer.scope == null ? reducer.reduceIndex(I, V, extent) : reducer.reduceIndex(I, V, context, extent);
        }
    };
}
function $23ff17797d38563c$export$66e58775f8a76bc5(I, X) {
    return X ? (0, $3dc3306e587e145d$export$2e2bcd8739ae039)((0, $6f0c14a1378d16c1$export$2e2bcd8739ae039)(I, (i)=>X[i]), (0, $cd9e805a4bbd13f9$export$43128fadae87b74a)) : [
        [
            ,
            I
        ]
    ];
}
function $23ff17797d38563c$export$8741001136aed6bd(reduce, value, fallback = $23ff17797d38563c$var$invalidReduce) {
    if (reduce == null) return fallback(reduce);
    if (typeof reduce.reduceIndex === "function") return reduce;
    if (typeof reduce.reduce === "function" && (0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(reduce)) return $23ff17797d38563c$var$reduceReduce(reduce); // N.B. array.reduce
    if (typeof reduce === "function") return $23ff17797d38563c$var$reduceFunction(reduce);
    if (/^p\d{2}$/i.test(reduce)) return $23ff17797d38563c$var$reduceAccessor((0, $cd9e805a4bbd13f9$export$c4df44c805494ac9)(reduce));
    switch(`${reduce}`.toLowerCase()){
        case "first":
            return $23ff17797d38563c$export$e76bb8aee9fc4afa;
        case "last":
            return $23ff17797d38563c$var$reduceLast;
        case "identity":
            return $23ff17797d38563c$export$e9e62aaf7ac0743d;
        case "count":
            return $23ff17797d38563c$export$32697fc8b2c2e2f7;
        case "distinct":
            return $23ff17797d38563c$var$reduceDistinct;
        case "sum":
            return value == null ? $23ff17797d38563c$export$32697fc8b2c2e2f7 : $23ff17797d38563c$var$reduceSum;
        case "proportion":
            return $23ff17797d38563c$var$reduceProportion(value, "data");
        case "proportion-facet":
            return $23ff17797d38563c$var$reduceProportion(value, "facet");
        case "deviation":
            return $23ff17797d38563c$var$reduceAccessor((0, $317408b795339b26$export$2e2bcd8739ae039));
        case "min":
            return $23ff17797d38563c$var$reduceAccessor((0, $02ed355deaa9e190$export$2e2bcd8739ae039));
        case "min-index":
            return $23ff17797d38563c$var$reduceAccessor((0, $70ebee7adc32f27f$export$2e2bcd8739ae039));
        case "max":
            return $23ff17797d38563c$var$reduceAccessor((0, $5a964dca3df4eea7$export$2e2bcd8739ae039));
        case "max-index":
            return $23ff17797d38563c$var$reduceAccessor((0, $3ce2d353ce06f740$export$2e2bcd8739ae039));
        case "mean":
            return $23ff17797d38563c$var$reduceMaybeTemporalAccessor((0, $be26fde1f1f97ef0$export$2e2bcd8739ae039));
        case "median":
            return $23ff17797d38563c$var$reduceMaybeTemporalAccessor((0, $5713cbb46e42efc2$export$2e2bcd8739ae039));
        case "variance":
            return $23ff17797d38563c$var$reduceAccessor((0, $4eefdd235be3059b$export$2e2bcd8739ae039));
        case "mode":
            return $23ff17797d38563c$var$reduceAccessor((0, $50f73767cb5db446$export$2e2bcd8739ae039));
    }
    return fallback(reduce);
}
function $23ff17797d38563c$var$invalidReduce(reduce) {
    throw new Error(`invalid reduce: ${reduce}`);
}
function $23ff17797d38563c$export$ac28e1cbca805a54(outputs, inputs) {
    return $23ff17797d38563c$export$8c5fe1f2932839cd(outputs, inputs, $23ff17797d38563c$var$maybeGroupOutput);
}
function $23ff17797d38563c$var$maybeGroupOutput(name, reduce, inputs) {
    return $23ff17797d38563c$export$d428705214c4bb4c(name, reduce, inputs, $23ff17797d38563c$var$maybeGroupEvaluator);
}
function $23ff17797d38563c$var$maybeGroupEvaluator(name, reduce, inputs) {
    return $23ff17797d38563c$export$af9bcd7c8847e1bc(name, reduce, inputs, $23ff17797d38563c$var$maybeGroupReduce);
}
function $23ff17797d38563c$var$maybeGroupReduce(reduce, value) {
    return $23ff17797d38563c$export$8741001136aed6bd(reduce, value, $23ff17797d38563c$var$maybeGroupReduceFallback);
}
function $23ff17797d38563c$var$maybeGroupReduceFallback(reduce) {
    switch(`${reduce}`.toLowerCase()){
        case "x":
            return $23ff17797d38563c$var$reduceX;
        case "y":
            return $23ff17797d38563c$var$reduceY;
    }
    throw new Error(`invalid group reduce: ${reduce}`);
}
function $23ff17797d38563c$export$2b68910c7fd8dbce(outputs, inputs) {
    for(const name in inputs){
        const value = inputs[name];
        if (value !== undefined && !outputs.some((o)=>o.name === name)) return value;
    }
}
function $23ff17797d38563c$export$e6df691e0874bc87(facets, sort, reverse) {
    if (sort) {
        const S = sort.output.transform();
        const compare = (i, j)=>(0, $0f3e37548c3914c7$export$686e14b8469efec4)(S[i], S[j]);
        facets.forEach((f)=>f.sort(compare));
    }
    if (reverse) facets.forEach((f)=>f.reverse());
}
function $23ff17797d38563c$var$reduceReduce(reduce) {
    console.warn("deprecated reduce interface; implement reduceIndex instead.");
    return {
        ...reduce,
        reduceIndex: reduce.reduce.bind(reduce)
    };
}
function $23ff17797d38563c$var$reduceFunction(f) {
    return {
        reduceIndex (I, X, extent) {
            return f((0, $cd9e805a4bbd13f9$export$b7df5d561049483a)(X, I), extent);
        }
    };
}
function $23ff17797d38563c$var$reduceAccessor(f) {
    return {
        reduceIndex (I, X) {
            return f(I, (i)=>X[i]);
        }
    };
}
function $23ff17797d38563c$var$reduceMaybeTemporalAccessor(f) {
    return {
        reduceIndex (I, X) {
            const x = f(I, (i)=>X[i]);
            return (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(X) ? new Date(x) : x;
        }
    };
}
const $23ff17797d38563c$export$e9e62aaf7ac0743d = {
    reduceIndex (I, X) {
        return (0, $cd9e805a4bbd13f9$export$b7df5d561049483a)(X, I);
    }
};
const $23ff17797d38563c$export$e76bb8aee9fc4afa = {
    reduceIndex (I, X) {
        return X[I[0]];
    }
};
const $23ff17797d38563c$var$reduceTitle = {
    reduceIndex (I, X) {
        const n = 5;
        const groups = (0, $3dc3306e587e145d$export$2e2bcd8739ae039)((0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (V)=>V.length, (i)=>X[i]), (0, $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d));
        const top = groups.slice(-n).reverse();
        if (top.length < groups.length) {
            const bottom = groups.slice(0, 1 - n);
            top[n - 1] = [
                `\u{2026} ${bottom.length.toLocaleString("en-US")} more`,
                (0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(bottom, (0, $cd9e805a4bbd13f9$export$3d3c77ce7df7d30d))
            ];
        }
        return top.map(([key, value])=>`${key} (${value.toLocaleString("en-US")})`).join("\n");
    }
};
const $23ff17797d38563c$var$reduceLast = {
    reduceIndex (I, X) {
        return X[I[I.length - 1]];
    }
};
const $23ff17797d38563c$export$32697fc8b2c2e2f7 = {
    label: "Frequency",
    reduceIndex (I) {
        return I.length;
    }
};
const $23ff17797d38563c$var$reduceDistinct = {
    label: "Distinct",
    reduceIndex (I, X) {
        const s = new (0, $3160658555deb5c9$export$55278c3294239828)();
        for (const i of I)s.add(X[i]);
        return s.size;
    }
};
const $23ff17797d38563c$var$reduceSum = $23ff17797d38563c$var$reduceAccessor((0, $daf42a1f07322cf6$export$2e2bcd8739ae039));
function $23ff17797d38563c$var$reduceProportion(value, scope) {
    return value == null ? {
        scope: scope,
        label: "Frequency",
        reduceIndex: (I, V, basis = 1)=>I.length / basis
    } : {
        scope: scope,
        reduceIndex: (I, V, basis = 1)=>(0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(I, (i)=>V[i]) / basis
    };
}
const $23ff17797d38563c$var$reduceX = {
    reduceIndex (I, X, { x: x }) {
        return x;
    }
};
const $23ff17797d38563c$var$reduceY = {
    reduceIndex (I, X, { y: y }) {
        return y;
    }
};
function $23ff17797d38563c$export$71aa6c912b956294(test) {
    if (typeof test !== "function") throw new Error(`invalid test function: ${test}`);
    return {
        reduceIndex (I, V, { data: data }) {
            return V[I.find((i)=>test(data[i], i, data))];
        }
    };
}


function $6eb5f337b2493843$export$47ab4c33d77e344d(data, { scale: scale, type: type, value: value, filter: filter, hint: hint, label: label = (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(value) }, name) {
    if (hint === undefined && typeof value?.transform === "function") hint = value.hint;
    return $6eb5f337b2493843$export$5de38149af3ed501(name, {
        scale: scale,
        type: type,
        value: (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value),
        label: label,
        filter: filter,
        hint: hint
    });
}
function $6eb5f337b2493843$export$422e7cd65ac5d2cf(channels, data) {
    return Object.fromEntries(Object.entries(channels).map(([name, channel])=>[
            name,
            $6eb5f337b2493843$export$47ab4c33d77e344d(data, channel, name)
        ]));
}
function $6eb5f337b2493843$export$9df10f3a4586f4ff(channels, scales) {
    const values = Object.fromEntries(Object.entries(channels).map(([name, { scale: scaleName, value: value }])=>{
        const scale = scaleName == null ? null : scales[scaleName];
        return [
            name,
            scale == null ? value : (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(value, scale)
        ];
    }));
    values.channels = channels; // expose channel state for advanced usage
    return values;
}
function $6eb5f337b2493843$export$5de38149af3ed501(name, channel) {
    const { scale: scale, value: value } = channel;
    if (scale === true || scale === "auto") switch(name){
        case "fill":
        case "stroke":
        case "color":
            channel.scale = scale !== true && (0, $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1)(value, (0, $cd9e805a4bbd13f9$export$e82f763eaa28f6fe)) ? null : "color";
            break;
        case "fillOpacity":
        case "strokeOpacity":
        case "opacity":
            channel.scale = scale !== true && (0, $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1)(value, (0, $cd9e805a4bbd13f9$export$4108b961417e5a2a)) ? null : "opacity";
            break;
        case "symbol":
            if (scale !== true && (0, $cd9e805a4bbd13f9$export$7ec05e1f26ecf6f1)(value, (0, $7ef09cabd5617a1b$export$a244864fd9645c7f))) {
                channel.scale = null;
                channel.value = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(value, (0, $7ef09cabd5617a1b$export$355b55bc2192971a));
            } else channel.scale = "symbol";
            break;
        default:
            channel.scale = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(name) ? name : null;
            break;
    }
    else if (scale === false) channel.scale = null;
    else if (scale != null && !(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(scale)) throw new Error(`unknown scale: ${scale}`);
    return channel;
}
function $6eb5f337b2493843$export$334f2e4e1c2a6aef(data, facets, channels, facetChannels, options) {
    const { order: defaultOrder, reverse: defaultReverse, reduce: defaultReduce = true, limit: defaultLimit } = options;
    for(const x in options){
        if (!(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(x)) continue; // ignore unknown scale keys (including generic options)
        let { value: y, order: order = defaultOrder, reverse: reverse = defaultReverse, reduce: reduce = defaultReduce, limit: limit = defaultLimit } = (0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(options[x]); // prettier-ignore
        const negate = y?.startsWith("-");
        if (negate) y = y.slice(1);
        order = order === undefined ? negate !== (y === "width" || y === "height") ? $6eb5f337b2493843$var$descendingGroup : $6eb5f337b2493843$var$ascendingGroup : $6eb5f337b2493843$var$maybeOrder(order); // prettier-ignore
        if (reduce == null || reduce === false) continue; // disabled reducer
        const X = x === "fx" || x === "fy" ? $6eb5f337b2493843$var$reindexFacetChannel(facets, facetChannels[x]) : $6eb5f337b2493843$var$findScaleChannel(channels, x);
        if (!X) throw new Error(`missing channel for scale: ${x}`);
        const XV = X.value;
        const [lo = 0, hi = Infinity] = (0, $cd9e805a4bbd13f9$export$9652023d9040757)(limit) ? limit : limit < 0 ? [
            limit
        ] : [
            0,
            limit
        ];
        if (y == null) X.domain = ()=>{
            let domain = Array.from(new (0, $3160658555deb5c9$export$55278c3294239828)(XV)); // remove any duplicates
            if (reverse) domain = domain.reverse();
            if (lo !== 0 || hi !== Infinity) domain = domain.slice(lo, hi);
            return domain;
        };
        else {
            const YV = y === "data" ? data : y === "height" ? $6eb5f337b2493843$var$difference(channels, "y1", "y2") : y === "width" ? $6eb5f337b2493843$var$difference(channels, "x1", "x2") : $6eb5f337b2493843$var$values(channels, y, y === "y" ? "y2" : y === "x" ? "x2" : undefined);
            const reducer = (0, $23ff17797d38563c$export$8741001136aed6bd)(reduce === true ? "max" : reduce, YV);
            X.domain = ()=>{
                let domain = (0, $6f0c14a1378d16c1$export$24814875ed03194b)((0, $cd9e805a4bbd13f9$export$d02631cccf789723)(XV), (I)=>reducer.reduceIndex(I, YV), (i)=>XV[i]);
                if (order) domain.sort(order);
                if (reverse) domain.reverse();
                if (lo !== 0 || hi !== Infinity) domain = domain.slice(lo, hi);
                return domain.map((0, $cd9e805a4bbd13f9$export$43128fadae87b74a));
            };
        }
    }
}
function $6eb5f337b2493843$var$findScaleChannel(channels, scale) {
    for(const name in channels){
        const channel = channels[name];
        if (channel.scale === scale) return channel;
    }
}
// Facet channels are not affected by transforms; so, to compute the domain of a
// facet scale, we must first re-index the facet channel according to the
// transformed mark index. Note: mutates channel, but that should be safe here?
function $6eb5f337b2493843$var$reindexFacetChannel(facets, channel) {
    const originalFacets = facets.original;
    if (originalFacets === facets) return channel; // not transformed
    const V1 = channel.value;
    const V2 = channel.value = []; // mutates channel!
    for(let i = 0; i < originalFacets.length; ++i){
        const vi = V1[originalFacets[i][0]];
        for (const j of facets[i])V2[j] = vi;
    }
    return channel;
}
function $6eb5f337b2493843$var$difference(channels, k1, k2) {
    const X1 = $6eb5f337b2493843$var$values(channels, k1);
    const X2 = $6eb5f337b2493843$var$values(channels, k2);
    return (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(X2, (x2, i)=>Math.abs(x2 - X1[i]), Float64Array);
}
function $6eb5f337b2493843$var$values(channels, name, alias) {
    let channel = channels[name];
    if (!channel && alias !== undefined) channel = channels[alias];
    if (channel) return channel.value;
    throw new Error(`missing channel: ${name}`);
}
function $6eb5f337b2493843$var$maybeOrder(order) {
    if (order == null || typeof order === "function") return order;
    switch(`${order}`.toLowerCase()){
        case "ascending":
            return $6eb5f337b2493843$var$ascendingGroup;
        case "descending":
            return $6eb5f337b2493843$var$descendingGroup;
    }
    throw new Error(`invalid order: ${order}`);
}
function $6eb5f337b2493843$var$ascendingGroup([ak, av], [bk, bv]) {
    return (0, $0f3e37548c3914c7$export$686e14b8469efec4)(av, bv) || (0, $0f3e37548c3914c7$export$686e14b8469efec4)(ak, bk);
}
function $6eb5f337b2493843$var$descendingGroup([ak, av], [bk, bv]) {
    return (0, $0f3e37548c3914c7$export$e82554a8bd790ef9)(av, bv) || (0, $0f3e37548c3914c7$export$686e14b8469efec4)(ak, bk);
}
function $6eb5f337b2493843$export$dd2b6e807fb37ba3(channels, key) {
    let channel = channels[key];
    if (!channel) return;
    while(channel.source)channel = channel.source;
    return channel.source === null ? null : channel;
}












// TODO https://github.com/d3/d3-scale-chromatic/pull/51
const $a49a01342b27942f$var$schemeObservable10 = [
    "#4269d0",
    "#efb118",
    "#ff725c",
    "#6cc5b0",
    "#3ca951",
    "#ff8ab7",
    "#a463f2",
    "#97bbf5",
    "#9c6b4e",
    "#9498a0"
];
const $a49a01342b27942f$var$categoricalSchemes = new Map([
    [
        "accent",
        (0, $5c89bc3d03077aec$export$2e2bcd8739ae039)
    ],
    [
        "category10",
        (0, $b0a93f4c47fccf6f$export$2e2bcd8739ae039)
    ],
    [
        "dark2",
        (0, $8720e88c6715774d$export$2e2bcd8739ae039)
    ],
    [
        "observable10",
        $a49a01342b27942f$var$schemeObservable10
    ],
    [
        "paired",
        (0, $892d66d4b4370fa9$export$2e2bcd8739ae039)
    ],
    [
        "pastel1",
        (0, $8b74c2f853351d4b$export$2e2bcd8739ae039)
    ],
    [
        "pastel2",
        (0, $21804f83495238ab$export$2e2bcd8739ae039)
    ],
    [
        "set1",
        (0, $067ed124de63e363$export$2e2bcd8739ae039)
    ],
    [
        "set2",
        (0, $0b28fee23808bb16$export$2e2bcd8739ae039)
    ],
    [
        "set3",
        (0, $2c32d07a5d4299df$export$2e2bcd8739ae039)
    ],
    [
        "tableau10",
        (0, $4fe0d67c4ca00f70$export$2e2bcd8739ae039)
    ]
]);
function $a49a01342b27942f$export$6be03a206d9fd924(scheme) {
    return scheme != null && $a49a01342b27942f$var$categoricalSchemes.has(`${scheme}`.toLowerCase());
}
const $a49a01342b27942f$var$ordinalSchemes = new Map([
    ...$a49a01342b27942f$var$categoricalSchemes,
    // diverging
    [
        "brbg",
        $a49a01342b27942f$var$scheme11((0, $923009811f34a285$export$3005042704f95a69), (0, $923009811f34a285$export$2e2bcd8739ae039))
    ],
    [
        "prgn",
        $a49a01342b27942f$var$scheme11((0, $bebec87caf5c9753$export$3005042704f95a69), (0, $bebec87caf5c9753$export$2e2bcd8739ae039))
    ],
    [
        "piyg",
        $a49a01342b27942f$var$scheme11((0, $cd2b06ef8006df98$export$3005042704f95a69), (0, $cd2b06ef8006df98$export$2e2bcd8739ae039))
    ],
    [
        "puor",
        $a49a01342b27942f$var$scheme11((0, $fa43973b0e53adde$export$3005042704f95a69), (0, $fa43973b0e53adde$export$2e2bcd8739ae039))
    ],
    [
        "rdbu",
        $a49a01342b27942f$var$scheme11((0, $459633cf9cf535bb$export$3005042704f95a69), (0, $459633cf9cf535bb$export$2e2bcd8739ae039))
    ],
    [
        "rdgy",
        $a49a01342b27942f$var$scheme11((0, $d593cda9522f5e9b$export$3005042704f95a69), (0, $d593cda9522f5e9b$export$2e2bcd8739ae039))
    ],
    [
        "rdylbu",
        $a49a01342b27942f$var$scheme11((0, $cc75fec219df38fc$export$3005042704f95a69), (0, $cc75fec219df38fc$export$2e2bcd8739ae039))
    ],
    [
        "rdylgn",
        $a49a01342b27942f$var$scheme11((0, $34bd5cca956fffae$export$3005042704f95a69), (0, $34bd5cca956fffae$export$2e2bcd8739ae039))
    ],
    [
        "spectral",
        $a49a01342b27942f$var$scheme11((0, $9f2dc97368c5eb16$export$3005042704f95a69), (0, $9f2dc97368c5eb16$export$2e2bcd8739ae039))
    ],
    // reversed diverging (for temperature data)
    [
        "burd",
        $a49a01342b27942f$var$scheme11r((0, $459633cf9cf535bb$export$3005042704f95a69), (0, $459633cf9cf535bb$export$2e2bcd8739ae039))
    ],
    [
        "buylrd",
        $a49a01342b27942f$var$scheme11r((0, $cc75fec219df38fc$export$3005042704f95a69), (0, $cc75fec219df38fc$export$2e2bcd8739ae039))
    ],
    // sequential (single-hue)
    [
        "blues",
        $a49a01342b27942f$var$scheme9((0, $145b892380fd2d31$export$3005042704f95a69), (0, $145b892380fd2d31$export$2e2bcd8739ae039))
    ],
    [
        "greens",
        $a49a01342b27942f$var$scheme9((0, $8f3c9c616b880108$export$3005042704f95a69), (0, $8f3c9c616b880108$export$2e2bcd8739ae039))
    ],
    [
        "greys",
        $a49a01342b27942f$var$scheme9((0, $7bfe5c88f8446526$export$3005042704f95a69), (0, $7bfe5c88f8446526$export$2e2bcd8739ae039))
    ],
    [
        "oranges",
        $a49a01342b27942f$var$scheme9((0, $595eb3851ff257d2$export$3005042704f95a69), (0, $595eb3851ff257d2$export$2e2bcd8739ae039))
    ],
    [
        "purples",
        $a49a01342b27942f$var$scheme9((0, $1d375f28523a6def$export$3005042704f95a69), (0, $1d375f28523a6def$export$2e2bcd8739ae039))
    ],
    [
        "reds",
        $a49a01342b27942f$var$scheme9((0, $1061f70ec19e6f6b$export$3005042704f95a69), (0, $1061f70ec19e6f6b$export$2e2bcd8739ae039))
    ],
    // sequential (multi-hue)
    [
        "turbo",
        $a49a01342b27942f$var$schemei((0, $b6e6a61cd0d5bfcf$export$2e2bcd8739ae039))
    ],
    [
        "viridis",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$2e2bcd8739ae039))
    ],
    [
        "magma",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$c41e69203f572e8d))
    ],
    [
        "inferno",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$ad0c8285c8ea6dbd))
    ],
    [
        "plasma",
        $a49a01342b27942f$var$schemei((0, $c1e92c032cb158e3$export$6664860a633d9daf))
    ],
    [
        "cividis",
        $a49a01342b27942f$var$schemei((0, $9952aaaded0c8a28$export$2e2bcd8739ae039))
    ],
    [
        "cubehelix",
        $a49a01342b27942f$var$schemei((0, $29d6cb6ff87ef07d$export$2e2bcd8739ae039))
    ],
    [
        "warm",
        $a49a01342b27942f$var$schemei((0, $99c57285242dd2ea$export$fc70efcec537be98))
    ],
    [
        "cool",
        $a49a01342b27942f$var$schemei((0, $99c57285242dd2ea$export$c5cedbc1ab3be2c3))
    ],
    [
        "bugn",
        $a49a01342b27942f$var$scheme9((0, $1346c9d2a50a7688$export$3005042704f95a69), (0, $1346c9d2a50a7688$export$2e2bcd8739ae039))
    ],
    [
        "bupu",
        $a49a01342b27942f$var$scheme9((0, $c6eb5bbbe1fe33f2$export$3005042704f95a69), (0, $c6eb5bbbe1fe33f2$export$2e2bcd8739ae039))
    ],
    [
        "gnbu",
        $a49a01342b27942f$var$scheme9((0, $54d7f7dcce705495$export$3005042704f95a69), (0, $54d7f7dcce705495$export$2e2bcd8739ae039))
    ],
    [
        "orrd",
        $a49a01342b27942f$var$scheme9((0, $eeccadfeb064b2e3$export$3005042704f95a69), (0, $eeccadfeb064b2e3$export$2e2bcd8739ae039))
    ],
    [
        "pubu",
        $a49a01342b27942f$var$scheme9((0, $378e987a98dccf42$export$3005042704f95a69), (0, $378e987a98dccf42$export$2e2bcd8739ae039))
    ],
    [
        "pubugn",
        $a49a01342b27942f$var$scheme9((0, $256ade4440a037db$export$3005042704f95a69), (0, $256ade4440a037db$export$2e2bcd8739ae039))
    ],
    [
        "purd",
        $a49a01342b27942f$var$scheme9((0, $5387771dbbae7a61$export$3005042704f95a69), (0, $5387771dbbae7a61$export$2e2bcd8739ae039))
    ],
    [
        "rdpu",
        $a49a01342b27942f$var$scheme9((0, $c0b866951e59a25a$export$3005042704f95a69), (0, $c0b866951e59a25a$export$2e2bcd8739ae039))
    ],
    [
        "ylgn",
        $a49a01342b27942f$var$scheme9((0, $9f35832fa0e76f1c$export$3005042704f95a69), (0, $9f35832fa0e76f1c$export$2e2bcd8739ae039))
    ],
    [
        "ylgnbu",
        $a49a01342b27942f$var$scheme9((0, $59f93d7737a98115$export$3005042704f95a69), (0, $59f93d7737a98115$export$2e2bcd8739ae039))
    ],
    [
        "ylorbr",
        $a49a01342b27942f$var$scheme9((0, $8ba4ac8d08f3d776$export$3005042704f95a69), (0, $8ba4ac8d08f3d776$export$2e2bcd8739ae039))
    ],
    [
        "ylorrd",
        $a49a01342b27942f$var$scheme9((0, $f3f63506e2889591$export$3005042704f95a69), (0, $f3f63506e2889591$export$2e2bcd8739ae039))
    ],
    // cyclical
    [
        "rainbow",
        $a49a01342b27942f$var$schemeicyclical((0, $99c57285242dd2ea$export$2e2bcd8739ae039))
    ],
    [
        "sinebow",
        $a49a01342b27942f$var$schemeicyclical((0, $8a82e5e51ab56b0d$export$2e2bcd8739ae039))
    ]
]);
function $a49a01342b27942f$var$scheme9(scheme, interpolate) {
    return ({ length: n })=>{
        if (n === 1) return [
            scheme[3][1]
        ]; // favor midpoint
        if (n === 2) return [
            scheme[3][1],
            scheme[3][2]
        ]; // favor darker
        n = Math.max(3, Math.floor(n));
        return n > 9 ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : scheme[n];
    };
}
function $a49a01342b27942f$var$scheme11(scheme, interpolate) {
    return ({ length: n })=>{
        if (n === 2) return [
            scheme[3][0],
            scheme[3][2]
        ]; // favor diverging extrema
        n = Math.max(3, Math.floor(n));
        return n > 11 ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : scheme[n];
    };
}
function $a49a01342b27942f$var$scheme11r(scheme, interpolate) {
    return ({ length: n })=>{
        if (n === 2) return [
            scheme[3][2],
            scheme[3][0]
        ]; // favor diverging extrema
        n = Math.max(3, Math.floor(n));
        return n > 11 ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)((t)=>interpolate(1 - t), n) : scheme[n].slice().reverse();
    };
}
function $a49a01342b27942f$var$schemei(interpolate) {
    return ({ length: n })=>(0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, Math.max(2, Math.floor(n)));
}
function $a49a01342b27942f$var$schemeicyclical(interpolate) {
    return ({ length: n })=>(0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, Math.floor(n) + 1).slice(0, -1);
}
function $a49a01342b27942f$export$b81675b3e2d350c6(scheme) {
    const s = `${scheme}`.toLowerCase();
    if (!$a49a01342b27942f$var$ordinalSchemes.has(s)) throw new Error(`unknown ordinal scheme: ${s}`);
    return $a49a01342b27942f$var$ordinalSchemes.get(s);
}
function $a49a01342b27942f$export$4247365b716746cf(scheme, length) {
    const s = $a49a01342b27942f$export$b81675b3e2d350c6(scheme);
    const r = typeof s === "function" ? s({
        length: length
    }) : s;
    return r.length !== length ? r.slice(0, length) : r;
}
function $a49a01342b27942f$export$ac9f44566dbce13a(domain, scheme = "greys") {
    const range = new Set();
    const [f, t] = $a49a01342b27942f$export$4247365b716746cf(scheme, 2);
    for (const value of domain){
        if (value == null) continue;
        if (value === true) range.add(t);
        else if (value === false) range.add(f);
        else return;
    }
    return [
        ...range
    ];
}
const $a49a01342b27942f$var$quantitativeSchemes = new Map([
    // diverging
    [
        "brbg",
        (0, $923009811f34a285$export$2e2bcd8739ae039)
    ],
    [
        "prgn",
        (0, $bebec87caf5c9753$export$2e2bcd8739ae039)
    ],
    [
        "piyg",
        (0, $cd2b06ef8006df98$export$2e2bcd8739ae039)
    ],
    [
        "puor",
        (0, $fa43973b0e53adde$export$2e2bcd8739ae039)
    ],
    [
        "rdbu",
        (0, $459633cf9cf535bb$export$2e2bcd8739ae039)
    ],
    [
        "rdgy",
        (0, $d593cda9522f5e9b$export$2e2bcd8739ae039)
    ],
    [
        "rdylbu",
        (0, $cc75fec219df38fc$export$2e2bcd8739ae039)
    ],
    [
        "rdylgn",
        (0, $34bd5cca956fffae$export$2e2bcd8739ae039)
    ],
    [
        "spectral",
        (0, $9f2dc97368c5eb16$export$2e2bcd8739ae039)
    ],
    // reversed diverging (for temperature data)
    [
        "burd",
        (t)=>(0, $459633cf9cf535bb$export$2e2bcd8739ae039)(1 - t)
    ],
    [
        "buylrd",
        (t)=>(0, $cc75fec219df38fc$export$2e2bcd8739ae039)(1 - t)
    ],
    // sequential (single-hue)
    [
        "blues",
        (0, $145b892380fd2d31$export$2e2bcd8739ae039)
    ],
    [
        "greens",
        (0, $8f3c9c616b880108$export$2e2bcd8739ae039)
    ],
    [
        "greys",
        (0, $7bfe5c88f8446526$export$2e2bcd8739ae039)
    ],
    [
        "purples",
        (0, $1d375f28523a6def$export$2e2bcd8739ae039)
    ],
    [
        "reds",
        (0, $1061f70ec19e6f6b$export$2e2bcd8739ae039)
    ],
    [
        "oranges",
        (0, $595eb3851ff257d2$export$2e2bcd8739ae039)
    ],
    // sequential (multi-hue)
    [
        "turbo",
        (0, $b6e6a61cd0d5bfcf$export$2e2bcd8739ae039)
    ],
    [
        "viridis",
        (0, $c1e92c032cb158e3$export$2e2bcd8739ae039)
    ],
    [
        "magma",
        (0, $c1e92c032cb158e3$export$c41e69203f572e8d)
    ],
    [
        "inferno",
        (0, $c1e92c032cb158e3$export$ad0c8285c8ea6dbd)
    ],
    [
        "plasma",
        (0, $c1e92c032cb158e3$export$6664860a633d9daf)
    ],
    [
        "cividis",
        (0, $9952aaaded0c8a28$export$2e2bcd8739ae039)
    ],
    [
        "cubehelix",
        (0, $29d6cb6ff87ef07d$export$2e2bcd8739ae039)
    ],
    [
        "warm",
        (0, $99c57285242dd2ea$export$fc70efcec537be98)
    ],
    [
        "cool",
        (0, $99c57285242dd2ea$export$c5cedbc1ab3be2c3)
    ],
    [
        "bugn",
        (0, $1346c9d2a50a7688$export$2e2bcd8739ae039)
    ],
    [
        "bupu",
        (0, $c6eb5bbbe1fe33f2$export$2e2bcd8739ae039)
    ],
    [
        "gnbu",
        (0, $54d7f7dcce705495$export$2e2bcd8739ae039)
    ],
    [
        "orrd",
        (0, $eeccadfeb064b2e3$export$2e2bcd8739ae039)
    ],
    [
        "pubugn",
        (0, $256ade4440a037db$export$2e2bcd8739ae039)
    ],
    [
        "pubu",
        (0, $378e987a98dccf42$export$2e2bcd8739ae039)
    ],
    [
        "purd",
        (0, $5387771dbbae7a61$export$2e2bcd8739ae039)
    ],
    [
        "rdpu",
        (0, $c0b866951e59a25a$export$2e2bcd8739ae039)
    ],
    [
        "ylgnbu",
        (0, $59f93d7737a98115$export$2e2bcd8739ae039)
    ],
    [
        "ylgn",
        (0, $9f35832fa0e76f1c$export$2e2bcd8739ae039)
    ],
    [
        "ylorbr",
        (0, $8ba4ac8d08f3d776$export$2e2bcd8739ae039)
    ],
    [
        "ylorrd",
        (0, $f3f63506e2889591$export$2e2bcd8739ae039)
    ],
    // cyclical
    [
        "rainbow",
        (0, $99c57285242dd2ea$export$2e2bcd8739ae039)
    ],
    [
        "sinebow",
        (0, $8a82e5e51ab56b0d$export$2e2bcd8739ae039)
    ]
]);
function $a49a01342b27942f$export$c2977bbb95728409(scheme) {
    const s = `${scheme}`.toLowerCase();
    if (!$a49a01342b27942f$var$quantitativeSchemes.has(s)) throw new Error(`unknown quantitative scheme: ${s}`);
    return $a49a01342b27942f$var$quantitativeSchemes.get(s);
}
const $a49a01342b27942f$var$divergingSchemes = new Set([
    "brbg",
    "prgn",
    "piyg",
    "puor",
    "rdbu",
    "rdgy",
    "rdylbu",
    "rdylgn",
    "spectral",
    "burd",
    "buylrd"
]);
function $a49a01342b27942f$export$bd1a4763c73ba9bf(scheme) {
    return scheme != null && $a49a01342b27942f$var$divergingSchemes.has(`${scheme}`.toLowerCase());
}


const $30c166b7628c3ceb$export$8a83211c878a3f1f = (i)=>(t)=>i(1 - t);
const $30c166b7628c3ceb$var$unit = [
    0,
    1
];
const $30c166b7628c3ceb$var$interpolators = new Map([
    // numbers
    [
        "number",
        (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)
    ],
    // color spaces
    [
        "rgb",
        (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039)
    ],
    [
        "hsl",
        (0, $852106acfdc40efe$export$2e2bcd8739ae039)
    ],
    [
        "hcl",
        (0, $86158b7019ca6112$export$2e2bcd8739ae039)
    ],
    [
        "lab",
        (0, $5eb07f15d29dfb2b$export$2e2bcd8739ae039)
    ]
]);
function $30c166b7628c3ceb$export$a720bd56dc6d3c41(interpolate) {
    const i = `${interpolate}`.toLowerCase();
    if (!$30c166b7628c3ceb$var$interpolators.has(i)) throw new Error(`unknown interpolator: ${i}`);
    return $30c166b7628c3ceb$var$interpolators.get(i);
}
function $30c166b7628c3ceb$export$a11fad23408ff50e(key, scale, channels, { type: type, nice: nice, clamp: clamp, zero: zero, domain: domain = $30c166b7628c3ceb$var$inferAutoDomain(key, channels), unknown: unknown, round: round, scheme: scheme, interval: interval, range: range = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$872dd985a098dd45) ? $30c166b7628c3ceb$var$inferRadialRange(channels, domain) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$f24224f1c91d8156) ? $30c166b7628c3ceb$var$inferLengthRange(channels, domain) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$c17a3be1057836e) ? $30c166b7628c3ceb$var$unit : undefined, interpolate: interpolate = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? scheme == null && range !== undefined ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $a49a01342b27942f$export$c2977bbb95728409)(scheme !== undefined ? scheme : type === "cyclical" ? "rainbow" : "turbo") : round ? (0, $c0f8a9efb1caa699$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039), reverse: reverse }) {
    interval = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, type);
    if (type === "cyclical" || type === "sequential") type = "linear"; // shorthand for color schemes
    if (typeof interpolate !== "function") interpolate = $30c166b7628c3ceb$export$a720bd56dc6d3c41(interpolate); // named interpolator
    reverse = !!reverse;
    // If an explicit range is specified, and it has a different length than the
    // domain, then redistribute the range using a piecewise interpolator.
    if (range !== undefined) {
        const n = (domain = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain)).length;
        const m = (range = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(range)).length;
        if (n !== m) {
            if (interpolate.length === 1) throw new Error("invalid piecewise interpolator"); // e.g., turbo
            interpolate = (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate, range);
            range = undefined;
        }
    }
    // Disambiguate between a two-argument interpolator that is used in
    // conjunction with the range, and a one-argument “fixed” interpolator on the
    // [0, 1] interval as with the RdBu color scheme.
    if (interpolate.length === 1) {
        if (reverse) {
            interpolate = $30c166b7628c3ceb$export$8a83211c878a3f1f(interpolate);
            reverse = false;
        }
        if (range === undefined) {
            range = Float64Array.from(domain, (_, i)=>i / (domain.length - 1));
            if (range.length === 2) range = $30c166b7628c3ceb$var$unit; // optimize common case of [0, 1]
        }
        scale.interpolate((range === $30c166b7628c3ceb$var$unit ? (0, $cd9e805a4bbd13f9$export$c983f826f44ff86) : $30c166b7628c3ceb$export$f68e9493607eda6)(interpolate));
    } else scale.interpolate(interpolate);
    // If a zero option is specified, we assume that the domain is numeric, and we
    // want to ensure that the domain crosses zero. However, note that the domain
    // may be reversed (descending) so we shouldn’t assume that the first value is
    // smaller than the last; and also it’s possible that the domain has more than
    // two values for a “poly” scale. And lastly be careful not to mutate input!
    if (zero) {
        const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
        if (min > 0 || max < 0) {
            domain = (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(domain);
            if ((0, $cd9e805a4bbd13f9$export$c25b1294fe9f63f1)(domain) !== Math.sign(min)) domain[domain.length - 1] = 0; // [2, 1] or [-2, -1]
            else domain[0] = 0; // [1, 2] or [-1, -2]
        }
    }
    if (reverse) domain = (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(domain);
    scale.domain(domain).unknown(unknown);
    if (nice) scale.nice($30c166b7628c3ceb$var$maybeNice(nice, type)), domain = scale.domain();
    if (range !== undefined) scale.range(range);
    if (clamp) scale.clamp(clamp);
    return {
        type: type,
        domain: domain,
        range: range,
        scale: scale,
        interpolate: interpolate,
        interval: interval
    };
}
function $30c166b7628c3ceb$var$maybeNice(nice, type) {
    return nice === true ? undefined : typeof nice === "number" ? nice : (0, $cd9e805a4bbd13f9$export$367d1ceccf20717f)(nice, type);
}
function $30c166b7628c3ceb$export$8eab0b226d0f3b42(key, channels, options) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)(), channels, options);
}
function $30c166b7628c3ceb$export$a5c8c8de32abacf0(key, channels, options) {
    return $30c166b7628c3ceb$export$ea2a572a59b9896a(key, channels, {
        ...options,
        exponent: 0.5
    });
}
function $30c166b7628c3ceb$export$ea2a572a59b9896a(key, channels, { exponent: exponent = 1, ...options }) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $d97c146f4f811488$export$2e2bcd8739ae039)().exponent(exponent), channels, {
        ...options,
        type: "pow"
    });
}
function $30c166b7628c3ceb$export$812089778d3d78b5(key, channels, { base: base = 10, domain: domain = $30c166b7628c3ceb$var$inferLogDomain(channels), ...options }) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $5bf2f979a0299157$export$2e2bcd8739ae039)().base(base), channels, {
        ...options,
        domain: domain
    });
}
function $30c166b7628c3ceb$export$b91aaebc8fcff1ed(key, channels, { constant: constant = 1, ...options }) {
    return $30c166b7628c3ceb$export$a11fad23408ff50e(key, (0, $cb758ed0dff37844$export$2e2bcd8739ae039)().constant(constant), channels, options);
}
function $30c166b7628c3ceb$export$491dcf080c701b2f(key, channels, { range: range, quantiles: quantiles = range === undefined ? 5 : (range = [
    ...range
]).length, n: n = quantiles, scheme: scheme = "rdylbu", domain: domain = $30c166b7628c3ceb$var$inferQuantileDomain(channels), unknown: unknown, interpolate: interpolate, reverse: reverse }) {
    if (range === undefined) range = interpolate !== undefined ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? (0, $a49a01342b27942f$export$4247365b716746cf)(scheme, n) : undefined;
    if (domain.length > 0) domain = (0, $96238d247b54f1ee$export$2e2bcd8739ae039)(domain, range === undefined ? {
        length: n
    } : range).quantiles();
    return $30c166b7628c3ceb$export$29c9ae4906e7bfbc(key, channels, {
        domain: domain,
        range: range,
        reverse: reverse,
        unknown: unknown
    });
}
function $30c166b7628c3ceb$export$25f12ee8f05111a7(key, channels, { range: range, n: n = range === undefined ? 5 : (range = [
    ...range
]).length, scheme: scheme = "rdylbu", domain: domain = $30c166b7628c3ceb$var$inferAutoDomain(key, channels), unknown: unknown, interpolate: interpolate, reverse: reverse }) {
    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
    let thresholds;
    if (range === undefined) {
        thresholds = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(min, max, n); // approximate number of nice, round thresholds
        if (thresholds[0] <= min) thresholds.splice(0, 1); // drop exact lower bound
        if (thresholds[thresholds.length - 1] >= max) thresholds.pop(); // drop exact upper bound
        n = thresholds.length + 1;
        range = interpolate !== undefined ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, n) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? (0, $a49a01342b27942f$export$4247365b716746cf)(scheme, n) : undefined;
    } else {
        thresholds = (0, $4f501ce7bede8755$export$2e2bcd8739ae039)((0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(min, max), n + 1).slice(1, -1); // exactly n - 1 thresholds to match range
        if (min instanceof Date) thresholds = thresholds.map((x)=>new Date(x)); // preserve date types
    }
    if ((0, $cd9e805a4bbd13f9$export$c25b1294fe9f63f1)((0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain)) < 0) thresholds.reverse(); // preserve descending domain
    return $30c166b7628c3ceb$export$29c9ae4906e7bfbc(key, channels, {
        domain: thresholds,
        range: range,
        reverse: reverse,
        unknown: unknown
    });
}
function $30c166b7628c3ceb$export$29c9ae4906e7bfbc(key, channels, { domain: domain = [
    0
], unknown: unknown, scheme: scheme = "rdylbu", interpolate: interpolate, range: range = interpolate !== undefined ? (0, $4f501ce7bede8755$export$2e2bcd8739ae039)(interpolate, domain.length + 1) : (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? (0, $a49a01342b27942f$export$4247365b716746cf)(scheme, domain.length + 1) : undefined, reverse: reverse }) {
    domain = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain);
    const sign = (0, $cd9e805a4bbd13f9$export$c25b1294fe9f63f1)(domain); // preserve descending domain
    if (!isNaN(sign) && !$30c166b7628c3ceb$var$isOrdered(domain, sign)) throw new Error(`the ${key} scale has a non-monotonic domain`);
    if (reverse) range = (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(range); // domain ascending, so reverse range
    return {
        type: "threshold",
        scale: (0, $8058838348a44fed$export$2e2bcd8739ae039)(sign < 0 ? (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(domain) : domain, range === undefined ? [] : range).unknown(unknown),
        domain: domain,
        range: range
    };
}
function $30c166b7628c3ceb$var$isOrdered(domain, sign) {
    for(let i = 1, n = domain.length, d = domain[0]; i < n; ++i){
        const s = (0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(d, d = domain[i]);
        if (s !== 0 && s !== sign) return false;
    }
    return true;
}
function $30c166b7628c3ceb$export$5f13182ef6dc55f1(key) {
    return {
        type: "identity",
        scale: (0, $743dde21c57c19a0$export$2d070ad8c31ab6b9)((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key)) ? (0, $dcfca0550ace1fe6$export$2e2bcd8739ae039)() : (d)=>d
    };
}
function $30c166b7628c3ceb$export$62c3bd2b30bf9970(channels, f = (0, $0f3e37548c3914c7$export$145b33b964ff85c1)) {
    return channels.length ? [
        (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? value : (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(value, f)),
        (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? value : (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(value, f))
    ] : [
        0,
        1
    ];
}
function $30c166b7628c3ceb$var$inferAutoDomain(key, channels) {
    const type = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key);
    return (type === (0, $743dde21c57c19a0$export$872dd985a098dd45) || type === (0, $743dde21c57c19a0$export$c17a3be1057836e) || type === (0, $743dde21c57c19a0$export$f24224f1c91d8156) ? $30c166b7628c3ceb$var$inferZeroDomain : $30c166b7628c3ceb$export$62c3bd2b30bf9970)(channels);
}
function $30c166b7628c3ceb$var$inferZeroDomain(channels) {
    return [
        0,
        channels.length ? (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? value : (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(value, (0, $0f3e37548c3914c7$export$145b33b964ff85c1))) : 1
    ];
}
// We don’t want the upper bound of the radial domain to be zero, as this would
// be degenerate, so we ignore nonpositive values. We also don’t want the
// maximum default radius to exceed 30px.
function $30c166b7628c3ceb$var$inferRadialRange(channels, domain) {
    const hint = channels.find(({ radius: radius })=>radius !== undefined);
    if (hint !== undefined) return [
        0,
        hint.radius
    ]; // a natural maximum radius, e.g. hexbins
    const h25 = (0, $231c9024a6754413$export$2e2bcd8739ae039)(channels, 0.5, ({ value: value })=>value === undefined ? NaN : (0, $231c9024a6754413$export$2e2bcd8739ae039)(value, 0.25, (0, $0f3e37548c3914c7$export$aa5128ab863cd04)));
    const range = domain.map((d)=>3 * Math.sqrt(d / h25));
    const k = 30 / (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(range);
    return k < 1 ? range.map((r)=>r * k) : range;
}
// We want a length scale’s domain to go from zero to a positive value, and to
// treat negative lengths if any as inverted vectors of equivalent magnitude. We
// also don’t want the maximum default length to exceed 60px.
function $30c166b7628c3ceb$var$inferLengthRange(channels, domain) {
    const h50 = (0, $5713cbb46e42efc2$export$2e2bcd8739ae039)(channels, ({ value: value })=>value === undefined ? NaN : (0, $5713cbb46e42efc2$export$2e2bcd8739ae039)(value, Math.abs));
    const range = domain.map((d)=>12 * d / h50);
    const k = 60 / (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(range);
    return k < 1 ? range.map((r)=>r * k) : range;
}
function $30c166b7628c3ceb$var$inferLogDomain(channels) {
    for (const { value: value } of channels){
        if (value !== undefined) for (let v of value){
            if (v > 0) return $30c166b7628c3ceb$export$62c3bd2b30bf9970(channels, (0, $0f3e37548c3914c7$export$aa5128ab863cd04));
            if (v < 0) return $30c166b7628c3ceb$export$62c3bd2b30bf9970(channels, (0, $0f3e37548c3914c7$export$5f47f64d03acd206));
        }
    }
    return [
        1,
        10
    ];
}
function $30c166b7628c3ceb$var$inferQuantileDomain(channels) {
    const domain = [];
    for (const { value: value } of channels){
        if (value === undefined) continue;
        for (const v of value)domain.push(v);
    }
    return domain;
}
function $30c166b7628c3ceb$export$f68e9493607eda6(interpolate) {
    return (i, j)=>(t)=>interpolate(i + t * (j - i));
}









function $d47764ac2a1afe36$var$createScaleD(key, scale, transform, channels, { type: type, nice: nice, clamp: clamp, domain: domain = (0, $30c166b7628c3ceb$export$62c3bd2b30bf9970)(channels), unknown: unknown, pivot: pivot = 0, scheme: scheme, range: range, symmetric: symmetric = true, interpolate: interpolate = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f) ? scheme == null && range !== undefined ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $a49a01342b27942f$export$c2977bbb95728409)(scheme !== undefined ? scheme : "rdbu") : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039), reverse: reverse }) {
    pivot = +pivot;
    domain = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(domain);
    let [min, max] = domain;
    if (domain.length > 2) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the diverging ${key} scale domain contains extra elements.`);
    if ((0, $3acd474ceacf8a38$export$2e2bcd8739ae039)(min, max) < 0) [min, max] = [
        max,
        min
    ], reverse = !reverse;
    min = Math.min(min, pivot);
    max = Math.max(max, pivot);
    // Sometimes interpolate is a named interpolator, such as "lab" for Lab color
    // space. Other times interpolate is a function that takes two arguments and
    // is used in conjunction with the range. And other times the interpolate
    // function is a “fixed” interpolator on the [0, 1] interval, as when a
    // color scheme such as interpolateRdBu is used.
    if (typeof interpolate !== "function") interpolate = (0, $30c166b7628c3ceb$export$a720bd56dc6d3c41)(interpolate);
    // If an explicit range is specified, promote it to a piecewise interpolator.
    if (range !== undefined) interpolate = interpolate.length === 1 ? (0, $30c166b7628c3ceb$export$f68e9493607eda6)(interpolate)(...range) : (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate, range);
    // Reverse before normalization.
    if (reverse) interpolate = (0, $30c166b7628c3ceb$export$8a83211c878a3f1f)(interpolate);
    // Normalize the interpolator for symmetric difference around the pivot.
    if (symmetric) {
        const mid = transform.apply(pivot);
        const mindelta = mid - transform.apply(min);
        const maxdelta = transform.apply(max) - mid;
        if (mindelta < maxdelta) min = transform.invert(mid - maxdelta);
        else if (mindelta > maxdelta) max = transform.invert(mid + mindelta);
    }
    scale.domain([
        min,
        pivot,
        max
    ]).unknown(unknown).interpolator(interpolate);
    if (clamp) scale.clamp(clamp);
    if (nice) scale.nice(nice);
    return {
        type: type,
        domain: [
            min,
            max
        ],
        pivot: pivot,
        interpolate: interpolate,
        scale: scale
    };
}
function $d47764ac2a1afe36$export$10bc5013af7fbfeb(key, channels, options) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$2e2bcd8739ae039)(), $d47764ac2a1afe36$var$transformIdentity, channels, options);
}
function $d47764ac2a1afe36$export$5c6d902e911bf823(key, channels, options) {
    return $d47764ac2a1afe36$export$4271a1a68e7dad01(key, channels, {
        ...options,
        exponent: 0.5
    });
}
function $d47764ac2a1afe36$export$4271a1a68e7dad01(key, channels, { exponent: exponent = 1, ...options }) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$d6cedcc63bf26e7e)().exponent(exponent = +exponent), $d47764ac2a1afe36$var$transformPow(exponent), channels, {
        ...options,
        type: "diverging-pow"
    });
}
function $d47764ac2a1afe36$export$23b5ded97d4d761d(key, channels, { base: base = 10, pivot: pivot = 1, domain: domain = (0, $30c166b7628c3ceb$export$62c3bd2b30bf9970)(channels, pivot < 0 ? (0, $0f3e37548c3914c7$export$5f47f64d03acd206) : (0, $0f3e37548c3914c7$export$aa5128ab863cd04)), ...options }) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$5f0266a9159c47fb)().base(base = +base), $d47764ac2a1afe36$var$transformLog, channels, {
        domain: domain,
        pivot: pivot,
        ...options
    });
}
function $d47764ac2a1afe36$export$2e609d678277a5b2(key, channels, { constant: constant = 1, ...options }) {
    return $d47764ac2a1afe36$var$createScaleD(key, (0, $19e76371916c670d$export$50b3da713cf557c6)().constant(constant = +constant), $d47764ac2a1afe36$var$transformSymlog(constant), channels, options);
}
const $d47764ac2a1afe36$var$transformIdentity = {
    apply (x) {
        return x;
    },
    invert (x) {
        return x;
    }
};
const $d47764ac2a1afe36$var$transformLog = {
    apply: Math.log,
    invert: Math.exp
};
const $d47764ac2a1afe36$var$transformSqrt = {
    apply (x) {
        return Math.sign(x) * Math.sqrt(Math.abs(x));
    },
    invert (x) {
        return Math.sign(x) * (x * x);
    }
};
function $d47764ac2a1afe36$var$transformPow(exponent) {
    return exponent === 0.5 ? $d47764ac2a1afe36$var$transformSqrt : {
        apply (x) {
            return Math.sign(x) * Math.pow(Math.abs(x), exponent);
        },
        invert (x) {
            return Math.sign(x) * Math.pow(Math.abs(x), 1 / exponent);
        }
    };
}
function $d47764ac2a1afe36$var$transformSymlog(constant) {
    return {
        apply (x) {
            return Math.sign(x) * Math.log1p(Math.abs(x / constant));
        },
        invert (x) {
            return Math.sign(x) * Math.expm1(Math.abs(x)) * constant;
        }
    };
}





function $5e40204519ce563c$var$createScaleT(key, scale, channels, options) {
    return (0, $30c166b7628c3ceb$export$a11fad23408ff50e)(key, scale, channels, options);
}
function $5e40204519ce563c$export$75a5e216fb2fb836(key, channels, options) {
    return $5e40204519ce563c$var$createScaleT(key, (0, $304372357472b2a4$export$2e2bcd8739ae039)(), channels, options);
}
function $5e40204519ce563c$export$54513e35ea306f4c(key, channels, options) {
    return $5e40204519ce563c$var$createScaleT(key, (0, $f4e8dbe80a3143de$export$2e2bcd8739ae039)(), channels, options);
}








const $578b04df998308c7$export$c689386541b0b504 = Symbol("ordinal");
function $578b04df998308c7$var$createScaleO(key, scale, channels, { type: type, interval: interval, domain: domain, range: range, reverse: reverse, hint: hint }) {
    interval = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, type);
    if (domain === undefined) domain = $578b04df998308c7$var$inferDomain(channels, interval, key);
    if (type === "categorical" || type === $578b04df998308c7$export$c689386541b0b504) type = "ordinal"; // shorthand for color schemes
    if (reverse) domain = (0, $0b47a96a2caef260$export$2e2bcd8739ae039)(domain);
    domain = scale.domain(domain).domain(); // deduplicate
    if (range !== undefined) {
        // If the range is specified as a function, pass it the domain.
        if (typeof range === "function") range = range(domain);
        scale.range(range);
    }
    return {
        type: type,
        domain: domain,
        range: range,
        scale: scale,
        hint: hint,
        interval: interval
    };
}
function $578b04df998308c7$export$ce1e458838513137(key, channels, { type: type, interval: interval, domain: domain, range: range, scheme: scheme, unknown: unknown, ...options }) {
    interval = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, type);
    if (domain === undefined) domain = $578b04df998308c7$var$inferDomain(channels, interval, key);
    let hint;
    if ((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$8f701197936bc2a6)) {
        hint = $578b04df998308c7$var$inferSymbolHint(channels);
        range = range === undefined ? $578b04df998308c7$var$inferSymbolRange(hint) : (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(range, (0, $7ef09cabd5617a1b$export$355b55bc2192971a));
    } else if ((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$35e9368ef982300f)) {
        if (range === undefined && (type === "ordinal" || type === $578b04df998308c7$export$c689386541b0b504)) {
            range = (0, $a49a01342b27942f$export$ac9f44566dbce13a)(domain, scheme);
            if (range !== undefined) scheme = undefined; // Don’t re-apply scheme.
        }
        if (scheme === undefined && range === undefined) scheme = type === "ordinal" ? "turbo" : "observable10";
        if (scheme !== undefined) {
            if (range !== undefined) {
                const interpolate = (0, $a49a01342b27942f$export$c2977bbb95728409)(scheme);
                const t0 = range[0], d = range[1] - range[0];
                range = ({ length: n })=>(0, $4f501ce7bede8755$export$2e2bcd8739ae039)((t)=>interpolate(t0 + d * t), n);
            } else range = (0, $a49a01342b27942f$export$b81675b3e2d350c6)(scheme);
        }
    }
    if (unknown === (0, $38404d762c7ac827$export$e4f898ab14d9d460)) throw new Error(`implicit unknown on ${key} scale is not supported`);
    return $578b04df998308c7$var$createScaleO(key, (0, $38404d762c7ac827$export$2e2bcd8739ae039)().unknown(unknown), channels, {
        ...options,
        type: type,
        domain: domain,
        range: range,
        hint: hint
    });
}
function $578b04df998308c7$export$76f15ed1f7e49d58(key, channels, { align: align = 0.5, padding: padding = 0.5, ...options }) {
    return $578b04df998308c7$var$maybeRound((0, $c1f2fa2a7653ca3a$export$105684a3041cb6f3)().align(align).padding(padding), channels, options, key);
}
function $578b04df998308c7$export$d3af6885a1dd51b1(key, channels, { align: align = 0.5, padding: padding = 0.1, paddingInner: paddingInner = padding, paddingOuter: paddingOuter = key === "fx" || key === "fy" ? 0 : padding, ...options }) {
    return $578b04df998308c7$var$maybeRound((0, $c1f2fa2a7653ca3a$export$2e2bcd8739ae039)().align(align).paddingInner(paddingInner).paddingOuter(paddingOuter), channels, options, key);
}
function $578b04df998308c7$var$maybeRound(scale, channels, options, key) {
    let { round: round } = options;
    if (round !== undefined) scale.round(round = !!round);
    scale = $578b04df998308c7$var$createScaleO(key, scale, channels, options);
    scale.round = round; // preserve for autoScaleRound
    return scale;
}
function $578b04df998308c7$var$inferDomain(channels, interval, key) {
    const values = new (0, $3160658555deb5c9$export$55278c3294239828)();
    for (const { value: value, domain: domain } of channels){
        if (domain !== undefined) return domain(); // see channelDomain
        if (value === undefined) continue;
        for (const v of value)values.add(v);
    }
    if (interval !== undefined) {
        const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(values).map(interval.floor, interval);
        return interval.range(min, interval.offset(max));
    }
    if (values.size > 10e3 && (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$5880b8b5730aff45)) throw new Error(`implicit ordinal domain of ${key} scale has more than 10,000 values`);
    return (0, $3dc3306e587e145d$export$2e2bcd8739ae039)(values, (0, $0f3e37548c3914c7$export$686e14b8469efec4));
}
// If all channels provide a consistent hint, propagate it to the scale.
function $578b04df998308c7$var$inferHint(channels, key) {
    let value;
    for (const { hint: hint } of channels){
        const candidate = hint?.[key];
        if (candidate === undefined) continue; // no hint here
        if (value === undefined) value = candidate; // first hint
        else if (value !== candidate) return; // inconsistent hint
    }
    return value;
}
function $578b04df998308c7$var$inferSymbolHint(channels) {
    return {
        fill: $578b04df998308c7$var$inferHint(channels, "fill"),
        stroke: $578b04df998308c7$var$inferHint(channels, "stroke")
    };
}
function $578b04df998308c7$var$inferSymbolRange(hint) {
    return (0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(hint.fill) ? (0, $497fe223f0c7b3e8$export$915e06de6acf8fe) : (0, $497fe223f0c7b3e8$export$19158c96a6700c15);
}




function $d2c16f7a6010a221$export$3935c083772c2fcc(channelsByScale, { label: globalLabel, inset: globalInset = 0, insetTop: globalInsetTop = globalInset, insetRight: globalInsetRight = globalInset, insetBottom: globalInsetBottom = globalInset, insetLeft: globalInsetLeft = globalInset, round: round, nice: nice, clamp: clamp, zero: zero, align: align, padding: padding, projection: projection, facet: { label: facetLabel = globalLabel } = {}, ...options } = {}) {
    const scales = {};
    for (const [key, channels] of channelsByScale){
        const scaleOptions = options[key];
        const scale = $d2c16f7a6010a221$var$createScale(key, channels, {
            round: (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key) === (0, $743dde21c57c19a0$export$5880b8b5730aff45) ? round : undefined,
            nice: nice,
            clamp: clamp,
            zero: zero,
            align: align,
            padding: padding,
            projection: projection,
            ...scaleOptions
        });
        if (scale) {
            // populate generic scale options (percent, transform, insets)
            let { label: label = key === "fx" || key === "fy" ? facetLabel : globalLabel, percent: percent, transform: transform, inset: inset, insetTop: insetTop = inset !== undefined ? inset : key === "y" ? globalInsetTop : 0, insetRight: insetRight = inset !== undefined ? inset : key === "x" ? globalInsetRight : 0, insetBottom: insetBottom = inset !== undefined ? inset : key === "y" ? globalInsetBottom : 0, insetLeft: insetLeft = inset !== undefined ? inset : key === "x" ? globalInsetLeft : 0 // not fx
             } = scaleOptions || {};
            if (transform == null) transform = undefined;
            else if (typeof transform !== "function") throw new Error("invalid scale transform; not a function");
            scale.percent = !!percent;
            scale.label = label === undefined ? $d2c16f7a6010a221$var$inferScaleLabel(channels, scale) : label;
            scale.transform = transform;
            if (key === "x" || key === "fx") {
                scale.insetLeft = +insetLeft;
                scale.insetRight = +insetRight;
            } else if (key === "y" || key === "fy") {
                scale.insetTop = +insetTop;
                scale.insetBottom = +insetBottom;
            }
            scales[key] = scale;
        }
    }
    return scales;
}
function $d2c16f7a6010a221$export$c2fb627c1b06c8b7(descriptors) {
    const scales = {};
    const scaleFunctions = {
        scales: scales
    };
    for (const [key, descriptor] of Object.entries(descriptors)){
        const { scale: scale, type: type, interval: interval, label: label } = descriptor;
        scales[key] = $d2c16f7a6010a221$var$exposeScale(descriptor);
        scaleFunctions[key] = scale;
        // TODO: pass these properties, which are needed for axes, in the descriptor.
        scale.type = type;
        if (interval != null) scale.interval = interval;
        if (label != null) scale.label = label;
    }
    return scaleFunctions;
}
function $d2c16f7a6010a221$export$9b57902db34fb271(scales, dimensions) {
    const { x: x, y: y, fx: fx, fy: fy } = scales;
    const superdimensions = fx || fy ? $d2c16f7a6010a221$export$5d21a1ac38f7e01a(dimensions) : dimensions;
    if (fx) $d2c16f7a6010a221$var$autoScaleRangeX(fx, superdimensions);
    if (fy) $d2c16f7a6010a221$var$autoScaleRangeY(fy, superdimensions);
    const subdimensions = fx || fy ? $d2c16f7a6010a221$export$d598388655a34790(scales, dimensions) : dimensions;
    if (x) $d2c16f7a6010a221$var$autoScaleRangeX(x, subdimensions);
    if (y) $d2c16f7a6010a221$var$autoScaleRangeY(y, subdimensions);
}
// Channels can have labels; if all the channels for a given scale are
// consistently labeled (i.e., have the same value if not undefined), and the
// corresponding scale doesn’t already have an explicit label, then the
// channels’ label is promoted to the scale. This inferred label should have an
// orientation-appropriate arrow added when used as an axis, but we don’t want
// to add the arrow when the label is set explicitly as an option; so, the
// inferred label is distinguished as an object with an “inferred” property.
function $d2c16f7a6010a221$var$inferScaleLabel(channels = [], scale) {
    let label;
    for (const { label: l } of channels){
        if (l === undefined) continue;
        if (label === undefined) label = l;
        else if (label !== l) return;
    }
    if (label === undefined) return;
    if (!$d2c16f7a6010a221$export$61579433626afe87(scale) && scale.percent) label = `${label} (%)`;
    return {
        inferred: true,
        toString: ()=>label
    };
}
function $d2c16f7a6010a221$export$cb20e1306358cc06(scale) {
    return Math.sign((0, $cd9e805a4bbd13f9$export$c25b1294fe9f63f1)(scale.domain())) * Math.sign((0, $cd9e805a4bbd13f9$export$c25b1294fe9f63f1)(scale.range()));
}
function $d2c16f7a6010a221$export$5d21a1ac38f7e01a(dimensions) {
    const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height, facet: { marginTop: facetMarginTop, marginRight: facetMarginRight, marginBottom: facetMarginBottom, marginLeft: facetMarginLeft } } = dimensions;
    return {
        marginTop: Math.max(marginTop, facetMarginTop),
        marginRight: Math.max(marginRight, facetMarginRight),
        marginBottom: Math.max(marginBottom, facetMarginBottom),
        marginLeft: Math.max(marginLeft, facetMarginLeft),
        width: width,
        height: height
    };
}
function $d2c16f7a6010a221$export$d598388655a34790({ fx: fx, fy: fy }, dimensions) {
    const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = $d2c16f7a6010a221$export$5d21a1ac38f7e01a(dimensions);
    return {
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        width: fx ? fx.scale.bandwidth() + marginLeft + marginRight : width,
        height: fy ? fy.scale.bandwidth() + marginTop + marginBottom : height,
        facet: {
            width: width,
            height: height
        }
    };
}
function $d2c16f7a6010a221$var$autoScaleRangeX(scale, dimensions) {
    if (scale.range === undefined) {
        const { insetLeft: insetLeft, insetRight: insetRight } = scale;
        const { width: width, marginLeft: marginLeft = 0, marginRight: marginRight = 0 } = dimensions;
        const left = marginLeft + insetLeft;
        const right = width - marginRight - insetRight;
        scale.range = [
            left,
            Math.max(left, right)
        ];
        if (!$d2c16f7a6010a221$export$61579433626afe87(scale)) scale.range = $d2c16f7a6010a221$var$piecewiseRange(scale);
        scale.scale.range(scale.range);
    }
    $d2c16f7a6010a221$var$autoScaleRound(scale);
}
function $d2c16f7a6010a221$var$autoScaleRangeY(scale, dimensions) {
    if (scale.range === undefined) {
        const { insetTop: insetTop, insetBottom: insetBottom } = scale;
        const { height: height, marginTop: marginTop = 0, marginBottom: marginBottom = 0 } = dimensions;
        const top = marginTop + insetTop;
        const bottom = height - marginBottom - insetBottom;
        scale.range = [
            Math.max(top, bottom),
            top
        ];
        if (!$d2c16f7a6010a221$export$61579433626afe87(scale)) scale.range = $d2c16f7a6010a221$var$piecewiseRange(scale);
        else scale.range.reverse();
        scale.scale.range(scale.range);
    }
    $d2c16f7a6010a221$var$autoScaleRound(scale);
}
function $d2c16f7a6010a221$var$autoScaleRound(scale) {
    if (scale.round === undefined && $d2c16f7a6010a221$var$isBandScale(scale) && $d2c16f7a6010a221$var$roundError(scale) <= 30) scale.scale.round(true);
}
// If we were to turn on rounding for this band or point scale, how much wasted
// space would it introduce (on both ends of the range)? This must match
// d3.scaleBand’s rounding behavior:
// https://github.com/d3/d3-scale/blob/83555bd759c7314420bd4240642beda5e258db9e/src/band.js#L20-L32
function $d2c16f7a6010a221$var$roundError({ scale: scale }) {
    const n = scale.domain().length;
    const [start, stop] = scale.range();
    const paddingInner = scale.paddingInner ? scale.paddingInner() : 1;
    const paddingOuter = scale.paddingOuter ? scale.paddingOuter() : scale.padding();
    const m = n - paddingInner;
    const step = Math.abs(stop - start) / Math.max(1, m + paddingOuter * 2);
    return (step - Math.floor(step)) * m;
}
function $d2c16f7a6010a221$var$piecewiseRange(scale) {
    const length = scale.scale.domain().length + $d2c16f7a6010a221$export$667642af40ee0f01(scale);
    if (!(length > 2)) return scale.range;
    const [start, end] = scale.range;
    return Array.from({
        length: length
    }, (_, i)=>start + i / (length - 1) * (end - start));
}
function $d2c16f7a6010a221$export$a566bffc16069997(key, scale, hint) {
    return $d2c16f7a6010a221$var$createScale(key, hint === undefined ? undefined : [
        {
            hint: hint
        }
    ], {
        ...scale
    });
}
function $d2c16f7a6010a221$var$createScale(key, channels = [], options = {}) {
    const type = $d2c16f7a6010a221$var$inferScaleType(key, channels, options);
    // Warn for common misuses of implicit ordinal scales. We disable this test if
    // you specify a scale interval or if you set the domain or range explicitly,
    // since setting the domain or range (typically with a cardinality of more than
    // two) is another indication that you intended for the scale to be ordinal; we
    // also disable it for facet scales since these are always band scales.
    if (options.type === undefined && options.domain === undefined && options.range === undefined && options.interval == null && key !== "fx" && key !== "fy" && $d2c16f7a6010a221$export$61579433626afe87({
        type: type
    })) {
        const values = channels.map(({ value: value })=>value).filter((value)=>value !== undefined);
        if (values.some((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7))) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: some data associated with the ${key} scale are dates. Dates are typically associated with a "utc" or "time" scale rather than a "${$d2c16f7a6010a221$var$formatScaleType(type)}" scale. If you are using a bar mark, you probably want a rect mark with the interval option instead; if you are using a group transform, you probably want a bin transform instead. If you want to treat this data as ordinal, you can specify the interval of the ${key} scale (e.g., d3.utcDay), or you can suppress this warning by setting the type of the ${key} scale to "${$d2c16f7a6010a221$var$formatScaleType(type)}".`);
        else if (values.some((0, $cd9e805a4bbd13f9$export$4ca903a67c0d1c91))) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: some data associated with the ${key} scale are strings that appear to be dates (e.g., YYYY-MM-DD). If these strings represent dates, you should parse them to Date objects. Dates are typically associated with a "utc" or "time" scale rather than a "${$d2c16f7a6010a221$var$formatScaleType(type)}" scale. If you are using a bar mark, you probably want a rect mark with the interval option instead; if you are using a group transform, you probably want a bin transform instead. If you want to treat this data as ordinal, you can suppress this warning by setting the type of the ${key} scale to "${$d2c16f7a6010a221$var$formatScaleType(type)}".`);
        else if (values.some((0, $cd9e805a4bbd13f9$export$797f4d96e209972c))) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: some data associated with the ${key} scale are strings that appear to be numbers. If these strings represent numbers, you should parse or coerce them to numbers. Numbers are typically associated with a "linear" scale rather than a "${$d2c16f7a6010a221$var$formatScaleType(type)}" scale. If you want to treat this data as ordinal, you can specify the interval of the ${key} scale (e.g., 1 for integers), or you can suppress this warning by setting the type of the ${key} scale to "${$d2c16f7a6010a221$var$formatScaleType(type)}".`);
    }
    options.type = type; // Mutates input!
    // Once the scale type is known, coerce the associated channel values and any
    // explicitly-specified domain to the expected type.
    switch(type){
        case "diverging":
        case "diverging-sqrt":
        case "diverging-pow":
        case "diverging-log":
        case "diverging-symlog":
        case "cyclical":
        case "sequential":
        case "linear":
        case "sqrt":
        case "threshold":
        case "quantile":
        case "pow":
        case "log":
        case "symlog":
            options = $d2c16f7a6010a221$var$coerceType(channels, options, (0, $cd9e805a4bbd13f9$export$803a244824c02a83));
            break;
        case "identity":
            switch((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key)){
                case 0, $743dde21c57c19a0$export$5880b8b5730aff45:
                    options = $d2c16f7a6010a221$var$coerceType(channels, options, (0, $cd9e805a4bbd13f9$export$803a244824c02a83));
                    break;
                case 0, $743dde21c57c19a0$export$8f701197936bc2a6:
                    options = $d2c16f7a6010a221$var$coerceType(channels, options, $d2c16f7a6010a221$var$coerceSymbols);
                    break;
            }
            break;
        case "utc":
        case "time":
            options = $d2c16f7a6010a221$var$coerceType(channels, options, (0, $cd9e805a4bbd13f9$export$9a67b3ad4b3297f7));
            break;
    }
    switch(type){
        case "diverging":
            return (0, $d47764ac2a1afe36$export$10bc5013af7fbfeb)(key, channels, options);
        case "diverging-sqrt":
            return (0, $d47764ac2a1afe36$export$5c6d902e911bf823)(key, channels, options);
        case "diverging-pow":
            return (0, $d47764ac2a1afe36$export$4271a1a68e7dad01)(key, channels, options);
        case "diverging-log":
            return (0, $d47764ac2a1afe36$export$23b5ded97d4d761d)(key, channels, options);
        case "diverging-symlog":
            return (0, $d47764ac2a1afe36$export$2e609d678277a5b2)(key, channels, options);
        case "categorical":
        case "ordinal":
        case 0, $578b04df998308c7$export$c689386541b0b504:
            return (0, $578b04df998308c7$export$ce1e458838513137)(key, channels, options);
        case "cyclical":
        case "sequential":
        case "linear":
            return (0, $30c166b7628c3ceb$export$8eab0b226d0f3b42)(key, channels, options);
        case "sqrt":
            return (0, $30c166b7628c3ceb$export$a5c8c8de32abacf0)(key, channels, options);
        case "threshold":
            return (0, $30c166b7628c3ceb$export$29c9ae4906e7bfbc)(key, channels, options);
        case "quantile":
            return (0, $30c166b7628c3ceb$export$491dcf080c701b2f)(key, channels, options);
        case "quantize":
            return (0, $30c166b7628c3ceb$export$25f12ee8f05111a7)(key, channels, options);
        case "pow":
            return (0, $30c166b7628c3ceb$export$ea2a572a59b9896a)(key, channels, options);
        case "log":
            return (0, $30c166b7628c3ceb$export$812089778d3d78b5)(key, channels, options);
        case "symlog":
            return (0, $30c166b7628c3ceb$export$b91aaebc8fcff1ed)(key, channels, options);
        case "utc":
            return (0, $5e40204519ce563c$export$54513e35ea306f4c)(key, channels, options);
        case "time":
            return (0, $5e40204519ce563c$export$75a5e216fb2fb836)(key, channels, options);
        case "point":
            return (0, $578b04df998308c7$export$76f15ed1f7e49d58)(key, channels, options);
        case "band":
            return (0, $578b04df998308c7$export$d3af6885a1dd51b1)(key, channels, options);
        case "identity":
            return (0, $30c166b7628c3ceb$export$5f13182ef6dc55f1)(key);
        case undefined:
            return;
        default:
            throw new Error(`unknown scale type: ${type}`);
    }
}
function $d2c16f7a6010a221$var$formatScaleType(type) {
    return typeof type === "symbol" ? type.description : type;
}
function $d2c16f7a6010a221$var$maybeScaleType(type) {
    return typeof type === "string" ? `${type}`.toLowerCase() : type;
}
// A special type symbol when the x and y scales are replaced with a projection.
const $d2c16f7a6010a221$var$typeProjection = {
    toString: ()=>"projection"
};
function $d2c16f7a6010a221$var$inferScaleType(key, channels, { type: type, domain: domain, range: range, scheme: scheme, pivot: pivot, projection: projection }) {
    type = $d2c16f7a6010a221$var$maybeScaleType(type);
    // The facet scales are always band scales; this cannot be changed.
    if (key === "fx" || key === "fy") return "band";
    // If a projection is specified, the x- and y-scales are disabled; these
    // channels will be projected rather than scaled. (But still check that none
    // of the associated channels are incompatible with a projection.)
    if ((key === "x" || key === "y") && projection != null) type = $d2c16f7a6010a221$var$typeProjection;
    // If a channel dictates a scale type, make sure that it is consistent with
    // the user-specified scale type (if any) and all other channels. For example,
    // barY requires x to be a band scale and disallows any other scale type.
    for (const channel of channels){
        const t = $d2c16f7a6010a221$var$maybeScaleType(channel.type);
        if (t === undefined) continue;
        else if (type === undefined) type = t;
        else if (type !== t) throw new Error(`scale incompatible with channel: ${type} !== ${t}`);
    }
    // If the scale, a channel, or user specified a (consistent) type, return it.
    if (type === $d2c16f7a6010a221$var$typeProjection) return;
    if (type !== undefined) return type;
    // If there’s no data (and no type) associated with this scale, don’t create a scale.
    if (domain === undefined && !channels.some(({ value: value })=>value !== undefined)) return;
    // Some scales have default types.
    const kind = (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(key);
    if (kind === (0, $743dde21c57c19a0$export$872dd985a098dd45)) return "sqrt";
    if (kind === (0, $743dde21c57c19a0$export$c17a3be1057836e) || kind === (0, $743dde21c57c19a0$export$f24224f1c91d8156)) return "linear";
    if (kind === (0, $743dde21c57c19a0$export$8f701197936bc2a6)) return "ordinal";
    // If the domain or range has more than two values, assume it’s ordinal. You
    // can still use a “piecewise” (or “polylinear”) scale, but you must set the
    // type explicitly.
    if ((domain || range || []).length > 2) return $d2c16f7a6010a221$var$asOrdinalType(kind);
    // Otherwise, infer the scale type from the data! Prefer the domain, if
    // present, over channels. (The domain and channels should be consistently
    // typed, and the domain is more explicit and typically much smaller.) We only
    // check the first defined value for expedience and simplicity; we expect
    // that the types are consistent.
    if (domain !== undefined) {
        if ((0, $cd9e805a4bbd13f9$export$ded408f9a9c9003b)(domain)) return $d2c16f7a6010a221$var$asOrdinalType(kind);
        if ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(domain)) return "utc";
    } else {
        const values = channels.map(({ value: value })=>value).filter((value)=>value !== undefined);
        if (values.some((0, $cd9e805a4bbd13f9$export$ded408f9a9c9003b))) return $d2c16f7a6010a221$var$asOrdinalType(kind);
        if (values.some((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7))) return "utc";
    }
    // For color scales, take a hint from the color scheme and pivot option.
    if (kind === (0, $743dde21c57c19a0$export$35e9368ef982300f)) {
        if (pivot != null || (0, $a49a01342b27942f$export$bd1a4763c73ba9bf)(scheme)) return "diverging";
        if ((0, $a49a01342b27942f$export$6be03a206d9fd924)(scheme)) return "categorical";
    }
    return "linear";
}
// Positional scales default to a point scale instead of an ordinal scale.
function $d2c16f7a6010a221$var$asOrdinalType(kind) {
    switch(kind){
        case 0, $743dde21c57c19a0$export$5880b8b5730aff45:
            return "point";
        case 0, $743dde21c57c19a0$export$35e9368ef982300f:
            return 0, $578b04df998308c7$export$c689386541b0b504;
        default:
            return "ordinal";
    }
}
function $d2c16f7a6010a221$export$60df8d74f7d563a1({ type: type }) {
    return type === "time" || type === "utc";
}
function $d2c16f7a6010a221$export$61579433626afe87({ type: type }) {
    return type === "ordinal" || type === "point" || type === "band" || type === (0, $578b04df998308c7$export$c689386541b0b504);
}
function $d2c16f7a6010a221$export$667642af40ee0f01({ type: type }) {
    return type === "threshold";
}
function $d2c16f7a6010a221$var$isBandScale({ type: type }) {
    return type === "point" || type === "band";
}
function $d2c16f7a6010a221$export$d977c0ec2df12b11({ type: type }) {
    return /^diverging($|-)/.test(type);
}
function $d2c16f7a6010a221$export$9c903d35b97d0190(scale) {
    if (scale === undefined) return true; // treat missing scale as collapsed
    const domain = scale.domain();
    const value = scale(domain[0]);
    for(let i = 1, n = domain.length; i < n; ++i){
        if (scale(domain[i]) - value) return false;
    }
    return true;
}
// Mutates channel.value!
function $d2c16f7a6010a221$var$coerceType(channels, { domain: domain, ...options }, coerceValues) {
    for (const c of channels)if (c.value !== undefined) {
        if (domain === undefined) domain = c.value?.domain; // promote channel domain
        c.value = coerceValues(c.value);
    }
    return {
        domain: domain === undefined ? domain : coerceValues(domain),
        ...options
    };
}
function $d2c16f7a6010a221$var$coerceSymbols(values) {
    return (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(values, (0, $7ef09cabd5617a1b$export$355b55bc2192971a));
}
function $d2c16f7a6010a221$export$dcdf75081b88279d(options = {}) {
    let scale;
    for(const key in options){
        if (!(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(key)) continue; // ignore unknown properties
        if (!(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options[key])) continue; // e.g., ignore {color: "red"}
        if (scale !== undefined) throw new Error("ambiguous scale definition; multiple scales found");
        scale = $d2c16f7a6010a221$var$exposeScale($d2c16f7a6010a221$export$a566bffc16069997(key, options[key]));
    }
    if (scale === undefined) throw new Error("invalid scale definition; no scale found");
    return scale;
}
function $d2c16f7a6010a221$export$de69b9c17a3f6bda(scales) {
    return (key)=>{
        if (!(0, $743dde21c57c19a0$export$4bb7493d241fd8a5).has(key = `${key}`)) throw new Error(`unknown scale: ${key}`);
        return scales[key];
    };
}
// Note: axis- and legend-related properties (such as label, ticks and
// tickFormat) are not included here as they do not affect the scale’s behavior.
function $d2c16f7a6010a221$var$exposeScale({ scale: scale, type: type, domain: domain, range: range, interpolate: interpolate, interval: interval, transform: transform, percent: percent, pivot: pivot }) {
    if (type === "identity") return {
        type: "identity",
        apply: (d)=>d,
        invert: (d)=>d
    };
    const unknown = scale.unknown ? scale.unknown() : undefined;
    return {
        type: type,
        domain: (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(domain),
        ...range !== undefined && {
            range: (0, $cd9e805a4bbd13f9$export$58adb3bec8346d0f)(range)
        },
        ...transform !== undefined && {
            transform: transform
        },
        ...percent && {
            percent: percent
        },
        ...unknown !== undefined && {
            unknown: unknown
        },
        ...interval !== undefined && {
            interval: interval
        },
        // quantitative
        ...interpolate !== undefined && {
            interpolate: interpolate
        },
        ...scale.clamp && {
            clamp: scale.clamp()
        },
        // diverging (always asymmetric; we never want to apply the symmetric transform twice)
        ...pivot !== undefined && {
            pivot: pivot,
            symmetric: false
        },
        // log, diverging-log
        ...scale.base && {
            base: scale.base()
        },
        // pow, diverging-pow
        ...scale.exponent && {
            exponent: scale.exponent()
        },
        // symlog, diverging-symlog
        ...scale.constant && {
            constant: scale.constant()
        },
        // band, point
        ...scale.align && {
            align: scale.align(),
            round: scale.round()
        },
        ...scale.padding && (scale.paddingInner ? {
            paddingInner: scale.paddingInner(),
            paddingOuter: scale.paddingOuter()
        } : {
            padding: scale.padding()
        }),
        ...scale.bandwidth && {
            bandwidth: scale.bandwidth(),
            step: scale.step()
        },
        // utilities
        apply: (t)=>scale(t),
        ...scale.invert && {
            invert: (t)=>scale.invert(t)
        }
    };
}


function $a6069a9074a3d58d$export$78806da010ca96a5(channelsByScale, options) {
    const { fx: fx, fy: fy } = (0, $d2c16f7a6010a221$export$3935c083772c2fcc)(channelsByScale, options);
    const fxDomain = fx?.scale.domain();
    const fyDomain = fy?.scale.domain();
    return fxDomain && fyDomain ? (0, $674b813fb857ae76$export$2e2bcd8739ae039)(fxDomain, fyDomain).map(([x, y], i)=>({
            x: x,
            y: y,
            i: i
        })) : fxDomain ? fxDomain.map((x, i)=>({
            x: x,
            i: i
        })) : fyDomain ? fyDomain.map((y, i)=>({
            y: y,
            i: i
        })) : undefined;
}
function $a6069a9074a3d58d$export$f59853a117afdf3c(facets, { x: X, y: Y }) {
    X &&= $a6069a9074a3d58d$var$facetIndex(X);
    Y &&= $a6069a9074a3d58d$var$facetIndex(Y);
    return facets.filter(X && Y // remove any facets no longer present in the domain
     ? (f)=>X.has(f.x) && Y.has(f.y) : X ? (f)=>X.has(f.x) : (f)=>Y.has(f.y)).sort(X && Y // reorder facets to match the new scale domains
     ? (a, b)=>X.get(a.x) - X.get(b.x) || Y.get(a.y) - Y.get(b.y) : X ? (a, b)=>X.get(a.x) - X.get(b.x) : (a, b)=>Y.get(a.y) - Y.get(b.y));
}
function $a6069a9074a3d58d$export$46a87af59f80d026(data, { fx: fx, fy: fy }) {
    const I = (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data);
    const FX = fx?.value;
    const FY = fy?.value;
    return fx && fy ? (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (G)=>(G.fx = FX[G[0]], G.fy = FY[G[0]], G), (i)=>FX[i], (i)=>FY[i]) : fx ? (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (G)=>(G.fx = FX[G[0]], G), (i)=>FX[i]) : (0, $6f0c14a1378d16c1$export$97e11c0b0230f130)(I, (G)=>(G.fy = FY[G[0]], G), (i)=>FY[i]);
}
function $a6069a9074a3d58d$export$1b78147bc5e9c7ba(fx, fy, { marginTop: marginTop, marginLeft: marginLeft }) {
    return fx && fy ? ({ x: x, y: y })=>`translate(${fx(x) - marginLeft},${fy(y) - marginTop})` : fx ? ({ x: x })=>`translate(${fx(x) - marginLeft},0)` : ({ y: y })=>`translate(0,${fy(y) - marginTop})`;
}
function $a6069a9074a3d58d$export$1cc7e8228bc740dc(index) {
    const ex = [];
    const e = new Uint32Array((0, $daf42a1f07322cf6$export$2e2bcd8739ae039)(index, (d)=>d.length));
    for (const i of index){
        let n = 0;
        for (const j of index){
            if (i === j) continue;
            e.set(j, n);
            n += j.length;
        }
        ex.push(e.slice(0, n));
    }
    return ex;
}
const $a6069a9074a3d58d$var$facetAnchors = new Map([
    [
        "top",
        $a6069a9074a3d58d$var$facetAnchorTop
    ],
    [
        "right",
        $a6069a9074a3d58d$var$facetAnchorRight
    ],
    [
        "bottom",
        $a6069a9074a3d58d$var$facetAnchorBottom
    ],
    [
        "left",
        $a6069a9074a3d58d$var$facetAnchorLeft
    ],
    [
        "top-left",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorTop, $a6069a9074a3d58d$var$facetAnchorLeft)
    ],
    [
        "top-right",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorTop, $a6069a9074a3d58d$var$facetAnchorRight)
    ],
    [
        "bottom-left",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorBottom, $a6069a9074a3d58d$var$facetAnchorLeft)
    ],
    [
        "bottom-right",
        $a6069a9074a3d58d$var$and($a6069a9074a3d58d$var$facetAnchorBottom, $a6069a9074a3d58d$var$facetAnchorRight)
    ],
    [
        "top-empty",
        $a6069a9074a3d58d$var$facetAnchorTopEmpty
    ],
    [
        "right-empty",
        $a6069a9074a3d58d$var$facetAnchorRightEmpty
    ],
    [
        "bottom-empty",
        $a6069a9074a3d58d$var$facetAnchorBottomEmpty
    ],
    [
        "left-empty",
        $a6069a9074a3d58d$var$facetAnchorLeftEmpty
    ],
    [
        "empty",
        $a6069a9074a3d58d$var$facetAnchorEmpty
    ]
]);
function $a6069a9074a3d58d$export$598b026809f23ca0(facetAnchor) {
    if (facetAnchor == null) return null;
    const anchor = $a6069a9074a3d58d$var$facetAnchors.get(`${facetAnchor}`.toLowerCase());
    if (anchor) return anchor;
    throw new Error(`invalid facet anchor: ${facetAnchor}`);
}
const $a6069a9074a3d58d$var$indexCache = new WeakMap();
function $a6069a9074a3d58d$var$facetIndex(V) {
    let I = $a6069a9074a3d58d$var$indexCache.get(V);
    if (!I) $a6069a9074a3d58d$var$indexCache.set(V, I = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)((0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(V, (v, i)=>[
            v,
            i
        ])));
    return I;
}
// Like V.indexOf(v), but with the same semantics as InternMap.
function $a6069a9074a3d58d$var$facetIndexOf(V, v) {
    return $a6069a9074a3d58d$var$facetIndex(V).get(v);
}
// Like facets.find, but with the same semantics as InternMap.
function $a6069a9074a3d58d$var$facetFind(facets, x, y) {
    x = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(x);
    y = (0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(y);
    return facets.find((f)=>Object.is((0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(f.x), x) && Object.is((0, $cd9e805a4bbd13f9$export$7e1278799275f68e)(f.y), y));
}
function $a6069a9074a3d58d$var$facetEmpty(facets, x, y) {
    return $a6069a9074a3d58d$var$facetFind(facets, x, y)?.empty;
}
function $a6069a9074a3d58d$var$facetAnchorTop(facets, { y: Y }, { y: y }) {
    return Y ? $a6069a9074a3d58d$var$facetIndexOf(Y, y) === 0 : true;
}
function $a6069a9074a3d58d$var$facetAnchorBottom(facets, { y: Y }, { y: y }) {
    return Y ? $a6069a9074a3d58d$var$facetIndexOf(Y, y) === Y.length - 1 : true;
}
function $a6069a9074a3d58d$var$facetAnchorLeft(facets, { x: X }, { x: x }) {
    return X ? $a6069a9074a3d58d$var$facetIndexOf(X, x) === 0 : true;
}
function $a6069a9074a3d58d$var$facetAnchorRight(facets, { x: X }, { x: x }) {
    return X ? $a6069a9074a3d58d$var$facetIndexOf(X, x) === X.length - 1 : true;
}
function $a6069a9074a3d58d$var$facetAnchorTopEmpty(facets, { y: Y }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!Y) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(Y, y);
    if (i > 0) return $a6069a9074a3d58d$var$facetEmpty(facets, x, Y[i - 1]);
}
function $a6069a9074a3d58d$var$facetAnchorBottomEmpty(facets, { y: Y }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!Y) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(Y, y);
    if (i < Y.length - 1) return $a6069a9074a3d58d$var$facetEmpty(facets, x, Y[i + 1]);
}
function $a6069a9074a3d58d$var$facetAnchorLeftEmpty(facets, { x: X }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!X) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(X, x);
    if (i > 0) return $a6069a9074a3d58d$var$facetEmpty(facets, X[i - 1], y);
}
function $a6069a9074a3d58d$var$facetAnchorRightEmpty(facets, { x: X }, { x: x, y: y, empty: empty }) {
    if (empty) return false;
    if (!X) return;
    const i = $a6069a9074a3d58d$var$facetIndexOf(X, x);
    if (i < X.length - 1) return $a6069a9074a3d58d$var$facetEmpty(facets, X[i + 1], y);
}
function $a6069a9074a3d58d$var$facetAnchorEmpty(facets, channels, { empty: empty }) {
    return empty;
}
function $a6069a9074a3d58d$var$and(a, b) {
    return function() {
        return a.apply(null, arguments) && b.apply(null, arguments);
    };
}
function $a6069a9074a3d58d$export$60f5bc485ae97c42(facets, { channels: { fx: fx, fy: fy }, groups: groups }) {
    return fx && fy ? facets.map(({ x: x, y: y })=>groups.get(x)?.get(y) ?? []) : fx ? facets.map(({ x: x })=>groups.get(x) ?? []) : facets.map(({ y: y })=>groups.get(y) ?? []);
}







const $0b574e6ffdcb6f7c$var$pi = Math.PI;
const $0b574e6ffdcb6f7c$var$tau = 2 * $0b574e6ffdcb6f7c$var$pi;
const $0b574e6ffdcb6f7c$var$defaultAspectRatio = 0.618;
function $0b574e6ffdcb6f7c$export$549167224996a0fb({ projection: projection, inset: globalInset = 0, insetTop: insetTop = globalInset, insetRight: insetRight = globalInset, insetBottom: insetBottom = globalInset, insetLeft: insetLeft = globalInset } = {}, dimensions) {
    if (projection == null) return;
    if (typeof projection.stream === "function") return projection; // d3 projection
    let options;
    let domain;
    let clip = "frame";
    // If the projection was specified as an object with additional options,
    // extract those. The order of precedence for insetTop (and other insets) is:
    // projection.insetTop, projection.inset, (global) insetTop, (global) inset.
    // Any other options on this object will be passed through to the initializer.
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(projection)) {
        let inset;
        ({ type: projection, domain: domain, inset: inset, insetTop: insetTop = inset !== undefined ? inset : insetTop, insetRight: insetRight = inset !== undefined ? inset : insetRight, insetBottom: insetBottom = inset !== undefined ? inset : insetBottom, insetLeft: insetLeft = inset !== undefined ? inset : insetLeft, clip: clip = clip, ...options } = projection);
        if (projection == null) return;
    }
    // For named projections, retrieve the corresponding projection initializer.
    if (typeof projection !== "function") ({ type: projection } = $0b574e6ffdcb6f7c$var$namedProjection(projection));
    // Compute the frame dimensions and invoke the projection initializer.
    const { width: width, height: height, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, marginBottom: marginBottom } = dimensions;
    const dx = width - marginLeft - marginRight - insetLeft - insetRight;
    const dy = height - marginTop - marginBottom - insetTop - insetBottom;
    projection = projection?.({
        width: dx,
        height: dy,
        clip: clip,
        ...options
    });
    // The projection initializer might decide to not use a projection.
    if (projection == null) return;
    clip = $0b574e6ffdcb6f7c$var$maybePostClip(clip, marginLeft, marginTop, width - marginRight, height - marginBottom);
    // Translate the origin to the top-left corner, respecting margins and insets.
    let tx = marginLeft + insetLeft;
    let ty = marginTop + insetTop;
    let transform;
    // If a domain is specified, fit the projection to the frame.
    if (domain != null) {
        const [[x0, y0], [x1, y1]] = (0, $58c46562f4a8d739$export$2e2bcd8739ae039)(projection).bounds(domain);
        const k = Math.min(dx / (x1 - x0), dy / (y1 - y0));
        if (k > 0) {
            tx -= (k * (x0 + x1) - dx) / 2;
            ty -= (k * (y0 + y1) - dy) / 2;
            transform = (0, $0412b2d170387dff$export$2e2bcd8739ae039)({
                point (x, y) {
                    this.stream.point(x * k + tx, y * k + ty);
                }
            });
        } else (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the projection could not be fit to the specified domain; using the default scale.`);
    }
    transform ??= tx === 0 && ty === 0 ? $0b574e6ffdcb6f7c$var$identity() : (0, $0412b2d170387dff$export$2e2bcd8739ae039)({
        point (x, y) {
            this.stream.point(x + tx, y + ty);
        }
    });
    return {
        stream: (s)=>projection.stream(transform.stream(clip(s)))
    };
}
function $0b574e6ffdcb6f7c$var$namedProjection(projection) {
    switch(`${projection}`.toLowerCase()){
        case "albers-usa":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $dae3a16b5ba78504$export$2e2bcd8739ae039), 0.7463, 0.4673);
        case "albers":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $189dcd4c41cb3d8a$export$2e2bcd8739ae039), 0.7463, 0.4673);
        case "azimuthal-equal-area":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $cde1dad42250dd7d$export$2e2bcd8739ae039), 4, 4);
        case "azimuthal-equidistant":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $7a9894a70b3e10e2$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        case "conic-conformal":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $c71ea640260518ba$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        case "conic-equal-area":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $be3cbe5874066802$export$2e2bcd8739ae039), 6.1702, 2.9781);
        case "conic-equidistant":
            return $0b574e6ffdcb6f7c$var$conicProjection((0, $d8f5b846585bb1cd$export$2e2bcd8739ae039), 7.312, 3.6282);
        case "equal-earth":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $fc041bd5ad9011bc$export$2e2bcd8739ae039), 5.4133, 2.6347);
        case "equirectangular":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $b150c6d84b26cddf$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$pi);
        case "gnomonic":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $ec357a35bfb88504$export$2e2bcd8739ae039), 3.4641, 3.4641);
        case "identity":
            return {
                type: $0b574e6ffdcb6f7c$var$identity
            };
        case "reflect-y":
            return {
                type: $0b574e6ffdcb6f7c$var$reflectY
            };
        case "mercator":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $ff090f04ba81e8e2$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        case "orthographic":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $5bed72effbe81a9c$export$2e2bcd8739ae039), 2, 2);
        case "stereographic":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $30512e786dc906d9$export$2e2bcd8739ae039), 2, 2);
        case "transverse-mercator":
            return $0b574e6ffdcb6f7c$var$scaleProjection((0, $75766842dfa94e14$export$2e2bcd8739ae039), $0b574e6ffdcb6f7c$var$tau, $0b574e6ffdcb6f7c$var$tau);
        default:
            throw new Error(`unknown projection type: ${projection}`);
    }
}
function $0b574e6ffdcb6f7c$var$maybePostClip(clip, x1, y1, x2, y2) {
    if (clip === false || clip == null || typeof clip === "number") return (s)=>s;
    if (clip === true) clip = "frame";
    switch(`${clip}`.toLowerCase()){
        case "frame":
            return (0, $7d62d240b7fd88a7$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        default:
            throw new Error(`unknown projection clip type: ${clip}`);
    }
}
function $0b574e6ffdcb6f7c$var$scaleProjection(createProjection, kx, ky) {
    return {
        type: ({ width: width, height: height, rotate: rotate, precision: precision = 0.15, clip: clip })=>{
            const projection = createProjection();
            if (precision != null) projection.precision?.(precision);
            if (rotate != null) projection.rotate?.(rotate);
            if (typeof clip === "number") projection.clipAngle?.(clip);
            projection.scale(Math.min(width / kx, height / ky));
            projection.translate([
                width / 2,
                height / 2
            ]);
            return projection;
        },
        aspectRatio: ky / kx
    };
}
function $0b574e6ffdcb6f7c$var$conicProjection(createProjection, kx, ky) {
    const { type: type, aspectRatio: aspectRatio } = $0b574e6ffdcb6f7c$var$scaleProjection(createProjection, kx, ky);
    return {
        type: (options)=>{
            const { parallels: parallels, domain: domain, width: width, height: height } = options;
            const projection = type(options);
            if (parallels != null) {
                projection.parallels(parallels);
                if (domain === undefined) projection.fitSize([
                    width,
                    height
                ], {
                    type: "Sphere"
                });
            }
            return projection;
        },
        aspectRatio: aspectRatio
    };
}
const $0b574e6ffdcb6f7c$var$identity = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)({
    stream: (stream)=>stream
});
const $0b574e6ffdcb6f7c$var$reflectY = (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)((0, $0412b2d170387dff$export$2e2bcd8739ae039)({
    point (x, y) {
        this.stream.point(x, -y);
    }
}));
function $0b574e6ffdcb6f7c$export$ab03b6763ed7026f(cx, cy, values, projection) {
    const x = values[cx];
    const y = values[cy];
    const n = x.length;
    const X = values[cx] = new Float64Array(n).fill(NaN);
    const Y = values[cy] = new Float64Array(n).fill(NaN);
    let i;
    const stream = projection.stream({
        point (x, y) {
            X[i] = x;
            Y[i] = y;
        }
    });
    for(i = 0; i < n; ++i)stream.point(x[i], y[i]);
}
function $0b574e6ffdcb6f7c$export$a364b560a2a07d35({ projection: projection } = {}) {
    if (projection == null) return false;
    if (typeof projection.stream === "function") return true;
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(projection)) projection = projection.type;
    return projection != null;
}
function $0b574e6ffdcb6f7c$export$9bd1d82590468035(projection) {
    if (typeof projection?.stream === "function") return $0b574e6ffdcb6f7c$var$defaultAspectRatio;
    if ((0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(projection)) projection = projection.type;
    if (projection == null) return;
    if (typeof projection !== "function") {
        const { aspectRatio: aspectRatio } = $0b574e6ffdcb6f7c$var$namedProjection(projection);
        if (aspectRatio) return aspectRatio;
    }
    return $0b574e6ffdcb6f7c$var$defaultAspectRatio;
}
function $0b574e6ffdcb6f7c$export$6688ad6aa07debf2(channels, scales, { projection: projection }) {
    const { x: x, y: y } = channels;
    let position = {};
    if (x) position.x = x;
    if (y) position.y = y;
    position = (0, $6eb5f337b2493843$export$9df10f3a4586f4ff)(position, scales);
    if (projection && x?.scale === "x" && y?.scale === "y") $0b574e6ffdcb6f7c$export$ab03b6763ed7026f("x", "y", position, projection);
    if (x) position.x = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(position.x);
    if (y) position.y = (0, $cd9e805a4bbd13f9$export$803a244824c02a83)(position.y);
    return position;
}
function $0b574e6ffdcb6f7c$export$b3eb7247b89a6856(channel) {
    const X = [];
    const Y = [];
    const x = {
        scale: "x",
        value: X
    };
    const y = {
        scale: "y",
        value: Y
    };
    const sink = {
        point (x, y) {
            X.push(x);
            Y.push(y);
        },
        lineStart () {},
        lineEnd () {},
        polygonStart () {},
        polygonEnd () {},
        sphere () {}
    };
    for (const object of channel.value)(0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, sink);
    return [
        x,
        y
    ];
}




class $24d8c38d667d16c2$export$c9d15bcfc6d42044 {
    constructor(data, channels = {}, options = {}, defaults){
        const { facet: facet = "auto", facetAnchor: facetAnchor, fx: fx, fy: fy, sort: sort, dx: dx = 0, dy: dy = 0, margin: margin = 0, marginTop: marginTop = margin, marginRight: marginRight = margin, marginBottom: marginBottom = margin, marginLeft: marginLeft = margin, clip: clip = defaults?.clip, channels: extraChannels, tip: tip, render: render } = options;
        this.data = data;
        this.sort = (0, $cd9e805a4bbd13f9$export$d6cc17845c0d71a0)(sort) ? sort : null;
        this.initializer = (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)(options).initializer;
        this.transform = this.initializer ? options.transform : (0, $9dfbc15f77c5eeba$export$884c4fb92a8b1ea6)(options).transform;
        if (facet === null || facet === false) this.facet = null;
        else {
            this.facet = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(facet === true ? "include" : facet, "facet", [
                "auto",
                "include",
                "exclude",
                "super"
            ]);
            this.fx = data === (0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9) && typeof fx === "string" ? [
                fx
            ] : fx;
            this.fy = data === (0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9) && typeof fy === "string" ? [
                fy
            ] : fy;
        }
        this.facetAnchor = (0, $a6069a9074a3d58d$export$598b026809f23ca0)(facetAnchor);
        channels = (0, $cd9e805a4bbd13f9$export$b221e5d053773f17)(channels);
        if (extraChannels !== undefined) channels = {
            ...$24d8c38d667d16c2$var$maybeChannels(extraChannels),
            ...channels
        };
        if (defaults !== undefined) channels = {
            ...(0, $547e5698440387a8$export$9dd6ff9ea0189349)(this, options, defaults),
            ...channels
        };
        this.channels = Object.fromEntries(Object.entries(channels).map(([name, channel])=>{
            if ((0, $cd9e805a4bbd13f9$export$dae3322343de7d27)(channel.value)) {
                // apply scale and label overrides
                const { value: value, label: label = channel.label, scale: scale = channel.scale } = channel.value;
                channel = {
                    ...channel,
                    label: label,
                    scale: scale,
                    value: value
                };
            }
            if (data === (0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9) && typeof channel.value === "string") {
                // convert field names to singleton values for decoration marks (e.g., frame)
                const { value: value } = channel;
                channel = {
                    ...channel,
                    value: [
                        value
                    ]
                };
            }
            return [
                name,
                channel
            ];
        }).filter(([name, { value: value, optional: optional }])=>{
            if (value != null) return true;
            if (optional) return false;
            throw new Error(`missing channel value: ${name}`);
        }));
        this.dx = +dx;
        this.dy = +dy;
        this.marginTop = +marginTop;
        this.marginRight = +marginRight;
        this.marginBottom = +marginBottom;
        this.marginLeft = +marginLeft;
        this.clip = (0, $547e5698440387a8$export$1920f6ea06533ca7)(clip);
        this.tip = $24d8c38d667d16c2$var$maybeTip(tip);
        // Super-faceting currently disallow position channels; in the future, we
        // could allow position to be specified in fx and fy in addition to (or
        // instead of) x and y.
        if (this.facet === "super") {
            if (fx || fy) throw new Error(`super-faceting cannot use fx or fy`);
            for(const name in this.channels){
                const { scale: scale } = channels[name];
                if (scale !== "x" && scale !== "y") continue;
                throw new Error(`super-faceting cannot use x or y`);
            }
        }
        if (render != null) this.render = $24d8c38d667d16c2$export$b80642eda489f786(render, this.render);
    }
    initialize(facets, facetChannels, plotOptions) {
        let data = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(this.data);
        if (facets === undefined && data != null) facets = [
            (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data)
        ];
        const originalFacets = facets;
        if (this.transform != null) ({ facets: facets, data: data } = this.transform(data, facets, plotOptions)), data = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(data);
        if (facets !== undefined) facets.original = originalFacets; // needed to read facetChannels
        const channels = (0, $6eb5f337b2493843$export$422e7cd65ac5d2cf)(this.channels, data);
        if (this.sort != null) (0, $6eb5f337b2493843$export$334f2e4e1c2a6aef)(data, facets, channels, facetChannels, this.sort); // mutates facetChannels!
        return {
            data: data,
            facets: facets,
            channels: channels
        };
    }
    filter(index, channels, values) {
        for(const name in channels){
            const { filter: filter = (0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97) } = channels[name];
            if (filter !== null) {
                const value = values[name];
                index = index.filter((i)=>filter(value[i]));
            }
        }
        return index;
    }
    // If there is a projection, and there are paired x and y channels associated
    // with the x and y scale respectively (and not already in screen coordinates
    // as with an initializer), then apply the projection, replacing the x and y
    // values. Note that the x and y scales themselves don’t exist if there is a
    // projection, but whether the channels are associated with scales still
    // determines whether the projection should apply; think of the projection as
    // a combination xy-scale.
    project(channels, values, context) {
        for(const cx in channels)if (channels[cx].scale === "x" && /^x|x$/.test(cx)) {
            const cy = cx.replace(/^x|x$/, "y");
            if (cy in channels && channels[cy].scale === "y") (0, $0b574e6ffdcb6f7c$export$ab03b6763ed7026f)(cx, cy, values, context.projection);
        }
    }
    scale(channels, scales, context) {
        const values = (0, $6eb5f337b2493843$export$9df10f3a4586f4ff)(channels, scales);
        if (context.projection) this.project(channels, values, context);
        return values;
    }
}
function $24d8c38d667d16c2$export$3a8025f2f3e0c64(...marks1) {
    marks1.plot = $24d8c38d667d16c2$export$c9d15bcfc6d42044.prototype.plot; // Note: depends on side-effect in plot!
    return marks1;
}
function $24d8c38d667d16c2$export$b80642eda489f786(r1, r2) {
    if (r1 == null) return r2 === null ? undefined : r2;
    if (r2 == null) return r1 === null ? undefined : r1;
    if (typeof r1 !== "function") throw new TypeError(`invalid render transform: ${r1}`);
    if (typeof r2 !== "function") throw new TypeError(`invalid render transform: ${r2}`);
    return function(i, s, v, d, c, next) {
        return r1.call(this, i, s, v, d, c, (i, s, v, d, c)=>{
            return r2.call(this, i, s, v, d, c, next); // preserve this
        });
    };
}
function $24d8c38d667d16c2$var$maybeChannels(channels) {
    return Object.fromEntries(Object.entries((0, $cd9e805a4bbd13f9$export$b221e5d053773f17)(channels)).map(([name, channel])=>{
        channel = typeof channel === "string" ? {
            value: channel,
            label: name
        } : (0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(channel); // for shorthand extra channels, use name as label
        if (channel.filter === undefined && channel.scale == null) channel = {
            ...channel,
            filter: null
        };
        return [
            name,
            channel
        ];
    }));
}
function $24d8c38d667d16c2$var$maybeTip(tip) {
    return tip === true ? "xy" : tip === false || tip == null ? null : typeof tip === "string" ? (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(tip, "tip", [
        "x",
        "y",
        "xy"
    ]) : tip; // tip options object
}
function $24d8c38d667d16c2$export$963b1143142dad19(options, pointer) {
    return options?.tip === true ? {
        ...options,
        tip: pointer
    } : (0, $cd9e805a4bbd13f9$export$a6cdc56e425d0d0a)(options?.tip) && options.tip.pointer === undefined ? {
        ...options,
        tip: {
            ...options.tip,
            pointer: pointer
        }
    } : options;
}





function $bfd513fc05083823$export$ce69bd05624d0c48(strings, ...parts) {
    let n = parts.length;
    // If any of the interpolated parameters are strings rather than functions,
    // bake them into the template to optimize performance during render.
    for(let j = 0, copy = true; j < n; ++j)if (typeof parts[j] !== "function") {
        if (copy) {
            strings = strings.slice(); // copy before mutate
            copy = false;
        }
        strings.splice(j, 2, strings[j] + parts[j] + strings[j + 1]);
        parts.splice(j, 1);
        --j, --n;
    }
    return (i)=>{
        let s = strings[0];
        for(let j = 0; j < n; ++j)s += parts[j](i) + strings[j + 1];
        return s;
    };
}





function $99fa11de593a4520$export$26b23c8bb7051b0({ inset: inset, insetLeft: insetLeft, insetRight: insetRight, ...options } = {}) {
    [insetLeft, insetRight] = $99fa11de593a4520$var$maybeInset(inset, insetLeft, insetRight);
    return {
        inset: inset,
        insetLeft: insetLeft,
        insetRight: insetRight,
        ...options
    };
}
function $99fa11de593a4520$export$cc1990e80430bfbb({ inset: inset, insetTop: insetTop, insetBottom: insetBottom, ...options } = {}) {
    [insetTop, insetBottom] = $99fa11de593a4520$var$maybeInset(inset, insetTop, insetBottom);
    return {
        inset: inset,
        insetTop: insetTop,
        insetBottom: insetBottom,
        ...options
    };
}
function $99fa11de593a4520$var$maybeInset(inset, inset1, inset2) {
    return inset === undefined && inset1 === undefined && inset2 === undefined ? (0, $547e5698440387a8$export$cc800923e997bb8) ? [
        1,
        0
    ] : [
        0.5,
        0.5
    ] : [
        inset1,
        inset2
    ];
}


// The interval may be specified either as x: {value, interval} or as {x,
// interval}. The former can be used to specify separate intervals for x and y,
// for example with Plot.rect.
function $785a735c79529924$var$maybeIntervalValue(value, { interval: interval }) {
    value = {
        ...(0, $cd9e805a4bbd13f9$export$f4579685de3ca7bf)(value)
    };
    value.interval = (0, $cd9e805a4bbd13f9$export$91a968a7e5747089)(value.interval === undefined ? interval : value.interval);
    return value;
}
function $785a735c79529924$var$maybeIntervalK(k, maybeInsetK, options, trivial) {
    const { [k]: v, [`${k}1`]: v1, [`${k}2`]: v2 } = options;
    const { value: value, interval: interval } = $785a735c79529924$var$maybeIntervalValue(v, options);
    if (value == null || interval == null && !trivial) return options;
    const label = (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(v);
    if (interval == null) {
        let V;
        const kv = {
            transform: (data)=>V || (V = (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value)),
            label: label
        };
        return {
            ...options,
            [k]: undefined,
            [`${k}1`]: v1 === undefined ? kv : v1,
            [`${k}2`]: v2 === undefined && !(v1 === v2 && trivial) ? kv : v2
        };
    }
    let D1, V1;
    function transform(data) {
        if (V1 !== undefined && data === D1) return V1; // memoize
        return V1 = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(D1 = data, value), (v)=>interval.floor(v));
    }
    return maybeInsetK({
        ...options,
        [k]: undefined,
        [`${k}1`]: v1 === undefined ? {
            transform: transform,
            label: label
        } : v1,
        [`${k}2`]: v2 === undefined ? {
            transform: (data)=>transform(data).map((v)=>interval.offset(v)),
            label: label
        } : v2
    });
}
function $785a735c79529924$var$maybeIntervalMidK(k, maybeInsetK, options) {
    const { [k]: v } = options;
    const { value: value, interval: interval } = $785a735c79529924$var$maybeIntervalValue(v, options);
    if (value == null || interval == null) return options;
    return maybeInsetK({
        ...options,
        [k]: {
            label: (0, $cd9e805a4bbd13f9$export$bd9d73a16a2ec705)(v),
            transform: (data)=>{
                const V1 = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)((0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, value), (v)=>interval.floor(v));
                const V2 = V1.map((v)=>interval.offset(v));
                return V1.map((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(V1) ? (v1, v2)=>v1 == null || isNaN(v1 = +v1) || (v2 = V2[v2], v2 == null) || isNaN(v2 = +v2) ? undefined : new Date((v1 + v2) / 2) : (v1, v2)=>v1 == null || (v2 = V2[v2], v2 == null) ? NaN : (+v1 + +v2) / 2);
            }
        }
    });
}
function $785a735c79529924$export$3e5af5df4bf84a22(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("x", (0, $99fa11de593a4520$export$26b23c8bb7051b0), options, true);
}
function $785a735c79529924$export$180507f16d7b6c92(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("y", (0, $99fa11de593a4520$export$cc1990e80430bfbb), options, true);
}
function $785a735c79529924$export$53df9f682f2ce607(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("x", (0, $99fa11de593a4520$export$26b23c8bb7051b0), options);
}
function $785a735c79529924$export$77d68ae5ebd03d2b(options = {}) {
    return $785a735c79529924$var$maybeIntervalK("y", (0, $99fa11de593a4520$export$cc1990e80430bfbb), options);
}
function $785a735c79529924$export$4d0ebe7ec032f34f(options = {}) {
    return $785a735c79529924$var$maybeIntervalMidK("x", (0, $99fa11de593a4520$export$26b23c8bb7051b0), options);
}
function $785a735c79529924$export$a7ad4939d5e92aaa(options = {}) {
    return $785a735c79529924$var$maybeIntervalMidK("y", (0, $99fa11de593a4520$export$cc1990e80430bfbb), options);
}


const $7910fd10d657c0be$var$defaults = {
    ariaLabel: "dot",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
};
function $7910fd10d657c0be$export$d1f5ec764946d194(options) {
    return options.sort === undefined && options.reverse === undefined ? (0, $9dfbc15f77c5eeba$export$97db5808d8f88186)({
        channel: "-r"
    }, options) : options;
}
class $7910fd10d657c0be$export$d046b3c4a416f60d extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, r: r, rotate: rotate, symbol: symbol = (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039), frameAnchor: frameAnchor } = options;
        const [vrotate, crotate] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(rotate, 0);
        const [vsymbol, csymbol] = (0, $7ef09cabd5617a1b$export$5b4fe6145c7212af)(symbol);
        const [vr, cr] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(r, vsymbol == null ? 3 : 4.5);
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            r: {
                value: vr,
                scale: "r",
                filter: (0, $0f3e37548c3914c7$export$aa5128ab863cd04),
                optional: true
            },
            rotate: {
                value: vrotate,
                optional: true
            },
            symbol: {
                value: vsymbol,
                scale: "auto",
                optional: true
            }
        }, $7910fd10d657c0be$export$d1f5ec764946d194(options), $7910fd10d657c0be$var$defaults);
        this.r = cr;
        this.rotate = crotate;
        this.symbol = csymbol;
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
        // Give a hint to the symbol scale; this allows the symbol scale to choose
        // appropriate default symbols based on whether the dots are filled or
        // stroked, and for the symbol legend to match the appearance of the dots.
        const { channels: channels } = this;
        const { symbol: symbolChannel } = channels;
        if (symbolChannel) {
            const { fill: fillChannel, stroke: strokeChannel } = channels;
            symbolChannel.hint = {
                fill: fillChannel ? fillChannel.value === symbolChannel.value ? "color" : "currentColor" : this.fill ?? "currentColor",
                stroke: strokeChannel ? strokeChannel.value === symbolChannel.value ? "color" : "currentColor" : this.stroke ?? "none"
            };
        }
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y: Y, r: R, rotate: A, symbol: S } = channels;
        const { r: r, rotate: rotate, symbol: symbol } = this;
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        const circle = symbol === (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039);
        const size = R ? undefined : r * r * Math.PI;
        if ((0, $0f3e37548c3914c7$export$5f47f64d03acd206)(r)) index = [];
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append(circle ? "circle" : "path").call((0, $547e5698440387a8$export$2949c2472f804203), this).call(circle ? (selection)=>{
                selection.attr("cx", X ? (i)=>X[i] : cx).attr("cy", Y ? (i)=>Y[i] : cy).attr("r", R ? (i)=>R[i] : r);
            } : (selection)=>{
                selection.attr("transform", (0, $bfd513fc05083823$export$ce69bd05624d0c48)`translate(${X ? (i)=>X[i] : cx},${Y ? (i)=>Y[i] : cy})${A ? (i)=>` rotate(${A[i]})` : rotate ? ` rotate(${rotate})` : ``}`).attr("d", R && S ? (i)=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    S[i].draw(p, R[i] * R[i] * Math.PI);
                    return p;
                } : R ? (i)=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    symbol.draw(p, R[i] * R[i] * Math.PI);
                    return p;
                } : S ? (i)=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    S[i].draw(p, size);
                    return p;
                } : (()=>{
                    const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                    symbol.draw(p, size);
                    return p;
                })());
            }).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels)).node();
    }
}
function $7910fd10d657c0be$export$94132a0e348806d4(data, { x: x, y: y, ...options } = {}) {
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $7910fd10d657c0be$export$d046b3c4a416f60d(data, {
        ...options,
        x: x,
        y: y
    });
}
function $7910fd10d657c0be$export$2786571523132693(data, { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $7910fd10d657c0be$export$d046b3c4a416f60d(data, (0, $785a735c79529924$export$a7ad4939d5e92aaa)({
        ...options,
        x: x
    }));
}
function $7910fd10d657c0be$export$ef8227e2f1ca16e1(data, { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $7910fd10d657c0be$export$d046b3c4a416f60d(data, (0, $785a735c79529924$export$4d0ebe7ec032f34f)({
        ...options,
        y: y
    }));
}
function $7910fd10d657c0be$export$e1d786d2f707b414(data, options) {
    return $7910fd10d657c0be$export$94132a0e348806d4(data, {
        ...options,
        symbol: "circle"
    });
}
function $7910fd10d657c0be$export$578abc0d25ff055c(data, options) {
    return $7910fd10d657c0be$export$94132a0e348806d4(data, {
        ...options,
        symbol: "hexagon"
    });
}








function $c6491cb5712bafc0$export$8066c1b52b2e9504(scales, marks, options = {}) {
    // Compute the default margins: the maximum of the marks’ margins. While not
    // always used, they may be needed to compute the default height of the plot.
    let marginTopDefault = 0.5 - (0, $547e5698440387a8$export$cc800923e997bb8), marginRightDefault = 0.5 + (0, $547e5698440387a8$export$cc800923e997bb8), marginBottomDefault = 0.5 + (0, $547e5698440387a8$export$cc800923e997bb8), marginLeftDefault = 0.5 - (0, $547e5698440387a8$export$cc800923e997bb8);
    for (const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft } of marks){
        if (marginTop > marginTopDefault) marginTopDefault = marginTop;
        if (marginRight > marginRightDefault) marginRightDefault = marginRight;
        if (marginBottom > marginBottomDefault) marginBottomDefault = marginBottom;
        if (marginLeft > marginLeftDefault) marginLeftDefault = marginLeft;
    }
    // Compute the actual margins. The order of precedence is: the side-specific
    // margin options, then the global margin option, then the defaults.
    let { margin: margin, marginTop: marginTop = margin !== undefined ? margin : marginTopDefault, marginRight: marginRight = margin !== undefined ? margin : marginRightDefault, marginBottom: marginBottom = margin !== undefined ? margin : marginBottomDefault, marginLeft: marginLeft = margin !== undefined ? margin : marginLeftDefault } = options;
    // Coerce the margin options to numbers.
    marginTop = +marginTop;
    marginRight = +marginRight;
    marginBottom = +marginBottom;
    marginLeft = +marginLeft;
    // Compute the outer dimensions of the plot. If the top and bottom margins are
    // specified explicitly, adjust the automatic height accordingly.
    let { width: width = 640, height: height = $c6491cb5712bafc0$var$autoHeight(scales, options, {
        width: width,
        marginTopDefault: marginTopDefault,
        marginRightDefault: marginRightDefault,
        marginBottomDefault: marginBottomDefault,
        marginLeftDefault: marginLeftDefault
    }) + Math.max(0, marginTop - marginTopDefault + marginBottom - marginBottomDefault) } = options;
    // Coerce the width and height.
    width = +width;
    height = +height;
    const dimensions = {
        width: width,
        height: height,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft
    };
    // Compute the facet margins.
    if (scales.fx || scales.fy) {
        let { margin: facetMargin, marginTop: facetMarginTop = facetMargin !== undefined ? facetMargin : marginTop, marginRight: facetMarginRight = facetMargin !== undefined ? facetMargin : marginRight, marginBottom: facetMarginBottom = facetMargin !== undefined ? facetMargin : marginBottom, marginLeft: facetMarginLeft = facetMargin !== undefined ? facetMargin : marginLeft } = options.facet ?? {};
        // Coerce the facet margin options to numbers.
        facetMarginTop = +facetMarginTop;
        facetMarginRight = +facetMarginRight;
        facetMarginBottom = +facetMarginBottom;
        facetMarginLeft = +facetMarginLeft;
        dimensions.facet = {
            marginTop: facetMarginTop,
            marginRight: facetMarginRight,
            marginBottom: facetMarginBottom,
            marginLeft: facetMarginLeft
        };
    }
    return dimensions;
}
function $c6491cb5712bafc0$var$autoHeight({ x: x, y: y, fy: fy, fx: fx }, { projection: projection, aspectRatio: aspectRatio }, { width: width, marginTopDefault: marginTopDefault, marginRightDefault: marginRightDefault, marginBottomDefault: marginBottomDefault, marginLeftDefault: marginLeftDefault }) {
    const nfy = fy ? fy.scale.domain().length : 1;
    // If a projection is specified, use its natural aspect ratio (if known).
    const ar = (0, $0b574e6ffdcb6f7c$export$9bd1d82590468035)(projection);
    if (ar) {
        const nfx = fx ? fx.scale.domain().length : 1;
        const far = (1.1 * nfy - 0.1) / (1.1 * nfx - 0.1) * ar; // 0.1 is default facet padding
        const lar = Math.max(0.1, Math.min(10, far)); // clamp the aspect ratio to a “reasonable” value
        return Math.round((width - marginLeftDefault - marginRightDefault) * lar + marginTopDefault + marginBottomDefault);
    }
    const ny = y ? (0, $d2c16f7a6010a221$export$61579433626afe87)(y) ? y.scale.domain().length : Math.max(7, 17 / nfy) : 1;
    // If a desired aspect ratio is given, compute a default height to match.
    if (aspectRatio != null) {
        aspectRatio = +aspectRatio;
        if (!(isFinite(aspectRatio) && aspectRatio > 0)) throw new Error(`invalid aspectRatio: ${aspectRatio}`);
        const ratio = $c6491cb5712bafc0$var$aspectRatioLength("y", y) / ($c6491cb5712bafc0$var$aspectRatioLength("x", x) * aspectRatio);
        const fxb = fx ? fx.scale.bandwidth() : 1;
        const fyb = fy ? fy.scale.bandwidth() : 1;
        const w = fxb * (width - marginLeftDefault - marginRightDefault) - x.insetLeft - x.insetRight;
        return (ratio * w + y.insetTop + y.insetBottom) / fyb + marginTopDefault + marginBottomDefault;
    }
    return !!(y || fy) * Math.max(1, Math.min(60, ny * nfy)) * 20 + !!fx * 30 + 60;
}
function $c6491cb5712bafc0$var$aspectRatioLength(k, scale) {
    if (!scale) throw new Error(`aspectRatio requires ${k} scale`);
    const { type: type, domain: domain } = scale;
    let transform;
    switch(type){
        case "linear":
        case "utc":
        case "time":
            transform = Number;
            break;
        case "pow":
            {
                const exponent = scale.scale.exponent();
                transform = (x)=>Math.pow(x, exponent);
                break;
            }
        case "log":
            transform = Math.log;
            break;
        case "point":
        case "band":
            return domain.length;
        default:
            throw new Error(`unsupported ${k} scale for aspectRatio: ${type}`);
    }
    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
    return Math.abs(transform(max) - transform(min));
}






const $06868e990a5c2092$var$states = new WeakMap();
function $06868e990a5c2092$var$pointerK(kx, ky, { x: x, y: y, px: px, py: py, maxRadius: maxRadius = 40, channels: channels, render: render, ...options } = {}) {
    maxRadius = +maxRadius;
    // When px or py is used, register an extra channel that the pointer
    // interaction can use to control which point is focused; this allows pointing
    // to function independently of where the downstream mark (e.g., a tip) is
    // displayed. Also default x or y to null to disable maybeTuple etc.
    if (px != null) x ??= null, channels = {
        ...channels,
        px: {
            value: px,
            scale: "x"
        }
    };
    if (py != null) y ??= null, channels = {
        ...channels,
        py: {
            value: py,
            scale: "y"
        }
    };
    return {
        x: x,
        y: y,
        channels: channels,
        ...options,
        // Unlike other composed transforms, the render transform must be the
        // outermost render function because it will re-render dynamically in
        // response to pointer events.
        render: (0, $24d8c38d667d16c2$export$b80642eda489f786)(function(index, scales, values, dimensions, context, next) {
            context = {
                ...context,
                pointerSticky: false
            };
            const svg = context.ownerSVGElement;
            const { data: data } = context.getMarkState(this);
            // Isolate state per-pointer, per-plot; if the pointer is reused by
            // multiple marks, they will share the same state (e.g., sticky modality).
            let state = $06868e990a5c2092$var$states.get(svg);
            if (!state) $06868e990a5c2092$var$states.set(svg, state = {
                sticky: false,
                roots: [],
                renders: []
            });
            // This serves as a unique identifier of the rendered mark per-plot; it is
            // used to record the currently-rendered elements (state.roots) so that we
            // can tell when a rendered element is clicked on.
            let renderIndex = state.renders.push(render) - 1;
            // For faceting, we want to compute the local coordinates of each point,
            // which means subtracting out the facet translation, if any. (It’s
            // tempting to do this using the local coordinates in SVG, but that’s
            // complicated by mark-specific transforms such as dx and dy.) Also, since
            // band scales return the upper bound of the band, we have to offset by
            // half the bandwidth.
            const { x: x, y: y, fx: fx, fy: fy } = scales;
            let tx = fx ? fx(index.fx) - dimensions.marginLeft : 0;
            let ty = fy ? fy(index.fy) - dimensions.marginTop : 0;
            if (x?.bandwidth) tx += x.bandwidth() / 2;
            if (y?.bandwidth) ty += y.bandwidth() / 2;
            // For faceting, we also need to record the closest point per facet per
            // mark (!), since each facet has its own pointer event listeners; we only
            // want the closest point across facets to be visible.
            const faceted = index.fi != null;
            let facetState;
            if (faceted) {
                let facetStates = state.facetStates;
                if (!facetStates) state.facetStates = facetStates = new Map();
                facetState = facetStates.get(this);
                if (!facetState) facetStates.set(this, facetState = new Map());
            }
            // The order of precedence for the pointer position is: px & py; the
            // middle of x1 & y1 and x2 & y2; or x1 & y1 (e.g., area); or lastly x &
            // y. If a dimension is unspecified, the frame anchor is used.
            const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
            const { px: PX, py: PY } = values;
            const px = PX ? (i)=>PX[i] : $06868e990a5c2092$export$15f8ded78c8d24ca(values, cx);
            const py = PY ? (i)=>PY[i] : $06868e990a5c2092$export$770d7614a8aa3617(values, cy);
            let i; // currently focused index
            let g; // currently rendered mark
            let s; // currently rendered stickiness
            let f; // current animation frame
            // When faceting, if more than one pointer would be visible, only show
            // this one if it is the closest. We defer rendering using an animation
            // frame to allow all pointer events to be received before deciding which
            // mark to render; although when hiding, we render immediately.
            function update(ii, ri) {
                if (faceted) {
                    if (f) f = cancelAnimationFrame(f);
                    if (ii == null) facetState.delete(index.fi);
                    else {
                        facetState.set(index.fi, ri);
                        f = requestAnimationFrame(()=>{
                            f = null;
                            for (const [fi, r] of facetState)if (r < ri || r === ri && fi < index.fi) {
                                ii = null;
                                break;
                            }
                            render(ii);
                        });
                        return;
                    }
                }
                render(ii);
            }
            function render(ii) {
                if (i === ii && s === state.sticky) return; // the tooltip hasn’t moved
                i = ii;
                s = context.pointerSticky = state.sticky;
                const I = i == null ? [] : [
                    i
                ];
                if (faceted) I.fx = index.fx, I.fy = index.fy, I.fi = index.fi;
                const r = next(I, scales, values, dimensions, context);
                if (g) {
                    // When faceting, preserve swapped mark and facet transforms; also
                    // remove ARIA attributes since these are promoted to the parent. This
                    // is perhaps brittle in that it depends on how Plot renders facets,
                    // but it produces a cleaner and more accessible SVG structure.
                    if (faceted) {
                        const p = g.parentNode;
                        const ft = g.getAttribute("transform");
                        const mt = r.getAttribute("transform");
                        ft ? r.setAttribute("transform", ft) : r.removeAttribute("transform");
                        mt ? p.setAttribute("transform", mt) : p.removeAttribute("transform");
                        r.removeAttribute("aria-label");
                        r.removeAttribute("aria-description");
                        r.removeAttribute("aria-hidden");
                    }
                    g.replaceWith(r);
                }
                state.roots[renderIndex] = g = r;
                // Dispatch the value. When simultaneously exiting this facet and
                // entering a new one, prioritize the entering facet.
                if (!(i == null && facetState?.size > 1)) context.dispatchValue(i == null ? null : data[i]);
                return r;
            }
            // Select the closest point to the mouse in the current facet; for
            // pointerX or pointerY, the orthogonal component of the distance is
            // squashed, selecting primarily on the dominant dimension. Across facets,
            // use unsquashed distance to determine the winner.
            function pointermove(event) {
                if (state.sticky || event.pointerType === "mouse" && event.buttons === 1) return; // dragging
                let [xp, yp] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
                xp -= tx, yp -= ty; // correct for facets and band scales
                const kpx = xp < dimensions.marginLeft || xp > dimensions.width - dimensions.marginRight ? 1 : kx;
                const kpy = yp < dimensions.marginTop || yp > dimensions.height - dimensions.marginBottom ? 1 : ky;
                let ii = null;
                let ri = maxRadius * maxRadius;
                for (const j of index){
                    const dx = kpx * (px(j) - xp);
                    const dy = kpy * (py(j) - yp);
                    const rj = dx * dx + dy * dy;
                    if (rj <= ri) ii = j, ri = rj;
                }
                if (ii != null && (kx !== 1 || ky !== 1)) {
                    const dx = px(ii) - xp;
                    const dy = py(ii) - yp;
                    ri = dx * dx + dy * dy;
                }
                update(ii, ri);
            }
            function pointerdown(event) {
                if (event.pointerType !== "mouse") return;
                if (i == null) return; // not pointing
                if (state.sticky && state.roots.some((r)=>r?.contains(event.target))) return; // stay sticky
                if (state.sticky) state.sticky = false, state.renders.forEach((r)=>r(null)); // clear all pointers
                else state.sticky = true, render(i);
                event.stopImmediatePropagation(); // suppress other pointers
            }
            function pointerleave(event) {
                if (event.pointerType !== "mouse") return;
                if (!state.sticky) update(null);
            }
            // We listen to the svg element; listening to the window instead would let
            // us receive pointer events from farther away, but would also make it
            // hard to know when to remove the listeners. (Using a mutation observer
            // to watch the entire document is likely too expensive.)
            svg.addEventListener("pointerenter", pointermove);
            svg.addEventListener("pointermove", pointermove);
            svg.addEventListener("pointerdown", pointerdown);
            svg.addEventListener("pointerleave", pointerleave);
            return render(null);
        }, render)
    };
}
function $06868e990a5c2092$export$b7fd2c2937973304(options) {
    return $06868e990a5c2092$var$pointerK(1, 1, options);
}
function $06868e990a5c2092$export$81f1118cc214bacd(options) {
    return $06868e990a5c2092$var$pointerK(1, 0.01, options);
}
function $06868e990a5c2092$export$a3d8dca9524ddc38(options) {
    return $06868e990a5c2092$var$pointerK(0.01, 1, options);
}
function $06868e990a5c2092$export$15f8ded78c8d24ca({ x1: X1, x2: X2, x: X = X1 }, cx) {
    return X1 && X2 ? (i)=>(X1[i] + X2[i]) / 2 : X ? (i)=>X[i] : ()=>cx;
}
function $06868e990a5c2092$export$770d7614a8aa3617({ y1: Y1, y2: Y2, y: Y = Y1 }, cy) {
    return Y1 && Y2 ? (i)=>(Y1[i] + Y2[i]) / 2 : Y ? (i)=>Y[i] : ()=>cy;
}



var $bYoiY = parcelRequire("bYoiY");



function $5349c8aa18563753$export$57ccd2691f3b457e(scale) {
    return (0, $d2c16f7a6010a221$export$61579433626afe87)(scale) && scale.interval === undefined ? undefined : "tabular-nums";
}






function $0e1b3cfced53194d$export$cc0ec4119b9c7105(color, options) {
    let { label: label = color.label, tickSize: tickSize = 6, width: width = 240, height: height = 44 + tickSize, marginTop: marginTop = 18, marginRight: marginRight = 0, marginBottom: marginBottom = 16 + tickSize, marginLeft: marginLeft = 0, style: style, ticks: ticks = (width - marginLeft - marginRight) / 64, tickFormat: tickFormat, fontVariant: fontVariant = (0, $5349c8aa18563753$export$57ccd2691f3b457e)(color), round: round = true, opacity: opacity, className: className } = options;
    const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
    className = (0, $547e5698440387a8$export$22300e6eaecca37)(className);
    opacity = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(opacity)[1];
    if (tickFormat === null) tickFormat = ()=>null;
    const svg = (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg", context).attr("class", `${className}-ramp`).attr("font-family", "system-ui, sans-serif").attr("font-size", 10).attr("width", width).attr("height", height).attr("viewBox", `0 0 ${width} ${height}`).call((svg)=>// Warning: if you edit this, change defaultClassName.
        svg.append("style").text(`:where(.${className}-ramp) {
  display: block;
  height: auto;
  height: intrinsic;
  max-width: 100%;
  overflow: visible;
}
:where(.${className}-ramp text) {
  white-space: pre;
}`)).call((0, $547e5698440387a8$export$4e6c5cc1af44143e), style);
    let tickAdjust = (g)=>g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
    let x;
    // Some D3 scales use scale.interpolate, some scale.interpolator, and some
    // scale.round; this normalizes the API so it works with all scale types.
    const applyRange = round ? (x, range)=>x.rangeRound(range) : (x, range)=>x.range(range);
    const { type: type, domain: domain, range: range, interpolate: interpolate, scale: scale, pivot: pivot } = color;
    // Continuous
    if (interpolate) {
        // Often interpolate is a “fixed” interpolator on the [0, 1] interval, as
        // with a built-in color scheme, but sometimes it is a function that takes
        // two arguments and is used in conjunction with the range.
        const interpolator = range === undefined ? interpolate : (0, $25f2a121ae5a240e$export$2e2bcd8739ae039)(interpolate.length === 1 ? (0, $30c166b7628c3ceb$export$f68e9493607eda6)(interpolate) : interpolate, range);
        // Construct a D3 scale of the same type, but with a range that evenly
        // divides the horizontal extent of the legend. (In the common case, the
        // domain.length is two, and so the range is simply the extent.) For a
        // diverging scale, we need an extra point in the range for the pivot such
        // that the pivot is always drawn in the middle.
        x = applyRange(scale.copy(), (0, $4f501ce7bede8755$export$2e2bcd8739ae039)((0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(marginLeft, width - marginRight), Math.min(domain.length + (pivot !== undefined), range === undefined ? Infinity : range.length)));
        // Construct a 256×1 canvas, filling each pixel using the interpolator.
        const n = 256;
        const canvas = context.document.createElement("canvas");
        canvas.width = n;
        canvas.height = 1;
        const context2 = canvas.getContext("2d");
        for(let i = 0, j = n - 1; i < n; ++i){
            context2.fillStyle = interpolator(i / j);
            context2.fillRect(i, 0, 1, 1);
        }
        svg.append("image").attr("opacity", opacity).attr("x", marginLeft).attr("y", marginTop).attr("width", width - marginLeft - marginRight).attr("height", height - marginTop - marginBottom).attr("preserveAspectRatio", "none").attr("xlink:href", canvas.toDataURL());
    } else if (type === "threshold") {
        const thresholds = domain;
        const thresholdFormat = tickFormat === undefined ? (d)=>d : typeof tickFormat === "string" ? (0, $54a757fa53542946$export$d9468344d3651243)(tickFormat) : tickFormat;
        // Construct a linear scale with evenly-spaced ticks for each of the
        // thresholds; the domain extends one beyond the threshold extent.
        x = applyRange((0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain([
            -1,
            range.length - 1
        ]), [
            marginLeft,
            width - marginRight
        ]);
        svg.append("g").attr("fill-opacity", opacity).selectAll().data(range).enter().append("rect").attr("x", (d, i)=>x(i - 1)).attr("y", marginTop).attr("width", (d, i)=>x(i) - x(i - 1)).attr("height", height - marginTop - marginBottom).attr("fill", (d)=>d);
        ticks = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(thresholds, (_, i)=>i);
        tickFormat = (i)=>thresholdFormat(thresholds[i], i);
    } else {
        x = applyRange((0, $c1f2fa2a7653ca3a$export$2e2bcd8739ae039)().domain(domain), [
            marginLeft,
            width - marginRight
        ]);
        svg.append("g").attr("fill-opacity", opacity).selectAll().data(domain).enter().append("rect").attr("x", x).attr("y", marginTop).attr("width", Math.max(0, x.bandwidth() - 1)).attr("height", height - marginTop - marginBottom).attr("fill", scale);
        tickAdjust = ()=>{};
    }
    svg.append("g").attr("transform", `translate(0,${height - marginBottom})`).call((0, $834b38f205523964$export$e5cb22533a15e72e)(x).ticks(Array.isArray(ticks) ? null : ticks, typeof tickFormat === "string" ? tickFormat : undefined).tickFormat(typeof tickFormat === "function" ? tickFormat : undefined).tickSize(tickSize).tickValues(Array.isArray(ticks) ? ticks : null)).attr("font-size", null).attr("font-family", null).attr("font-variant", (0, $547e5698440387a8$export$e1c487990851f09f)(fontVariant, "normal")).call(tickAdjust).call((g)=>g.select(".domain").remove());
    if (label !== undefined) svg.append("text").attr("x", marginLeft).attr("y", marginTop - 6).attr("fill", "currentColor") // TODO move to stylesheet?
    .attr("font-weight", "bold").text(label);
    return svg.node();
}











const $313afcb1ba78b0a6$export$8449e153fbd325fc = Math.PI / 180;











function $f013115577adb919$export$6b811a095661528f(mark, { marker: marker, markerStart: markerStart = marker, markerMid: markerMid = marker, markerEnd: markerEnd = marker } = {}) {
    mark.markerStart = $f013115577adb919$var$maybeMarker(markerStart);
    mark.markerMid = $f013115577adb919$var$maybeMarker(markerMid);
    mark.markerEnd = $f013115577adb919$var$maybeMarker(markerEnd);
}
function $f013115577adb919$var$maybeMarker(marker) {
    if (marker == null || marker === false) return null;
    if (marker === true) return $f013115577adb919$var$markerCircleFill;
    if (typeof marker === "function") return marker;
    switch(`${marker}`.toLowerCase()){
        case "none":
            return null;
        case "arrow":
            return $f013115577adb919$var$markerArrow("auto");
        case "arrow-reverse":
            return $f013115577adb919$var$markerArrow("auto-start-reverse");
        case "dot":
            return $f013115577adb919$var$markerDot;
        case "circle":
        case "circle-fill":
            return $f013115577adb919$var$markerCircleFill;
        case "circle-stroke":
            return $f013115577adb919$var$markerCircleStroke;
        case "tick":
            return $f013115577adb919$var$markerTick("auto");
        case "tick-x":
            return $f013115577adb919$var$markerTick(90);
        case "tick-y":
            return $f013115577adb919$var$markerTick(0);
    }
    throw new Error(`invalid marker: ${marker}`);
}
function $f013115577adb919$var$markerArrow(orient) {
    return (color, context)=>(0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("orient", orient).attr("fill", "none").attr("stroke", color).attr("stroke-width", 1.5).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").call((marker)=>marker.append("path").attr("d", "M-1.5,-3l3,3l-3,3")).node();
}
function $f013115577adb919$var$markerDot(color, context) {
    return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", color).attr("stroke", "none").call((marker)=>marker.append("circle").attr("r", 2.5)).node();
}
function $f013115577adb919$var$markerCircleFill(color, context) {
    return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", color).attr("stroke", "var(--plot-background)").attr("stroke-width", 1.5).call((marker)=>marker.append("circle").attr("r", 3)).node();
}
function $f013115577adb919$var$markerCircleStroke(color, context) {
    return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-5 -5 10 10").attr("markerWidth", 6.67).attr("markerHeight", 6.67).attr("fill", "var(--plot-background)").attr("stroke", color).attr("stroke-width", 1.5).call((marker)=>marker.append("circle").attr("r", 3)).node();
}
function $f013115577adb919$var$markerTick(orient) {
    return (color, context)=>(0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:marker", context).attr("viewBox", "-3 -3 6 6").attr("markerWidth", 6).attr("markerHeight", 6).attr("orient", orient).attr("stroke", color).call((marker)=>marker.append("path").attr("d", "M0,-3v6")).node();
}
let $f013115577adb919$var$nextMarkerId = 0;
function $f013115577adb919$export$3725d839c1ddab92(path, mark, { stroke: S }, context) {
    return $f013115577adb919$var$applyMarkersColor(path, mark, S && ((i)=>S[i]), context);
}
function $f013115577adb919$export$e6a749a5a88e9589(path, mark, { stroke: S }, context) {
    return $f013115577adb919$var$applyMarkersColor(path, mark, S && (([i])=>S[i]), context);
}
function $f013115577adb919$var$applyMarkersColor(path, { markerStart: markerStart, markerMid: markerMid, markerEnd: markerEnd, stroke: stroke }, strokeof = ()=>stroke, context) {
    const iriByMarkerColor = new Map();
    function applyMarker(marker) {
        return function(i) {
            const color = strokeof(i);
            let iriByColor = iriByMarkerColor.get(marker);
            if (!iriByColor) iriByMarkerColor.set(marker, iriByColor = new Map());
            let iri = iriByColor.get(color);
            if (!iri) {
                const node = this.parentNode.insertBefore(marker(color, context), this);
                const id = `plot-marker-${++$f013115577adb919$var$nextMarkerId}`;
                node.setAttribute("id", id);
                iriByColor.set(color, iri = `url(#${id})`);
            }
            return iri;
        };
    }
    if (markerStart) path.attr("marker-start", applyMarker(markerStart));
    if (markerMid) path.attr("marker-mid", applyMarker(markerMid));
    if (markerEnd) path.attr("marker-end", applyMarker(markerEnd));
}






const $60ff8edb66755c31$var$defaults = {
    ariaLabel: "rule",
    fill: null,
    stroke: "currentColor"
};
class $60ff8edb66755c31$export$89bb5d5f432a0c7c extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y1: y1, y2: y2, inset: inset = 0, insetTop: insetTop = inset, insetBottom: insetBottom = inset } = options;
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y1: {
                value: y1,
                scale: "y",
                optional: true
            },
            y2: {
                value: y2,
                scale: "y",
                optional: true
            }
        }, (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "x"), $60ff8edb66755c31$var$defaults);
        this.insetTop = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetTop);
        this.insetBottom = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetBottom);
        (0, $f013115577adb919$export$6b811a095661528f)(this, options);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y1: Y1, y2: Y2 } = channels;
        const { width: width, height: height, marginTop: marginTop, marginRight: marginRight, marginLeft: marginLeft, marginBottom: marginBottom } = dimensions;
        const { insetTop: insetTop, insetBottom: insetBottom } = this;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x
        }, (0, $547e5698440387a8$export$cc800923e997bb8), 0).call((g)=>g.selectAll().data(index).enter().append("line").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("x1", X ? (i)=>X[i] : (marginLeft + width - marginRight) / 2).attr("x2", X ? (i)=>X[i] : (marginLeft + width - marginRight) / 2).attr("y1", Y1 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(y) ? (i)=>Y1[i] + insetTop : marginTop + insetTop).attr("y2", Y2 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(y) ? y.bandwidth ? (i)=>Y2[i] + y.bandwidth() - insetBottom : (i)=>Y2[i] - insetBottom : height - marginBottom - insetBottom).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels).call((0, $f013115577adb919$export$3725d839c1ddab92), this, channels, context)).node();
    }
}
class $60ff8edb66755c31$export$5af3dd6659e3ddb1 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x1: x1, x2: x2, y: y, inset: inset = 0, insetRight: insetRight = inset, insetLeft: insetLeft = inset } = options;
        super(data, {
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            x1: {
                value: x1,
                scale: "x",
                optional: true
            },
            x2: {
                value: x2,
                scale: "x",
                optional: true
            }
        }, (0, $24d8c38d667d16c2$export$963b1143142dad19)(options, "y"), $60ff8edb66755c31$var$defaults);
        this.insetRight = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetRight);
        this.insetLeft = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetLeft);
        (0, $f013115577adb919$export$6b811a095661528f)(this, options);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { y: Y, x1: X1, x2: X2 } = channels;
        const { width: width, height: height, marginTop: marginTop, marginRight: marginRight, marginLeft: marginLeft, marginBottom: marginBottom } = dimensions;
        const { insetLeft: insetLeft, insetRight: insetRight } = this;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            y: Y && y
        }, 0, (0, $547e5698440387a8$export$cc800923e997bb8)).call((g)=>g.selectAll().data(index).enter().append("line").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("x1", X1 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(x) ? (i)=>X1[i] + insetLeft : marginLeft + insetLeft).attr("x2", X2 && !(0, $d2c16f7a6010a221$export$9c903d35b97d0190)(x) ? x.bandwidth ? (i)=>X2[i] + x.bandwidth() - insetRight : (i)=>X2[i] - insetRight : width - marginRight - insetRight).attr("y1", Y ? (i)=>Y[i] : (marginTop + height - marginBottom) / 2).attr("y2", Y ? (i)=>Y[i] : (marginTop + height - marginBottom) / 2).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels).call((0, $f013115577adb919$export$3725d839c1ddab92), this, channels, context)).node();
    }
}
function $60ff8edb66755c31$export$22653c04c6d89eeb(data, options) {
    let { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), y: y, y1: y1, y2: y2, ...rest } = (0, $785a735c79529924$export$77d68ae5ebd03d2b)(options);
    [y1, y2] = $60ff8edb66755c31$var$maybeOptionalZero(y, y1, y2);
    return new $60ff8edb66755c31$export$89bb5d5f432a0c7c(data, {
        ...rest,
        x: x,
        y1: y1,
        y2: y2
    });
}
function $60ff8edb66755c31$export$d121b88bc74f6ae5(data, options) {
    let { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), x: x, x1: x1, x2: x2, ...rest } = (0, $785a735c79529924$export$53df9f682f2ce607)(options);
    [x1, x2] = $60ff8edb66755c31$var$maybeOptionalZero(x, x1, x2);
    return new $60ff8edb66755c31$export$5af3dd6659e3ddb1(data, {
        ...rest,
        y: y,
        x1: x1,
        x2: x2
    });
}
// For marks specified either as [0, x] or [x1, x2], or nothing.
function $60ff8edb66755c31$var$maybeOptionalZero(x, x1, x2) {
    if (x == null) {
        if (x1 === undefined) {
            if (x2 !== undefined) return [
                0,
                x2
            ];
        } else {
            if (x2 === undefined) return [
                0,
                x1
            ];
        }
    } else if (x1 === undefined) return x2 === undefined ? [
        0,
        x
    ] : [
        x,
        x2
    ];
    else if (x2 === undefined) return [
        x,
        x1
    ];
    return [
        x1,
        x2
    ];
}











const $b4855ffaf649c526$var$defaults = {
    ariaLabel: "text",
    strokeLinejoin: "round",
    strokeWidth: 3,
    paintOrder: "stroke"
};
const $b4855ffaf649c526$var$softHyphen = "\xad";
class $b4855ffaf649c526$export$5f1af8db9871e1d6 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, text: text = (0, $cd9e805a4bbd13f9$export$9652023d9040757)(data) && (0, $cd9e805a4bbd13f9$export$43674e37205f3011)(data) ? (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655) : (0, $cd9e805a4bbd13f9$export$305f7d4e9d4624f2), frameAnchor: frameAnchor, textAnchor: textAnchor = /right$/i.test(frameAnchor) ? "end" : /left$/i.test(frameAnchor) ? "start" : "middle", lineAnchor: lineAnchor = /^top/i.test(frameAnchor) ? "top" : /^bottom/i.test(frameAnchor) ? "bottom" : "middle", lineHeight: lineHeight = 1, lineWidth: lineWidth = Infinity, textOverflow: textOverflow, monospace: monospace, fontFamily: fontFamily = monospace ? "ui-monospace, monospace" : undefined, fontSize: fontSize, fontStyle: fontStyle, fontVariant: fontVariant, fontWeight: fontWeight, rotate: rotate } = options;
        const [vrotate, crotate] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(rotate, 0);
        const [vfontSize, cfontSize] = $b4855ffaf649c526$var$maybeFontSizeChannel(fontSize);
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            fontSize: {
                value: vfontSize,
                optional: true
            },
            rotate: {
                value: (0, $cd9e805a4bbd13f9$export$a152540187b5d206)(vrotate),
                optional: true
            },
            text: {
                value: text,
                filter: (0, $0f3e37548c3914c7$export$6ce6c9218151d511),
                optional: true
            }
        }, options, $b4855ffaf649c526$var$defaults);
        this.rotate = crotate;
        this.textAnchor = (0, $547e5698440387a8$export$e1c487990851f09f)(textAnchor, "middle");
        this.lineAnchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(lineAnchor, "lineAnchor", [
            "top",
            "middle",
            "bottom"
        ]);
        this.lineHeight = +lineHeight;
        this.lineWidth = +lineWidth;
        this.textOverflow = $b4855ffaf649c526$export$5286100f10ca66d(textOverflow);
        this.monospace = !!monospace;
        this.fontFamily = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontFamily);
        this.fontSize = cfontSize;
        this.fontStyle = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontStyle);
        this.fontVariant = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontVariant);
        this.fontWeight = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontWeight);
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
        if (!(this.lineWidth >= 0)) throw new Error(`invalid lineWidth: ${lineWidth}`);
        this.splitLines = $b4855ffaf649c526$export$8cfde575cbd41e40(this);
        this.clipLine = $b4855ffaf649c526$export$f7f3d67a35896a0e(this);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y: Y, rotate: R, text: T, title: TL, fontSize: FS } = channels;
        const { rotate: rotate } = this;
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call($b4855ffaf649c526$export$8b7aa25119010c38, this, T, dimensions).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append("text").call((0, $547e5698440387a8$export$2949c2472f804203), this).call($b4855ffaf649c526$var$applyMultilineText, this, T, TL).attr("transform", (0, $bfd513fc05083823$export$ce69bd05624d0c48)`translate(${X ? (i)=>X[i] : cx},${Y ? (i)=>Y[i] : cy})${R ? (i)=>` rotate(${R[i]})` : rotate ? ` rotate(${rotate})` : ``}`).call((0, $547e5698440387a8$export$47765c6b16054eb2), "font-size", FS && ((i)=>FS[i])).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels)).node();
    }
}
function $b4855ffaf649c526$export$5286100f10ca66d(textOverflow) {
    return textOverflow == null ? null : (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(textOverflow, "textOverflow", [
        "clip",
        "ellipsis",
        "clip-start",
        "clip-end",
        "ellipsis-start",
        "ellipsis-middle",
        "ellipsis-end"
    ]).replace(/^(clip|ellipsis)$/, "$1-end");
}
function $b4855ffaf649c526$var$applyMultilineText(selection, mark, T, TL) {
    if (!T) return;
    const { lineAnchor: lineAnchor, lineHeight: lineHeight, textOverflow: textOverflow, splitLines: splitLines, clipLine: clipLine } = mark;
    selection.each(function(i) {
        const lines = splitLines((0, $4b16c4377cd1e2de$export$bb457229db2006fb)(T[i]) ?? "").map(clipLine);
        const n = lines.length;
        const y = lineAnchor === "top" ? 0.71 : lineAnchor === "bottom" ? 1 - n : (164 - n * 100) / 200;
        if (n > 1) {
            let m = 0;
            for(let i = 0; i < n; ++i){
                ++m;
                if (!lines[i]) continue;
                const tspan = this.ownerDocument.createElementNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).svg, "tspan");
                tspan.setAttribute("x", 0);
                if (i === m - 1) tspan.setAttribute("y", `${(y + i) * lineHeight}em`);
                else tspan.setAttribute("dy", `${m * lineHeight}em`);
                tspan.textContent = lines[i];
                this.appendChild(tspan);
                m = 0;
            }
        } else {
            if (y) this.setAttribute("y", `${y * lineHeight}em`);
            this.textContent = lines[0];
        }
        if (textOverflow && !TL && lines[0] !== T[i]) {
            const title = this.ownerDocument.createElementNS((0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).svg, "title");
            title.textContent = T[i];
            this.appendChild(title);
        }
    });
}
function $b4855ffaf649c526$export$6f093cfa640b7166(data, { x: x, y: y, ...options } = {}) {
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $b4855ffaf649c526$export$5f1af8db9871e1d6(data, {
        ...options,
        x: x,
        y: y
    });
}
function $b4855ffaf649c526$export$5aac532f27b03078(data, { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $b4855ffaf649c526$export$5f1af8db9871e1d6(data, (0, $785a735c79529924$export$a7ad4939d5e92aaa)({
        ...options,
        x: x
    }));
}
function $b4855ffaf649c526$export$b11955fec8f4d045(data, { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...options } = {}) {
    return new $b4855ffaf649c526$export$5f1af8db9871e1d6(data, (0, $785a735c79529924$export$4d0ebe7ec032f34f)({
        ...options,
        y: y
    }));
}
function $b4855ffaf649c526$export$8b7aa25119010c38(selection, mark, T) {
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "text-anchor", mark.textAnchor);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-family", mark.fontFamily);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-size", mark.fontSize);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-style", mark.fontStyle);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-variant", mark.fontVariant === undefined ? $b4855ffaf649c526$var$inferFontVariant(T) : mark.fontVariant);
    (0, $547e5698440387a8$export$47765c6b16054eb2)(selection, "font-weight", mark.fontWeight);
}
function $b4855ffaf649c526$var$inferFontVariant(T) {
    return T && ((0, $cd9e805a4bbd13f9$export$e90fb89750dba83f)(T) || (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(T)) ? "tabular-nums" : undefined;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/font-size
const $b4855ffaf649c526$var$fontSizes = new Set([
    // global keywords
    "inherit",
    "initial",
    "revert",
    "unset",
    // absolute keywords
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large",
    // relative keywords
    "larger",
    "smaller"
]);
// The font size may be expressed as a constant in the following forms:
// - number in pixels
// - string keyword: see above
// - string <length>: e.g., "12px"
// - string <percentage>: e.g., "80%"
// Anything else is assumed to be a channel definition.
function $b4855ffaf649c526$var$maybeFontSizeChannel(fontSize) {
    if (fontSize == null || typeof fontSize === "number") return [
        undefined,
        fontSize
    ];
    if (typeof fontSize !== "string") return [
        fontSize,
        undefined
    ];
    fontSize = fontSize.trim().toLowerCase();
    return $b4855ffaf649c526$var$fontSizes.has(fontSize) || /^[+-]?\d*\.?\d+(e[+-]?\d+)?(\w*|%)$/.test(fontSize) ? [
        undefined,
        fontSize
    ] : [
        fontSize,
        undefined
    ];
}
// This is a greedy algorithm for line wrapping. It would be better to use the
// Knuth–Plass line breaking algorithm (but that would be much more complex).
// https://en.wikipedia.org/wiki/Line_wrap_and_word_wrap
function $b4855ffaf649c526$var$lineWrap(input, maxWidth, widthof) {
    const lines = [];
    let lineStart, lineEnd = 0;
    for (const [wordStart, wordEnd, required] of $b4855ffaf649c526$var$lineBreaks(input)){
        // Record the start of a line. This isn’t the same as the previous line’s
        // end because we often skip spaces between lines.
        if (lineStart === undefined) lineStart = wordStart;
        // If the current line is not empty, and if adding the current word would
        // make the line longer than the allowed width, then break the line at the
        // previous word end.
        if (lineEnd > lineStart && widthof(input, lineStart, wordEnd) > maxWidth) {
            lines.push(input.slice(lineStart, lineEnd) + (input[lineEnd - 1] === $b4855ffaf649c526$var$softHyphen ? "-" : ""));
            lineStart = wordStart;
        }
        // If this is a required break (a newline), emit the line and reset.
        if (required) {
            lines.push(input.slice(lineStart, wordEnd));
            lineStart = undefined;
            continue;
        }
        // Extend the current line to include the new word.
        lineEnd = wordEnd;
    }
    return lines;
}
// This is a rudimentary (and U.S.-centric) algorithm for finding opportunities
// to break lines between words. A better and far more comprehensive approach
// would be to use the official Unicode Line Breaking Algorithm.
// https://unicode.org/reports/tr14/
function* $b4855ffaf649c526$var$lineBreaks(input) {
    let i = 0, j = 0;
    const n = input.length;
    while(j < n){
        let k = 1;
        switch(input[j]){
            case $b4855ffaf649c526$var$softHyphen:
            case "-":
                ++j;
                yield [
                    i,
                    j,
                    false
                ];
                i = j;
                break;
            case " ":
                yield [
                    i,
                    j,
                    false
                ];
                while(input[++j] === " "); // skip multiple spaces
                i = j;
                break;
            case "\r":
                if (input[j + 1] === "\n") ++k; // falls through
            case "\n":
                yield [
                    i,
                    j,
                    true
                ];
                j += k;
                i = j;
                break;
            default:
                ++j;
                break;
        }
    }
    yield [
        i,
        j,
        true
    ];
}
// Computed as round(measureText(text).width * 10) at 10px system-ui. For
// characters that are not represented in this map, we’d ideally want to use a
// weighted average of what we expect to see. But since we don’t really know
// what that is, using “e” seems reasonable.
const $b4855ffaf649c526$var$defaultWidthMap = {
    a: 56,
    b: 63,
    c: 57,
    d: 63,
    e: 58,
    f: 37,
    g: 62,
    h: 60,
    i: 26,
    j: 26,
    k: 55,
    l: 26,
    m: 88,
    n: 60,
    o: 60,
    p: 62,
    q: 62,
    r: 39,
    s: 54,
    t: 38,
    u: 60,
    v: 55,
    w: 79,
    x: 54,
    y: 55,
    z: 55,
    A: 69,
    B: 67,
    C: 73,
    D: 74,
    E: 61,
    F: 58,
    G: 76,
    H: 75,
    I: 28,
    J: 55,
    K: 67,
    L: 58,
    M: 89,
    N: 75,
    O: 78,
    P: 65,
    Q: 78,
    R: 67,
    S: 65,
    T: 65,
    U: 75,
    V: 69,
    W: 98,
    X: 69,
    Y: 67,
    Z: 67,
    0: 64,
    1: 48,
    2: 62,
    3: 64,
    4: 66,
    5: 63,
    6: 65,
    7: 58,
    8: 65,
    9: 65,
    " ": 29,
    "!": 32,
    '"': 49,
    "'": 31,
    "(": 39,
    ")": 39,
    ",": 31,
    "-": 48,
    ".": 31,
    "/": 32,
    ":": 31,
    ";": 31,
    "?": 52,
    "\u2018": 31,
    "\u2019": 31,
    "\u201C": 47,
    "\u201D": 47,
    "\u2026": 82
};
function $b4855ffaf649c526$export$205274d8d0bfa3a(text, start = 0, end = text.length) {
    let sum = 0;
    for(let i = start; i < end; i = $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i))sum += $b4855ffaf649c526$var$defaultWidthMap[text[i]] ?? ($b4855ffaf649c526$var$isPictographic(text, i) ? 120 : $b4855ffaf649c526$var$defaultWidthMap.e);
    return sum;
}
function $b4855ffaf649c526$export$4f4ed94d656e5d4a(text, start = 0, end = text.length) {
    let sum = 0;
    for(let i = start; i < end; i = $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i))sum += $b4855ffaf649c526$var$isPictographic(text, i) ? 126 : 63;
    return sum;
}
function $b4855ffaf649c526$export$8cfde575cbd41e40({ monospace: monospace, lineWidth: lineWidth, textOverflow: textOverflow }) {
    if (textOverflow != null || lineWidth == Infinity) return (text)=>text.split(/\r\n?|\n/g);
    const widthof = monospace ? $b4855ffaf649c526$export$4f4ed94d656e5d4a : $b4855ffaf649c526$export$205274d8d0bfa3a;
    const maxWidth = lineWidth * 100;
    return (text)=>$b4855ffaf649c526$var$lineWrap(text, maxWidth, widthof);
}
function $b4855ffaf649c526$export$f7f3d67a35896a0e({ monospace: monospace, lineWidth: lineWidth, textOverflow: textOverflow }) {
    if (textOverflow == null || lineWidth == Infinity) return (text)=>text;
    const widthof = monospace ? $b4855ffaf649c526$export$4f4ed94d656e5d4a : $b4855ffaf649c526$export$205274d8d0bfa3a;
    const maxWidth = lineWidth * 100;
    switch(textOverflow){
        case "clip-start":
            return (text)=>$b4855ffaf649c526$export$bfc5cdfbfe7a8da8(text, maxWidth, widthof, "");
        case "clip-end":
            return (text)=>$b4855ffaf649c526$export$989f1dcb8b8843ad(text, maxWidth, widthof, "");
        case "ellipsis-start":
            return (text)=>$b4855ffaf649c526$export$bfc5cdfbfe7a8da8(text, maxWidth, widthof, $b4855ffaf649c526$export$a5b94313d6908893);
        case "ellipsis-middle":
            return (text)=>$b4855ffaf649c526$export$e3606efe4bf37377(text, maxWidth, widthof, $b4855ffaf649c526$export$a5b94313d6908893);
        case "ellipsis-end":
            return (text)=>$b4855ffaf649c526$export$989f1dcb8b8843ad(text, maxWidth, widthof, $b4855ffaf649c526$export$a5b94313d6908893);
    }
}
const $b4855ffaf649c526$export$a5b94313d6908893 = "\u2026";
function $b4855ffaf649c526$export$af2a99f971a346e6(text, width, widthof, inset) {
    const I = []; // indexes of read character boundaries
    let w = 0; // current line width
    for(let i = 0, j = 0, n = text.length; i < n; i = j){
        j = $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i); // read the next character
        const l = widthof(text, i, j); // current character width
        if (w + l > width) {
            w += inset;
            while(w > width && i > 0)j = i, i = I.pop(), w -= widthof(text, i, j); // remove excess
            return [
                i,
                width - w
            ];
        }
        w += l;
        I.push(i);
    }
    return [
        -1,
        0
    ];
}
function $b4855ffaf649c526$export$989f1dcb8b8843ad(text, width, widthof, ellipsis) {
    text = text.trim(); // ignore leading and trailing whitespace
    const e = widthof(ellipsis);
    const [i] = $b4855ffaf649c526$export$af2a99f971a346e6(text, width, widthof, e);
    return i < 0 ? text : text.slice(0, i).trimEnd() + ellipsis;
}
function $b4855ffaf649c526$export$e3606efe4bf37377(text, width, widthof, ellipsis) {
    text = text.trim(); // ignore leading and trailing whitespace
    const w = widthof(text);
    if (w <= width) return text;
    const e = widthof(ellipsis) / 2;
    const [i, ei] = $b4855ffaf649c526$export$af2a99f971a346e6(text, width / 2, widthof, e);
    const [j] = $b4855ffaf649c526$export$af2a99f971a346e6(text, w - width / 2 - ei + e, widthof, -e); // TODO read spaces?
    return j < 0 ? ellipsis : text.slice(0, i).trimEnd() + ellipsis + text.slice($b4855ffaf649c526$export$9864f8d4d3d2fe51(text, j)).trimStart();
}
function $b4855ffaf649c526$export$bfc5cdfbfe7a8da8(text, width, widthof, ellipsis) {
    text = text.trim(); // ignore leading and trailing whitespace
    const w = widthof(text);
    if (w <= width) return text;
    const e = widthof(ellipsis);
    const [j] = $b4855ffaf649c526$export$af2a99f971a346e6(text, w - width + e, widthof, -e); // TODO read spaces?
    return j < 0 ? ellipsis : ellipsis + text.slice($b4855ffaf649c526$export$9864f8d4d3d2fe51(text, j)).trimStart();
}
const $b4855ffaf649c526$var$reCombiner = /[\p{Combining_Mark}\p{Emoji_Modifier}]+/uy;
const $b4855ffaf649c526$var$rePictographic = /\p{Extended_Pictographic}/uy;
function $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i) {
    i += $b4855ffaf649c526$var$isSurrogatePair(text, i) ? 2 : 1;
    if ($b4855ffaf649c526$var$isCombiner(text, i)) i = $b4855ffaf649c526$var$reCombiner.lastIndex;
    if ($b4855ffaf649c526$var$isZeroWidthJoiner(text, i)) return $b4855ffaf649c526$export$9864f8d4d3d2fe51(text, i + 1);
    return i;
}
// We avoid more expensive regex tests involving Unicode property classes by
// first checking for the common case of 7-bit ASCII characters.
function $b4855ffaf649c526$var$isAscii(text, i) {
    return text.charCodeAt(i) < 0x80;
}
function $b4855ffaf649c526$var$isSurrogatePair(text, i) {
    const hi = text.charCodeAt(i);
    if (hi >= 0xd800 && hi < 0xdc00) {
        const lo = text.charCodeAt(i + 1);
        return lo >= 0xdc00 && lo < 0xe000;
    }
    return false;
}
function $b4855ffaf649c526$var$isZeroWidthJoiner(text, i) {
    return text.charCodeAt(i) === 0x200d;
}
function $b4855ffaf649c526$var$isCombiner(text, i) {
    return $b4855ffaf649c526$var$isAscii(text, i) ? false : ($b4855ffaf649c526$var$reCombiner.lastIndex = i, $b4855ffaf649c526$var$reCombiner.test(text));
}
function $b4855ffaf649c526$var$isPictographic(text, i) {
    return $b4855ffaf649c526$var$isAscii(text, i) ? false : ($b4855ffaf649c526$var$rePictographic.lastIndex = i, $b4855ffaf649c526$var$rePictographic.test(text));
}








const $2d02506c373828f7$var$defaults = {
    ariaLabel: "vector",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
};
const $2d02506c373828f7$var$defaultRadius = 3.5;
// The size of the arrowhead is proportional to its length, but we still allow
// the relative size of the head to be controlled via the mark’s width option;
// doubling the default radius will produce an arrowhead that is twice as big.
// That said, we’ll probably want a arrow with a fixed head size, too.
const $2d02506c373828f7$var$wingRatio = $2d02506c373828f7$var$defaultRadius * 5;
const $2d02506c373828f7$var$shapeArrow = {
    draw (context, l, r) {
        const wing = l * r / $2d02506c373828f7$var$wingRatio;
        context.moveTo(0, 0);
        context.lineTo(0, -l);
        context.moveTo(-wing, wing - l);
        context.lineTo(0, -l);
        context.lineTo(wing, wing - l);
    }
};
const $2d02506c373828f7$var$shapeSpike = {
    draw (context, l, r) {
        context.moveTo(-r, 0);
        context.lineTo(0, -l);
        context.lineTo(r, 0);
    }
};
const $2d02506c373828f7$var$shapes = new Map([
    [
        "arrow",
        $2d02506c373828f7$var$shapeArrow
    ],
    [
        "spike",
        $2d02506c373828f7$var$shapeSpike
    ]
]);
function $2d02506c373828f7$var$isShapeObject(value) {
    return value && typeof value.draw === "function";
}
function $2d02506c373828f7$var$maybeShape(shape) {
    if ($2d02506c373828f7$var$isShapeObject(shape)) return shape;
    const value = $2d02506c373828f7$var$shapes.get(`${shape}`.toLowerCase());
    if (value) return value;
    throw new Error(`invalid shape: ${shape}`);
}
class $2d02506c373828f7$export$9b781de7bf37bf48 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        const { x: x, y: y, r: r = $2d02506c373828f7$var$defaultRadius, length: length, rotate: rotate, shape: shape = $2d02506c373828f7$var$shapeArrow, anchor: anchor = "middle", frameAnchor: frameAnchor } = options;
        const [vl, cl] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(length, 12);
        const [vr, cr] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(rotate, 0);
        super(data, {
            x: {
                value: x,
                scale: "x",
                optional: true
            },
            y: {
                value: y,
                scale: "y",
                optional: true
            },
            length: {
                value: vl,
                scale: "length",
                optional: true
            },
            rotate: {
                value: vr,
                optional: true
            }
        }, options, $2d02506c373828f7$var$defaults);
        this.r = +r;
        this.length = cl;
        this.rotate = cr;
        this.shape = $2d02506c373828f7$var$maybeShape(shape);
        this.anchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(anchor, "anchor", [
            "start",
            "middle",
            "end"
        ]);
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
    }
    render(index, scales, channels, dimensions, context) {
        const { x: x, y: y } = scales;
        const { x: X, y: Y, length: L, rotate: A } = channels;
        const { length: length, rotate: rotate, anchor: anchor, shape: shape, r: r } = this;
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append("path").call((0, $547e5698440387a8$export$2949c2472f804203), this).attr("transform", (0, $bfd513fc05083823$export$ce69bd05624d0c48)`translate(${X ? (i)=>X[i] : cx},${Y ? (i)=>Y[i] : cy})${A ? (i)=>` rotate(${A[i]})` : rotate ? ` rotate(${rotate})` : ``}${anchor === "start" ? `` : anchor === "end" ? L ? (i)=>` translate(0,${L[i]})` : ` translate(0,${length})` : L ? (i)=>` translate(0,${L[i] / 2})` : ` translate(0,${length / 2})`}`).attr("d", L ? (i)=>{
                const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                shape.draw(p, L[i], r);
                return p;
            } : (()=>{
                const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
                shape.draw(p, length, r);
                return p;
            })()).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels)).node();
    }
}
function $2d02506c373828f7$export$6074e20ba5c64bef(data, options = {}) {
    let { x: x, y: y, ...rest } = options;
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $2d02506c373828f7$export$9b781de7bf37bf48(data, {
        ...rest,
        x: x,
        y: y
    });
}
function $2d02506c373828f7$export$dc781e748fde228d(data, options = {}) {
    const { x: x = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...rest } = options;
    return new $2d02506c373828f7$export$9b781de7bf37bf48(data, {
        ...rest,
        x: x
    });
}
function $2d02506c373828f7$export$326ea72b1565acd6(data, options = {}) {
    const { y: y = (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655), ...rest } = options;
    return new $2d02506c373828f7$export$9b781de7bf37bf48(data, {
        ...rest,
        y: y
    });
}
function $2d02506c373828f7$export$a9313a4740510eae(data, options = {}) {
    const { shape: shape = $2d02506c373828f7$var$shapeSpike, stroke: stroke = $2d02506c373828f7$var$defaults.stroke, strokeWidth: strokeWidth = 1, fill: fill = stroke, fillOpacity: fillOpacity = 0.3, anchor: anchor = "start", ...rest } = options;
    return $2d02506c373828f7$export$6074e20ba5c64bef(data, {
        ...rest,
        shape: shape,
        stroke: stroke,
        strokeWidth: strokeWidth,
        fill: fill,
        fillOpacity: fillOpacity,
        anchor: anchor
    });
}


function $fcb78e8696b500a3$var$maybeData(data, options) {
    if (arguments.length < 2 && !(0, $cd9e805a4bbd13f9$export$9652023d9040757)(data)) options = data, data = null;
    if (options === undefined) options = {};
    return [
        data,
        options
    ];
}
function $fcb78e8696b500a3$var$maybeAnchor({ anchor: anchor } = {}, anchors) {
    return anchor === undefined ? anchors[0] : (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(anchor, "anchor", anchors);
}
function $fcb78e8696b500a3$var$anchorY(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "left",
        "right"
    ]);
}
function $fcb78e8696b500a3$var$anchorFy(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "right",
        "left"
    ]);
}
function $fcb78e8696b500a3$var$anchorX(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "bottom",
        "top"
    ]);
}
function $fcb78e8696b500a3$var$anchorFx(options) {
    return $fcb78e8696b500a3$var$maybeAnchor(options, [
        "top",
        "bottom"
    ]);
}
function $fcb78e8696b500a3$export$e4a0de62e0e52fb4() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKy("y", $fcb78e8696b500a3$var$anchorY(options), data, options);
}
function $fcb78e8696b500a3$export$3cb762475a490c3b() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKy("fy", $fcb78e8696b500a3$var$anchorFy(options), data, options);
}
function $fcb78e8696b500a3$export$5bc1a9741b148b9f() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKx("x", $fcb78e8696b500a3$var$anchorX(options), data, options);
}
function $fcb78e8696b500a3$export$cf6d8c730042fe7f() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$axisKx("fx", $fcb78e8696b500a3$var$anchorFx(options), data, options);
}
function $fcb78e8696b500a3$var$axisKy(k, anchor, data, { color: color = "currentColor", opacity: opacity = 1, stroke: stroke = color, strokeOpacity: strokeOpacity = opacity, strokeWidth: strokeWidth = 1, fill: fill = color, fillOpacity: fillOpacity = opacity, textAnchor: textAnchor, textStroke: textStroke, textStrokeOpacity: textStrokeOpacity, textStrokeWidth: textStrokeWidth, tickSize: tickSize = k === "y" ? 6 : 0, tickPadding: tickPadding, tickRotate: tickRotate, x: x, margin: margin, marginTop: marginTop = margin === undefined ? 20 : margin, marginRight: marginRight = margin === undefined ? anchor === "right" ? 40 : 0 : margin, marginBottom: marginBottom = margin === undefined ? 20 : margin, marginLeft: marginLeft = margin === undefined ? anchor === "left" ? 40 : 0 : margin, label: label, labelAnchor: labelAnchor, labelArrow: labelArrow, labelOffset: labelOffset, ...options }) {
    tickSize = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickSize);
    tickPadding = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickPadding);
    tickRotate = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickRotate);
    if (labelAnchor !== undefined) labelAnchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(labelAnchor, "labelAnchor", [
        "center",
        "top",
        "bottom"
    ]);
    labelArrow = $fcb78e8696b500a3$var$maybeLabelArrow(labelArrow);
    return (0, $24d8c38d667d16c2$export$3a8025f2f3e0c64)(tickSize && !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(stroke) ? $fcb78e8696b500a3$var$axisTickKy(k, anchor, data, {
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        x: x,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) ? $fcb78e8696b500a3$var$axisTextKy(k, anchor, data, {
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: textStroke,
        strokeOpacity: textStrokeOpacity,
        strokeWidth: textStrokeWidth,
        textAnchor: textAnchor,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        x: x,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) && label !== null ? (0, $b4855ffaf649c526$export$6f093cfa640b7166)([], $fcb78e8696b500a3$var$labelOptions({
        fill: fill,
        fillOpacity: fillOpacity,
        ...options
    }, function(data, facets, channels, scales, dimensions) {
        const scale = scales[k];
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft } = k === "y" && dimensions.inset || dimensions;
        const cla = labelAnchor ?? (scale.bandwidth ? "center" : "top");
        const clo = labelOffset ?? (anchor === "right" ? marginRight : marginLeft) - 3;
        if (cla === "center") {
            this.textAnchor = undefined; // middle
            this.lineAnchor = anchor === "right" ? "bottom" : "top";
            this.frameAnchor = anchor;
            this.rotate = -90;
        } else {
            this.textAnchor = anchor === "right" ? "end" : "start";
            this.lineAnchor = cla;
            this.frameAnchor = `${cla}-${anchor}`;
            this.rotate = 0;
        }
        this.dy = cla === "top" ? 3 - marginTop : cla === "bottom" ? marginBottom - 3 : 0;
        this.dx = anchor === "right" ? clo : -clo;
        this.ariaLabel = `${k}-axis label`;
        return {
            facets: [
                [
                    0
                ]
            ],
            channels: {
                text: {
                    value: [
                        $fcb78e8696b500a3$var$formatAxisLabel(k, scale, {
                            anchor: anchor,
                            label: label,
                            labelAnchor: cla,
                            labelArrow: labelArrow
                        })
                    ]
                }
            }
        };
    })) : null);
}
function $fcb78e8696b500a3$var$axisKx(k, anchor, data, { color: color = "currentColor", opacity: opacity = 1, stroke: stroke = color, strokeOpacity: strokeOpacity = opacity, strokeWidth: strokeWidth = 1, fill: fill = color, fillOpacity: fillOpacity = opacity, textAnchor: textAnchor, textStroke: textStroke, textStrokeOpacity: textStrokeOpacity, textStrokeWidth: textStrokeWidth, tickSize: tickSize = k === "x" ? 6 : 0, tickPadding: tickPadding, tickRotate: tickRotate, y: y, margin: margin, marginTop: marginTop = margin === undefined ? anchor === "top" ? 30 : 0 : margin, marginRight: marginRight = margin === undefined ? 20 : margin, marginBottom: marginBottom = margin === undefined ? anchor === "bottom" ? 30 : 0 : margin, marginLeft: marginLeft = margin === undefined ? 20 : margin, label: label, labelAnchor: labelAnchor, labelArrow: labelArrow, labelOffset: labelOffset, ...options }) {
    tickSize = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickSize);
    tickPadding = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickPadding);
    tickRotate = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(tickRotate);
    if (labelAnchor !== undefined) labelAnchor = (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(labelAnchor, "labelAnchor", [
        "center",
        "left",
        "right"
    ]);
    labelArrow = $fcb78e8696b500a3$var$maybeLabelArrow(labelArrow);
    return (0, $24d8c38d667d16c2$export$3a8025f2f3e0c64)(tickSize && !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(stroke) ? $fcb78e8696b500a3$var$axisTickKx(k, anchor, data, {
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        y: y,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) ? $fcb78e8696b500a3$var$axisTextKx(k, anchor, data, {
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: textStroke,
        strokeOpacity: textStrokeOpacity,
        strokeWidth: textStrokeWidth,
        textAnchor: textAnchor,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotate: tickRotate,
        y: y,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        ...options
    }) : null, !(0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) && label !== null ? (0, $b4855ffaf649c526$export$6f093cfa640b7166)([], $fcb78e8696b500a3$var$labelOptions({
        fill: fill,
        fillOpacity: fillOpacity,
        ...options
    }, function(data, facets, channels, scales, dimensions) {
        const scale = scales[k];
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft } = k === "x" && dimensions.inset || dimensions;
        const cla = labelAnchor ?? (scale.bandwidth ? "center" : "right");
        const clo = labelOffset ?? (anchor === "top" ? marginTop : marginBottom) - 3;
        if (cla === "center") {
            this.frameAnchor = anchor;
            this.textAnchor = undefined; // middle
        } else {
            this.frameAnchor = `${anchor}-${cla}`;
            this.textAnchor = cla === "right" ? "end" : "start";
        }
        this.lineAnchor = anchor;
        this.dy = anchor === "top" ? -clo : clo;
        this.dx = cla === "right" ? marginRight - 3 : cla === "left" ? 3 - marginLeft : 0;
        this.ariaLabel = `${k}-axis label`;
        return {
            facets: [
                [
                    0
                ]
            ],
            channels: {
                text: {
                    value: [
                        $fcb78e8696b500a3$var$formatAxisLabel(k, scale, {
                            anchor: anchor,
                            label: label,
                            labelAnchor: cla,
                            labelArrow: labelArrow
                        })
                    ]
                }
            }
        };
    })) : null);
}
function $fcb78e8696b500a3$var$axisTickKy(k, anchor, data, { strokeWidth: strokeWidth = 1, strokeLinecap: strokeLinecap = null, strokeLinejoin: strokeLinejoin = null, facetAnchor: facetAnchor = anchor + (k === "y" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, inset: inset = 0, insetLeft: insetLeft = inset, insetRight: insetRight = inset, dx: dx = 0, y: y = k === "y" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $2d02506c373828f7$export$326ea72b1565acd6), k, anchor, `${k}-axis tick`, data, {
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin,
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        y: y,
        ...options,
        dx: anchor === "left" ? +dx - (0, $547e5698440387a8$export$cc800923e997bb8) + +insetLeft : +dx + (0, $547e5698440387a8$export$cc800923e997bb8) - insetRight,
        anchor: "start",
        length: tickSize,
        shape: anchor === "left" ? $fcb78e8696b500a3$var$shapeTickLeft : $fcb78e8696b500a3$var$shapeTickRight
    });
}
function $fcb78e8696b500a3$var$axisTickKx(k, anchor, data, { strokeWidth: strokeWidth = 1, strokeLinecap: strokeLinecap = null, strokeLinejoin: strokeLinejoin = null, facetAnchor: facetAnchor = anchor + (k === "x" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, inset: inset = 0, insetTop: insetTop = inset, insetBottom: insetBottom = inset, dy: dy = 0, x: x = k === "x" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $2d02506c373828f7$export$dc781e748fde228d), k, anchor, `${k}-axis tick`, data, {
        strokeWidth: strokeWidth,
        strokeLinejoin: strokeLinejoin,
        strokeLinecap: strokeLinecap,
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        x: x,
        ...options,
        dy: anchor === "bottom" ? +dy - (0, $547e5698440387a8$export$cc800923e997bb8) - insetBottom : +dy + (0, $547e5698440387a8$export$cc800923e997bb8) + +insetTop,
        anchor: "start",
        length: tickSize,
        shape: anchor === "bottom" ? $fcb78e8696b500a3$var$shapeTickBottom : $fcb78e8696b500a3$var$shapeTickTop
    });
}
function $fcb78e8696b500a3$var$axisTextKy(k, anchor, data, { facetAnchor: facetAnchor = anchor + (k === "y" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, tickRotate: tickRotate = 0, tickPadding: tickPadding = Math.max(3, 9 - tickSize) + (Math.abs(tickRotate) > 60 ? 4 * Math.cos(tickRotate * (0, $313afcb1ba78b0a6$export$8449e153fbd325fc)) : 0), text: text, textAnchor: textAnchor = Math.abs(tickRotate) > 60 ? "middle" : anchor === "left" ? "end" : "start", lineAnchor: lineAnchor = tickRotate > 60 ? "top" : tickRotate < -60 ? "bottom" : "middle", fontVariant: fontVariant, inset: inset = 0, insetLeft: insetLeft = inset, insetRight: insetRight = inset, dx: dx = 0, y: y = k === "y" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $b4855ffaf649c526$export$b11955fec8f4d045), k, anchor, `${k}-axis tick label`, data, {
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        text: text,
        textAnchor: textAnchor,
        lineAnchor: lineAnchor,
        fontVariant: fontVariant,
        rotate: tickRotate,
        y: y,
        ...options,
        dx: anchor === "left" ? +dx - tickSize - tickPadding + +insetLeft : +dx + +tickSize + +tickPadding - insetRight
    }, function(scale, data, ticks, tickFormat, channels) {
        if (fontVariant === undefined) this.fontVariant = $fcb78e8696b500a3$var$inferFontVariant(scale);
        if (text === undefined) channels.text = $fcb78e8696b500a3$var$inferTextChannel(scale, data, ticks, tickFormat, anchor);
    });
}
function $fcb78e8696b500a3$var$axisTextKx(k, anchor, data, { facetAnchor: facetAnchor = anchor + (k === "x" ? "-empty" : ""), frameAnchor: frameAnchor = anchor, tickSize: tickSize, tickRotate: tickRotate = 0, tickPadding: tickPadding = Math.max(3, 9 - tickSize) + (Math.abs(tickRotate) >= 10 ? 4 * Math.cos(tickRotate * (0, $313afcb1ba78b0a6$export$8449e153fbd325fc)) : 0), text: text, textAnchor: textAnchor = Math.abs(tickRotate) >= 10 ? tickRotate < 0 ^ anchor === "bottom" ? "start" : "end" : "middle", lineAnchor: lineAnchor = Math.abs(tickRotate) >= 10 ? "middle" : anchor === "bottom" ? "top" : "bottom", fontVariant: fontVariant, inset: inset = 0, insetTop: insetTop = inset, insetBottom: insetBottom = inset, dy: dy = 0, x: x = k === "x" ? undefined : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $b4855ffaf649c526$export$5aac532f27b03078), k, anchor, `${k}-axis tick label`, data, {
        facetAnchor: facetAnchor,
        frameAnchor: frameAnchor,
        text: text === undefined ? null : text,
        textAnchor: textAnchor,
        lineAnchor: lineAnchor,
        fontVariant: fontVariant,
        rotate: tickRotate,
        x: x,
        ...options,
        dy: anchor === "bottom" ? +dy + +tickSize + +tickPadding - insetBottom : +dy - tickSize - tickPadding + +insetTop
    }, function(scale, data, ticks, tickFormat, channels) {
        if (fontVariant === undefined) this.fontVariant = $fcb78e8696b500a3$var$inferFontVariant(scale);
        if (text === undefined) channels.text = $fcb78e8696b500a3$var$inferTextChannel(scale, data, ticks, tickFormat, anchor);
    });
}
function $fcb78e8696b500a3$export$7510dfed5fcfcd8f() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKy("y", $fcb78e8696b500a3$var$anchorY(options), data, options);
}
function $fcb78e8696b500a3$export$7093722adfac6b64() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKy("fy", $fcb78e8696b500a3$var$anchorFy(options), data, options);
}
function $fcb78e8696b500a3$export$6ac963799f18e4c() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKx("x", $fcb78e8696b500a3$var$anchorX(options), data, options);
}
function $fcb78e8696b500a3$export$8d672a2bd8b3cb8b() {
    const [data, options] = $fcb78e8696b500a3$var$maybeData(...arguments);
    return $fcb78e8696b500a3$var$gridKx("fx", $fcb78e8696b500a3$var$anchorFx(options), data, options);
}
function $fcb78e8696b500a3$var$gridKy(k, anchor, data, { y: y = k === "y" ? undefined : null, x: x = null, x1: x1 = anchor === "left" ? x : null, x2: x2 = anchor === "right" ? x : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $60ff8edb66755c31$export$d121b88bc74f6ae5), k, anchor, `${k}-grid`, data, {
        y: y,
        x1: x1,
        x2: x2,
        ...$fcb78e8696b500a3$var$gridDefaults(options)
    });
}
function $fcb78e8696b500a3$var$gridKx(k, anchor, data, { x: x = k === "x" ? undefined : null, y: y = null, y1: y1 = anchor === "top" ? y : null, y2: y2 = anchor === "bottom" ? y : null, ...options }) {
    return $fcb78e8696b500a3$var$axisMark((0, $60ff8edb66755c31$export$22653c04c6d89eeb), k, anchor, `${k}-grid`, data, {
        x: x,
        y1: y1,
        y2: y2,
        ...$fcb78e8696b500a3$var$gridDefaults(options)
    });
}
function $fcb78e8696b500a3$var$gridDefaults({ color: color = "currentColor", opacity: opacity = 0.1, stroke: stroke = color, strokeOpacity: strokeOpacity = opacity, strokeWidth: strokeWidth = 1, ...options }) {
    return {
        stroke: stroke,
        strokeOpacity: strokeOpacity,
        strokeWidth: strokeWidth,
        ...options
    };
}
function $fcb78e8696b500a3$var$labelOptions({ fill: fill, fillOpacity: fillOpacity, fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontVariant: fontVariant, fontWeight: fontWeight, monospace: monospace, pointerEvents: pointerEvents, shapeRendering: shapeRendering, clip: clip = false }, initializer) {
    // Only propagate these options if constant.
    [, fill] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    [, fillOpacity] = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(fillOpacity);
    return {
        facet: "super",
        x: null,
        y: null,
        fill: fill,
        fillOpacity: fillOpacity,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight,
        monospace: monospace,
        pointerEvents: pointerEvents,
        shapeRendering: shapeRendering,
        clip: clip,
        initializer: initializer
    };
}
function $fcb78e8696b500a3$var$axisMark(mark, k, anchor, ariaLabel, data, options, initialize) {
    let channels;
    function axisInitializer(data, facets, _channels, scales, dimensions, context) {
        const initializeFacets = data == null && (k === "fx" || k === "fy");
        const { [k]: scale } = scales;
        if (!scale) throw new Error(`missing scale: ${k}`);
        const domain = scale.domain();
        let { interval: interval, ticks: ticks, tickFormat: tickFormat, tickSpacing: tickSpacing = k === "x" ? 80 : 35 } = options;
        // For a scale with a temporal domain, also allow the ticks to be specified
        // as a string which is promoted to a time interval. In the case of ordinal
        // scales, the interval is interpreted as UTC.
        if (typeof ticks === "string" && $fcb78e8696b500a3$var$hasTemporalDomain(scale)) interval = ticks, ticks = undefined;
        // The interval axis option is an alternative method of specifying ticks;
        // for example, for a numeric scale, ticks = 5 means “about 5 ticks” whereas
        // interval = 5 means “ticks every 5 units”. (This is not to be confused
        // with the interval scale option, which affects the scale’s behavior!)
        // Lastly use the tickSpacing option to infer the desired tick count.
        if (ticks === undefined) ticks = (0, $cd9e805a4bbd13f9$export$e13732492629ec8c)(interval, scale.type) ?? $fcb78e8696b500a3$var$inferTickCount(scale, tickSpacing);
        if (data == null) {
            if ((0, $cd9e805a4bbd13f9$export$9652023d9040757)(ticks)) // Use explicit ticks, if specified.
            data = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(ticks);
            else if ((0, $cd9e805a4bbd13f9$export$59b3ee3d90b7f75e)(ticks)) // Use the tick interval, if specified.
            data = $fcb78e8696b500a3$var$inclusiveRange(ticks, ...(0, $24461355656d8852$export$2e2bcd8739ae039)(domain));
            else if (scale.interval) {
                // If the scale interval is a standard time interval such as "day", we
                // may be able to generalize the scale interval it to a larger aligned
                // time interval to create the desired number of ticks.
                let interval = scale.interval;
                if (scale.ticks) {
                    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(domain);
                    const n = (max - min) / interval[0, $49e9bdee870d78f0$export$6b9291a5690ab4c6]; // current tick count
                    // We don’t explicitly check that given interval is a time interval;
                    // in that case the generalized interval will be undefined, just like
                    // a nonstandard interval. TODO Generalize integer intervals, too.
                    interval = (0, $49e9bdee870d78f0$export$29a4ccaf5efe074d)(interval, n / ticks) ?? interval;
                    data = $fcb78e8696b500a3$var$inclusiveRange(interval, min, max);
                } else {
                    data = domain;
                    const n = data.length; // current tick count
                    interval = (0, $49e9bdee870d78f0$export$29a4ccaf5efe074d)(interval, n / ticks) ?? interval;
                    if (interval !== scale.interval) data = $fcb78e8696b500a3$var$inclusiveRange(interval, ...(0, $24461355656d8852$export$2e2bcd8739ae039)(data));
                }
                if (interval === scale.interval) {
                    // If we weren’t able to generalize the scale’s interval, compute the
                    // positive number n such that taking every nth value from the scale’s
                    // domain produces as close as possible to the desired number of
                    // ticks. For example, if the domain has 100 values and 5 ticks are
                    // desired, n = 20.
                    const n = Math.round(data.length / ticks);
                    if (n > 1) data = data.filter((d, i)=>i % n === 0);
                }
            } else if (scale.ticks) data = scale.ticks(ticks);
            else // For ordinal scales, the domain will already be generated using the
            // scale’s interval, if any.
            data = domain;
            if (!scale.ticks && data.length && data !== domain) {
                // For ordinal scales, intersect the ticks with the scale domain since
                // the scale is only defined on its domain. If all of the ticks are
                // removed, then warn that the ticks and scale domain may be misaligned
                // (e.g., "year" ticks and "4 weeks" interval).
                const domainSet = new (0, $3160658555deb5c9$export$55278c3294239828)(domain);
                data = data.filter((d)=>domainSet.has(d));
                if (!data.length) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the ${k}-axis ticks appear to not align with the scale domain, resulting in no ticks. Try different ticks?`); // prettier-ignore
            }
            if (k === "y" || k === "x") facets = [
                (0, $cd9e805a4bbd13f9$export$d02631cccf789723)(data)
            ];
            else channels[k] = {
                scale: k,
                value: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)
            };
        }
        initialize?.call(this, scale, data, ticks, tickFormat, channels);
        const initializedChannels = Object.fromEntries(Object.entries(channels).map(([name, channel])=>{
            return [
                name,
                {
                    ...channel,
                    value: (0, $cd9e805a4bbd13f9$export$1414f04542a0b4f4)(data, channel.value)
                }
            ];
        }));
        if (initializeFacets) facets = context.filterFacets(data, initializedChannels);
        return {
            data: data,
            facets: facets,
            channels: initializedChannels
        };
    }
    // Apply any basic initializers after the axis initializer computes the ticks.
    const basicInitializer = (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)(options).initializer;
    const m = mark(data, (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)({
        ...options,
        initializer: axisInitializer
    }, basicInitializer));
    if (data == null) {
        channels = m.channels;
        m.channels = {};
    } else channels = {};
    m.ariaLabel = ariaLabel;
    if (m.clip === undefined) m.clip = false; // don’t clip axes by default
    return m;
}
function $fcb78e8696b500a3$var$inferTickCount(scale, tickSpacing) {
    const [min, max] = (0, $24461355656d8852$export$2e2bcd8739ae039)(scale.range());
    return (max - min) / tickSpacing;
}
function $fcb78e8696b500a3$var$inferTextChannel(scale, data, ticks, tickFormat, anchor) {
    return {
        value: $fcb78e8696b500a3$export$c2c6970049f8b561(scale, data, ticks, tickFormat, anchor)
    };
}
function $fcb78e8696b500a3$export$c2c6970049f8b561(scale, data, ticks, tickFormat, anchor) {
    return typeof tickFormat === "function" ? tickFormat : tickFormat === undefined && data && (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(data) ? (0, $49e9bdee870d78f0$export$8d2dceb4d1e6fd24)(scale.type, data, anchor) ?? (0, $4b16c4377cd1e2de$export$bb457229db2006fb) : scale.tickFormat ? scale.tickFormat(typeof ticks === "number" ? ticks : null, tickFormat) : tickFormat === undefined ? (0, $4b16c4377cd1e2de$export$bb457229db2006fb) : typeof tickFormat === "string" ? ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(scale.domain()) ? (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb) : (0, $54a757fa53542946$export$d9468344d3651243))(tickFormat) : (0, $cd9e805a4bbd13f9$export$c983f826f44ff86)(tickFormat);
}
function $fcb78e8696b500a3$var$inclusiveRange(interval, min, max) {
    return interval.range(min, interval.offset(interval.floor(max)));
}
const $fcb78e8696b500a3$var$shapeTickBottom = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(0, l);
    }
};
const $fcb78e8696b500a3$var$shapeTickTop = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(0, -l);
    }
};
const $fcb78e8696b500a3$var$shapeTickLeft = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(-l, 0);
    }
};
const $fcb78e8696b500a3$var$shapeTickRight = {
    draw (context, l) {
        context.moveTo(0, 0);
        context.lineTo(l, 0);
    }
};
// TODO Unify this with the other inferFontVariant; here we only have a scale
// function rather than a scale descriptor.
function $fcb78e8696b500a3$var$inferFontVariant(scale) {
    return scale.bandwidth && !scale.interval ? undefined : "tabular-nums";
}
// Takes the scale label, and if this is not an ordinal scale and the label was
// inferred from an associated channel, adds an orientation-appropriate arrow.
function $fcb78e8696b500a3$var$formatAxisLabel(k, scale, { anchor: anchor, label: label = scale.label, labelAnchor: labelAnchor, labelArrow: labelArrow } = {}) {
    if (label == null || label.inferred && $fcb78e8696b500a3$var$hasTemporalDomain(scale) && /^(date|time|year)$/i.test(label)) return;
    label = String(label); // coerce to a string after checking if inferred
    if (labelArrow === "auto") labelArrow = (!scale.bandwidth || scale.interval) && !/[↑↓→←]/.test(label);
    if (!labelArrow) return label;
    if (labelArrow === true) {
        const order = (0, $d2c16f7a6010a221$export$cb20e1306358cc06)(scale);
        if (order) labelArrow = /x$/.test(k) || labelAnchor === "center" ? /x$/.test(k) === order < 0 ? "left" : "right" : order < 0 ? "up" : "down";
    }
    switch(labelArrow){
        case "left":
            return `\u{2190} ${label}`;
        case "right":
            return `${label} \u{2192}`;
        case "up":
            return anchor === "right" ? `${label} \u{2191}` : `\u{2191} ${label}`;
        case "down":
            return anchor === "right" ? `${label} \u{2193}` : `\u{2193} ${label}`;
    }
    return label;
}
function $fcb78e8696b500a3$var$maybeLabelArrow(labelArrow = "auto") {
    return (0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(labelArrow) ? false : typeof labelArrow === "boolean" ? labelArrow : (0, $cd9e805a4bbd13f9$export$2e81050496d0e63e)(labelArrow, "labelArrow", [
        "auto",
        "up",
        "right",
        "down",
        "left"
    ]);
}
function $fcb78e8696b500a3$var$hasTemporalDomain(scale) {
    return (0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(scale.domain());
}


function $c9ad7b4f4b4e94b8$var$maybeScale(scale, key) {
    if (key == null) return key;
    const s = scale(key);
    if (!s) throw new Error(`scale not found: ${key}`);
    return s;
}
function $c9ad7b4f4b4e94b8$export$20b28fb174c65a54(color, { opacity: opacity, ...options } = {}) {
    if (!(0, $d2c16f7a6010a221$export$61579433626afe87)(color) && !(0, $d2c16f7a6010a221$export$667642af40ee0f01)(color)) throw new Error(`swatches legend requires ordinal or threshold color scale (not ${color.type})`);
    return $c9ad7b4f4b4e94b8$var$legendItems(color, options, (selection, scale, width, height)=>selection.append("svg").attr("width", width).attr("height", height).attr("fill", scale.scale).attr("fill-opacity", (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(opacity)[1]).append("rect").attr("width", "100%").attr("height", "100%"));
}
function $c9ad7b4f4b4e94b8$export$99df2788a81f2501(symbol, { fill: fill = symbol.hint?.fill !== undefined ? symbol.hint.fill : "none", fillOpacity: fillOpacity = 1, stroke: stroke = symbol.hint?.stroke !== undefined ? symbol.hint.stroke : (0, $cd9e805a4bbd13f9$export$143ac3c9068abf57)(fill) ? "currentColor" : "none", strokeOpacity: strokeOpacity = 1, strokeWidth: strokeWidth = 1.5, r: r = 4.5, ...options } = {}, scale) {
    const [vf, cf] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(fill);
    const [vs, cs] = (0, $cd9e805a4bbd13f9$export$6dcb63290aa6d572)(stroke);
    const sf = $c9ad7b4f4b4e94b8$var$maybeScale(scale, vf);
    const ss = $c9ad7b4f4b4e94b8$var$maybeScale(scale, vs);
    const size = r * r * Math.PI;
    fillOpacity = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(fillOpacity)[1];
    strokeOpacity = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeOpacity)[1];
    strokeWidth = (0, $cd9e805a4bbd13f9$export$75c96357b71c0240)(strokeWidth)[1];
    return $c9ad7b4f4b4e94b8$var$legendItems(symbol, options, (selection, scale, width, height)=>selection.append("svg").attr("viewBox", "-8 -8 16 16").attr("width", width).attr("height", height).attr("fill", vf === "color" ? (d)=>sf.scale(d) : cf).attr("fill-opacity", fillOpacity).attr("stroke", vs === "color" ? (d)=>ss.scale(d) : cs).attr("stroke-opacity", strokeOpacity).attr("stroke-width", strokeWidth).append("path").attr("d", (d)=>{
            const p = (0, $c9f66a4d1c06b373$export$e181c6ece8d9cc5f)();
            symbol.scale(d).draw(p, size);
            return p;
        }));
}
function $c9ad7b4f4b4e94b8$var$legendItems(scale, options = {}, swatch) {
    let { columns: columns, tickFormat: tickFormat, fontVariant: fontVariant = (0, $5349c8aa18563753$export$57ccd2691f3b457e)(scale), swatchSize: // TODO label,
    swatchSize = 15, swatchWidth: swatchWidth = swatchSize, swatchHeight: swatchHeight = swatchSize, marginLeft: marginLeft = 0, className: className, style: style, width: width } = options;
    const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
    className = (0, $547e5698440387a8$export$22300e6eaecca37)(className);
    tickFormat = (0, $fcb78e8696b500a3$export$c2c6970049f8b561)(scale.scale, scale.domain, undefined, tickFormat);
    const swatches = (0, $871355576fc3efd9$export$185802fd694ee1f5)("div", context).attr("class", `${className}-swatches ${className}-swatches-${columns != null ? "columns" : "wrap"}`);
    let extraStyle;
    if (columns != null) {
        extraStyle = `:where(.${className}-swatches-columns .${className}-swatch) {
  display: flex;
  align-items: center;
  break-inside: avoid;
  padding-bottom: 1px;
}
:where(.${className}-swatches-columns .${className}-swatch::before) {
  flex-shrink: 0;
}
:where(.${className}-swatches-columns .${className}-swatch-label) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`;
        swatches.style("columns", columns).selectAll().data(scale.domain).enter().append("div").attr("class", `${className}-swatch`).call(swatch, scale, swatchWidth, swatchHeight).call((item)=>item.append("div").attr("class", `${className}-swatch-label`).attr("title", tickFormat).text(tickFormat));
    } else {
        extraStyle = `:where(.${className}-swatches-wrap) {
  display: flex;
  align-items: center;
  min-height: 33px;
  flex-wrap: wrap;
}
:where(.${className}-swatches-wrap .${className}-swatch) {
  display: inline-flex;
  align-items: center;
  margin-right: 1em;
}`;
        swatches.selectAll().data(scale.domain).enter().append("span").attr("class", `${className}-swatch`).call(swatch, scale, swatchWidth, swatchHeight).append(function() {
            return this.ownerDocument.createTextNode(tickFormat.apply(this, arguments));
        });
    }
    return swatches.call((div)=>div.insert("style", "*").text(`:where(.${className}-swatches) {
  font-family: system-ui, sans-serif;
  font-size: 10px;
  margin-bottom: 0.5em;
}
:where(.${className}-swatch > svg) {
  margin-right: 0.5em;
  overflow: visible;
}
${extraStyle}`)).style("margin-left", marginLeft ? `${+marginLeft}px` : null).style("width", width === undefined ? null : `${+width}px`).style("font-variant", (0, $547e5698440387a8$export$e1c487990851f09f)(fontVariant, "normal")).call((0, $547e5698440387a8$export$4e6c5cc1af44143e), style).node();
}




const $e6941eca40ba0848$var$legendRegistry = new Map([
    [
        "symbol",
        (0, $c9ad7b4f4b4e94b8$export$99df2788a81f2501)
    ],
    [
        "color",
        $e6941eca40ba0848$var$legendColor
    ],
    [
        "opacity",
        $e6941eca40ba0848$var$legendOpacity
    ]
]);
function $e6941eca40ba0848$export$9a9b59e08de24cef(options = {}) {
    for (const [key, value] of $e6941eca40ba0848$var$legendRegistry){
        const scale = options[key];
        if ((0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(scale)) {
            // e.g., ignore {color: "red"}
            const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
            let hint;
            // For symbol legends, pass a hint to the symbol scale.
            if (key === "symbol") {
                const { fill: fill, stroke: stroke = fill === undefined && (0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options.color) ? "color" : undefined } = options;
                hint = {
                    fill: fill,
                    stroke: stroke
                };
            }
            return value((0, $d2c16f7a6010a221$export$a566bffc16069997)(key, scale, hint), $e6941eca40ba0848$var$legendOptions(context, scale, options), (key)=>(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options[key]) ? (0, $d2c16f7a6010a221$export$a566bffc16069997)(key, options[key]) : null);
        }
    }
    throw new Error("unknown legend type; no scale found");
}
function $e6941eca40ba0848$export$d2e05e4b3a11ee5a(scales, context, defaults = {}) {
    return (key, options)=>{
        if (!$e6941eca40ba0848$var$legendRegistry.has(key)) throw new Error(`unknown legend type: ${key}`);
        if (!(key in scales)) return;
        return $e6941eca40ba0848$var$legendRegistry.get(key)(scales[key], $e6941eca40ba0848$var$legendOptions(context, defaults[key], options), (key)=>scales[key]);
    };
}
function $e6941eca40ba0848$var$legendOptions({ className: className, ...context }, { label: label, ticks: ticks, tickFormat: tickFormat } = {}, options) {
    return (0, $cd9e805a4bbd13f9$export$4dc9a6b0ae3dfd2a)(options, {
        className: className,
        ...context
    }, {
        label: label,
        ticks: ticks,
        tickFormat: tickFormat
    });
}
function $e6941eca40ba0848$var$legendColor(color, { legend: legend = true, ...options }) {
    if (legend === true) legend = color.type === "ordinal" ? "swatches" : "ramp";
    if (color.domain === undefined) return;
    switch(`${legend}`.toLowerCase()){
        case "swatches":
            return (0, $c9ad7b4f4b4e94b8$export$20b28fb174c65a54)(color, options);
        case "ramp":
            return (0, $0e1b3cfced53194d$export$cc0ec4119b9c7105)(color, options);
        default:
            throw new Error(`unknown legend type: ${legend}`);
    }
}
function $e6941eca40ba0848$var$legendOpacity({ type: type, interpolate: interpolate, ...scale }, { legend: legend = true, color: color = (0, $bYoiY.rgb)(0, 0, 0), ...options }) {
    if (!interpolate) throw new Error(`${type} opacity scales are not supported`);
    if (legend === true) legend = "ramp";
    if (`${legend}`.toLowerCase() !== "ramp") throw new Error(`${legend} opacity legends are not supported`);
    return $e6941eca40ba0848$var$legendColor({
        type: type,
        ...scale,
        interpolate: $e6941eca40ba0848$var$interpolateOpacity(color)
    }, {
        legend: legend,
        ...options
    });
}
function $e6941eca40ba0848$var$interpolateOpacity(color) {
    const { r: r, g: g, b: b } = (0, $bYoiY.rgb)(color) || (0, $bYoiY.rgb)(0, 0, 0); // treat invalid color as black
    return (t)=>`rgba(${r},${g},${b},${t})`;
}
function $e6941eca40ba0848$export$7d86fc1221ad3a46(scales, context, options) {
    const legends = [];
    for (const [key, value] of $e6941eca40ba0848$var$legendRegistry){
        const o = options[key];
        if (o?.legend && key in scales) {
            const legend = value(scales[key], $e6941eca40ba0848$var$legendOptions(context, scales[key], o), (key)=>scales[key]);
            if (legend != null) legends.push(legend);
        }
    }
    return legends;
}








const $b946fb4c8a04d9d8$var$defaults = {
    ariaLabel: "frame",
    fill: "none",
    stroke: "currentColor",
    clip: false
};
const $b946fb4c8a04d9d8$var$lineDefaults = {
    ariaLabel: "frame",
    fill: null,
    stroke: "currentColor",
    strokeLinecap: "square",
    clip: false
};
class $b946fb4c8a04d9d8$export$b89a827e9254211a extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(options = {}){
        const { anchor: anchor = null, inset: inset = 0, insetTop: insetTop = inset, insetRight: insetRight = inset, insetBottom: insetBottom = inset, insetLeft: insetLeft = inset, rx: rx, ry: ry } = options;
        super((0, $cd9e805a4bbd13f9$export$439306a4dcaafbb9), undefined, options, anchor == null ? $b946fb4c8a04d9d8$var$defaults : $b946fb4c8a04d9d8$var$lineDefaults);
        this.anchor = (0, $cd9e805a4bbd13f9$export$a305618d7bff6223)(anchor, "anchor", [
            "top",
            "right",
            "bottom",
            "left"
        ]);
        this.insetTop = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetTop);
        this.insetRight = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetRight);
        this.insetBottom = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetBottom);
        this.insetLeft = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(insetLeft);
        this.rx = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(rx);
        this.ry = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(ry);
    }
    render(index, scales, channels, dimensions, context) {
        const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = dimensions;
        const { anchor: anchor, insetTop: insetTop, insetRight: insetRight, insetBottom: insetBottom, insetLeft: insetLeft, rx: rx, ry: ry } = this;
        const x1 = marginLeft + insetLeft;
        const x2 = width - marginRight - insetRight;
        const y1 = marginTop + insetTop;
        const y2 = height - marginBottom - insetBottom;
        return (0, $871355576fc3efd9$export$185802fd694ee1f5)(anchor ? "svg:line" : "svg:rect", context).datum(0).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $547e5698440387a8$export$2949c2472f804203), this).call((0, $547e5698440387a8$export$43a1bc6cf61126e3), this, channels).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {}).call(anchor === "left" ? (line)=>line.attr("x1", x1).attr("x2", x1).attr("y1", y1).attr("y2", y2) : anchor === "right" ? (line)=>line.attr("x1", x2).attr("x2", x2).attr("y1", y1).attr("y2", y2) : anchor === "top" ? (line)=>line.attr("x1", x1).attr("x2", x2).attr("y1", y1).attr("y2", y1) : anchor === "bottom" ? (line)=>line.attr("x1", x1).attr("x2", x2).attr("y1", y2).attr("y2", y2) : (rect)=>rect.attr("x", x1).attr("y", y1).attr("width", x2 - x1).attr("height", y2 - y1).attr("rx", rx).attr("ry", ry)).node();
    }
}
function $b946fb4c8a04d9d8$export$2cef06c20297c17d(options) {
    return new $b946fb4c8a04d9d8$export$b89a827e9254211a(options);
}













const $45befbcddbf9afbb$var$defaults = {
    ariaLabel: "tip",
    fill: "var(--plot-background)",
    stroke: "currentColor"
};
// These channels are not displayed in the default tip; see formatChannels.
const $45befbcddbf9afbb$var$ignoreChannels = new Set([
    "geometry",
    "href",
    "src",
    "ariaLabel",
    "scales"
]);
class $45befbcddbf9afbb$export$c92c6401b52a9298 extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(data, options = {}){
        if (options.tip) options = {
            ...options,
            tip: false
        };
        if (options.title === undefined && (0, $cd9e805a4bbd13f9$export$9652023d9040757)(data) && (0, $cd9e805a4bbd13f9$export$43674e37205f3011)(data)) options = {
            ...options,
            title: (0, $cd9e805a4bbd13f9$export$f0954fd7d5368655)
        };
        const { x: x, y: y, x1: x1, x2: x2, y1: y1, y2: y2, anchor: anchor, preferredAnchor: preferredAnchor = "bottom", monospace: monospace, fontFamily: fontFamily = monospace ? "ui-monospace, monospace" : undefined, fontSize: fontSize, fontStyle: fontStyle, fontVariant: fontVariant, fontWeight: fontWeight, lineHeight: lineHeight = 1, lineWidth: lineWidth = 20, frameAnchor: frameAnchor, format: format, textAnchor: textAnchor = "start", textOverflow: textOverflow, textPadding: textPadding = 8, title: title, pointerSize: pointerSize = 12, pathFilter: pathFilter = "drop-shadow(0 3px 4px rgba(0,0,0,0.2))" } = options;
        super(data, {
            x: {
                value: x1 != null && x2 != null ? null : x,
                scale: "x",
                optional: true
            },
            y: {
                value: y1 != null && y2 != null ? null : y,
                scale: "y",
                optional: true
            },
            x1: {
                value: x1,
                scale: "x",
                optional: x2 == null
            },
            y1: {
                value: y1,
                scale: "y",
                optional: y2 == null
            },
            x2: {
                value: x2,
                scale: "x",
                optional: x1 == null
            },
            y2: {
                value: y2,
                scale: "y",
                optional: y1 == null
            },
            title: {
                value: title,
                optional: true
            } // filter: defined
        }, options, $45befbcddbf9afbb$var$defaults);
        this.anchor = (0, $cd9e805a4bbd13f9$export$6738a673c9b9c522)(anchor, "anchor");
        this.preferredAnchor = (0, $cd9e805a4bbd13f9$export$6738a673c9b9c522)(preferredAnchor, "preferredAnchor");
        this.frameAnchor = (0, $cd9e805a4bbd13f9$export$e2bf218018856d53)(frameAnchor);
        this.textAnchor = (0, $547e5698440387a8$export$e1c487990851f09f)(textAnchor, "middle");
        this.textPadding = +textPadding;
        this.pointerSize = +pointerSize;
        this.pathFilter = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(pathFilter);
        this.lineHeight = +lineHeight;
        this.lineWidth = +lineWidth;
        this.textOverflow = (0, $b4855ffaf649c526$export$5286100f10ca66d)(textOverflow);
        this.monospace = !!monospace;
        this.fontFamily = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontFamily);
        this.fontSize = (0, $cd9e805a4bbd13f9$export$98e628dec113755e)(fontSize);
        this.fontStyle = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontStyle);
        this.fontVariant = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontVariant);
        this.fontWeight = (0, $cd9e805a4bbd13f9$export$22b082955e083ec3)(fontWeight);
        for(const key in $45befbcddbf9afbb$var$defaults)if (key in this.channels) this[key] = $45befbcddbf9afbb$var$defaults[key]; // apply default even if channel
        this.splitLines = (0, $b4855ffaf649c526$export$8cfde575cbd41e40)(this);
        this.clipLine = (0, $b4855ffaf649c526$export$f7f3d67a35896a0e)(this);
        this.format = {
            ...format
        }; // defensive copy before mutate; also promote nullish to empty
    }
    render(index, scales, values, dimensions, context) {
        const mark = this;
        const { x: x, y: y, fx: fx, fy: fy } = scales;
        const { ownerSVGElement: svg, document: document } = context;
        const { anchor: anchor, monospace: monospace, lineHeight: lineHeight, lineWidth: lineWidth } = this;
        const { textPadding: r, pointerSize: m, pathFilter: pathFilter } = this;
        const { marginTop: marginTop, marginLeft: marginLeft } = dimensions;
        // The anchor position is the middle of x1 & y1 and x2 & y2, if available,
        // or x & y; the former is considered more specific because it’s how we
        // disable the implicit stack and interval transforms. If any dimension is
        // unspecified, we fallback to the frame anchor. We also need to know the
        // facet offsets to detect when the tip would draw outside the plot, and
        // thus we need to change the orientation.
        const { x1: X1, y1: Y1, x2: X2, y2: Y2, x: X = X1 ?? X2, y: Y = Y1 ?? Y2 } = values;
        const ox = fx ? fx(index.fx) - marginLeft : 0;
        const oy = fy ? fy(index.fy) - marginTop : 0;
        // The order of precedence for the anchor position is: the middle of x1 & y1
        // and x2 & y2; or x1 & y1 (e.g., area); or lastly x & y. If a dimension is
        // unspecified, the frame anchor is used.
        const [cx, cy] = (0, $547e5698440387a8$export$867c1a80005e0d82)(this, dimensions);
        const px = (0, $06868e990a5c2092$export$15f8ded78c8d24ca)(values, cx);
        const py = (0, $06868e990a5c2092$export$770d7614a8aa3617)(values, cy);
        // Resolve the text metric implementation. We may need an ellipsis for text
        // truncation, so we optimistically compute the ellipsis width.
        const widthof = monospace ? (0, $b4855ffaf649c526$export$4f4ed94d656e5d4a) : (0, $b4855ffaf649c526$export$205274d8d0bfa3a);
        const ee = widthof((0, $b4855ffaf649c526$export$a5b94313d6908893));
        // If there’s a title channel, display that as-is; otherwise, show multiple
        // channels as name-value pairs.
        let sources, format;
        if ("title" in values) {
            sources = values.channels;
            format = $45befbcddbf9afbb$var$formatTitle;
        } else {
            sources = $45befbcddbf9afbb$var$getSourceChannels.call(this, values, scales);
            format = $45befbcddbf9afbb$var$formatChannels;
        }
        // We don’t call applyChannelStyles because we only use the channels to
        // derive the content of the tip, not its aesthetics.
        const g = (0, $871355576fc3efd9$export$185802fd694ee1f5)("svg:g", context).call((0, $547e5698440387a8$export$b9ed040f258dd66e), this, dimensions, context).call((0, $b4855ffaf649c526$export$8b7aa25119010c38), this).call((0, $547e5698440387a8$export$9f9dcb98c894b623), this, {
            x: X && x,
            y: Y && y
        }).call((g)=>g.selectAll().data(index).enter().append("g").attr("transform", (i)=>`translate(${Math.round(px(i))},${Math.round(py(i))})`) // crisp edges
            .call((0, $547e5698440387a8$export$2949c2472f804203), this).call((g)=>g.append("path").attr("filter", pathFilter)).call((g)=>g.append("text").each(function(i) {
                    const that = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this);
                    // prevent style inheritance (from path)
                    this.setAttribute("fill", "currentColor");
                    this.setAttribute("fill-opacity", 1);
                    this.setAttribute("stroke", "none");
                    // iteratively render each channel value
                    const lines = format.call(mark, i, index, sources, scales, values);
                    if (typeof lines === "string") for (const line of mark.splitLines(lines))renderLine(that, {
                        value: mark.clipLine(line)
                    });
                    else {
                        const labels = new Set();
                        for (const line of lines){
                            const { label: label = "" } = line;
                            if (label && labels.has(label)) continue;
                            else labels.add(label);
                            renderLine(that, line);
                        }
                    }
                })));
        // Renders a single line (a name-value pair) to the tip, truncating the text
        // as needed, and adding a title if the text is truncated. Note that this is
        // just the initial layout of the text; in postrender we will compute the
        // exact text metrics and translate the text as needed once we know the
        // tip’s orientation (anchor).
        function renderLine(selection, { label: label, value: value, color: color, opacity: opacity }) {
            label ??= "", value ??= "";
            const swatch = color != null || opacity != null;
            let title;
            let w = lineWidth * 100;
            const [j] = (0, $b4855ffaf649c526$export$af2a99f971a346e6)(label, w, widthof, ee);
            if (j >= 0) {
                // label is truncated
                label = label.slice(0, j).trimEnd() + (0, $b4855ffaf649c526$export$a5b94313d6908893);
                title = value.trim();
                value = "";
            } else {
                if (label || !value && !swatch) value = " " + value;
                const [k] = (0, $b4855ffaf649c526$export$af2a99f971a346e6)(value, w - widthof(label), widthof, ee);
                if (k >= 0) {
                    // value is truncated
                    title = value.trim();
                    value = value.slice(0, k).trimEnd() + (0, $b4855ffaf649c526$export$a5b94313d6908893);
                }
            }
            const line = selection.append("tspan").attr("x", 0).attr("dy", `${lineHeight}em`).text("\u200B"); // zwsp for double-click
            if (label) line.append("tspan").attr("font-weight", "bold").text(label);
            if (value) line.append(()=>document.createTextNode(value));
            if (swatch) line.append("tspan").text(" \u25A0").attr("fill", color).attr("fill-opacity", opacity).style("user-select", "none"); // prettier-ignore
            if (title) line.append("title").text(title);
        }
        // Only after the plot is attached to the page can we compute the exact text
        // metrics needed to determine the tip size and orientation (anchor).
        function postrender() {
            const { width: width, height: height } = dimensions.facet ?? dimensions;
            g.selectChildren().each(function(i) {
                let { x: tx, width: w, height: h } = this.getBBox();
                w = Math.round(w), h = Math.round(h); // crisp edges
                let a = anchor; // use the specified anchor, if any
                if (a === undefined) {
                    const x = px(i) + ox;
                    const y = py(i) + oy;
                    const fitLeft = x + w + m + r * 2 < width;
                    const fitRight = x - w - m - r * 2 > 0;
                    const fitTop = y + h + m + r * 2 < height;
                    const fitBottom = y - h - m - r * 2 > 0;
                    a = fitLeft && fitRight ? fitTop && fitBottom ? mark.preferredAnchor : fitBottom ? "bottom" : "top" : fitTop && fitBottom ? fitLeft ? "left" : "right" : (fitLeft || fitRight) && (fitTop || fitBottom) ? `${fitBottom ? "bottom" : "top"}-${fitLeft ? "left" : "right"}` : mark.preferredAnchor;
                }
                const path = this.firstChild; // note: assumes exactly two children!
                const text = this.lastChild; // note: assumes exactly two children!
                path.setAttribute("d", $45befbcddbf9afbb$var$getPath(a, m, r, w, h));
                if (tx) for (const t of text.childNodes)t.setAttribute("x", -tx);
                text.setAttribute("y", `${+$45befbcddbf9afbb$var$getLineOffset(a, text.childNodes.length, lineHeight).toFixed(6)}em`);
                text.setAttribute("transform", `translate(${$45befbcddbf9afbb$var$getTextTranslate(a, m, r, w, h)})`);
            });
            g.attr("visibility", null);
        }
        // Wait until the plot is inserted into the page so that we can use getBBox
        // to compute the exact text dimensions. If the SVG is already connected, as
        // when the pointer interaction triggers the re-render, use a faster
        // microtask instead of an animation frame; if this SSR (e.g., JSDOM), skip
        // this step. Perhaps this could be done synchronously; getting the
        // dimensions of the SVG is easy, and although accurate text metrics are
        // hard, we could use approximate heuristics.
        if (index.length) {
            g.attr("visibility", "hidden"); // hide until postrender
            if (svg.isConnected) Promise.resolve().then(postrender);
            else if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(postrender);
        }
        return g.node();
    }
}
function $45befbcddbf9afbb$export$5e5b4df997cb5eaa(data, { x: x, y: y, ...options } = {}) {
    if (options.frameAnchor === undefined) [x, y] = (0, $cd9e805a4bbd13f9$export$8598999985068071)(x, y);
    return new $45befbcddbf9afbb$export$c92c6401b52a9298(data, {
        ...options,
        x: x,
        y: y
    });
}
function $45befbcddbf9afbb$var$getLineOffset(anchor, length, lineHeight) {
    return /^top(?:-|$)/.test(anchor) ? 0.94 - lineHeight : -0.29 - length * lineHeight;
}
function $45befbcddbf9afbb$var$getTextTranslate(anchor, m, r, width, height) {
    switch(anchor){
        case "middle":
            return [
                -width / 2,
                height / 2
            ];
        case "top-left":
            return [
                r,
                m + r
            ];
        case "top":
            return [
                -width / 2,
                m / 2 + r
            ];
        case "top-right":
            return [
                -width - r,
                m + r
            ];
        case "right":
            return [
                -m / 2 - width - r,
                height / 2
            ];
        case "bottom-left":
            return [
                r,
                -m - r
            ];
        case "bottom":
            return [
                -width / 2,
                -m / 2 - r
            ];
        case "bottom-right":
            return [
                -width - r,
                -m - r
            ];
        case "left":
            return [
                r + m / 2,
                height / 2
            ];
    }
}
function $45befbcddbf9afbb$var$getPath(anchor, m, r, width, height) {
    const w = width + r * 2;
    const h = height + r * 2;
    switch(anchor){
        case "middle":
            return `M${-w / 2},${-h / 2}h${w}v${h}h${-w}z`;
        case "top-left":
            return `M0,0l${m},${m}h${w - m}v${h}h${-w}z`;
        case "top":
            return `M0,0l${m / 2},${m / 2}h${(w - m) / 2}v${h}h${-w}v${-h}h${(w - m) / 2}z`;
        case "top-right":
            return `M0,0l${-m},${m}h${m - w}v${h}h${w}z`;
        case "right":
            return `M0,0l${-m / 2},${-m / 2}v${m / 2 - h / 2}h${-w}v${h}h${w}v${m / 2 - h / 2}z`;
        case "bottom-left":
            return `M0,0l${m},${-m}h${w - m}v${-h}h${-w}z`;
        case "bottom":
            return `M0,0l${m / 2},${-m / 2}h${(w - m) / 2}v${-h}h${-w}v${h}h${(w - m) / 2}z`;
        case "bottom-right":
            return `M0,0l${-m},${-m}h${m - w}v${-h}h${w}z`;
        case "left":
            return `M0,0l${m / 2},${-m / 2}v${m / 2 - h / 2}h${w}v${h}h${-w}v${m / 2 - h / 2}z`;
    }
}
// Note: mutates this.format!
function $45befbcddbf9afbb$var$getSourceChannels({ channels: channels }, scales) {
    const sources = {};
    // Promote x and y shorthand for paired channels (in order).
    let format = this.format;
    format = $45befbcddbf9afbb$var$maybeExpandPairedFormat(format, channels, "x");
    format = $45befbcddbf9afbb$var$maybeExpandPairedFormat(format, channels, "y");
    this.format = format;
    // Prioritize channels with explicit formats, in the given order.
    for(const key in format){
        const value = format[key];
        if (value === null || value === false) continue;
        else if (key === "fx" || key === "fy") sources[key] = true;
        else {
            const source = (0, $6eb5f337b2493843$export$dd2b6e807fb37ba3)(channels, key);
            if (source) sources[key] = source;
        }
    }
    // Then fallback to all other (non-ignored) channels.
    for(const key in channels){
        if (key in sources || key in format || $45befbcddbf9afbb$var$ignoreChannels.has(key)) continue;
        const source = (0, $6eb5f337b2493843$export$dd2b6e807fb37ba3)(channels, key);
        if (source) sources[key] = source;
    }
    // And lastly facet channels, but only if this mark is faceted.
    if (this.facet) {
        if (scales.fx && !("fx" in format)) sources.fx = true;
        if (scales.fy && !("fy" in format)) sources.fy = true;
    }
    // Promote shorthand string formats, and materialize default formats.
    for(const key in sources){
        const format = this.format[key];
        if (typeof format === "string") {
            const value = sources[key]?.value ?? scales[key]?.domain() ?? [];
            this.format[key] = ((0, $cd9e805a4bbd13f9$export$a0ef8f4ef32ae0e7)(value) ? (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb) : (0, $54a757fa53542946$export$d9468344d3651243))(format);
        } else if (format === undefined || format === true) {
            // For ordinal scales, the inferred tick format can be more concise, such
            // as only showing the year for yearly data.
            const scale = scales[key];
            this.format[key] = scale?.bandwidth ? (0, $fcb78e8696b500a3$export$c2c6970049f8b561)(scale, scale.domain()) : (0, $4b16c4377cd1e2de$export$bb457229db2006fb);
        }
    }
    return sources;
}
// Promote x and y shorthand for paired channels, while preserving order.
function $45befbcddbf9afbb$var$maybeExpandPairedFormat(format, channels, key) {
    if (!(key in format)) return format;
    const key1 = `${key}1`;
    const key2 = `${key}2`;
    if ((key1 in format || !(key1 in channels)) && (key2 in format || !(key2 in channels))) return format;
    const entries = Object.entries(format);
    const value = format[key];
    entries.splice(entries.findIndex(([name])=>name === key) + 1, 0, [
        key1,
        value
    ], [
        key2,
        value
    ]);
    return Object.fromEntries(entries);
}
function $45befbcddbf9afbb$var$formatTitle(i, index, { title: title }) {
    return (0, $4b16c4377cd1e2de$export$bb457229db2006fb)(title.value[i], i);
}
function* $45befbcddbf9afbb$var$formatChannels(i, index, channels, scales, values) {
    for(const key in channels){
        if (key === "fx" || key === "fy") {
            yield {
                label: $45befbcddbf9afbb$var$formatLabel(scales, channels, key),
                value: this.format[key](index[key], i)
            };
            continue;
        }
        if (key === "x1" && "x2" in channels) continue;
        if (key === "y1" && "y2" in channels) continue;
        const channel = channels[key];
        if (key === "x2" && "x1" in channels) yield {
            label: $45befbcddbf9afbb$var$formatPairLabel(scales, channels, "x"),
            value: $45befbcddbf9afbb$var$formatPair(this.format.x2, channels.x1, channel, i)
        };
        else if (key === "y2" && "y1" in channels) yield {
            label: $45befbcddbf9afbb$var$formatPairLabel(scales, channels, "y"),
            value: $45befbcddbf9afbb$var$formatPair(this.format.y2, channels.y1, channel, i)
        };
        else {
            const value = channel.value[i];
            const scale = channel.scale;
            if (!(0, $0f3e37548c3914c7$export$43f40ad3fa1d5c97)(value) && scale == null) continue;
            yield {
                label: $45befbcddbf9afbb$var$formatLabel(scales, channels, key),
                value: this.format[key](value, i),
                color: scale === "color" ? values[key][i] : null,
                opacity: scale === "opacity" ? values[key][i] : null
            };
        }
    }
}
function $45befbcddbf9afbb$var$formatPair(formatValue, c1, c2, i) {
    return c2.hint?.length // e.g., stackY’s y1 and y2
     ? `${formatValue(c2.value[i] - c1.value[i], i)}` : `${formatValue(c1.value[i], i)}\u{2013}${formatValue(c2.value[i], i)}`;
}
function $45befbcddbf9afbb$var$formatPairLabel(scales, channels, key) {
    const l1 = $45befbcddbf9afbb$var$formatLabel(scales, channels, `${key}1`, key);
    const l2 = $45befbcddbf9afbb$var$formatLabel(scales, channels, `${key}2`, key);
    return l1 === l2 ? l1 : `${l1}\u{2013}${l2}`;
}
function $45befbcddbf9afbb$var$formatLabel(scales, channels, key, defaultLabel = key) {
    const channel = channels[key];
    const scale = scales[channel?.scale ?? key];
    return String(scale?.label ?? channel?.label ?? defaultLabel);
}









function $dce15e0807f8b267$export$2bbbe2756ad57c66(options = {}) {
    const { facet: facet, style: style, title: title, subtitle: subtitle, caption: caption, ariaLabel: ariaLabel, ariaDescription: ariaDescription } = options;
    // className for inline styles
    const className = (0, $547e5698440387a8$export$22300e6eaecca37)(options.className);
    // Flatten any nested marks.
    const marks = options.marks === undefined ? [] : $dce15e0807f8b267$var$flatMarks(options.marks);
    // Add implicit tips.
    marks.push(...$dce15e0807f8b267$var$inferTips(marks));
    // Compute the top-level facet state. This has roughly the same structure as
    // mark-specific facet state, except there isn’t a facetsIndex, and there’s a
    // data and dataLength so we can warn the user if a different data of the same
    // length is used in a mark.
    const topFacetState = $dce15e0807f8b267$var$maybeTopFacet(facet, options);
    // Construct a map from (faceted) Mark instance to facet state, including:
    // channels - an {fx?, fy?} object to add to the fx and fy scale
    // groups - a possibly-nested map from facet values to indexes in the data array
    // facetsIndex - a sparse nested array of indices corresponding to the valid facets
    const facetStateByMark = new Map();
    for (const mark of marks){
        const facetState = $dce15e0807f8b267$var$maybeMarkFacet(mark, topFacetState, options);
        if (facetState) facetStateByMark.set(mark, facetState);
    }
    // Compute a Map from scale name to an array of associated channels.
    const channelsByScale = new Map();
    if (topFacetState) $dce15e0807f8b267$var$addScaleChannels(channelsByScale, [
        topFacetState
    ], options);
    $dce15e0807f8b267$var$addScaleChannels(channelsByScale, facetStateByMark, options);
    // Add implicit axis marks. Because this happens after faceting (because it
    // depends on whether faceting is present), we must initialize the facet state
    // of any implicit axes, too.
    const axes = $dce15e0807f8b267$var$flatMarks($dce15e0807f8b267$var$inferAxes(marks, channelsByScale, options));
    for (const mark of axes){
        const facetState = $dce15e0807f8b267$var$maybeMarkFacet(mark, topFacetState, options);
        if (facetState) facetStateByMark.set(mark, facetState);
    }
    marks.unshift(...axes);
    // All the possible facets are given by the domains of the fx or fy scales, or
    // the cross-product of these domains if we facet by both x and y. We sort
    // them in order to apply the facet filters afterwards.
    let facets = (0, $a6069a9074a3d58d$export$78806da010ca96a5)(channelsByScale, options);
    if (facets !== undefined) {
        const topFacetsIndex = topFacetState ? (0, $a6069a9074a3d58d$export$60f5bc485ae97c42)(facets, topFacetState) : undefined;
        // Compute a facet index for each mark, parallel to the facets array. For
        // mark-level facets, compute an index for that mark’s data and options.
        // Otherwise, use the top-level facet index.
        for (const mark of marks){
            if (mark.facet === null || mark.facet === "super") continue;
            const facetState = facetStateByMark.get(mark);
            if (facetState === undefined) continue;
            facetState.facetsIndex = mark.fx != null || mark.fy != null ? (0, $a6069a9074a3d58d$export$60f5bc485ae97c42)(facets, facetState) : topFacetsIndex;
        }
        // The cross product of the domains of fx and fy can include fx-fy
        // combinations for which no mark has an instance associated with that
        // combination, and therefore we don’t want to render this facet (not even
        // the frame). The same can occur if you specify the domain of fx and fy
        // explicitly, but there is no mark instance associated with some values in
        // the domain. Expunge empty facets, and clear the corresponding elements
        // from the nested index in each mark.
        const nonEmpty = new Set();
        for (const { facetsIndex: facetsIndex } of facetStateByMark.values())facetsIndex?.forEach((index, i)=>{
            if (index?.length > 0) nonEmpty.add(i);
        });
        // If all the facets are empty (as when none of the marks are actually
        // faceted), none of them are empty.
        facets.forEach(0 < nonEmpty.size && nonEmpty.size < facets.length ? (f, i)=>f.empty = !nonEmpty.has(i) : (f)=>f.empty = false);
        // For any mark using the “exclude” facet mode, invert the index.
        for (const mark of marks)if (mark.facet === "exclude") {
            const facetState = facetStateByMark.get(mark);
            if (facetState !== undefined) facetState.facetsIndex = (0, $a6069a9074a3d58d$export$1cc7e8228bc740dc)(facetState.facetsIndex);
        }
    }
    // If a scale is explicitly declared in options, initialize its associated
    // channels to the empty array; this will guarantee that a corresponding scale
    // will be created later (even if there are no other channels). Ignore facet
    // scale declarations, which are handled above.
    for (const key of (0, $743dde21c57c19a0$export$4bb7493d241fd8a5).keys())if ((0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(options[key]) && key !== "fx" && key !== "fy") channelsByScale.set(key, []);
    // A Map from Mark instance to its render state, including:
    // index - the data index e.g. [0, 1, 2, 3, …]
    // channels - an array of materialized channels e.g. [["x", {value}], …]
    // faceted - a boolean indicating whether this mark is faceted
    // values - an object of scaled values e.g. {x: [40, 32, …], …}
    const stateByMark = new Map();
    // Initialize the marks’ state.
    for (const mark of marks){
        if (stateByMark.has(mark)) throw new Error("duplicate mark; each mark must be unique");
        const { facetsIndex: facetsIndex, channels: facetChannels } = facetStateByMark.get(mark) ?? {};
        const { data: data, facets: facets, channels: channels } = mark.initialize(facetsIndex, facetChannels, options);
        $dce15e0807f8b267$var$applyScaleTransforms(channels, options);
        stateByMark.set(mark, {
            data: data,
            facets: facets,
            channels: channels
        });
    }
    // Initalize the scales and dimensions.
    const scaleDescriptors = (0, $d2c16f7a6010a221$export$3935c083772c2fcc)($dce15e0807f8b267$var$addScaleChannels(channelsByScale, stateByMark, options), options);
    const dimensions = (0, $c6491cb5712bafc0$export$8066c1b52b2e9504)(scaleDescriptors, marks, options);
    (0, $d2c16f7a6010a221$export$9b57902db34fb271)(scaleDescriptors, dimensions);
    const scales = (0, $d2c16f7a6010a221$export$c2fb627c1b06c8b7)(scaleDescriptors);
    const { fx: fx, fy: fy } = scales;
    const subdimensions = fx || fy ? (0, $d2c16f7a6010a221$export$d598388655a34790)(scaleDescriptors, dimensions) : dimensions;
    const superdimensions = fx || fy ? $dce15e0807f8b267$var$actualDimensions(scales, dimensions) : dimensions;
    // Initialize the context.
    const context = (0, $871355576fc3efd9$export$fd42f52fd3ae1109)(options);
    const document = context.document;
    const svg = (0, $8408c2f95f59818f$export$2e2bcd8739ae039)("svg").call(document.documentElement);
    let figure = svg; // replaced with the figure element, if any
    context.ownerSVGElement = svg;
    context.className = className;
    context.projection = (0, $0b574e6ffdcb6f7c$export$549167224996a0fb)(options, subdimensions);
    // Allows e.g. the axis mark to determine faceting lazily.
    context.filterFacets = (data, channels)=>{
        return (0, $a6069a9074a3d58d$export$60f5bc485ae97c42)(facets, {
            channels: channels,
            groups: (0, $a6069a9074a3d58d$export$46a87af59f80d026)(data, channels)
        });
    };
    // Allows e.g. the tip mark to reference channels and data on other marks.
    context.getMarkState = (mark)=>{
        const state = stateByMark.get(mark);
        const facetState = facetStateByMark.get(mark);
        return {
            ...state,
            channels: {
                ...state.channels,
                ...facetState?.channels
            }
        };
    };
    // Allows e.g. the pointer transform to support viewof.
    context.dispatchValue = (value)=>{
        if (figure.value === value) return;
        figure.value = value;
        figure.dispatchEvent(new Event("input", {
            bubbles: true
        }));
    };
    // Reinitialize; for deriving channels dependent on other channels.
    const newByScale = new Set();
    for (const [mark, state] of stateByMark)if (mark.initializer != null) {
        const dimensions = mark.facet === "super" ? superdimensions : subdimensions;
        const update = mark.initializer(state.data, state.facets, state.channels, scales, dimensions, context);
        if (update.data !== undefined) state.data = update.data;
        if (update.facets !== undefined) state.facets = update.facets;
        if (update.channels !== undefined) {
            const { fx: fx, fy: fy, ...channels } = update.channels; // separate facet channels
            $dce15e0807f8b267$var$inferChannelScales(channels);
            Object.assign(state.channels, channels);
            for (const channel of Object.values(channels)){
                const { scale: scale } = channel;
                // Initializers aren’t allowed to redefine position scales as this
                // would introduce a circular dependency; so simply scale these
                // channels as-is rather than creating new scales, and assume that
                // they already have the scale’s transform applied, if any (e.g., when
                // generating ticks for the axis mark).
                if (scale != null && !(0, $743dde21c57c19a0$export$1680e4b48df7f4f2)((0, $743dde21c57c19a0$export$4bb7493d241fd8a5).get(scale))) {
                    $dce15e0807f8b267$var$applyScaleTransform(channel, options);
                    newByScale.add(scale);
                }
            }
            // If the initializer returns new mark-level facet channels, we must
            // record that the mark is now faceted. Note: we aren’t actually
            // populating the facet state, but subsequently we won’t need it.
            if (fx != null || fy != null) facetStateByMark.set(mark, true);
        }
    }
    // Reconstruct scales if new scaled channels were created during
    // reinitialization. Preserve existing scale labels, if any.
    if (newByScale.size) {
        const newChannelsByScale = new Map();
        $dce15e0807f8b267$var$addScaleChannels(newChannelsByScale, stateByMark, options, (key)=>newByScale.has(key));
        $dce15e0807f8b267$var$addScaleChannels(channelsByScale, stateByMark, options, (key)=>newByScale.has(key));
        const newScaleDescriptors = $dce15e0807f8b267$var$inheritScaleLabels((0, $d2c16f7a6010a221$export$3935c083772c2fcc)(newChannelsByScale, options), scaleDescriptors);
        const { scales: newExposedScales, ...newScales } = (0, $d2c16f7a6010a221$export$c2fb627c1b06c8b7)(newScaleDescriptors);
        Object.assign(scaleDescriptors, newScaleDescriptors);
        Object.assign(scales, newScales);
        Object.assign(scales.scales, newExposedScales);
    }
    // Sort and filter the facets to match the fx and fy domains; this is needed
    // because the facets were constructed prior to the fx and fy scales.
    let facetDomains, facetTranslate;
    if (facets !== undefined) {
        facetDomains = {
            x: fx?.domain(),
            y: fy?.domain()
        };
        facets = (0, $a6069a9074a3d58d$export$f59853a117afdf3c)(facets, facetDomains);
        facetTranslate = (0, $a6069a9074a3d58d$export$1b78147bc5e9c7ba)(fx, fy, dimensions);
    }
    // Compute value objects, applying scales and projection as needed.
    for (const [mark, state] of stateByMark)state.values = mark.scale(state.channels, scales, context);
    const { width: width, height: height } = dimensions;
    (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(svg).attr("class", className).attr("fill", "currentColor").attr("font-family", "system-ui, sans-serif").attr("font-size", 10).attr("text-anchor", "middle").attr("width", width).attr("height", height).attr("viewBox", `0 0 ${width} ${height}`).attr("aria-label", ariaLabel).attr("aria-description", ariaDescription).call((svg)=>// Warning: if you edit this, change defaultClassName.
        svg.append("style").text(`:where(.${className}) {
  --plot-background: white;
  display: block;
  height: auto;
  height: intrinsic;
  max-width: 100%;
}
:where(.${className} text),
:where(.${className} tspan) {
  white-space: pre;
}`)).call((0, $547e5698440387a8$export$4e6c5cc1af44143e), style);
    // Render marks.
    for (const mark of marks){
        const { channels: channels, values: values, facets: indexes } = stateByMark.get(mark);
        // Render a non-faceted mark.
        if (facets === undefined || mark.facet === "super") {
            let index = null;
            if (indexes) {
                index = indexes[0];
                index = mark.filter(index, channels, values);
                if (index.length === 0) continue;
            }
            const node = mark.render(index, scales, values, superdimensions, context);
            if (node == null) continue;
            svg.appendChild(node);
        } else {
            let g;
            for (const f of facets){
                if (!(mark.facetAnchor?.(facets, facetDomains, f) ?? !f.empty)) continue;
                let index = null;
                if (indexes) {
                    const faceted = facetStateByMark.has(mark);
                    index = indexes[faceted ? f.i : 0];
                    index = mark.filter(index, channels, values);
                    if (index.length === 0) continue;
                    if (!faceted && index === indexes[0]) index = (0, $cd9e805a4bbd13f9$export$7ec32827e4221318)(index); // copy before assigning fx, fy, fi
                    index.fx = f.x, index.fy = f.y, index.fi = f.i;
                }
                const node = mark.render(index, scales, values, subdimensions, context);
                if (node == null) continue;
                // Lazily construct the shared group (to drop empty marks).
                (g ??= (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(svg).append("g")).append(()=>node).datum(f);
                // Promote ARIA attributes and mark transform to avoid repetition on
                // each facet; this assumes that these attributes are consistent across
                // facets, but that should be the case!
                for (const name of [
                    "aria-label",
                    "aria-description",
                    "aria-hidden",
                    "transform"
                ])if (node.hasAttribute(name)) {
                    g.attr(name, node.getAttribute(name));
                    node.removeAttribute(name);
                }
            }
            g?.selectChildren().attr("transform", facetTranslate);
        }
    }
    // Wrap the plot in a figure, if needed.
    const legends = (0, $e6941eca40ba0848$export$7d86fc1221ad3a46)(scaleDescriptors, context, options);
    const { figure: figured = title != null || subtitle != null || caption != null || legends.length > 0 } = options;
    if (figured) {
        figure = document.createElement("figure");
        figure.className = `${className}-figure`;
        figure.style.maxWidth = "initial"; // avoid Observable default style
        if (title != null) figure.append($dce15e0807f8b267$var$createTitleElement(document, title, "h2"));
        if (subtitle != null) figure.append($dce15e0807f8b267$var$createTitleElement(document, subtitle, "h3"));
        figure.append(...legends, svg);
        if (caption != null) figure.append($dce15e0807f8b267$var$createFigcaption(document, caption));
    }
    figure.scale = (0, $d2c16f7a6010a221$export$de69b9c17a3f6bda)(scales.scales);
    figure.legend = (0, $e6941eca40ba0848$export$d2e05e4b3a11ee5a)(scaleDescriptors, context, options);
    const w = (0, $30c329e934b7a0f1$export$1876d6a9858b29e7)();
    if (w > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(svg).append("text").attr("x", width).attr("y", 20).attr("dy", "-1em").attr("text-anchor", "end").attr("font-family", "initial") // fix emoji rendering in Chrome
    .text("\u26A0\uFE0F") // emoji variation selector
    .append("title").text(`${w.toLocaleString("en-US")} warning${w === 1 ? "" : "s"}. Please check the console.`);
    return figure;
}
function $dce15e0807f8b267$var$createTitleElement(document, contents, tag) {
    if (contents.ownerDocument) return contents;
    const e = document.createElement(tag);
    e.append(contents);
    return e;
}
function $dce15e0807f8b267$var$createFigcaption(document, caption) {
    const e = document.createElement("figcaption");
    e.append(caption);
    return e;
}
function $dce15e0807f8b267$var$plotThis({ marks: marks = [], ...options } = {}) {
    return $dce15e0807f8b267$export$2bbbe2756ad57c66({
        ...options,
        marks: [
            ...marks,
            this
        ]
    });
}
// Note: This side-effect avoids a circular dependency.
(0, $24d8c38d667d16c2$export$c9d15bcfc6d42044).prototype.plot = $dce15e0807f8b267$var$plotThis;
function $dce15e0807f8b267$var$flatMarks(marks) {
    return marks.flat(Infinity).filter((mark)=>mark != null).map($dce15e0807f8b267$var$markify);
}
function $dce15e0807f8b267$var$markify(mark) {
    return typeof mark.render === "function" ? mark : new $dce15e0807f8b267$var$Render(mark);
}
class $dce15e0807f8b267$var$Render extends (0, $24d8c38d667d16c2$export$c9d15bcfc6d42044) {
    constructor(render){
        if (typeof render !== "function") throw new TypeError("invalid mark; missing render function");
        super();
        this.render = render;
    }
    render() {}
}
// Note: mutates channel.value to apply the scale transform, if any.
function $dce15e0807f8b267$var$applyScaleTransforms(channels, options) {
    for(const name in channels)$dce15e0807f8b267$var$applyScaleTransform(channels[name], options);
    return channels;
}
// Note: mutates channel.value to apply the scale transform, if any. Also sets
// channel.transform to false to prevent duplicate transform application.
function $dce15e0807f8b267$var$applyScaleTransform(channel, options) {
    const { scale: scale, transform: t = true } = channel;
    if (scale == null || !t) return;
    const { type: type, percent: percent, interval: interval, transform: transform = percent ? (x)=>x * 100 : (0, $cd9e805a4bbd13f9$export$2170e2fe1255e79b)(interval, type) } = options[scale] ?? {};
    if (transform == null) return;
    channel.value = (0, $cd9e805a4bbd13f9$export$871de8747c9eaa88)(channel.value, transform);
    channel.transform = false;
}
// An initializer may generate channels without knowing how the downstream mark
// will use them. Marks are typically responsible associated scales with
// channels, but here we assume common behavior across marks.
function $dce15e0807f8b267$var$inferChannelScales(channels) {
    for(const name in channels)(0, $6eb5f337b2493843$export$5de38149af3ed501)(name, channels[name]);
}
function $dce15e0807f8b267$var$addScaleChannels(channelsByScale, stateByMark, options, filter = (0, $cd9e805a4bbd13f9$export$7a668e70ea2210d9)) {
    for (const { channels: channels } of stateByMark.values())for(const name in channels){
        const channel = channels[name];
        const { scale: scale } = channel;
        if (scale != null && filter(scale)) {
            // Geo marks affect the default x and y domains if there is no
            // projection. Skip this (as an optimization) when a projection is
            // specified, or when the domains for x and y are specified.
            if (scale === "projection") {
                if (!(0, $0b574e6ffdcb6f7c$export$a364b560a2a07d35)(options)) {
                    const gx = options.x?.domain === undefined;
                    const gy = options.y?.domain === undefined;
                    if (gx || gy) {
                        const [x, y] = (0, $0b574e6ffdcb6f7c$export$b3eb7247b89a6856)(channel);
                        if (gx) $dce15e0807f8b267$var$addScaleChannel(channelsByScale, "x", x);
                        if (gy) $dce15e0807f8b267$var$addScaleChannel(channelsByScale, "y", y);
                    }
                }
            } else $dce15e0807f8b267$var$addScaleChannel(channelsByScale, scale, channel);
        }
    }
    return channelsByScale;
}
function $dce15e0807f8b267$var$addScaleChannel(channelsByScale, scale, channel) {
    const scaleChannels = channelsByScale.get(scale);
    if (scaleChannels !== undefined) scaleChannels.push(channel);
    else channelsByScale.set(scale, [
        channel
    ]);
}
// Returns the facet groups, and possibly fx and fy channels, associated with
// the top-level facet option {data, x, y}.
function $dce15e0807f8b267$var$maybeTopFacet(facet, options) {
    if (facet == null) return;
    const { x: x, y: y } = facet;
    if (x == null && y == null) return;
    const data = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(facet.data);
    if (data == null) throw new Error("missing facet data");
    const channels = {};
    if (x != null) channels.fx = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
        value: x,
        scale: "fx"
    });
    if (y != null) channels.fy = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
        value: y,
        scale: "fy"
    });
    $dce15e0807f8b267$var$applyScaleTransforms(channels, options);
    const groups = (0, $a6069a9074a3d58d$export$46a87af59f80d026)(data, channels);
    return {
        channels: channels,
        groups: groups,
        data: facet.data
    };
}
// Returns the facet groups, and possibly fx and fy channels, associated with a
// mark, either through top-level faceting or mark-level facet options {fx, fy}.
function $dce15e0807f8b267$var$maybeMarkFacet(mark, topFacetState, options) {
    if (mark.facet === null || mark.facet === "super") return;
    // This mark defines a mark-level facet. TODO There’s some code duplication
    // here with maybeTopFacet that we could reduce.
    const { fx: fx, fy: fy } = mark;
    if (fx != null || fy != null) {
        const data = (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(mark.data ?? fx ?? fy);
        if (data === undefined) throw new Error(`missing facet data in ${mark.ariaLabel}`);
        if (data === null) return; // ignore channel definitions if no data is provided TODO this right?
        const channels = {};
        if (fx != null) channels.fx = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
            value: fx,
            scale: "fx"
        });
        if (fy != null) channels.fy = (0, $6eb5f337b2493843$export$47ab4c33d77e344d)(data, {
            value: fy,
            scale: "fy"
        });
        $dce15e0807f8b267$var$applyScaleTransforms(channels, options);
        return {
            channels: channels,
            groups: (0, $a6069a9074a3d58d$export$46a87af59f80d026)(data, channels)
        };
    }
    // This mark links to a top-level facet, if present.
    if (topFacetState === undefined) return;
    // TODO Can we link the top-level facet channels here?
    const { channels: channels, groups: groups, data: data } = topFacetState;
    if (mark.facet !== "auto" || mark.data === data) return {
        channels: channels,
        groups: groups
    };
    // Warn for the common pitfall of wanting to facet mapped data with the
    // top-level facet option.
    if (data.length > 0 && (groups.size > 1 || groups.size === 1 && channels.fx && channels.fy && [
        ...groups
    ][0][1].size > 1) && (0, $cd9e805a4bbd13f9$export$3131421a7d01b4fb)(mark.data)?.length === data.length) (0, $30c329e934b7a0f1$export$c106dd0671a0fc2d)(`Warning: the ${mark.ariaLabel} mark appears to use faceted data, but isn\u{2019}t faceted. The mark data has the same length as the facet data and the mark facet option is "auto", but the mark data and facet data are distinct. If this mark should be faceted, set the mark facet option to true; otherwise, suppress this warning by setting the mark facet option to false.`);
}
function $dce15e0807f8b267$var$derive(mark, options = {}) {
    return (0, $9dfbc15f77c5eeba$export$aff46cc71669aeb2)({
        ...options,
        x: null,
        y: null
    }, (data, facets, channels, scales, dimensions, context)=>{
        return context.getMarkState(mark);
    });
}
function $dce15e0807f8b267$var$inferTips(marks) {
    const tips = [];
    for (const mark of marks){
        let tipOptions = mark.tip;
        if (tipOptions) {
            if (tipOptions === true) tipOptions = {};
            else if (typeof tipOptions === "string") tipOptions = {
                pointer: tipOptions
            };
            let { pointer: p, preferredAnchor: a } = tipOptions;
            p = /^x$/i.test(p) ? (0, $06868e990a5c2092$export$81f1118cc214bacd) : /^y$/i.test(p) ? (0, $06868e990a5c2092$export$a3d8dca9524ddc38) : (0, $06868e990a5c2092$export$b7fd2c2937973304); // TODO validate?
            tipOptions = p($dce15e0807f8b267$var$derive(mark, tipOptions));
            tipOptions.title = null; // prevent implicit title for primitive data
            if (a === undefined) tipOptions.preferredAnchor = p === (0, $06868e990a5c2092$export$a3d8dca9524ddc38) ? "left" : "bottom";
            const t = (0, $45befbcddbf9afbb$export$5e5b4df997cb5eaa)(mark.data, tipOptions);
            t.facet = mark.facet; // inherit facet settings
            t.facetAnchor = mark.facetAnchor; // inherit facet settings
            tips.push(t);
        }
    }
    return tips;
}
function $dce15e0807f8b267$var$inferAxes(marks, channelsByScale, options) {
    let { projection: projection, x: x = {}, y: y = {}, fx: fx = {}, fy: fy = {}, axis: axis, grid: grid, facet: facet = {}, facet: { axis: facetAxis = axis, grid: facetGrid } = facet, x: { axis: xAxis = axis, grid: xGrid = xAxis === null ? null : grid } = x, y: { axis: yAxis = axis, grid: yGrid = yAxis === null ? null : grid } = y, fx: { axis: fxAxis = facetAxis, grid: fxGrid = fxAxis === null ? null : facetGrid } = fx, fy: { axis: fyAxis = facetAxis, grid: fyGrid = fyAxis === null ? null : facetGrid } = fy } = options;
    // Disable axes if the corresponding scale is not present.
    if (projection || !(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(x) && !$dce15e0807f8b267$var$hasPositionChannel("x", marks)) xAxis = xGrid = null;
    if (projection || !(0, $cd9e805a4bbd13f9$export$1fb8003448468be0)(y) && !$dce15e0807f8b267$var$hasPositionChannel("y", marks)) yAxis = yGrid = null;
    if (!channelsByScale.has("fx")) fxAxis = fxGrid = null;
    if (!channelsByScale.has("fy")) fyAxis = fyGrid = null;
    // Resolve the default implicit axes by checking for explicit ones.
    if (xAxis === undefined) xAxis = !$dce15e0807f8b267$var$hasAxis(marks, "x");
    if (yAxis === undefined) yAxis = !$dce15e0807f8b267$var$hasAxis(marks, "y");
    if (fxAxis === undefined) fxAxis = !$dce15e0807f8b267$var$hasAxis(marks, "fx");
    if (fyAxis === undefined) fyAxis = !$dce15e0807f8b267$var$hasAxis(marks, "fy");
    // Resolve the default orientation of axes.
    if (xAxis === true) xAxis = "bottom";
    if (yAxis === true) yAxis = "left";
    if (fxAxis === true) fxAxis = xAxis === "top" || xAxis === null ? "bottom" : "top";
    if (fyAxis === true) fyAxis = yAxis === "right" || yAxis === null ? "left" : "right";
    const axes = [];
    $dce15e0807f8b267$var$maybeGrid(axes, fyGrid, (0, $fcb78e8696b500a3$export$7093722adfac6b64), fy);
    $dce15e0807f8b267$var$maybeAxis(axes, fyAxis, (0, $fcb78e8696b500a3$export$3cb762475a490c3b), "right", "left", facet, fy);
    $dce15e0807f8b267$var$maybeGrid(axes, fxGrid, (0, $fcb78e8696b500a3$export$8d672a2bd8b3cb8b), fx);
    $dce15e0807f8b267$var$maybeAxis(axes, fxAxis, (0, $fcb78e8696b500a3$export$cf6d8c730042fe7f), "top", "bottom", facet, fx);
    $dce15e0807f8b267$var$maybeGrid(axes, yGrid, (0, $fcb78e8696b500a3$export$7510dfed5fcfcd8f), y);
    $dce15e0807f8b267$var$maybeAxis(axes, yAxis, (0, $fcb78e8696b500a3$export$e4a0de62e0e52fb4), "left", "right", options, y);
    $dce15e0807f8b267$var$maybeGrid(axes, xGrid, (0, $fcb78e8696b500a3$export$6ac963799f18e4c), x);
    $dce15e0807f8b267$var$maybeAxis(axes, xAxis, (0, $fcb78e8696b500a3$export$5bc1a9741b148b9f), "bottom", "top", options, x);
    return axes;
}
function $dce15e0807f8b267$var$maybeAxis(axes, axis, axisType, primary, secondary, defaults, options) {
    if (!axis) return;
    const both = $dce15e0807f8b267$var$isBoth(axis);
    options = $dce15e0807f8b267$var$axisOptions(both ? primary : axis, defaults, options);
    const { line: line } = options;
    if ((axisType === (0, $fcb78e8696b500a3$export$e4a0de62e0e52fb4) || axisType === (0, $fcb78e8696b500a3$export$5bc1a9741b148b9f)) && line && !(0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(line)) axes.push((0, $b946fb4c8a04d9d8$export$2cef06c20297c17d)($dce15e0807f8b267$var$lineOptions(options)));
    axes.push(axisType(options));
    if (both) axes.push(axisType({
        ...options,
        anchor: secondary,
        label: null
    }));
}
function $dce15e0807f8b267$var$maybeGrid(axes, grid, gridType, options) {
    if (!grid || (0, $cd9e805a4bbd13f9$export$e56af863d5645d5f)(grid)) return;
    axes.push(gridType($dce15e0807f8b267$var$gridOptions(grid, options)));
}
function $dce15e0807f8b267$var$isBoth(value) {
    return /^\s*both\s*$/i.test(value);
}
function $dce15e0807f8b267$var$axisOptions(anchor, defaults, { line: line = defaults.line, ticks: ticks, tickSize: tickSize, tickSpacing: tickSpacing, tickPadding: tickPadding, tickFormat: tickFormat, tickRotate: tickRotate, fontVariant: fontVariant, ariaLabel: ariaLabel, ariaDescription: ariaDescription, label: label = defaults.label, labelAnchor: labelAnchor, labelArrow: labelArrow = defaults.labelArrow, labelOffset: labelOffset }) {
    return {
        anchor: anchor,
        line: line,
        ticks: ticks,
        tickSize: tickSize,
        tickSpacing: tickSpacing,
        tickPadding: tickPadding,
        tickFormat: tickFormat,
        tickRotate: tickRotate,
        fontVariant: fontVariant,
        ariaLabel: ariaLabel,
        ariaDescription: ariaDescription,
        label: label,
        labelAnchor: labelAnchor,
        labelArrow: labelArrow,
        labelOffset: labelOffset
    };
}
function $dce15e0807f8b267$var$lineOptions(options) {
    const { anchor: anchor, line: line } = options;
    return {
        anchor: anchor,
        facetAnchor: anchor + "-empty",
        stroke: line === true ? undefined : line
    };
}
function $dce15e0807f8b267$var$gridOptions(grid, { stroke: stroke = (0, $cd9e805a4bbd13f9$export$e82f763eaa28f6fe)(grid) ? grid : undefined, ticks: ticks = $dce15e0807f8b267$var$isGridTicks(grid) ? grid : undefined, tickSpacing: tickSpacing, ariaLabel: ariaLabel, ariaDescription: ariaDescription }) {
    return {
        stroke: stroke,
        ticks: ticks,
        tickSpacing: tickSpacing,
        ariaLabel: ariaLabel,
        ariaDescription: ariaDescription
    };
}
function $dce15e0807f8b267$var$isGridTicks(grid) {
    switch(typeof grid){
        case "number":
            return true;
        case "string":
            return !(0, $cd9e805a4bbd13f9$export$e82f763eaa28f6fe)(grid);
    }
    return (0, $cd9e805a4bbd13f9$export$9652023d9040757)(grid) || typeof grid?.range === "function";
}
// Is there an explicit axis already present? TODO We probably want a more
// explicit test than looking for the ARIA label, but it does afford some
// flexibility in axis implementation which is nice.
function $dce15e0807f8b267$var$hasAxis(marks, k) {
    const prefix = `${k}-axis `;
    return marks.some((m)=>m.ariaLabel?.startsWith(prefix));
}
function $dce15e0807f8b267$var$hasPositionChannel(k, marks) {
    for (const mark of marks)for(const key in mark.channels){
        const { scale: scale } = mark.channels[key];
        if (scale === k || scale === "projection") return true;
    }
    return false;
}
function $dce15e0807f8b267$var$inheritScaleLabels(newScales, scales) {
    for(const key in newScales){
        const newScale = newScales[key];
        const scale = scales[key];
        if (newScale.label === undefined && scale) newScale.label = scale.label;
    }
    return newScales;
}
// This differs from the other outerDimensions in that it accounts for rounding
// and outer padding in the facet scales; we want the frame to align exactly
// with the actual range, not the desired range.
function $dce15e0807f8b267$var$actualDimensions({ fx: fx, fy: fy }, dimensions) {
    const { marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, width: width, height: height } = (0, $d2c16f7a6010a221$export$5d21a1ac38f7e01a)(dimensions);
    const fxr = fx && $dce15e0807f8b267$var$outerRange(fx);
    const fyr = fy && $dce15e0807f8b267$var$outerRange(fy);
    return {
        marginTop: fy ? fyr[0] : marginTop,
        marginRight: fx ? width - fxr[1] : marginRight,
        marginBottom: fy ? height - fyr[1] : marginBottom,
        marginLeft: fx ? fxr[0] : marginLeft,
        // Some marks, namely the x- and y-axis labels, want to know what the
        // desired (rather than actual) margins are for positioning.
        inset: {
            marginTop: dimensions.marginTop,
            marginRight: dimensions.marginRight,
            marginBottom: dimensions.marginBottom,
            marginLeft: dimensions.marginLeft
        },
        width: width,
        height: height
    };
}
function $dce15e0807f8b267$var$outerRange(scale) {
    const domain = scale.domain();
    let x1 = scale(domain[0]);
    let x2 = scale(domain[domain.length - 1]);
    if (x2 < x1) [x1, x2] = [
        x2,
        x1
    ];
    return [
        x1,
        x2 + scale.bandwidth()
    ];
}


var $6a7397d0745d4f70$exports = {};
let $6a7397d0745d4f70$var$a = {
    "name": "exp_warned_01",
    "method": "manual",
    "recording": "QmbefrD7SVCt77eDyQg86zsU6HdEFwF5zYcxpqKcuRuUN8",
    "episodes": [
        {
            "t": [
                7.510016,
                7.53152
            ],
            "f": [
                64208.984375,
                80810.546875
            ],
            "l": [
                1877504,
                1882880
            ]
        },
        {
            "t": [
                7.996416,
                8.066048
            ],
            "f": [
                25376,
                31232
            ],
            "l": [
                1999104,
                2016512
            ]
        },
        {
            "t": [
                8.124416,
                8.139776
            ],
            "f": [
                25146.484375,
                28320.3125
            ],
            "l": [
                2031104,
                2034944
            ]
        },
        {
            "t": [
                10.820608,
                10.845184
            ],
            "f": [
                62988.28125,
                77636.71875
            ],
            "l": [
                2705152,
                2711296
            ]
        },
        {
            "t": [
                31.960064,
                31.981568
            ],
            "f": [
                59814.453125,
                70312.5
            ],
            "l": [
                7990016,
                7995392
            ]
        },
        {
            "t": [
                32.335872,
                32.350208
            ],
            "f": [
                73242.1875,
                78369.140625
            ],
            "l": [
                8083968,
                8087552
            ]
        },
        {
            "t": [
                32.4096,
                32.422912
            ],
            "f": [
                88867.1875,
                92041.015625
            ],
            "l": [
                8102400,
                8105728
            ]
        },
        {
            "t": [
                33.062912,
                33.077248
            ],
            "f": [
                61035.15625,
                63720.703125
            ],
            "l": [
                8265728,
                8269312
            ]
        },
        {
            "t": [
                36.640768,
                36.672512
            ],
            "f": [
                71044.921875,
                95458.984375
            ],
            "l": [
                9160192,
                9168128
            ]
        },
        {
            "t": [
                36.784128,
                36.85888
            ],
            "f": [
                58105.46875,
                67626.953125
            ],
            "l": [
                9196032,
                9214720
            ]
        },
        {
            "t": [
                36.969472,
                37.185536
            ],
            "f": [
                58105.46875,
                93261.71875
            ],
            "l": [
                9242368,
                9296384
            ]
        },
        {
            "t": [
                39.566336,
                39.657472
            ],
            "f": [
                58593.75,
                102783.203125
            ],
            "l": [
                9891584,
                9914368
            ]
        },
        {
            "t": [
                50.712576,
                50.736128
            ],
            "f": [
                72021.484375,
                83251.953125
            ],
            "l": [
                12678144,
                12684032
            ]
        },
        {
            "t": [
                51.25632,
                51.270656
            ],
            "f": [
                61279.296875,
                64453.125
            ],
            "l": [
                12814080,
                12817664
            ]
        },
        {
            "t": [
                51.531776,
                51.547136
            ],
            "f": [
                68847.65625,
                73242.1875
            ],
            "l": [
                12882944,
                12886784
            ]
        },
        {
            "t": [
                51.620864,
                51.633152
            ],
            "f": [
                30273.4375,
                34423.828125
            ],
            "l": [
                12905216,
                12908288
            ]
        },
        {
            "t": [
                51.944448,
                51.954688
            ],
            "f": [
                64697.265625,
                70800.78125
            ],
            "l": [
                12986112,
                12988672
            ]
        },
        {
            "t": [
                52.345856,
                52.371456
            ],
            "f": [
                62255.859375,
                97412.109375
            ],
            "l": [
                13086464,
                13092864
            ]
        },
        {
            "t": [
                52.545536,
                52.583424
            ],
            "f": [
                58105.46875,
                96679.6875
            ],
            "l": [
                13136384,
                13145856
            ]
        },
        {
            "t": [
                52.714496,
                52.750336
            ],
            "f": [
                26123.046875,
                34423.828125
            ],
            "l": [
                13178624,
                13187584
            ]
        },
        {
            "t": [
                53.049344,
                53.067776
            ],
            "f": [
                63964.84375,
                73730.46875
            ],
            "l": [
                13262336,
                13266944
            ]
        },
        {
            "t": [
                53.100544,
                53.136384
            ],
            "f": [
                30517.578125,
                75195.3125
            ],
            "l": [
                13275136,
                13284096
            ]
        },
        {
            "t": [
                53.245952,
                53.276672
            ],
            "f": [
                43457.03125,
                103515.625
            ],
            "l": [
                13311488,
                13319168
            ]
        },
        {
            "t": [
                61.846528,
                62.000128
            ],
            "f": [
                57373.046875,
                68603.515625
            ],
            "l": [
                15461632,
                15500032
            ]
        },
        {
            "t": [
                67.334144,
                67.386368
            ],
            "f": [
                59536,
                91012
            ],
            "l": [
                16833536,
                16846592
            ]
        },
        {
            "t": [
                70.280192,
                70.316032
            ],
            "f": [
                41236,
                72468
            ],
            "l": [
                17570048,
                17579008
            ]
        },
        {
            "t": [
                70.663168,
                70.688768
            ],
            "f": [
                37088,
                48556
            ],
            "l": [
                17665792,
                17672192
            ]
        },
        {
            "t": [
                71.256064,
                71.269376
            ],
            "f": [
                56884.765625,
                60791.015625
            ],
            "l": [
                17814016,
                17817344
            ]
        },
        {
            "t": [
                73.817088,
                73.873408
            ],
            "f": [
                59570.3125,
                68115.234375
            ],
            "l": [
                18454272,
                18468352
            ]
        },
        {
            "t": [
                73.977856,
                74.049536
            ],
            "f": [
                60512,
                70028
            ],
            "l": [
                18494464,
                18512384
            ]
        },
        {
            "t": [
                74.89024,
                74.91584
            ],
            "f": [
                61244,
                70516
            ],
            "l": [
                18722560,
                18728960
            ]
        },
        {
            "t": [
                83.853312,
                83.900416
            ],
            "f": [
                60546.875,
                92529.296875
            ],
            "l": [
                20963328,
                20975104
            ]
        },
        {
            "t": [
                85.960704,
                86.014976
            ],
            "f": [
                59082.03125,
                81542.96875
            ],
            "l": [
                21490176,
                21503744
            ]
        },
        {
            "t": [
                90.057728,
                90.097664
            ],
            "f": [
                46875,
                72753.90625
            ],
            "l": [
                22514432,
                22524416
            ]
        },
        {
            "t": [
                90.676224,
                90.69568
            ],
            "f": [
                36865.234375,
                44677.734375
            ],
            "l": [
                22669056,
                22673920
            ]
        },
        {
            "t": [
                90.753024,
                90.7776
            ],
            "f": [
                55664.0625,
                93017.578125
            ],
            "l": [
                22688256,
                22694400
            ]
        },
        {
            "t": [
                92.422144,
                92.435456
            ],
            "f": [
                91308.59375,
                96923.828125
            ],
            "l": [
                23105536,
                23108864
            ]
        },
        {
            "t": [
                93.310976,
                93.329408
            ],
            "f": [
                84716.796875,
                93261.71875
            ],
            "l": [
                23327744,
                23332352
            ]
        },
        {
            "t": [
                93.831168,
                93.843456
            ],
            "f": [
                66894.53125,
                73242.1875
            ],
            "l": [
                23457792,
                23460864
            ]
        },
        {
            "t": [
                95.802368,
                95.840256
            ],
            "f": [
                62011.71875,
                79833.984375
            ],
            "l": [
                23950592,
                23960064
            ]
        },
        {
            "t": [
                102.011904,
                102.022144
            ],
            "f": [
                61767.578125,
                67382.8125
            ],
            "l": [
                25502976,
                25505536
            ]
        },
        {
            "t": [
                106.397696,
                106.431488
            ],
            "f": [
                30761.71875,
                40527.34375
            ],
            "l": [
                26599424,
                26607872
            ]
        },
        {
            "t": [
                109.093888,
                109.11744
            ],
            "f": [
                88378.90625,
                101074.21875
            ],
            "l": [
                27273472,
                27279360
            ]
        },
        {
            "t": [
                109.54752,
                109.600768
            ],
            "f": [
                59570.3125,
                86669.921875
            ],
            "l": [
                27386880,
                27400192
            ]
        },
        {
            "t": [
                110.635008,
                110.696448
            ],
            "f": [
                61732,
                79056
            ],
            "l": [
                27658752,
                27674112
            ]
        },
        {
            "t": [
                113.206272,
                113.221632
            ],
            "f": [
                64697.265625,
                67382.8125
            ],
            "l": [
                28301568,
                28305408
            ]
        },
        {
            "t": [
                113.547264,
                113.557504
            ],
            "f": [
                90087.890625,
                92773.4375
            ],
            "l": [
                28386816,
                28389376
            ]
        },
        {
            "t": [
                128.638976,
                128.654336
            ],
            "f": [
                67382.8125,
                70800.78125
            ],
            "l": [
                32159744,
                32163584
            ]
        },
        {
            "t": [
                128.823296,
                128.894976
            ],
            "f": [
                25146.484375,
                35400.390625
            ],
            "l": [
                32205824,
                32223744
            ]
        },
        {
            "t": [
                141.099008,
                141.134848
            ],
            "f": [
                58837.890625,
                79345.703125
            ],
            "l": [
                35274752,
                35283712
            ]
        },
        {
            "t": [
                141.80352,
                141.831168
            ],
            "f": [
                59326.171875,
                65673.828125
            ],
            "l": [
                35450880,
                35457792
            ]
        },
        {
            "t": [
                144.861184,
                144.884736
            ],
            "f": [
                62255.859375,
                86669.921875
            ],
            "l": [
                36215296,
                36221184
            ]
        },
        {
            "t": [
                145.396736,
                145.410048
            ],
            "f": [
                69335.9375,
                77148.4375
            ],
            "l": [
                36349184,
                36352512
            ]
        },
        {
            "t": [
                145.69984,
                145.72032
            ],
            "f": [
                74462.890625,
                85693.359375
            ],
            "l": [
                36424960,
                36430080
            ]
        },
        {
            "t": [
                146.01216,
                146.05312
            ],
            "f": [
                60058.59375,
                92529.296875
            ],
            "l": [
                36503040,
                36513280
            ]
        },
        {
            "t": [
                146.177024,
                146.192384
            ],
            "f": [
                59082.03125,
                62011.71875
            ],
            "l": [
                36544256,
                36548096
            ]
        },
        {
            "t": [
                148.913152,
                148.95616
            ],
            "f": [
                48828.125,
                85205.078125
            ],
            "l": [
                37228288,
                37239040
            ]
        },
        {
            "t": [
                149.354496,
                149.379072
            ],
            "f": [
                36621.09375,
                39062.5
            ],
            "l": [
                37338624,
                37344768
            ]
        },
        {
            "t": [
                149.420032,
                149.453824
            ],
            "f": [
                60546.875,
                94726.5625
            ],
            "l": [
                37355008,
                37363456
            ]
        },
        {
            "t": [
                151.02976,
                151.052288
            ],
            "f": [
                56884.765625,
                84716.796875
            ],
            "l": [
                37757440,
                37763072
            ]
        },
        {
            "t": [
                151.074816,
                151.117824
            ],
            "f": [
                90332.03125,
                110595.703125
            ],
            "l": [
                37768704,
                37779456
            ]
        },
        {
            "t": [
                151.665664,
                151.703552
            ],
            "f": [
                74951.171875,
                108642.578125
            ],
            "l": [
                37916416,
                37925888
            ]
        },
        {
            "t": [
                151.948288,
                152.208384
            ],
            "f": [
                44433.59375,
                97656.25
            ],
            "l": [
                37987072,
                38052096
            ]
        },
        {
            "t": [
                154.0608,
                154.082304
            ],
            "f": [
                85205.078125,
                91552.734375
            ],
            "l": [
                38515200,
                38520576
            ]
        },
        {
            "t": [
                154.109952,
                154.123264
            ],
            "f": [
                99365.234375,
                106445.3125
            ],
            "l": [
                38527488,
                38530816
            ]
        },
        {
            "t": [
                159.089664,
                159.128576
            ],
            "f": [
                67138.671875,
                76416.015625
            ],
            "l": [
                39772416,
                39782144
            ]
        },
        {
            "t": [
                167.515136,
                167.545856
            ],
            "f": [
                60791.015625,
                81787.109375
            ],
            "l": [
                41878784,
                41886464
            ]
        },
        {
            "t": [
                168.208384,
                168.223744
            ],
            "f": [
                69824.21875,
                73730.46875
            ],
            "l": [
                42052096,
                42055936
            ]
        },
        {
            "t": [
                169.382912,
                169.413632
            ],
            "f": [
                58837.890625,
                71777.34375
            ],
            "l": [
                42345728,
                42353408
            ]
        },
        {
            "t": [
                171.603968,
                171.6736
            ],
            "f": [
                58837.890625,
                102050.78125
            ],
            "l": [
                42900992,
                42918400
            ]
        },
        {
            "t": [
                172.428288,
                172.480512
            ],
            "f": [
                58837.890625,
                88134.765625
            ],
            "l": [
                43107072,
                43120128
            ]
        },
        {
            "t": [
                174.35648,
                174.374912
            ],
            "f": [
                34179.6875,
                39794.921875
            ],
            "l": [
                43589120,
                43593728
            ]
        },
        {
            "t": [
                174.759936,
                174.782464
            ],
            "f": [
                58349.609375,
                68115.234375
            ],
            "l": [
                43689984,
                43695616
            ]
        },
        {
            "t": [
                174.910464,
                174.934016
            ],
            "f": [
                68564,
                70760
            ],
            "l": [
                43727616,
                43733504
            ]
        },
        {
            "t": [
                177.089536,
                177.108992
            ],
            "f": [
                42236.328125,
                48583.984375
            ],
            "l": [
                44272384,
                44277248
            ]
        },
        {
            "t": [
                177.821696,
                177.851392
            ],
            "f": [
                55419.921875,
                76660.15625
            ],
            "l": [
                44455424,
                44462848
            ]
        },
        {
            "t": [
                178.236416,
                178.265088
            ],
            "f": [
                64941.40625,
                112304.6875
            ],
            "l": [
                44559104,
                44566272
            ]
        },
        {
            "t": [
                178.599936,
                178.632704
            ],
            "f": [
                31250,
                47607.421875
            ],
            "l": [
                44649984,
                44658176
            ]
        },
        {
            "t": [
                178.696192,
                178.7136
            ],
            "f": [
                111083.984375,
                114013.671875
            ],
            "l": [
                44674048,
                44678400
            ]
        },
        {
            "t": [
                179.027968,
                179.042304
            ],
            "f": [
                55419.921875,
                59326.171875
            ],
            "l": [
                44756992,
                44760576
            ]
        },
        {
            "t": [
                179.175424,
                179.18464
            ],
            "f": [
                58837.890625,
                62255.859375
            ],
            "l": [
                44793856,
                44796160
            ]
        },
        {
            "t": [
                187.900928,
                187.912192
            ],
            "f": [
                59814.453125,
                70556.640625
            ],
            "l": [
                46975232,
                46978048
            ]
        },
        {
            "t": [
                192.100352,
                192.1536
            ],
            "f": [
                59326.171875,
                85205.078125
            ],
            "l": [
                48025088,
                48038400
            ]
        },
        {
            "t": [
                192.411648,
                192.453632
            ],
            "f": [
                52734.375,
                93994.140625
            ],
            "l": [
                48102912,
                48113408
            ]
        },
        {
            "t": [
                192.702464,
                192.714752
            ],
            "f": [
                61279.296875,
                63476.5625
            ],
            "l": [
                48175616,
                48178688
            ]
        },
        {
            "t": [
                196.139008,
                196.163584
            ],
            "f": [
                30761.71875,
                32958.984375
            ],
            "l": [
                49034752,
                49040896
            ]
        },
        {
            "t": [
                203.961344,
                203.987968
            ],
            "f": [
                61035.15625,
                93750
            ],
            "l": [
                50990336,
                50996992
            ]
        },
        {
            "t": [
                209.072128,
                209.093632
            ],
            "f": [
                49804.6875,
                69335.9375
            ],
            "l": [
                52268032,
                52273408
            ]
        },
        {
            "t": [
                211.032064,
                211.049472
            ],
            "f": [
                36865.234375,
                54199.21875
            ],
            "l": [
                52758016,
                52762368
            ]
        },
        {
            "t": [
                213.44768,
                213.487616
            ],
            "f": [
                57128.90625,
                69580.078125
            ],
            "l": [
                53361920,
                53371904
            ]
        },
        {
            "t": [
                213.576704,
                213.61664
            ],
            "f": [
                54443.359375,
                72509.765625
            ],
            "l": [
                53394176,
                53404160
            ]
        },
        {
            "t": [
                215.088128,
                215.141376
            ],
            "f": [
                64941.40625,
                82519.53125
            ],
            "l": [
                53772032,
                53785344
            ]
        },
        {
            "t": [
                215.287808,
                215.314432
            ],
            "f": [
                56152.34375,
                61523.4375
            ],
            "l": [
                53821952,
                53828608
            ]
        },
        {
            "t": [
                216.02304,
                216.0384
            ],
            "f": [
                61523.4375,
                83496.09375
            ],
            "l": [
                54005760,
                54009600
            ]
        },
        {
            "t": [
                217.663488,
                217.673728
            ],
            "f": [
                63476.5625,
                67626.953125
            ],
            "l": [
                54415872,
                54418432
            ]
        },
        {
            "t": [
                220.164096,
                220.174336
            ],
            "f": [
                74707.03125,
                78369.140625
            ],
            "l": [
                55041024,
                55043584
            ]
        },
        {
            "t": [
                220.909568,
                220.952576
            ],
            "f": [
                57617.1875,
                87402.34375
            ],
            "l": [
                55227392,
                55238144
            ]
        },
        {
            "t": [
                224.093184,
                224.200704
            ],
            "f": [
                59082.03125,
                96435.546875
            ],
            "l": [
                56023296,
                56050176
            ]
        },
        {
            "t": [
                225.672192,
                225.753088
            ],
            "f": [
                61035.15625,
                90087.890625
            ],
            "l": [
                56418048,
                56438272
            ]
        },
        {
            "t": [
                226.051072,
                226.112512
            ],
            "f": [
                46386.71875,
                67138.671875
            ],
            "l": [
                56512768,
                56528128
            ]
        },
        {
            "t": [
                226.22208,
                226.248704
            ],
            "f": [
                55175.78125,
                67138.671875
            ],
            "l": [
                56555520,
                56562176
            ]
        },
        {
            "t": [
                226.825216,
                226.90304
            ],
            "f": [
                56640.625,
                102050.78125
            ],
            "l": [
                56706304,
                56725760
            ]
        },
        {
            "t": [
                227.16416,
                227.182592
            ],
            "f": [
                55175.78125,
                62744.140625
            ],
            "l": [
                56791040,
                56795648
            ]
        },
        {
            "t": [
                249.298944,
                249.411584
            ],
            "f": [
                62500,
                69091.796875
            ],
            "l": [
                62324736,
                62352896
            ]
        },
        {
            "t": [
                249.66656,
                249.705472
            ],
            "f": [
                58105.46875,
                62744.140625
            ],
            "l": [
                62416640,
                62426368
            ]
        },
        {
            "t": [
                274.624512,
                274.676736
            ],
            "f": [
                68359.375,
                74218.75
            ],
            "l": [
                68656128,
                68669184
            ]
        },
        {
            "t": [
                290.531328,
                290.610176
            ],
            "f": [
                59570.3125,
                70068.359375
            ],
            "l": [
                72632832,
                72652544
            ]
        },
        {
            "t": [
                292.78208,
                292.81792
            ],
            "f": [
                52490.234375,
                69824.21875
            ],
            "l": [
                73195520,
                73204480
            ]
        },
        {
            "t": [
                295.225344,
                295.26528
            ],
            "f": [
                58349.609375,
                84472.65625
            ],
            "l": [
                73806336,
                73816320
            ]
        },
        {
            "t": [
                296.139776,
                296.17152
            ],
            "f": [
                52734.375,
                70312.5
            ],
            "l": [
                74034944,
                74042880
            ]
        },
        {
            "t": [
                298.842112,
                298.939392
            ],
            "f": [
                48339.84375,
                82763.671875
            ],
            "l": [
                74710528,
                74734848
            ]
        },
        {
            "t": [
                299.092992,
                299.1616
            ],
            "f": [
                55175.78125,
                62255.859375
            ],
            "l": [
                74773248,
                74790400
            ]
        },
        {
            "t": [
                299.501568,
                299.570176
            ],
            "f": [
                51757.8125,
                87158.203125
            ],
            "l": [
                74875392,
                74892544
            ]
        },
        {
            "t": [
                301.473792,
                301.530112
            ],
            "f": [
                52246.09375,
                80078.125
            ],
            "l": [
                75368448,
                75382528
            ]
        },
        {
            "t": [
                301.807616,
                301.960192
            ],
            "f": [
                49316.40625,
                81054.6875
            ],
            "l": [
                75451904,
                75490048
            ]
        },
        {
            "t": [
                302.294016,
                302.367744
            ],
            "f": [
                50781.25,
                55664.0625
            ],
            "l": [
                75573504,
                75591936
            ]
        },
        {
            "t": [
                302.752768,
                302.870528
            ],
            "f": [
                52246.09375,
                86669.921875
            ],
            "l": [
                75688192,
                75717632
            ]
        },
        {
            "t": [
                310.699008,
                310.71744
            ],
            "f": [
                67138.671875,
                70556.640625
            ],
            "l": [
                77674752,
                77679360
            ]
        },
        {
            "t": [
                313.432064,
                313.495552
            ],
            "f": [
                52704,
                55632
            ],
            "l": [
                78358016,
                78373888
            ]
        },
        {
            "t": [
                313.596928,
                313.952256
            ],
            "f": [
                30761.71875,
                38330.078125
            ],
            "l": [
                78399232,
                78488064
            ]
        },
        {
            "t": [
                314.254336,
                315.507712
            ],
            "f": [
                27832.03125,
                32958.984375
            ],
            "l": [
                78563584,
                78876928
            ]
        },
        {
            "t": [
                315.872256,
                317.308928
            ],
            "f": [
                25864,
                28792
            ],
            "l": [
                78968064,
                79327232
            ]
        },
        {
            "t": [
                318.442496,
                319.753216
            ],
            "f": [
                22949.21875,
                30029.296875
            ],
            "l": [
                79610624,
                79938304
            ]
        },
        {
            "t": [
                321.28,
                322.38592
            ],
            "f": [
                23193.359375,
                29296.875
            ],
            "l": [
                80320000,
                80596480
            ]
        },
        {
            "t": [
                324.015104,
                325.410816
            ],
            "f": [
                24400,
                27328
            ],
            "l": [
                81003776,
                81352704
            ]
        },
        {
            "t": [
                328.199168,
                329.086976
            ],
            "f": [
                22705.078125,
                28564.453125
            ],
            "l": [
                82049792,
                82271744
            ]
        },
        {
            "t": [
                330.056704,
                330.790912
            ],
            "f": [
                24156,
                25620
            ],
            "l": [
                82514176,
                82697728
            ]
        },
        {
            "t": [
                335.373312,
                336.110592
            ],
            "f": [
                23424,
                27572
            ],
            "l": [
                83843328,
                84027648
            ]
        },
        {
            "t": [
                348.278784,
                349.070336
            ],
            "f": [
                22216.796875,
                27832.03125
            ],
            "l": [
                87069696,
                87267584
            ]
        },
        {
            "t": [
                354.705408,
                354.753536
            ],
            "f": [
                23193.359375,
                24902.34375
            ],
            "l": [
                88676352,
                88688384
            ]
        },
        {
            "t": [
                363.109376,
                363.867136
            ],
            "f": [
                22705.078125,
                29052.734375
            ],
            "l": [
                90777344,
                90966784
            ]
        },
        {
            "t": [
                368.400384,
                368.913408
            ],
            "f": [
                23668,
                26352
            ],
            "l": [
                92100096,
                92228352
            ]
        },
        {
            "t": [
                377.628672,
                377.644032
            ],
            "f": [
                59326.171875,
                62255.859375
            ],
            "l": [
                94407168,
                94411008
            ]
        },
        {
            "t": [
                377.69728,
                377.730048
            ],
            "f": [
                60058.59375,
                62744.140625
            ],
            "l": [
                94424320,
                94432512
            ]
        },
        {
            "t": [
                380.3136,
                381.68064
            ],
            "f": [
                22949.21875,
                29541.015625
            ],
            "l": [
                95078400,
                95420160
            ]
        },
        {
            "t": [
                385.916928,
                385.953792
            ],
            "f": [
                20019.53125,
                21240.234375
            ],
            "l": [
                96479232,
                96488448
            ]
        },
        {
            "t": [
                388.914176,
                388.938752
            ],
            "f": [
                20507.8125,
                21972.65625
            ],
            "l": [
                97228544,
                97234688
            ]
        },
        {
            "t": [
                390.354944,
                390.402048
            ],
            "f": [
                20263.671875,
                22216.796875
            ],
            "l": [
                97588736,
                97600512
            ]
        },
        {
            "t": [
                393.44128,
                395.088896
            ],
            "f": [
                24644,
                30256
            ],
            "l": [
                98360320,
                98772224
            ]
        },
        {
            "t": [
                395.541504,
                396.742656
            ],
            "f": [
                23668,
                25864
            ],
            "l": [
                98885376,
                99185664
            ]
        },
        {
            "t": [
                396.929024,
                397.976576
            ],
            "f": [
                24400,
                27328
            ],
            "l": [
                99232256,
                99494144
            ]
        },
        {
            "t": [
                398.196736,
                398.347264
            ],
            "f": [
                23912,
                24888
            ],
            "l": [
                99549184,
                99586816
            ]
        },
        {
            "t": [
                399.909888,
                400.377856
            ],
            "f": [
                21972.65625,
                27587.890625
            ],
            "l": [
                99977472,
                100094464
            ]
        },
        {
            "t": [
                402.911232,
                403.093504
            ],
            "f": [
                20996.09375,
                22949.21875
            ],
            "l": [
                100727808,
                100773376
            ]
        },
        {
            "t": [
                404.383744,
                404.488192
            ],
            "f": [
                21240.234375,
                23925.78125
            ],
            "l": [
                101095936,
                101122048
            ]
        },
        {
            "t": [
                405.782528,
                405.848064
            ],
            "f": [
                21728.515625,
                22949.21875
            ],
            "l": [
                101445632,
                101462016
            ]
        },
        {
            "t": [
                406.977536,
                407.037952
            ],
            "f": [
                21240.234375,
                22705.078125
            ],
            "l": [
                101744384,
                101759488
            ]
        },
        {
            "t": [
                407.863296,
                407.967744
            ],
            "f": [
                21228,
                22448
            ],
            "l": [
                101965824,
                101991936
            ]
        },
        {
            "t": [
                408.763392,
                408.877056
            ],
            "f": [
                21960,
                22692
            ],
            "l": [
                102190848,
                102219264
            ]
        },
        {
            "t": [
                409.6,
                409.71264
            ],
            "f": [
                21240.234375,
                23193.359375
            ],
            "l": [
                102400000,
                102428160
            ]
        },
        {
            "t": [
                410.466304,
                410.55744
            ],
            "f": [
                21240.234375,
                22460.9375
            ],
            "l": [
                102616576,
                102639360
            ]
        },
        {
            "t": [
                411.399168,
                411.595776
            ],
            "f": [
                21240.234375,
                22705.078125
            ],
            "l": [
                102849792,
                102898944
            ]
        },
        {
            "t": [
                412.258304,
                412.351488
            ],
            "f": [
                20507.8125,
                22705.078125
            ],
            "l": [
                103064576,
                103087872
            ]
        },
        {
            "t": [
                412.985344,
                413.182976
            ],
            "f": [
                20996.09375,
                22705.078125
            ],
            "l": [
                103246336,
                103295744
            ]
        },
        {
            "t": [
                413.830144,
                414.012416
            ],
            "f": [
                21240.234375,
                22705.078125
            ],
            "l": [
                103457536,
                103503104
            ]
        },
        {
            "t": [
                414.657536,
                414.887936
            ],
            "f": [
                21240.234375,
                22949.21875
            ],
            "l": [
                103664384,
                103721984
            ]
        },
        {
            "t": [
                415.547392,
                415.693824
            ],
            "f": [
                21240.234375,
                23437.5
            ],
            "l": [
                103886848,
                103923456
            ]
        },
        {
            "t": [
                435.3792,
                436.119552
            ],
            "f": [
                23424,
                29524
            ],
            "l": [
                108844800,
                109029888
            ]
        },
        {
            "t": [
                440.7296,
                441.322496
            ],
            "f": [
                23668,
                27328
            ],
            "l": [
                110182400,
                110330624
            ]
        },
        {
            "t": [
                459.196416,
                460.638208
            ],
            "f": [
                24156,
                31232
            ],
            "l": [
                114799104,
                115159552
            ]
        },
        {
            "t": [
                468.726784,
                469.495808
            ],
            "f": [
                23437.5,
                30029.296875
            ],
            "l": [
                117181696,
                117373952
            ]
        },
        {
            "t": [
                474.140672,
                476.035072
            ],
            "f": [
                24888,
                32208
            ],
            "l": [
                118535168,
                119008768
            ]
        },
        {
            "t": [
                476.186624,
                477.462528
            ],
            "f": [
                25132,
                26596
            ],
            "l": [
                119046656,
                119365632
            ]
        },
        {
            "t": [
                477.63968,
                479.031296
            ],
            "f": [
                24400,
                25620
            ],
            "l": [
                119409920,
                119757824
            ]
        },
        {
            "t": [
                479.21152,
                479.940608
            ],
            "f": [
                24156,
                25132
            ],
            "l": [
                119802880,
                119985152
            ]
        },
        {
            "t": [
                482.038784,
                482.526208
            ],
            "f": [
                23668,
                25132
            ],
            "l": [
                120509696,
                120631552
            ]
        },
        {
            "t": [
                483.264512,
                483.337216
            ],
            "f": [
                22448,
                23424
            ],
            "l": [
                120816128,
                120834304
            ]
        },
        {
            "t": [
                484.13184,
                484.242432
            ],
            "f": [
                22204,
                23180
            ],
            "l": [
                121032960,
                121060608
            ]
        },
        {
            "t": [
                484.348928,
                484.40832
            ],
            "f": [
                21728.515625,
                22949.21875
            ],
            "l": [
                121087232,
                121102080
            ]
        },
        {
            "t": [
                485.152768,
                485.584896
            ],
            "f": [
                22204,
                24888
            ],
            "l": [
                121288192,
                121396224
            ]
        },
        {
            "t": [
                486.278144,
                486.293504
            ],
            "f": [
                21484.375,
                22949.21875
            ],
            "l": [
                121569536,
                121573376
            ]
        },
        {
            "t": [
                486.975488,
                487.03488
            ],
            "f": [
                21484.375,
                23437.5
            ],
            "l": [
                121743872,
                121758720
            ]
        },
        {
            "t": [
                488.085504,
                488.184832
            ],
            "f": [
                22204,
                23668
            ],
            "l": [
                122021376,
                122046208
            ]
        },
        {
            "t": [
                488.89344,
                489.089024
            ],
            "f": [
                22448,
                24644
            ],
            "l": [
                122223360,
                122272256
            ]
        },
        {
            "t": [
                490.354688,
                490.374144
            ],
            "f": [
                31005.859375,
                35156.25
            ],
            "l": [
                122588672,
                122593536
            ]
        },
        {
            "t": [
                494.3872,
                495.10912
            ],
            "f": [
                24400,
                28548
            ],
            "l": [
                123596800,
                123777280
            ]
        },
        {
            "t": [
                500.168704,
                500.748288
            ],
            "f": [
                24156,
                28304
            ],
            "l": [
                125042176,
                125187072
            ]
        },
        {
            "t": [
                508.787712,
                509.50144
            ],
            "f": [
                23912,
                28792
            ],
            "l": [
                127196928,
                127375360
            ]
        },
        {
            "t": [
                516.483072,
                517.257216
            ],
            "f": [
                23668,
                29036
            ],
            "l": [
                129120768,
                129314304
            ]
        },
        {
            "t": [
                539.10528,
                540.623872
            ],
            "f": [
                24658.203125,
                32470.703125
            ],
            "l": [
                134776320,
                135155968
            ]
        },
        {
            "t": [
                540.849152,
                541.420544
            ],
            "f": [
                23681.640625,
                26611.328125
            ],
            "l": [
                135212288,
                135355136
            ]
        },
        {
            "t": [
                545.036288,
                545.50528
            ],
            "f": [
                24400,
                28060
            ],
            "l": [
                136259072,
                136376320
            ]
        },
        {
            "t": [
                553.795584,
                555.419648
            ],
            "f": [
                26352,
                31476
            ],
            "l": [
                138448896,
                138854912
            ]
        },
        {
            "t": [
                555.61216,
                556.942336
            ],
            "f": [
                24888,
                26352
            ],
            "l": [
                138903040,
                139235584
            ]
        },
        {
            "t": [
                557.160448,
                557.607936
            ],
            "f": [
                24888,
                25620
            ],
            "l": [
                139290112,
                139401984
            ]
        },
        {
            "t": [
                558.312448,
                558.562304
            ],
            "f": [
                24400,
                26108
            ],
            "l": [
                139578112,
                139640576
            ]
        },
        {
            "t": [
                558.769152,
                558.87872
            ],
            "f": [
                23193.359375,
                25390.625
            ],
            "l": [
                139692288,
                139719680
            ]
        },
        {
            "t": [
                567.296,
                567.790592
            ],
            "f": [
                24400,
                25864
            ],
            "l": [
                141824000,
                141947648
            ]
        },
        {
            "t": [
                568.553472,
                568.667136
            ],
            "f": [
                21728.515625,
                23681.640625
            ],
            "l": [
                142138368,
                142166784
            ]
        },
        {
            "t": [
                568.706048,
                568.748032
            ],
            "f": [
                21728.515625,
                23681.640625
            ],
            "l": [
                142176512,
                142187008
            ]
        },
        {
            "t": [
                569.383936,
                569.56928
            ],
            "f": [
                21728.515625,
                24169.921875
            ],
            "l": [
                142345984,
                142392320
            ]
        },
        {
            "t": [
                570.19904,
                570.483712
            ],
            "f": [
                22936,
                25376
            ],
            "l": [
                142549760,
                142620928
            ]
        },
        {
            "t": [
                571.261952,
                571.312128
            ],
            "f": [
                21728.515625,
                23925.78125
            ],
            "l": [
                142815488,
                142828032
            ]
        },
        {
            "t": [
                572.38528,
                572.41088
            ],
            "f": [
                23437.5,
                24658.203125
            ],
            "l": [
                143096320,
                143102720
            ]
        },
        {
            "t": [
                579.068928,
                579.895296
            ],
            "f": [
                24400,
                30256
            ],
            "l": [
                144767232,
                144973824
            ]
        },
        {
            "t": [
                583.788544,
                584.05888
            ],
            "f": [
                24888,
                26840
            ],
            "l": [
                145947136,
                146014720
            ]
        },
        {
            "t": [
                591.081472,
                591.594496
            ],
            "f": [
                23912,
                28548
            ],
            "l": [
                147770368,
                147898624
            ]
        },
        {
            "t": [
                597.12512,
                597.281792
            ],
            "f": [
                24400,
                26352
            ],
            "l": [
                149281280,
                149320448
            ]
        },
        {
            "t": [
                600.148992,
                600.697856
            ],
            "f": [
                29541.015625,
                36376.953125
            ],
            "l": [
                150037248,
                150174464
            ]
        },
        {
            "t": [
                601.481216,
                602.070016
            ],
            "f": [
                24169.921875,
                27343.75
            ],
            "l": [
                150370304,
                150517504
            ]
        },
        {
            "t": [
                602.252288,
                604.063744
            ],
            "f": [
                22705.078125,
                27099.609375
            ],
            "l": [
                150563072,
                151015936
            ]
        },
        {
            "t": [
                607.740928,
                609.143808
            ],
            "f": [
                22460.9375,
                28320.3125
            ],
            "l": [
                151935232,
                152285952
            ]
        },
        {
            "t": [
                608.545792,
                608.940032
            ],
            "f": [
                23437.5,
                28564.453125
            ],
            "l": [
                152136448,
                152235008
            ]
        },
        {
            "t": [
                609.687552,
                611.329024
            ],
            "f": [
                22216.796875,
                26367.1875
            ],
            "l": [
                152421888,
                152832256
            ]
        },
        {
            "t": [
                620.819456,
                621.82912
            ],
            "f": [
                23437.5,
                32226.5625
            ],
            "l": [
                155204864,
                155457280
            ]
        },
        {
            "t": [
                621.284352,
                622.500864
            ],
            "f": [
                23193.359375,
                30029.296875
            ],
            "l": [
                155321088,
                155625216
            ]
        },
        {
            "t": [
                622.72512,
                623.574016
            ],
            "f": [
                22216.796875,
                25878.90625
            ],
            "l": [
                155681280,
                155893504
            ]
        },
        {
            "t": [
                627.2256,
                627.45088
            ],
            "f": [
                24902.34375,
                25878.90625
            ],
            "l": [
                156806400,
                156862720
            ]
        },
        {
            "t": [
                627.634176,
                628.621312
            ],
            "f": [
                22705.078125,
                26123.046875
            ],
            "l": [
                156908544,
                157155328
            ]
        },
        {
            "t": [
                629.63712,
                630.366208
            ],
            "f": [
                24400,
                29280
            ],
            "l": [
                157409280,
                157591552
            ]
        },
        {
            "t": [
                632.91904,
                633.00608
            ],
            "f": [
                48583.984375,
                67138.671875
            ],
            "l": [
                158229760,
                158251520
            ]
        },
        {
            "t": [
                633.03168,
                634.691584
            ],
            "f": [
                27343.75,
                34667.96875
            ],
            "l": [
                158257920,
                158672896
            ]
        },
        {
            "t": [
                634.8544,
                636.3904
            ],
            "f": [
                25620,
                27816
            ],
            "l": [
                158713600,
                159097600
            ]
        },
        {
            "t": [
                636.567552,
                637.728768
            ],
            "f": [
                25864,
                26840
            ],
            "l": [
                159141888,
                159432192
            ]
        },
        {
            "t": [
                637.933568,
                637.95712
            ],
            "f": [
                24169.921875,
                25878.90625
            ],
            "l": [
                159483392,
                159489280
            ]
        },
        {
            "t": [
                638.957568,
                639.250432
            ],
            "f": [
                24888,
                26840
            ],
            "l": [
                159739392,
                159812608
            ]
        },
        {
            "t": [
                639.439872,
                640.14336
            ],
            "f": [
                24888,
                26108
            ],
            "l": [
                159859968,
                160035840
            ]
        },
        {
            "t": [
                640.769024,
                640.95744
            ],
            "f": [
                23180,
                25376
            ],
            "l": [
                160192256,
                160239360
            ]
        },
        {
            "t": [
                642.031616,
                642.10432
            ],
            "f": [
                21484.375,
                23193.359375
            ],
            "l": [
                160507904,
                160526080
            ]
        },
        {
            "t": [
                643.270656,
                643.319808
            ],
            "f": [
                21728.515625,
                23681.640625
            ],
            "l": [
                160817664,
                160829952
            ]
        },
        {
            "t": [
                644.52096,
                644.775936
            ],
            "f": [
                22448,
                25132
            ],
            "l": [
                161130240,
                161193984
            ]
        },
        {
            "t": [
                645.738496,
                645.868544
            ],
            "f": [
                22448,
                23180
            ],
            "l": [
                161434624,
                161467136
            ]
        },
        {
            "t": [
                646.408192,
                646.424576
            ],
            "f": [
                30517.578125,
                34179.6875
            ],
            "l": [
                161602048,
                161606144
            ]
        },
        {
            "t": [
                646.602752,
                646.729728
            ],
            "f": [
                22216.796875,
                23925.78125
            ],
            "l": [
                161650688,
                161682432
            ]
        },
        {
            "t": [
                647.23456,
                647.25504
            ],
            "f": [
                27832.03125,
                34667.96875
            ],
            "l": [
                161808640,
                161813760
            ]
        },
        {
            "t": [
                647.49568,
                647.606272
            ],
            "f": [
                22204,
                22936
            ],
            "l": [
                161873920,
                161901568
            ]
        },
        {
            "t": [
                648.357888,
                648.522752
            ],
            "f": [
                21716,
                22692
            ],
            "l": [
                162089472,
                162130688
            ]
        },
        {
            "t": [
                649.422848,
                649.56416
            ],
            "f": [
                22204,
                22936
            ],
            "l": [
                162355712,
                162391040
            ]
        },
        {
            "t": [
                653.165568,
                653.657088
            ],
            "f": [
                24400,
                28792
            ],
            "l": [
                163291392,
                163414272
            ]
        },
        {
            "t": [
                658.520064,
                659.57376
            ],
            "f": [
                23424,
                29036
            ],
            "l": [
                164630016,
                164893440
            ]
        },
        {
            "t": [
                659.689472,
                660.276224
            ],
            "f": [
                24400,
                30012
            ],
            "l": [
                164922368,
                165069056
            ]
        },
        {
            "t": [
                660.34688,
                661.224448
            ],
            "f": [
                22216.796875,
                26123.046875
            ],
            "l": [
                165086720,
                165306112
            ]
        },
        {
            "t": [
                661.89824,
                662.86592
            ],
            "f": [
                22692,
                25620
            ],
            "l": [
                165474560,
                165716480
            ]
        },
        {
            "t": [
                663.474176,
                664.506368
            ],
            "f": [
                22692,
                25864
            ],
            "l": [
                165868544,
                166126592
            ]
        },
        {
            "t": [
                665.088,
                665.926656
            ],
            "f": [
                22692,
                26108
            ],
            "l": [
                166272000,
                166481664
            ]
        },
        {
            "t": [
                665.370624,
                665.473024
            ],
            "f": [
                24658.203125,
                27343.75
            ],
            "l": [
                166342656,
                166368256
            ]
        },
        {
            "t": [
                666.643456,
                667.70944
            ],
            "f": [
                22460.9375,
                26123.046875
            ],
            "l": [
                166660864,
                166927360
            ]
        },
        {
            "t": [
                667.96032,
                668.47744
            ],
            "f": [
                22936,
                26108
            ],
            "l": [
                166990080,
                167119360
            ]
        },
        {
            "t": [
                670.806016,
                671.020032
            ],
            "f": [
                24658.203125,
                27832.03125
            ],
            "l": [
                167701504,
                167755008
            ]
        },
        {
            "t": [
                673.542144,
                674.66752
            ],
            "f": [
                21972.65625,
                28564.453125
            ],
            "l": [
                168385536,
                168666880
            ]
        },
        {
            "t": [
                675.28704,
                676.173824
            ],
            "f": [
                21972.65625,
                25634.765625
            ],
            "l": [
                168821760,
                169043456
            ]
        },
        {
            "t": [
                676.726784,
                678.025216
            ],
            "f": [
                21972.65625,
                26367.1875
            ],
            "l": [
                169181696,
                169506304
            ]
        },
        {
            "t": [
                678.262784,
                679.404544
            ],
            "f": [
                21972.65625,
                26367.1875
            ],
            "l": [
                169565696,
                169851136
            ]
        },
        {
            "t": [
                683.664384,
                683.712512
            ],
            "f": [
                24902.34375,
                26855.46875
            ],
            "l": [
                170916096,
                170928128
            ]
        },
        {
            "t": [
                689.006592,
                689.573888
            ],
            "f": [
                22949.21875,
                29296.875
            ],
            "l": [
                172251648,
                172393472
            ]
        },
        {
            "t": [
                689.304576,
                690.392064
            ],
            "f": [
                21972.65625,
                29296.875
            ],
            "l": [
                172326144,
                172598016
            ]
        },
        {
            "t": [
                691.004416,
                692.102144
            ],
            "f": [
                21484.375,
                26611.328125
            ],
            "l": [
                172751104,
                173025536
            ]
        },
        {
            "t": [
                693.609472,
                693.67808
            ],
            "f": [
                49560.546875,
                55908.203125
            ],
            "l": [
                173402368,
                173419520
            ]
        },
        {
            "t": [
                698.08128,
                698.11712
            ],
            "f": [
                43188,
                46848
            ],
            "l": [
                174520320,
                174529280
            ]
        },
        {
            "t": [
                698.249216,
                698.724352
            ],
            "f": [
                24644,
                27084
            ],
            "l": [
                174562304,
                174681088
            ]
        },
        {
            "t": [
                700.517376,
                700.548096
            ],
            "f": [
                46142.578125,
                50537.109375
            ],
            "l": [
                175129344,
                175137024
            ]
        },
        {
            "t": [
                704.63488,
                705.099776
            ],
            "f": [
                22949.21875,
                27587.890625
            ],
            "l": [
                176158720,
                176274944
            ]
        },
        {
            "t": [
                707.547136,
                707.57376
            ],
            "f": [
                48583.984375,
                68603.515625
            ],
            "l": [
                176886784,
                176893440
            ]
        },
        {
            "t": [
                713.259008,
                713.314304
            ],
            "f": [
                28808.59375,
                32714.84375
            ],
            "l": [
                178314752,
                178328576
            ]
        },
        {
            "t": [
                713.547776,
                715.285504
            ],
            "f": [
                28548,
                31232
            ],
            "l": [
                178386944,
                178821376
            ]
        },
        {
            "t": [
                715.416576,
                717.333504
            ],
            "f": [
                26108,
                29036
            ],
            "l": [
                178854144,
                179333376
            ]
        },
        {
            "t": [
                717.494272,
                718.497792
            ],
            "f": [
                24888,
                27084
            ],
            "l": [
                179373568,
                179624448
            ]
        },
        {
            "t": [
                718.553088,
                718.595072
            ],
            "f": [
                23681.640625,
                25146.484375
            ],
            "l": [
                179638272,
                179648768
            ]
        },
        {
            "t": [
                718.67904,
                718.715904
            ],
            "f": [
                23681.640625,
                25146.484375
            ],
            "l": [
                179669760,
                179678976
            ]
        },
        {
            "t": [
                718.804992,
                718.862336
            ],
            "f": [
                23925.78125,
                25390.625
            ],
            "l": [
                179701248,
                179715584
            ]
        },
        {
            "t": [
                718.90944,
                719.310848
            ],
            "f": [
                24888,
                25620
            ],
            "l": [
                179727360,
                179827712
            ]
        },
        {
            "t": [
                719.50336,
                720.059392
            ],
            "f": [
                24156,
                26352
            ],
            "l": [
                179875840,
                180014848
            ]
        },
        {
            "t": [
                720.924672,
                721.007616
            ],
            "f": [
                24169.921875,
                26367.1875
            ],
            "l": [
                180231168,
                180251904
            ]
        },
        {
            "t": [
                721.180672,
                721.519616
            ],
            "f": [
                23193.359375,
                26123.046875
            ],
            "l": [
                180295168,
                180379904
            ]
        },
        {
            "t": [
                722.740224,
                723.127296
            ],
            "f": [
                24400,
                26108
            ],
            "l": [
                180685056,
                180781824
            ]
        },
        {
            "t": [
                724.22912,
                724.255744
            ],
            "f": [
                23193.359375,
                24414.0625
            ],
            "l": [
                181057280,
                181063936
            ]
        },
        {
            "t": [
                727.995392,
                728.36096
            ],
            "f": [
                24400,
                26352
            ],
            "l": [
                181998848,
                182090240
            ]
        },
        {
            "t": [
                729.488384,
                729.885696
            ],
            "f": [
                24644,
                26352
            ],
            "l": [
                182372096,
                182471424
            ]
        },
        {
            "t": [
                730.8032,
                730.84416
            ],
            "f": [
                21728.515625,
                22705.078125
            ],
            "l": [
                182700800,
                182711040
            ]
        },
        {
            "t": [
                734.261248,
                734.588928
            ],
            "f": [
                24888,
                27572
            ],
            "l": [
                183565312,
                183647232
            ]
        },
        {
            "t": [
                751.058944,
                751.451136
            ],
            "f": [
                23681.640625,
                28564.453125
            ],
            "l": [
                187764736,
                187862784
            ]
        },
        {
            "t": [
                751.82592,
                751.894528
            ],
            "f": [
                25146.484375,
                26855.46875
            ],
            "l": [
                187956480,
                187973632
            ]
        },
        {
            "t": [
                751.942656,
                752.055296
            ],
            "f": [
                24658.203125,
                26611.328125
            ],
            "l": [
                187985664,
                188013824
            ]
        },
        {
            "t": [
                752.108544,
                752.203776
            ],
            "f": [
                24414.0625,
                25634.765625
            ],
            "l": [
                188027136,
                188050944
            ]
        },
        {
            "t": [
                752.27136,
                752.32256
            ],
            "f": [
                23925.78125,
                25390.625
            ],
            "l": [
                188067840,
                188080640
            ]
        },
        {
            "t": [
                754.388992,
                754.84672
            ],
            "f": [
                22949.21875,
                26367.1875
            ],
            "l": [
                188597248,
                188711680
            ]
        },
        {
            "t": [
                754.889728,
                754.998272
            ],
            "f": [
                22949.21875,
                24169.921875
            ],
            "l": [
                188722432,
                188749568
            ]
        },
        {
            "t": [
                759.33184,
                759.735296
            ],
            "f": [
                23912,
                28304
            ],
            "l": [
                189832960,
                189933824
            ]
        },
        {
            "t": [
                761.289728,
                762.094592
            ],
            "f": [
                21972.65625,
                27832.03125
            ],
            "l": [
                190322432,
                190523648
            ]
        },
        {
            "t": [
                763.259904,
                763.933696
            ],
            "f": [
                20751.953125,
                25634.765625
            ],
            "l": [
                190814976,
                190983424
            ]
        },
        {
            "t": [
                764.951552,
                765.899776
            ],
            "f": [
                21484.375,
                26123.046875
            ],
            "l": [
                191237888,
                191474944
            ]
        },
        {
            "t": [
                767.053824,
                767.537152
            ],
            "f": [
                23437.5,
                29785.15625
            ],
            "l": [
                191763456,
                191884288
            ]
        },
        {
            "t": [
                773.256192,
                773.653504
            ],
            "f": [
                27099.609375,
                30029.296875
            ],
            "l": [
                193314048,
                193413376
            ]
        },
        {
            "t": [
                793.459712,
                793.498624
            ],
            "f": [
                29785.15625,
                31250
            ],
            "l": [
                198364928,
                198374656
            ]
        },
        {
            "t": [
                793.690112,
                794.43968
            ],
            "f": [
                28076.171875,
                31250
            ],
            "l": [
                198422528,
                198609920
            ]
        },
        {
            "t": [
                794.576896,
                796.32384
            ],
            "f": [
                28548,
                30256
            ],
            "l": [
                198644224,
                199080960
            ]
        },
        {
            "t": [
                796.479488,
                798.086144
            ],
            "f": [
                26108,
                27816
            ],
            "l": [
                199119872,
                199521536
            ]
        },
        {
            "t": [
                798.260224,
                798.90944
            ],
            "f": [
                25376,
                27572
            ],
            "l": [
                199565056,
                199727360
            ]
        },
        {
            "t": [
                799.729664,
                800.074752
            ],
            "f": [
                25376,
                26352
            ],
            "l": [
                199932416,
                200018688
            ]
        },
        {
            "t": [
                800.280576,
                800.589824
            ],
            "f": [
                25376,
                26596
            ],
            "l": [
                200070144,
                200147456
            ]
        },
        {
            "t": [
                801.608704,
                801.677312
            ],
            "f": [
                25864,
                26596
            ],
            "l": [
                200402176,
                200419328
            ]
        },
        {
            "t": [
                806.214656,
                806.575104
            ],
            "f": [
                24644,
                26352
            ],
            "l": [
                201553664,
                201643776
            ]
        },
        {
            "t": [
                809.616384,
                809.91744
            ],
            "f": [
                24156,
                26352
            ],
            "l": [
                202404096,
                202479360
            ]
        },
        {
            "t": [
                814.639104,
                814.683136
            ],
            "f": [
                23193.359375,
                25146.484375
            ],
            "l": [
                203659776,
                203670784
            ]
        },
        {
            "t": [
                830.021632,
                830.492672
            ],
            "f": [
                24888,
                30012
            ],
            "l": [
                207505408,
                207623168
            ]
        },
        {
            "t": [
                839.803904,
                839.822336
            ],
            "f": [
                22460.9375,
                24169.921875
            ],
            "l": [
                209950976,
                209955584
            ]
        },
        {
            "t": [
                845.40928,
                845.858816
            ],
            "f": [
                24169.921875,
                29785.15625
            ],
            "l": [
                211352320,
                211464704
            ]
        },
        {
            "t": [
                860.56448,
                860.588032
            ],
            "f": [
                42968.75,
                44921.875
            ],
            "l": [
                215141120,
                215147008
            ]
        },
        {
            "t": [
                860.623872,
                861.32736
            ],
            "f": [
                23925.78125,
                30761.71875
            ],
            "l": [
                215155968,
                215331840
            ]
        },
        {
            "t": [
                869.505024,
                871.11168
            ],
            "f": [
                24169.921875,
                32958.984375
            ],
            "l": [
                217376256,
                217777920
            ]
        },
        {
            "t": [
                873.39008,
                873.41568
            ],
            "f": [
                30273.4375,
                32470.703125
            ],
            "l": [
                218347520,
                218353920
            ]
        },
        {
            "t": [
                873.623552,
                874.50624
            ],
            "f": [
                29768,
                31476
            ],
            "l": [
                218405888,
                218626560
            ]
        },
        {
            "t": [
                874.60352,
                875.317248
            ],
            "f": [
                27816,
                30500
            ],
            "l": [
                218650880,
                218829312
            ]
        },
        {
            "t": [
                875.588608,
                876.660736
            ],
            "f": [
                27084,
                29280
            ],
            "l": [
                218897152,
                219165184
            ]
        },
        {
            "t": [
                876.8256,
                878.168064
            ],
            "f": [
                25620,
                27572
            ],
            "l": [
                219206400,
                219542016
            ]
        },
        {
            "t": [
                881.133568,
                881.191936
            ],
            "f": [
                22949.21875,
                24902.34375
            ],
            "l": [
                220283392,
                220297984
            ]
        },
        {
            "t": [
                881.270784,
                881.509376
            ],
            "f": [
                24644,
                26108
            ],
            "l": [
                220317696,
                220377344
            ]
        },
        {
            "t": [
                888.691712,
                889.069568
            ],
            "f": [
                22448,
                25132
            ],
            "l": [
                222172928,
                222267392
            ]
        },
        {
            "t": [
                893.073408,
                893.458432
            ],
            "f": [
                25132,
                28304
            ],
            "l": [
                223268352,
                223364608
            ]
        },
        {
            "t": [
                897.517568,
                897.865728
            ],
            "f": [
                24644,
                27328
            ],
            "l": [
                224379392,
                224466432
            ]
        },
        {
            "t": [
                905.531392,
                905.829376
            ],
            "f": [
                24644,
                27328
            ],
            "l": [
                226382848,
                226457344
            ]
        },
        {
            "t": [
                918.257664,
                918.72768
            ],
            "f": [
                24400,
                28548
            ],
            "l": [
                229564416,
                229681920
            ]
        },
        {
            "t": [
                921.08288,
                921.133056
            ],
            "f": [
                23925.78125,
                25146.484375
            ],
            "l": [
                230270720,
                230283264
            ]
        },
        {
            "t": [
                927.895552,
                928.25088
            ],
            "f": [
                23912,
                27084
            ],
            "l": [
                231973888,
                232062720
            ]
        },
        {
            "t": [
                936.767488,
                937.527296
            ],
            "f": [
                24414.0625,
                31250
            ],
            "l": [
                234191872,
                234381824
            ]
        },
        {
            "t": [
                941.978624,
                942.536704
            ],
            "f": [
                24414.0625,
                29785.15625
            ],
            "l": [
                235494656,
                235634176
            ]
        },
        {
            "t": [
                946.382848,
                946.392064
            ],
            "f": [
                59082.03125,
                63476.5625
            ],
            "l": [
                236595712,
                236598016
            ]
        },
        {
            "t": [
                947.544064,
                947.603456
            ],
            "f": [
                48095.703125,
                53955.078125
            ],
            "l": [
                236886016,
                236900864
            ]
        },
        {
            "t": [
                947.77344,
                947.949568
            ],
            "f": [
                52246.09375,
                79101.5625
            ],
            "l": [
                236943360,
                236987392
            ]
        },
        {
            "t": [
                950.309888,
                950.352896
            ],
            "f": [
                53710.9375,
                59570.3125
            ],
            "l": [
                237577472,
                237588224
            ]
        },
        {
            "t": [
                954.201088,
                954.661888
            ],
            "f": [
                30029.296875,
                47607.421875
            ],
            "l": [
                238550272,
                238665472
            ]
        },
        {
            "t": [
                954.765312,
                955.3664
            ],
            "f": [
                29785.15625,
                33203.125
            ],
            "l": [
                238691328,
                238841600
            ]
        },
        {
            "t": [
                955.615232,
                956.576768
            ],
            "f": [
                28320.3125,
                30517.578125
            ],
            "l": [
                238903808,
                239144192
            ]
        },
        {
            "t": [
                956.695552,
                957.16352
            ],
            "f": [
                28548,
                30256
            ],
            "l": [
                239173888,
                239290880
            ]
        },
        {
            "t": [
                957.698048,
                958.128128
            ],
            "f": [
                28320.3125,
                31250
            ],
            "l": [
                239424512,
                239532032
            ]
        },
        {
            "t": [
                958.240768,
                958.41792
            ],
            "f": [
                29036,
                29768
            ],
            "l": [
                239560192,
                239604480
            ]
        },
        {
            "t": [
                962.14016,
                962.873344
            ],
            "f": [
                30273.4375,
                34667.96875
            ],
            "l": [
                240535040,
                240718336
            ]
        },
        {
            "t": [
                964.178944,
                965.955584
            ],
            "f": [
                26123.046875,
                32714.84375
            ],
            "l": [
                241044736,
                241488896
            ]
        },
        {
            "t": [
                966.178816,
                966.733824
            ],
            "f": [
                25864,
                27084
            ],
            "l": [
                241544704,
                241683456
            ]
        },
        {
            "t": [
                967.076864,
                967.527424
            ],
            "f": [
                25620,
                26840
            ],
            "l": [
                241769216,
                241881856
            ]
        },
        {
            "t": [
                967.770112,
                968.159232
            ],
            "f": [
                25864,
                27328
            ],
            "l": [
                241942528,
                242039808
            ]
        },
        {
            "t": [
                969.652224,
                969.96864
            ],
            "f": [
                25376,
                26596
            ],
            "l": [
                242413056,
                242492160
            ]
        }
    ]
};
$6a7397d0745d4f70$exports = $6a7397d0745d4f70$var$a;


window.anot = $6a7397d0745d4f70$exports;
//Pseudo-backend, will be replaced by the real one caching relations from IPFS records
var $bd645c269c090d3b$export$782d57a8ae50ac09;
const $bd645c269c090d3b$var$known_anot_cids = new Set([
    "QmRsZW5qwoPGAh9Z79Dos12SAyJam7e373f8sxp1xYXRTi",
    "QmZyVBpkkdpyK2km9r4c9CSGpL7m9AEQRsMDy1GfAH2CvV",
    "QmdUMUK9NeUpLktRhueQFnvXY3rDv7WHQymQwPbUYvYKB4",
    "QmbXeXZSKiaMpB56vPanemwVy7iLKFLb3w1Tti9mEdkhF6",
    "QmRxHZVJ5fzUyawgUoTSupdLHQGcGiUe5YxZnKumNKLN8H",
    "QmdAhpArMZexjc3wDfoSEMxeACd6akdBpdZGaWcAxskyuD",
    "QmfTtmvo1AnAo3cWZPgMp9p1KbJU4dthYjJzdRzH4iUxj6",
    "QmaCufbgLVwTX1zKv6LafP4onC2nDvSY35yhfFGCvHm3M5",
    "QmNtZirRefcSL1UtR383vBjUKAsgj1vZyVmh7LfraZ4qan",
    "QmXtYo7KfcJWzuT9mvqfC8LWMB9sMo85C3La7JAt9DsKVM",
    "QmNT61KWMptP22wbqXaJBHJA9THsWd9mvAFjhV4BipECqy",
    "QmT8dgRhJfk83QDWwsQE9Xu1TmA8hmjNAKerC3nwZahitq",
    "QmcKGeXqqSzKRqxrcUqEyUVAbJr1YitMJTjAgoyghC6PgG",
    "QmNvtN4oZ91ma8xwKfkkQEdb18R8jwB9q5p8GxRJ9GkLkD",
    "QmYdnrLQT5u33wWPamFK5zkJJrv9nzGff1j9dnLpxaTtMN",
    "QmZLngGX6ntpeyhXmN7APebhfu8gZiQiVrLBXRyyvdj2DG",
    "QmPYeYLQ36LuzpoNHXLPr2o2zrZPZmQ4zjMTZKsjzy2HGH",
    "QmbyYup29YX4H1tWtTZ6ytXfqj7ypddnryWiL4RZtVumZW",
    "QmY5CQhKrYgbDV889i7oW5WyvASYiyzAFTRhMM62v2PDvi",
    "QmRULsuDRoWqqtijTKP7rprRgxNQuTpKVcYswE7H7Wzq76"
]);
const $bd645c269c090d3b$var$known_exp_cids = new Set([
    "QmbBWPeHn4nYGRtfnjwfeehfpx84hNbAF4BKvikB6NKGJW"
]);
function $bd645c269c090d3b$var$dcid(cid) {
    if ($bd645c269c090d3b$var$known_anot_cids.has(cid)) return "anot";
    if ($bd645c269c090d3b$var$known_exp_cids.has(cid)) return "exp";
}
$bd645c269c090d3b$export$782d57a8ae50ac09 = $bd645c269c090d3b$var$dcid;


var $2b6e161c9edcf319$require$dcid = $bd645c269c090d3b$export$782d57a8ae50ac09;
async function $2b6e161c9edcf319$var$get_cid(cid, recv) {
    try {
        const response = await fetch("https://cloudflare-ipfs.com/ipfs/" + cid);
        const r = await response.json();
        console.log(r);
        recv(r, cid);
    } catch (err) {
        $2b6e161c9edcf319$var$make_oops_ui(cid);
    }
}
console.log($6a7397d0745d4f70$exports);
let $2b6e161c9edcf319$var$data = $6a7397d0745d4f70$exports.episodes.map((x)=>({
        Time: (x.t[0] + x.t[1]) / 2,
        Length: x.t[1] - x.t[0],
        Frequency: (x.f[0] + x.f[1]) / 2
    }));
console.log($2b6e161c9edcf319$var$data);
function $2b6e161c9edcf319$var$ignition() {
    let url = new URL(window.location.toString());
    let cid = url.searchParams.get("cid");
    if (!cid) return $2b6e161c9edcf319$var$make_welcome_ui();
    let kind = $2b6e161c9edcf319$require$dcid(cid);
    if (!kind) return $2b6e161c9edcf319$var$make_oops_ui(cid);
    if (kind === "anot") return $2b6e161c9edcf319$var$get_cid(cid, $2b6e161c9edcf319$var$make_annot_ui);
    if (kind == "exp") return $2b6e161c9edcf319$var$get_cid(cid, $2b6e161c9edcf319$var$make_exp_ui);
}
function $2b6e161c9edcf319$var$make_oops_ui(cid) {
    document.title = "Not found \u2014 Ultrasonic Vocalisation Repository";
    document.querySelector("main").innerHTML = "<div id='oops'><h1>Resource cannot be found</h1>CID '" + cid + "' is not whitelisted for the repository," + " is not valid or couldn't be loaded." + "</div>";
}
function $2b6e161c9edcf319$var$make_welcome_ui() {
    document.title = "Ultrasonic Vocalisation Repository";
    document.querySelector("#tb").innerText = "Experiment list";
    let main = document.querySelector("main");
    main.innerHTML = '<ul><li><a href="?cid=QmbBWPeHn4nYGRtfnjwfeehfpx84hNbAF4BKvikB6NKGJW">Recordings of rat alarm calls emitted and relied in social context</a></li></ul>';
}
function $2b6e161c9edcf319$var$make_annot_ui(anot, anot_cid) {
    let main = document.querySelector("main");
    main.innerHTML = '<div id="summary_table"></div><div id="scatterplot"></div> <div id="timeline"></div> ';
    document.title = anot.name + " \u2014 annotated USV recording";
    let scat = document.querySelector("#scatterplot");
    let timl = document.querySelector("#timeline");
    let tab = document.querySelector("#summary_table");
    document.querySelector("#tb").innerText = anot.name + " \u2014 annotated USV recording";
    let data = anot.episodes.map((x)=>({
            Time: (x.t[0] + x.t[1]) / 2,
            Length: x.t[1] - x.t[0],
            Frequency: (x.f[0] + x.f[1]) / 2
        }));
    $2b6e161c9edcf319$var$annot_scatter(data, scat);
    $2b6e161c9edcf319$var$annot_timeline(data, timl);
    $2b6e161c9edcf319$var$annot_table(anot, tab);
}
function $2b6e161c9edcf319$var$make_exp_ui(exp, exp_cid) {
    let main = document.querySelector("main");
    main.innerHTML = '<div id="exp_table"></div>';
    document.title = exp.title + " \u2014 USV experiment";
    let exp_table = document.querySelector("#exp_table");
    document.querySelector("#tb").innerText = "";
    let ac = exp.authors.map((x)=>{
        console.log(x);
        console.log(x.orcid);
        if (x.orcid) return '<a href="https://orcid.org/' + x.orcid + '">' + (x.name || "??") + "</a>";
        else return x.name || "??";
    }).join(", ");
    let al = Object.entries(exp.annotated_recordings).map((x)=>{
        let cid = x[0];
        let v = x[1];
        let name = v.case || cid;
        return '<li><a href="?cid=' + cid + '">' + name + "</a></li>";
    }).join("");
    let rl = exp.citations.map((x)=>{
        return '<li><a href="' + x.doi + '">' + x.text + "</a></li>";
    }).join("");
    exp_table.innerHTML = "<h1>" + exp.title + "</h1>" + '<p class="authors">Contributors: ' + ac + "</p>" + "<h2>Annotated recordings</h2>" + "<ul>" + al + "</ul>" + "<h2>References</h2>" + "<ul>" + rl + "</ul>" + "<h2>License</h2>" + exp.license;
}
function $2b6e161c9edcf319$var$annot_table(anot, div) {
    div.innerHTML = "<h2>Summary</h2><p>Annotation " + anot.name + " lists " + anot.episodes.length + " episodes.</p>" + "<p>Method: " + anot.method + "</p>" + "<p>Associated recording: " + anot.recording + "</p>";
}
function $2b6e161c9edcf319$var$annot_scatter(data, div) {
    const plot = $dce15e0807f8b267$export$2bbbe2756ad57c66({
        color: {
            legend: true,
            label: "Recording time [s]"
        },
        marks: [
            $7910fd10d657c0be$export$94132a0e348806d4(data, {
                x: "Length",
                y: "Frequency",
                fill: "Time"
            })
        ],
        x: {
            type: "log",
            label: "Episode span [s]"
        },
        y: {
            label: "Episode mid frequency [Hz]"
        }
    });
    //const div = document.querySelector("#myplot")
    div.innerHTML = "<h2>Episode scatterplot</h2>";
    div.append(plot);
}
function $2b6e161c9edcf319$var$annot_timeline(data, div) {
    const plot = $dce15e0807f8b267$export$2bbbe2756ad57c66({
        color: {
            legend: true,
            label: "Episode span [s]"
        },
        marks: [
            $7910fd10d657c0be$export$94132a0e348806d4(data, {
                x: "Time",
                y: "Frequency",
                fill: "Length"
            })
        ],
        x: {
            label: "Recording time [s]"
        },
        y: {
            label: "Episode mid frequency [Hz]"
        },
        width: document.body.clientWidth * 0.8
    });
    div.innerHTML = "<h2>Episode timeline</h2>";
    div.append(plot);
}
$2b6e161c9edcf319$var$ignition();


//# sourceMappingURL=index.ea921e90.js.map
